import * as i0 from '@angular/core';
import { Injectable, Component, ChangeDetectionStrategy, Input, Pipe, EventEmitter, Output, NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import * as i3 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i2 from '@ionic/storage';
import { IonicStorageModule } from '@ionic/storage';
import { __awaiter } from 'tslib';
import { Subject } from 'rxjs';
import * as i1 from '@ionic/angular';
import { IonicModule } from '@ionic/angular';
import { FormsModule } from '@angular/forms';
import * as i1$1 from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { timeout } from 'rxjs/operators';

class CommonLibService {
    constructor() { }
}
CommonLibService.ɵfac = function CommonLibService_Factory(t) { return new (t || CommonLibService)(); };
CommonLibService.ɵprov = i0.ɵɵdefineInjectable({ token: CommonLibService, factory: CommonLibService.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(CommonLibService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

function CommonLibComponent_p_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p");
    i0.ɵɵtext(1, " CoomonLib works very well! Very veruy well well well!!! 12 ");
    i0.ɵɵelementEnd();
} }
class CommonLibComponent {
    constructor() { }
    ngOnInit() {
    }
}
CommonLibComponent.ɵfac = function CommonLibComponent_Factory(t) { return new (t || CommonLibComponent)(); };
CommonLibComponent.ɵcmp = i0.ɵɵdefineComponent({ type: CommonLibComponent, selectors: [["common_commonLib"]], decls: 1, vars: 1, consts: [[4, "ngIf"]], template: function CommonLibComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, CommonLibComponent_p_0_Template, 2, 0, "p", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", true);
    } }, directives: [i3.NgIf], encapsulation: 2 });
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(CommonLibComponent, [{
        type: Component,
        args: [{
                selector: 'common_commonLib',
                template: `
    <p *ngIf="true">
      CoomonLib works very well! Very veruy well well well!!! 12
    </p>
  `,
                styles: []
            }]
    }], function () { return []; }, null); })();

function AlertPage_ion_button_9_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ion-button", 8);
    i0.ɵɵlistener("click", function AlertPage_ion_button_9_Template_ion_button_click_0_listener() { i0.ɵɵrestoreView(_r3); const button_r1 = ctx.$implicit; const ctx_r2 = i0.ɵɵnextContext(); return ctx_r2.toggleClick(button_r1); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const button_r1 = ctx.$implicit;
    i0.ɵɵproperty("fill", button_r1.fill)("color", button_r1.color || "main-strong_base");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", button_r1.label, " ");
} }
class AlertPage {
    constructor(cd, modalCtrl, view) {
        this.cd = cd;
        this.modalCtrl = modalCtrl;
        this.view = view;
        // listener
        this.listener = {
            view: null,
        };
    }
    ngOnInit() { }
    ionViewDidEnter() {
        this.listenerView();
    }
    ionViewWillLeave() {
        if (this.listener.view) {
            this.listener.view.unsubscribe();
        }
    }
    dismiss() {
        this.modalCtrl.dismiss();
    }
    // listener
    listenerView() {
        this.listener.view = ViewService.updateView$.subscribe((obj) => {
            this.view.pipeChanged++;
            this.cd.markForCheck();
            setTimeout(() => {
                this.cd.markForCheck();
            }, 250);
        });
    }
    toggleClick(button) {
        if (button.click) {
            button.click();
        }
        this.dismiss();
    }
}
AlertPage.ɵfac = function AlertPage_Factory(t) { return new (t || AlertPage)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.ModalController), i0.ɵɵdirectiveInject(ViewService)); };
AlertPage.ɵcmp = i0.ɵɵdefineComponent({ type: AlertPage, selectors: [["app-alert"]], inputs: { icon: "icon", msg: "msg", title: "title", buttons: "buttons" }, decls: 10, vars: 4, consts: [[1, "page"], ["color", "mid_base", "fill", "clear", 1, "pg-btn", "pg-btn-close", 3, "click"], ["name", "close", "slot", "icon-only", 1, "btn-icon"], [1, "icon", 3, "src"], [1, "title"], [1, "msg", 3, "innerHTML"], [1, "pg-btns"], ["class", "pg-btn pg-btn-ok", 3, "fill", "color", "click", 4, "ngFor", "ngForOf"], [1, "pg-btn", "pg-btn-ok", 3, "fill", "color", "click"]], template: function AlertPage_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "ion-content");
        i0.ɵɵelementStart(1, "div", 0);
        i0.ɵɵelementStart(2, "ion-button", 1);
        i0.ɵɵlistener("click", function AlertPage_Template_ion_button_click_2_listener() { return ctx.dismiss(); });
        i0.ɵɵelement(3, "ion-icon", 2);
        i0.ɵɵelementEnd();
        i0.ɵɵelement(4, "ion-icon", 3);
        i0.ɵɵelementStart(5, "div", 4);
        i0.ɵɵtext(6);
        i0.ɵɵelementEnd();
        i0.ɵɵelement(7, "div", 5);
        i0.ɵɵelementStart(8, "div", 6);
        i0.ɵɵtemplate(9, AlertPage_ion_button_9_Template, 2, 3, "ion-button", 7);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("src", ctx.icon);
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate1(" ", ctx.title, " ");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("innerHTML", ctx.msg, i0.ɵɵsanitizeHtml);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngForOf", ctx.buttons);
    } }, directives: [i1.IonContent, i1.IonButton, i1.IonIcon, i3.NgForOf], styles: [".page[_ngcontent-%COMP%]   .msg[_ngcontent-%COMP%], .page[_ngcontent-%COMP%]   .title[_ngcontent-%COMP%]{word-break:break-all;word-break:break-word}.page[_ngcontent-%COMP%]{display:flex;flex-direction:column;min-height:100%;padding:20px}.page[_ngcontent-%COMP%]   .icon[_ngcontent-%COMP%]{-ms-grid-row-align:center;align-self:center;font-size:38px;margin-bottom:25px;margin-top:5px}.page[_ngcontent-%COMP%]   .msg[_ngcontent-%COMP%]{color:var(--app-mid);line-height:1.3;margin-bottom:30px;padding:0 10px}.page[_ngcontent-%COMP%]   .pg-btns[_ngcontent-%COMP%]{align-items:center;display:flex;justify-content:flex-end;margin-top:auto}.page[_ngcontent-%COMP%]   .pg-btns[_ngcontent-%COMP%]   .pg-btn[_ngcontent-%COMP%]:not(:last-child){margin-right:10px}.page[_ngcontent-%COMP%]   .pg-btn[_ngcontent-%COMP%]{align-self:flex-end;margin:0}.page[_ngcontent-%COMP%]   .pg-btn.pg-btn-close[_ngcontent-%COMP%]{--border-radius:50%;--padding-bottom:5px;--padding-end:5px;--padding-start:5px;--padding-top:5px;height:auto;margin-right:-10px;margin-top:-10px}.page[_ngcontent-%COMP%]   .pg-btn.pg-btn-close[_ngcontent-%COMP%]   .btn-icon[_ngcontent-%COMP%]{font-size:24px}.page[_ngcontent-%COMP%]   .pg-btn.pg-btn-ok[_ngcontent-%COMP%]{font-weight:600;height:32px;min-width:70px}.page[_ngcontent-%COMP%]   .title[_ngcontent-%COMP%]{color:var(--app-mid);font-size:17px;font-weight:500;margin-bottom:10px;padding:0 10px}"], changeDetection: 0 });
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(AlertPage, [{
        type: Component,
        args: [{
                selector: 'app-alert',
                templateUrl: './alert.page.html',
                styleUrls: ['./alert.page.scss'],
                changeDetection: ChangeDetectionStrategy.OnPush
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i1.ModalController }, { type: ViewService }]; }, { icon: [{
            type: Input
        }], msg: [{
            type: Input
        }], title: [{
            type: Input
        }], buttons: [{
            type: Input
        }] }); })();

function SmallAlertPage_ion_button_9_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ion-button", 8);
    i0.ɵɵlistener("click", function SmallAlertPage_ion_button_9_Template_ion_button_click_0_listener() { i0.ɵɵrestoreView(_r3); const button_r1 = ctx.$implicit; const ctx_r2 = i0.ɵɵnextContext(); return ctx_r2.toggleClick(button_r1); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const button_r1 = ctx.$implicit;
    i0.ɵɵproperty("fill", button_r1.fill)("color", button_r1.color || "main-strong_base");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", button_r1.label, " ");
} }
class SmallAlertPage {
    constructor(cd, modalCtrl, view) {
        this.cd = cd;
        this.modalCtrl = modalCtrl;
        this.view = view;
        // listener
        this.listener = {
            view: null,
        };
    }
    ngOnInit() { }
    ionViewDidEnter() {
        this.listenerView();
    }
    ionViewWillLeave() {
        if (this.listener.view) {
            this.listener.view.unsubscribe();
        }
    }
    dismiss() {
        this.modalCtrl.dismiss();
    }
    // listener
    listenerView() {
        this.listener.view = ViewService.updateView$.subscribe((obj) => {
            this.view.pipeChanged++;
            this.cd.markForCheck();
            setTimeout(() => {
                this.cd.markForCheck();
            }, 250);
        });
    }
    toggleClick(button) {
        if (button.click) {
            button.click();
        }
        this.dismiss();
    }
}
SmallAlertPage.ɵfac = function SmallAlertPage_Factory(t) { return new (t || SmallAlertPage)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.ModalController), i0.ɵɵdirectiveInject(ViewService)); };
SmallAlertPage.ɵcmp = i0.ɵɵdefineComponent({ type: SmallAlertPage, selectors: [["app-small-alert"]], inputs: { icon: "icon", msg: "msg", title: "title", buttons: "buttons" }, decls: 10, vars: 4, consts: [[1, "page"], ["color", "mid_base", "fill", "clear", 1, "pg-btn", "pg-btn-close", 3, "click"], ["name", "close", "slot", "icon-only", 1, "btn-icon"], [1, "icon", 3, "src"], [1, "title"], [1, "msg", 3, "innerHTML"], [1, "pg-btns"], ["class", "pg-btn pg-btn-ok", "size", "small", 3, "fill", "color", "click", 4, "ngFor", "ngForOf"], ["size", "small", 1, "pg-btn", "pg-btn-ok", 3, "fill", "color", "click"]], template: function SmallAlertPage_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "ion-content");
        i0.ɵɵelementStart(1, "div", 0);
        i0.ɵɵelementStart(2, "ion-button", 1);
        i0.ɵɵlistener("click", function SmallAlertPage_Template_ion_button_click_2_listener() { return ctx.dismiss(); });
        i0.ɵɵelement(3, "ion-icon", 2);
        i0.ɵɵelementEnd();
        i0.ɵɵelement(4, "ion-icon", 3);
        i0.ɵɵelementStart(5, "div", 4);
        i0.ɵɵtext(6);
        i0.ɵɵelementEnd();
        i0.ɵɵelement(7, "div", 5);
        i0.ɵɵelementStart(8, "div", 6);
        i0.ɵɵtemplate(9, SmallAlertPage_ion_button_9_Template, 2, 3, "ion-button", 7);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("src", ctx.icon);
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate1(" ", ctx.title, " ");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("innerHTML", ctx.msg, i0.ɵɵsanitizeHtml);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngForOf", ctx.buttons);
    } }, directives: [i1.IonContent, i1.IonButton, i1.IonIcon, i3.NgForOf], styles: [".page[_ngcontent-%COMP%]   .msg[_ngcontent-%COMP%], .page[_ngcontent-%COMP%]   .title[_ngcontent-%COMP%]{word-break:break-all;word-break:break-word}.page[_ngcontent-%COMP%]{display:flex;flex-direction:column;min-height:100%;padding:20px}.page[_ngcontent-%COMP%]   .icon[_ngcontent-%COMP%]{-ms-grid-row-align:center;align-self:center;font-size:25px;margin-bottom:10px;position:absolute}.page[_ngcontent-%COMP%]   .msg[_ngcontent-%COMP%]{color:var(--app-mid);font-size:14px;line-height:1.3;margin-bottom:20px;padding:0 10px}.page[_ngcontent-%COMP%]   .pg-btns[_ngcontent-%COMP%]{align-items:center;display:flex;justify-content:flex-end;margin-top:auto}.page[_ngcontent-%COMP%]   .pg-btns[_ngcontent-%COMP%]   .pg-btn[_ngcontent-%COMP%]:not(:last-child){margin-right:10px}.page[_ngcontent-%COMP%]   .pg-btn[_ngcontent-%COMP%]{align-self:flex-end;margin:0}.page[_ngcontent-%COMP%]   .pg-btn.pg-btn-close[_ngcontent-%COMP%]{--border-radius:50%;--padding-bottom:5px;--padding-end:5px;--padding-start:5px;--padding-top:5px;height:auto;margin-right:-10px;margin-top:-10px}.page[_ngcontent-%COMP%]   .pg-btn.pg-btn-close[_ngcontent-%COMP%]   .btn-icon[_ngcontent-%COMP%]{font-size:24px}.page[_ngcontent-%COMP%]   .pg-btn.pg-btn-ok[_ngcontent-%COMP%]{font-weight:600;height:32px;min-width:70px}.page[_ngcontent-%COMP%]   .title[_ngcontent-%COMP%]{color:var(--app-mid);font-size:17px;font-weight:500;margin-bottom:10px;margin-top:10px;padding:0 10px}"], changeDetection: 0 });
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(SmallAlertPage, [{
        type: Component,
        args: [{
                selector: 'app-small-alert',
                templateUrl: './small-alert.page.html',
                styleUrls: ['./small-alert.page.scss'],
                changeDetection: ChangeDetectionStrategy.OnPush
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i1.ModalController }, { type: ViewService }]; }, { icon: [{
            type: Input
        }], msg: [{
            type: Input
        }], title: [{
            type: Input
        }], buttons: [{
            type: Input
        }] }); })();

class ViewService {
    constructor(alertController, modalCtrl, loadingCtrl, popoverController) {
        this.alertController = alertController;
        this.modalCtrl = modalCtrl;
        this.loadingCtrl = loadingCtrl;
        this.popoverController = popoverController;
        this.pipeChanged = 0;
        // I don't like this here
        this.topbar = {
            currentPath: "routes-history",
        };
    }
    initialize(iconsMap, isMobile) {
        ViewService.iconsMap = iconsMap;
        ViewService.isMobile = isMobile;
    }
    /**
     * VIGO
     * @param path
     */
    setCurrentPath(path) {
        this.currentPath = path;
        ViewService.updateView.next('currentPath');
    }
    presentAlert(header, message, buttons, subHeader, cssClass, backdropDismiss, inputs) {
        return __awaiter(this, void 0, void 0, function* () {
            const alert = yield this.alertController.create({
                cssClass: cssClass,
                header: header,
                subHeader: subHeader,
                message: message,
                buttons: buttons,
                inputs: inputs,
                backdropDismiss: backdropDismiss
            });
            yield alert.present();
        });
    }
    // Crea un alert grafico. L'icona è presa da iconsMap e deve essere passato nel metodo initialize
    modalAlert(title, msg, icon, buttons) {
        return __awaiter(this, void 0, void 0, function* () {
            if (buttons) {
                if (!Array.isArray(buttons)) {
                    buttons = [{ label: buttons }];
                }
            }
            if (!icon)
                icon = 'info';
            const modal = yield this.modalCtrl.create({
                component: ViewService.isMobile ? SmallAlertPage : AlertPage,
                componentProps: {
                    msg: msg,
                    title: title,
                    buttons: buttons,
                    view: ViewService
                },
                cssClass: "modal_alert",
            });
            modal.componentProps.icon = ViewService.iconsMap[icon] || '';
            return yield modal.present();
        });
    }
    showLoading(message) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.loading && this.loading.isOverlay)
                this.loading.dismiss();
            this.loading = yield this.loadingCtrl.create({
                message: message
            });
            yield this.loading.present();
        });
    }
    hideLoading() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.loading)
                yield this.loading.dismiss();
        });
    }
    presentPopover(ev, component, componentProps) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!component)
                return;
            const popover = yield this.popoverController.create({
                component: component,
                event: ev,
                translucent: true,
                componentProps: componentProps
            });
            yield popover.present();
            return popover;
        });
    }
}
// Oggetto con tutte le icone necessarie con chiave es {'succ': 'assets/imgs/icons/...'} valorizzato in inizialize
ViewService.iconsMap = {};
// events
ViewService.updateView = new Subject();
ViewService.updateView$ = ViewService.updateView.asObservable();
ViewService.ɵfac = function ViewService_Factory(t) { return new (t || ViewService)(i0.ɵɵinject(i1.AlertController), i0.ɵɵinject(i1.ModalController), i0.ɵɵinject(i1.LoadingController), i0.ɵɵinject(i1.PopoverController)); };
ViewService.ɵprov = i0.ɵɵdefineInjectable({ token: ViewService, factory: ViewService.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(ViewService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.AlertController }, { type: i1.ModalController }, { type: i1.LoadingController }, { type: i1.PopoverController }]; }, null); })();

function TopBarComponent_ion_button_7_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "ion-icon", 19);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const btn_r5 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("name", btn_r5.ionIcon);
} }
function TopBarComponent_ion_button_7_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ion-icon", 20);
} if (rf & 2) {
    const btn_r5 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("src", "assets/imgs/icons-fdc/" + btn_r5.icon);
} }
function TopBarComponent_ion_button_7_Template(rf, ctx) { if (rf & 1) {
    const _r12 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ion-button", 3);
    i0.ɵɵlistener("click", function TopBarComponent_ion_button_7_Template_ion_button_click_0_listener() { i0.ɵɵrestoreView(_r12); const btn_r5 = ctx.$implicit; const ctx_r11 = i0.ɵɵnextContext(); return ctx_r11.openPage(btn_r5.path); });
    i0.ɵɵelementStart(1, "div", 4);
    i0.ɵɵtemplate(2, TopBarComponent_ion_button_7_ng_container_2_Template, 2, 1, "ng-container", 16);
    i0.ɵɵtemplate(3, TopBarComponent_ion_button_7_ng_template_3_Template, 1, 1, "ng-template", null, 17, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementStart(5, "div", 18);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const btn_r5 = ctx.$implicit;
    const _r7 = i0.ɵɵreference(4);
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("selected", btn_r5.path === ctx_r0.view.currentPath);
    i0.ɵɵproperty("disabled", !btn_r5.path);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", btn_r5.ionIcon)("ngIfElse", _r7);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", btn_r5.label, " ");
} }
function TopBarComponent_ion_button_9_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "ion-icon", 19);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const btn_r13 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("name", btn_r13.ionIcon);
} }
function TopBarComponent_ion_button_9_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ion-icon", 20);
} if (rf & 2) {
    const btn_r13 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("src", "assets/imgs/icons-fdc/" + btn_r13.icon);
} }
function TopBarComponent_ion_button_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "ion-button", 21);
    i0.ɵɵelementStart(1, "div", 4);
    i0.ɵɵtemplate(2, TopBarComponent_ion_button_9_ng_container_2_Template, 2, 1, "ng-container", 16);
    i0.ɵɵtemplate(3, TopBarComponent_ion_button_9_ng_template_3_Template, 1, 1, "ng-template", null, 22, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementStart(5, "div", 18);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const btn_r13 = ctx.$implicit;
    const _r15 = i0.ɵɵreference(4);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", btn_r13.ionIcon)("ngIfElse", _r15);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", btn_r13.label, " ");
} }
function TopBarComponent_div_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 23);
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵstyleProp("background-image", "url(" + ctx_r2.tempAvatar + ")");
} }
function TopBarComponent_ng_template_15_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 24);
    i0.ɵɵtext(1, " FC ");
    i0.ɵɵelementEnd();
} }
class TopBarComponent {
    constructor(ref, view) {
        this.ref = ref;
        this.view = view;
        this.listeners = [];
        this.tempAvatar = "https://www.cinemat" +
            "ographe.it/wp-content/uploads/2" +
            "019/04/Avatar.jpg";
    }
    ngOnInit() {
        this.listeners.push(ViewService.updateView$.subscribe(() => {
            this.ref.markForCheck();
        }));
    }
    ngOnDestroy() {
        for (let listener of this.listeners) {
            listener.unsubscribe();
        }
    }
    openPage(path) {
        if (path && path != this.view.currentPath) {
            this.navCtrl.navigateRoot("/" + path);
            this.view.setCurrentPath(path);
            this.ref.markForCheck();
        }
    }
    // sidebar
    set_sidebar_isEnabled() {
        return __awaiter(this, void 0, void 0, function* () {
            // this.sidebar_isEnabled = await this.menuCtrl.isEnabled("sidebar");
            // this.cd.markForCheck();
        });
    }
    toggleSidebar() {
        // this.menuCtrl.toggle("sidebar");
    }
}
TopBarComponent.ɵfac = function TopBarComponent_Factory(t) { return new (t || TopBarComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(ViewService)); };
TopBarComponent.ɵcmp = i0.ɵɵdefineComponent({ type: TopBarComponent, selectors: [["common-top-bar"]], inputs: { menuButtons: "menuButtons", navButtons: "navButtons", sidebar_isEnabled: "sidebar_isEnabled", navCtrl: "navCtrl" }, decls: 17, vars: 5, consts: [[1, "component"], [1, "side", "side-left"], [1, "btns-wrap", "btns-wrap-1"], ["color", "base_main", "fill", "clear", 1, "tb-btn", 3, "disabled", "click"], [1, "td-btn-inner"], ["name", "menu", 1, "btn-icon"], [1, "btns-wrap", "btns-wrap-2"], ["class", "tb-btn", "color", "base_main", "fill", "clear", 3, "selected", "disabled", "click", 4, "ngFor", "ngForOf"], [1, "btns-wrap", "btns-wrap-3"], ["class", "tb-btn", "color", "base_main", "fill", "clear", 4, "ngFor", "ngForOf"], [1, "side", "side-right"], [1, "recipient-topbar-inner"], [1, "recipient-head"], [1, "rec-avatar"], ["class", "avatar-pic", 3, "background-image", 4, "ngIf", "ngIfElse"], ["recipientHead_noAvt", ""], [4, "ngIf", "ngIfElse"], ["btnsWrap2_btn_svgIcon", ""], [1, "btn-lbl"], [1, "btn-icon", 3, "name"], [1, "btn-icon", 3, "src"], ["color", "base_main", "fill", "clear", 1, "tb-btn"], ["btnsWrap3_btn_svgIcon", ""], [1, "avatar-pic"], [1, "avatar-lbl"]], template: function TopBarComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵelementStart(3, "ion-button", 3);
        i0.ɵɵlistener("click", function TopBarComponent_Template_ion_button_click_3_listener() { return ctx.toggleSidebar(); });
        i0.ɵɵelementStart(4, "div", 4);
        i0.ɵɵelement(5, "ion-icon", 5);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(6, "div", 6);
        i0.ɵɵtemplate(7, TopBarComponent_ion_button_7_Template, 7, 6, "ion-button", 7);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(8, "div", 8);
        i0.ɵɵtemplate(9, TopBarComponent_ion_button_9_Template, 7, 3, "ion-button", 9);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(10, "div", 10);
        i0.ɵɵelementStart(11, "div", 11);
        i0.ɵɵelementStart(12, "div", 12);
        i0.ɵɵelementStart(13, "div", 13);
        i0.ɵɵtemplate(14, TopBarComponent_div_14_Template, 1, 2, "div", 14);
        i0.ɵɵtemplate(15, TopBarComponent_ng_template_15_Template, 2, 0, "ng-template", null, 15, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        const _r3 = i0.ɵɵreference(16);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("disabled", !ctx.sidebar_isEnabled);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngForOf", ctx.navButtons);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngForOf", ctx.menuButtons);
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("ngIf", false)("ngIfElse", _r3);
    } }, directives: [i1.IonButton, i1.IonIcon, i3.NgForOf, i3.NgIf], styles: [".component[_ngcontent-%COMP%]{background-color:var(--app-main-darker);display:flex}.component[_ngcontent-%COMP%]   .side.side-left[_ngcontent-%COMP%]{display:flex;flex:1;padding:6px 10px 6px 15px}.component[_ngcontent-%COMP%]   .side.side-left[_ngcontent-%COMP%]   .btns-wrap[_ngcontent-%COMP%]{align-items:center;display:flex}.component[_ngcontent-%COMP%]   .side.side-left[_ngcontent-%COMP%]   .btns-wrap.btns-wrap-1[_ngcontent-%COMP%]   .tb-btn[_ngcontent-%COMP%]{--border-radius:50%;--padding-end:0;--padding-start:0;height:auto;margin:0}.component[_ngcontent-%COMP%]   .side.side-left[_ngcontent-%COMP%]   .btns-wrap.btns-wrap-1[_ngcontent-%COMP%]   .tb-btn[_ngcontent-%COMP%]   .td-btn-inner[_ngcontent-%COMP%]{display:flex;padding:8px}.component[_ngcontent-%COMP%]   .side.side-left[_ngcontent-%COMP%]   .btns-wrap.btns-wrap-1[_ngcontent-%COMP%]   .tb-btn[_ngcontent-%COMP%]   .td-btn-inner[_ngcontent-%COMP%]   .btn-icon[_ngcontent-%COMP%]{font-size:30px}.component[_ngcontent-%COMP%]   .side.side-left[_ngcontent-%COMP%]   .btns-wrap.btns-wrap-2[_ngcontent-%COMP%]{flex:1;padding:0 15px}.component[_ngcontent-%COMP%]   .side.side-left[_ngcontent-%COMP%]   .btns-wrap.btns-wrap-2[_ngcontent-%COMP%]   .tb-btn[_ngcontent-%COMP%]{--border-radius:6px;--padding-end:0;--padding-start:0;border-radius:6px;height:auto;margin:0}.component[_ngcontent-%COMP%]   .side.side-left[_ngcontent-%COMP%]   .btns-wrap.btns-wrap-2[_ngcontent-%COMP%]   .tb-btn[_ngcontent-%COMP%]   .td-btn-inner[_ngcontent-%COMP%]{align-items:center;display:flex;flex-direction:column;padding:8px 12px 7px}.component[_ngcontent-%COMP%]   .side.side-left[_ngcontent-%COMP%]   .btns-wrap.btns-wrap-2[_ngcontent-%COMP%]   .tb-btn[_ngcontent-%COMP%]   .td-btn-inner[_ngcontent-%COMP%]   .btn-icon[_ngcontent-%COMP%]{font-size:28px}.component[_ngcontent-%COMP%]   .side.side-left[_ngcontent-%COMP%]   .btns-wrap.btns-wrap-2[_ngcontent-%COMP%]   .tb-btn[_ngcontent-%COMP%]   .td-btn-inner[_ngcontent-%COMP%]   .btn-lbl[_ngcontent-%COMP%]{font-size:12px;padding-top:9px}.component[_ngcontent-%COMP%]   .side.side-left[_ngcontent-%COMP%]   .btns-wrap.btns-wrap-2[_ngcontent-%COMP%]   .tb-btn[_ngcontent-%COMP%]:not(:last-child){margin-right:7px}.component[_ngcontent-%COMP%]   .side.side-left[_ngcontent-%COMP%]   .btns-wrap.btns-wrap-2[_ngcontent-%COMP%]   .tb-btn.selected[_ngcontent-%COMP%]{background-color:var(--app-main-strong)}.component[_ngcontent-%COMP%]   .side.side-left[_ngcontent-%COMP%]   .btns-wrap.btns-wrap-2[_ngcontent-%COMP%]   .tb-btn.selected[_ngcontent-%COMP%]   .td-btn-inner[_ngcontent-%COMP%]{cursor:auto}.component[_ngcontent-%COMP%]   .side.side-left[_ngcontent-%COMP%]   .btns-wrap.btns-wrap-3[_ngcontent-%COMP%]{border-left:2px solid var(--app-mid-light);padding-left:15px}.component[_ngcontent-%COMP%]   .side.side-left[_ngcontent-%COMP%]   .btns-wrap.btns-wrap-3[_ngcontent-%COMP%]   .tb-btn[_ngcontent-%COMP%]{--border-radius:6px;--padding-end:0;--padding-start:0;height:auto;margin:0}.component[_ngcontent-%COMP%]   .side.side-left[_ngcontent-%COMP%]   .btns-wrap.btns-wrap-3[_ngcontent-%COMP%]   .tb-btn[_ngcontent-%COMP%]   .td-btn-inner[_ngcontent-%COMP%]{align-items:center;display:flex;flex-direction:column;padding:8px 12px 7px}.component[_ngcontent-%COMP%]   .side.side-left[_ngcontent-%COMP%]   .btns-wrap.btns-wrap-3[_ngcontent-%COMP%]   .tb-btn[_ngcontent-%COMP%]   .td-btn-inner[_ngcontent-%COMP%]   .btn-icon[_ngcontent-%COMP%]{font-size:28px}.component[_ngcontent-%COMP%]   .side.side-left[_ngcontent-%COMP%]   .btns-wrap.btns-wrap-3[_ngcontent-%COMP%]   .tb-btn[_ngcontent-%COMP%]   .td-btn-inner[_ngcontent-%COMP%]   .btn-lbl[_ngcontent-%COMP%]{font-size:12px;padding-top:9px}.component[_ngcontent-%COMP%]   .side.side-left[_ngcontent-%COMP%]   .btns-wrap.btns-wrap-3[_ngcontent-%COMP%]   .tb-btn[_ngcontent-%COMP%]:not(:last-child){margin-right:7px}.component[_ngcontent-%COMP%]   .side.side-right[_ngcontent-%COMP%]   .recipient-topbar-inner[_ngcontent-%COMP%]{align-items:center;cursor:pointer;display:flex;min-height:100%;padding:8px 20px 8px 10px}.component[_ngcontent-%COMP%]   .side.side-right[_ngcontent-%COMP%]   .recipient-topbar-inner[_ngcontent-%COMP%]   .recipient-head[_ngcontent-%COMP%]   .rec-avatar[_ngcontent-%COMP%]{background-color:var(--app-main);border-radius:50%;display:flex;height:50px;overflow:hidden;width:50px}.component[_ngcontent-%COMP%]   .side.side-right[_ngcontent-%COMP%]   .recipient-topbar-inner[_ngcontent-%COMP%]   .recipient-head[_ngcontent-%COMP%]   .rec-avatar[_ngcontent-%COMP%]   .avatar-pic[_ngcontent-%COMP%]{background-position:50%;background-repeat:no-repeat;background-size:cover;width:100%}.component[_ngcontent-%COMP%]   .side.side-right[_ngcontent-%COMP%]   .recipient-topbar-inner[_ngcontent-%COMP%]   .recipient-head[_ngcontent-%COMP%]   .rec-avatar[_ngcontent-%COMP%]   .avatar-lbl[_ngcontent-%COMP%]{-moz-user-select:none;-ms-grid-row-align:center;-ms-user-select:none;-webkit-user-select:none;align-self:center;color:#fff;font-size:17px;font-weight:600;margin:0 8px;overflow:hidden;text-align:center;text-overflow:ellipsis;user-select:none;white-space:nowrap;width:100%}.component[_ngcontent-%COMP%]   .side.side-right[_ngcontent-%COMP%]   .recipient-topbar-inner[_ngcontent-%COMP%]   .recipient-head[_ngcontent-%COMP%]   .rec-avatar[_ngcontent-%COMP%]   .avatar-lbl.sm[_ngcontent-%COMP%]{font-size:14px;margin:0 5px}"], changeDetection: 0 });
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(TopBarComponent, [{
        type: Component,
        args: [{
                selector: 'common-top-bar',
                templateUrl: './top-bar.component.html',
                styleUrls: ['./top-bar.component.scss'],
                changeDetection: ChangeDetectionStrategy.OnPush
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: ViewService }]; }, { menuButtons: [{
            type: Input
        }], navButtons: [{
            type: Input
        }], sidebar_isEnabled: [{
            type: Input
        }], navCtrl: [{
            type: Input
        }] }); })();

class SearchPipe {
    transform(items, fields, query, changed, different) {
        let filtered = items;
        if (query) {
            if (fields.length > 0) {
                let searchTarget;
                let props;
                let itemProp;
                filtered = items.filter(item => {
                    searchTarget = "";
                    fields.forEach((field) => {
                        props = field.split(".");
                        itemProp = item;
                        for (let prop of props) {
                            if (itemProp[prop] || itemProp[prop] == 0) {
                                itemProp = itemProp[prop];
                            }
                            else {
                                itemProp = "";
                                break;
                            }
                        }
                        searchTarget += itemProp + " ";
                    });
                    if (!different) {
                        return searchTarget.toUpperCase().indexOf(query.toUpperCase()) !== -1;
                    }
                    else {
                        return searchTarget.toUpperCase().indexOf(query.toUpperCase()) === -1;
                    }
                });
            }
            else {
                filtered = items.filter(item => item.includes(query));
            }
        }
        return filtered;
    }
}
SearchPipe.ɵfac = function SearchPipe_Factory(t) { return new (t || SearchPipe)(); };
SearchPipe.ɵpipe = i0.ɵɵdefinePipe({ name: "search", type: SearchPipe, pure: true });
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(SearchPipe, [{
        type: Pipe,
        args: [{
                name: 'search'
            }]
    }], null, null); })();

class DurationPipe {
    transform(seconds, type, label_day, label_days, label_hours, label_min, label_seconds, changed) {
        seconds = parseInt((seconds / 1000).toString());
        if (type === 'delta g h m') {
            seconds = parseInt("" + (Date.now() / 1000)) - seconds;
            if (!seconds || seconds === 0)
                return "0 s  ";
            let m = parseInt("" + (seconds / 60));
            let h = parseInt("" + (m / 60));
            m = m - (h * 60);
            let g = parseInt("" + (h / 24));
            h = h - (g * 24);
            let result = "";
            if (m > 0) {
                result = m + " " + (label_min || "m") + "  " + result;
            }
            if (h > 0) {
                result = h + " " + (label_hours || "h") + "  " + result;
            }
            if (g > 0) {
                result = g + " " + (label_day || "d") + "  " + result;
            }
            if (!result) {
                result = seconds + " s";
            }
            return result;
        }
        else if ('g h m || m s') {
            if (!seconds || seconds === 0)
                return "0 s";
            let s = seconds;
            let m = parseInt("" + (seconds / 60));
            s = s - (m * 60);
            let h = parseInt("" + (m / 60));
            m = m - (h * 60);
            let g = parseInt("" + (h / 24));
            h = h - (g * 24);
            let result = "";
            if (g > 0 || h > 0) {
                if (m > 0) {
                    result = m + " " + (label_min || "m") + "  " + result;
                }
                if (h > 0) {
                    result = h + " " + (label_hours || "h") + "  " + result;
                }
                if (g > 0) {
                    result = g + " " + (label_day || "d") + "  " + result;
                }
            }
            else {
                if (s > 0) {
                    result = s + " " + (label_seconds || "s") + "  " + result;
                }
                if (m > 0) {
                    result = m + " " + (label_min || "m") + "  " + result;
                }
            }
            return result;
        }
        else if (type == 'g min s') {
            if (!seconds || seconds === 0)
                return "0 s  ";
            let m = parseInt("" + (seconds / 60));
            let s = seconds - (m * 60);
            let h = parseInt("" + (m / 60));
            m = m - (h * 60);
            let g = parseInt("" + (h / 24));
            h = h - (g * 24);
            let result = "";
            if (s > 0) {
                result += s + " " + (label_seconds || "s") + "  ";
            }
            if (m > 0) {
                result = m + " " + (label_min || "m") + "  " + result;
            }
            if (h > 0) {
                result = h + " " + (label_hours || "h") + "  " + result;
            }
            if (g > 0) {
                result = g + " " + (label_days || "d") + "  " + result;
            }
            return result;
        }
        else if (type == 'min s') {
            if (!seconds || seconds === 0)
                return "0 s";
            let m = parseInt("" + (seconds / 60));
            let s = seconds - (m * 60);
            let h = parseInt("" + (m / 60));
            m = m - (h * 60);
            let g = parseInt("" + (h / 24));
            h = h - (g * 24);
            let result = "";
            if (s > 0) {
                result += s + " " + (label_seconds || "s");
            }
            if (m > 0) {
                result = m + " " + (label_min || "min") + " " + result;
            }
            if (h > 0) {
                result = h + " " + (label_hours || "h") + " " + result;
            }
            if (g > 0) {
                result = g + " " + (label_days || "d") + " " + result;
            }
            return result;
        }
        else if (type == 'g hh:mm:ss') {
            if (!seconds || seconds === 0)
                return "00:00:00";
            let m = parseInt("" + (seconds / 60));
            let s = seconds - (m * 60);
            let h = parseInt("" + (m / 60));
            m = m - (h * 60);
            let g = parseInt("" + (h / 24));
            h = h - (g * 24);
            let result = "";
            if (g > 0) {
                if (g > 1) {
                    result += g + " " + (label_days || "d") + " ";
                }
                else {
                    result += g + " " + (label_day || "d") + " ";
                }
            }
            if (h > 0) {
                if (h > 9) {
                    result += h + ":";
                }
                else {
                    result += "0" + h + ":";
                }
            }
            else {
                result += "00:";
            }
            if (m > 0) {
                if (m > 9) {
                    result += m + ":";
                }
                else {
                    result += "0" + m + ":";
                }
            }
            else {
                result += "00:";
            }
            if (s > 0) {
                if (s > 9) {
                    result += s;
                }
                else {
                    result += "0" + s;
                }
            }
            else {
                result += "00";
            }
            return result;
        }
        else {
            if (!seconds)
                return "00:00";
            let min = Math.floor(seconds / 60);
            let result = "";
            result = "" + min;
            if (min < 10) {
                result = "0" + min;
            }
            result += ":";
            let s = seconds - (min * 60);
            if (s < 10) {
                result += "0" + s;
            }
            else {
                result += s;
            }
            return result;
        }
    }
}
DurationPipe.ɵfac = function DurationPipe_Factory(t) { return new (t || DurationPipe)(); };
DurationPipe.ɵpipe = i0.ɵɵdefinePipe({ name: "duration", type: DurationPipe, pure: true });
DurationPipe.ɵprov = i0.ɵɵdefineInjectable({ token: DurationPipe, factory: DurationPipe.ɵfac });
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(DurationPipe, [{
        type: Pipe,
        args: [{
                name: 'duration'
            }]
    }, {
        type: Injectable
    }], null, null); })();

class WeekDaysPipe {
    transform(days, lang) {
        let res = "";
        if (!days || days.length < 7) {
            return res;
        }
        let count = 0;
        if (days[0]) {
            res += lang.dom + ", ";
            count++;
        }
        if (days[1]) {
            res += lang.lun + ", ";
            count++;
        }
        if (days[2]) {
            res += lang.mar + ", ";
            count++;
        }
        if (days[3]) {
            res += lang.mer + ", ";
            count++;
        }
        if (days[4]) {
            res += lang.gio + ", ";
            count++;
        }
        if (days[5]) {
            res += lang.ven + ", ";
            count++;
        }
        if (days[6]) {
            res += lang.sab + ", ";
            count++;
        }
        if (res) {
            res = res.substr(0, res.length - 2);
        }
        if (count === 7)
            return lang.tutti;
        return res;
    }
}
WeekDaysPipe.ɵfac = function WeekDaysPipe_Factory(t) { return new (t || WeekDaysPipe)(); };
WeekDaysPipe.ɵpipe = i0.ɵɵdefinePipe({ name: "weekDays", type: WeekDaysPipe, pure: true });
WeekDaysPipe.ɵprov = i0.ɵɵdefineInjectable({ token: WeekDaysPipe, factory: WeekDaysPipe.ɵfac });
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(WeekDaysPipe, [{
        type: Pipe,
        args: [{
                name: 'weekDays'
            }]
    }, {
        type: Injectable
    }], null, null); })();

class SortAlphabeticallyPipe {
    transform(list, fields, crescent, changed, disabled) {
        if (disabled)
            return list;
        if (!list)
            return list;
        let no_null_list = [];
        let null_list = [];
        for (let x = 0; x < list.length; x++) {
            let current = null;
            for (let i = 0; i < fields.length; i++) {
                let fieldList = fields[i].split(".");
                let aus_a = list[x];
                for (let j = 0; j < fieldList.length; j++) {
                    if (aus_a.hasOwnProperty(fieldList[j])) {
                        aus_a = aus_a[fieldList[j]];
                    }
                    else {
                        aus_a = null;
                        break;
                    }
                }
                if (aus_a) {
                    current += aus_a;
                }
            }
            if (current) {
                list[x].compareQuery = current.toLowerCase();
                no_null_list.push(list[x]);
            }
            else {
                null_list.push(list[x]);
            }
        }
        no_null_list.sort((a, b) => {
            if (a.compareQuery > b.compareQuery) {
                return crescent ? 1 : -1;
            }
            if (a.compareQuery < b.compareQuery) {
                return crescent ? -1 : 1;
            }
            return 0;
        });
        return no_null_list.concat(null_list);
    }
}
SortAlphabeticallyPipe.ɵfac = function SortAlphabeticallyPipe_Factory(t) { return new (t || SortAlphabeticallyPipe)(); };
SortAlphabeticallyPipe.ɵpipe = i0.ɵɵdefinePipe({ name: "sortAlphabetically", type: SortAlphabeticallyPipe, pure: true });
SortAlphabeticallyPipe.ɵprov = i0.ɵɵdefineInjectable({ token: SortAlphabeticallyPipe, factory: SortAlphabeticallyPipe.ɵfac });
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(SortAlphabeticallyPipe, [{
        type: Pipe,
        args: [{
                name: 'sortAlphabetically'
            }]
    }, {
        type: Injectable
    }], null, null); })();

class EmailListPipe {
    transform(emails, limit, noElementsLabel) {
        let res = ``;
        if (!emails || !limit || emails.length <= 0)
            return noElementsLabel || "";
        for (let i = 0; i < emails.length; i++) {
            let email = emails[i];
            if (i < limit) {
                res += email + `<br>`;
            }
            else {
                res += `<label class="text-muted"> + ${emails.length - limit} </label>`;
                break;
            }
        }
        return res;
    }
}
EmailListPipe.ɵfac = function EmailListPipe_Factory(t) { return new (t || EmailListPipe)(); };
EmailListPipe.ɵpipe = i0.ɵɵdefinePipe({ name: "emailList", type: EmailListPipe, pure: true });
EmailListPipe.ɵprov = i0.ɵɵdefineInjectable({ token: EmailListPipe, factory: EmailListPipe.ɵfac });
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(EmailListPipe, [{
        type: Pipe,
        args: [{
                name: 'emailList'
            }]
    }, {
        type: Injectable
    }], null, null); })();

class ParticipantListPipe {
    transform(idList, limit, organization, noElementsLabel, meLabel) {
        let res = ``;
        if (!idList || !limit || idList.length <= 0)
            return noElementsLabel || "";
        for (let i = 0; i < idList.length; i++) {
            if (i < limit) {
                if (meLabel && idList[i] === organization.me._id) {
                    res = (meLabel) + `<br>` + res;
                }
                else {
                    let p = organization.getParticipant(idList[i]);
                    if (p) {
                        res += (p.name || p.email) + `<br>`;
                    }
                    else {
                        limit++;
                    }
                }
            }
            else {
                res += `<label class="text-muted">+ ${idList.length - limit}</label>`;
                break;
            }
        }
        return res;
    }
}
ParticipantListPipe.ɵfac = function ParticipantListPipe_Factory(t) { return new (t || ParticipantListPipe)(); };
ParticipantListPipe.ɵpipe = i0.ɵɵdefinePipe({ name: "participantList", type: ParticipantListPipe, pure: true });
ParticipantListPipe.ɵprov = i0.ɵɵdefineInjectable({ token: ParticipantListPipe, factory: ParticipantListPipe.ɵfac });
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(ParticipantListPipe, [{
        type: Pipe,
        args: [{
                name: 'participantList'
            }]
    }, {
        type: Injectable
    }], null, null); })();

class SortPipe {
    transform(array, field, isDescending, changed) {
        // console.log(field);
        if (!array || array.length <= 0 || !field)
            return array;
        return array.sort((a, b) => {
            let x, y, compareRes;
            if (a[field] !== 0 && !a[field]) {
                a[field] = "";
            }
            if (b[field] !== 0 && !b[field]) {
                b[field] = "";
            }
            x = ("" + a[field]).toLowerCase();
            if (typeof a[field] === "number") {
                x = a[field];
            }
            y = ("" + b[field]).toLowerCase();
            if (typeof b[field] === "number") {
                y = b[field];
            }
            if (x < y) {
                compareRes = -1;
            }
            if (x > y) {
                compareRes = 1;
            }
            if (isDescending) {
                compareRes = -compareRes;
            }
            if (!compareRes) {
                compareRes = 0;
            }
            return compareRes;
        });
    }
}
SortPipe.ɵfac = function SortPipe_Factory(t) { return new (t || SortPipe)(); };
SortPipe.ɵpipe = i0.ɵɵdefinePipe({ name: "sort", type: SortPipe, pure: true });
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(SortPipe, [{
        type: Pipe,
        args: [{
                name: 'sort',
            }]
    }], null, null); })();

class DecimalNumberPipe {
    transform(num, decimals, no_number) {
        if (!num)
            return no_number;
        let num_string = num.toString();
        let result;
        let splitted = num_string.split(".");
        if (decimals <= 0)
            return splitted[0];
        if (splitted.length == 2) {
            if (splitted[1].length >= decimals) {
                result = splitted[0] + "," + splitted[1].substring(0, decimals);
            }
            else {
                result = splitted[0] + "," + splitted[1];
                for (let i = (splitted[1].length); i < decimals; i++) {
                    result += "0";
                }
            }
        }
        else {
            result = splitted[0] + ",";
            for (let i = 0; i < decimals; i++) {
                result += "0";
            }
        }
        return result;
    }
}
DecimalNumberPipe.ɵfac = function DecimalNumberPipe_Factory(t) { return new (t || DecimalNumberPipe)(); };
DecimalNumberPipe.ɵpipe = i0.ɵɵdefinePipe({ name: "decimalNumber", type: DecimalNumberPipe, pure: true });
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(DecimalNumberPipe, [{
        type: Pipe,
        args: [{
                name: 'decimalNumber',
            }]
    }], null, null); })();

class PoiListPipe {
    transform(pois, limit, othersLabel, noElementsLabel, changed, type) {
        let res;
        switch (type) {
            case "reportMobile":
                res = ``;
                if (!pois || !limit || pois.length <= 0)
                    return noElementsLabel || "";
                for (let i = 0; i < pois.length; i++) {
                    let poi = pois[i].name;
                    if (i < limit) {
                        res +=
                            `<div class="ovp-li ovp-li--poi">
                ${poi}
              </div>`;
                    }
                    else {
                        if (othersLabel) {
                            res +=
                                `<a class="ovp-li">
                  ${othersLabel}
                </a>`;
                        }
                        else {
                            res +=
                                `<a class="ovp-li">
                  ...
                </a>`;
                        }
                        break;
                    }
                }
                break;
            default:
                res = ``;
                if (!pois || !limit || pois.length <= 0)
                    return noElementsLabel || "";
                for (let i = 0; i < pois.length; i++) {
                    let poi = pois[i].name;
                    if (i < limit) {
                        res += poi + `<br>`;
                    }
                    else {
                        if (othersLabel) {
                            res += `<a>` + othersLabel + `</a>`;
                        }
                        else {
                            res += `<a>...</a>`;
                        }
                        break;
                    }
                }
        }
        return res;
    }
}
PoiListPipe.ɵfac = function PoiListPipe_Factory(t) { return new (t || PoiListPipe)(); };
PoiListPipe.ɵpipe = i0.ɵɵdefinePipe({ name: "poiList", type: PoiListPipe, pure: true });
PoiListPipe.ɵprov = i0.ɵɵdefineInjectable({ token: PoiListPipe, factory: PoiListPipe.ɵfac });
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(PoiListPipe, [{
        type: Pipe,
        args: [{
                name: 'poiList'
            }]
    }, {
        type: Injectable
    }], null, null); })();

class DeltaTimePipe {
    transform(ms, format, from_now, lang, css_class, changed) {
        if (from_now)
            ms = Date.now() - ms;
        const seconds = parseInt((ms / 1000).toString());
        if (!lang) {
            lang = {};
        }
        const default_lang = {
            label_seconds: 's',
            label_min: 'min',
            label_hours: 'h',
            label_day: 'd',
        };
        let s = seconds;
        let m = parseInt("" + (seconds / 60));
        s = s - (m * 60);
        let h = parseInt("" + (m / 60));
        m = m - (h * 60);
        let g = parseInt("" + (h / 24));
        h = h - (g * 24);
        let result = "";
        switch (format) {
            case 'html d m s || m s':
                if (g > 0 || h > 0) {
                    if (m > 0) {
                        result = `${m}<label class="${css_class}">${(lang.label_min || default_lang.label_min)}</label>${result}`;
                    }
                    if (h > 0) {
                        result = `${h}<label class="${css_class}">${(lang.label_hours || default_lang.label_hours)}</label>${result}`;
                    }
                    if (g > 0) {
                        result = `${g}<label class="${css_class}">${(lang.label_day || default_lang.label_day)}</label>${result}`;
                    }
                }
                else {
                    if (s > 0) {
                        result = `${s}<label class="${css_class}">${(lang.label_seconds || default_lang.label_seconds)}</label>${result}`;
                    }
                    if (m > 0) {
                        result = `${m}<label class="${css_class}">${(lang.label_min || default_lang.label_min)}</label>${result}`;
                    }
                }
                break;
            case 'd m s || m s':
                if (g > 0 || h > 0) {
                    if (m > 0) {
                        result = `${m} ${(lang.label_min || default_lang.label_min)} ${result}`;
                    }
                    if (h > 0) {
                        result = `${h} ${(lang.label_hours || default_lang.label_hours)} ${result}`;
                    }
                    if (g > 0) {
                        result = `${g} ${(lang.label_day || default_lang.label_day)} ${result}`;
                    }
                }
                else {
                    if (s > 0) {
                        result = `${s} ${(lang.label_seconds || default_lang.label_seconds)} ${result}`;
                    }
                    if (m > 0) {
                        result = `${m} ${(lang.label_min || default_lang.label_min)} ${result}`;
                    }
                }
                break;
            case 'html d h m s':
                if (s > 0) {
                    result = `${s}<label class="${css_class}">${(lang.label_seconds || default_lang.label_seconds)}</label>${result}`;
                }
                if (m > 0 || h > 0) {
                    result = `${m}<label class="${css_class}">${(lang.label_min || default_lang.label_min)}</label>${result}`;
                }
                if (h > 0 || g > 0) {
                    result = `${h}<label class="${css_class}">${(lang.label_hours || default_lang.label_hours)}</label>${result}`;
                }
                if (g > 0) {
                    result = `${g}<label class="${css_class}">${(lang.label_day || default_lang.label_day)}</label>${result}`;
                }
                break;
            case 'd h m s':
                if (s > 0) {
                    result = `${s} ${(lang.label_seconds || default_lang.label_seconds)} ${result}`;
                }
                if (m > 0 || h > 0) {
                    result = `${m} ${(lang.label_min || default_lang.label_min)} ${result}`;
                }
                if (h > 0 || g > 0) {
                    result = `${h} ${(lang.label_hours || default_lang.label_hours)} ${result}`;
                }
                if (g > 0) {
                    result = `${g} ${(lang.label_day || default_lang.label_day)} ${result}`;
                }
                break;
            case 'html d h m || s':
                if (m > 0) {
                    result = `${m}<label class="${css_class}">${(lang.label_min || default_lang.label_min)}</label>${result}`;
                }
                if (h > 0) {
                    result = `${h}<label class="${css_class}">${(lang.label_hours || default_lang.label_hours)}</label>${result}`;
                }
                if (g > 0) {
                    result = `${g}<label class="${css_class}">${(lang.label_day || default_lang.label_day)}</label>${result}`;
                }
                if (!result) {
                    result = `${s}<label class="${css_class}">${(lang.label_seconds || default_lang.label_seconds)}</label>${result}`;
                }
                break;
            case 'd h m || s':
                if (m > 0) {
                    result = `${m} ${(lang.label_min || default_lang.label_min)} ${result}`;
                }
                if (h > 0) {
                    result = `${h} ${(lang.label_hours || default_lang.label_hours)} ${result}`;
                }
                if (g > 0) {
                    result = `${g} ${(lang.label_day || default_lang.label_day)} ${result}`;
                }
                if (!result) {
                    result = `${s} ${(lang.label_seconds || default_lang.label_seconds)} ${result}`;
                }
                break;
        }
        return result;
    }
}
DeltaTimePipe.ɵfac = function DeltaTimePipe_Factory(t) { return new (t || DeltaTimePipe)(); };
DeltaTimePipe.ɵpipe = i0.ɵɵdefinePipe({ name: "deltaTime", type: DeltaTimePipe, pure: true });
DeltaTimePipe.ɵprov = i0.ɵɵdefineInjectable({ token: DeltaTimePipe, factory: DeltaTimePipe.ɵfac });
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(DeltaTimePipe, [{
        type: Pipe,
        args: [{
                name: 'deltaTime'
            }]
    }, {
        type: Injectable
    }], null, null); })();

function ChipbarComponent_ion_button_1_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ion-button", 5);
    i0.ɵɵlistener("click", function ChipbarComponent_ion_button_1_Template_ion_button_click_0_listener() { i0.ɵɵrestoreView(_r4); const ctx_r3 = i0.ɵɵnextContext(); return ctx_r3.scrollChipbar(true); });
    i0.ɵɵelement(1, "ion-icon", 6);
    i0.ɵɵelementEnd();
} }
function ChipbarComponent_div_3_ion_icon_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ion-icon", 11);
} if (rf & 2) {
    const item_r5 = i0.ɵɵnextContext().$implicit;
    const ctx_r6 = i0.ɵɵnextContext();
    i0.ɵɵproperty("name", item_r5[ctx_r6.chipPropNames.icon]);
} }
function ChipbarComponent_div_3_label_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "label", 12);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r5 = i0.ɵɵnextContext().$implicit;
    const ctx_r7 = i0.ɵɵnextContext();
    i0.ɵɵstyleProp("color", item_r5[ctx_r7.chipPropNames.selected] ? item_r5.main_color : item_r5.sub_color)("background-color", item_r5[ctx_r7.chipPropNames.selected] ? item_r5.sub_color : item_r5.main_color);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(item_r5.counter);
} }
function ChipbarComponent_div_3_label_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "label", 13);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r5 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵstyleProp("color", "#FFFFFF")("background-color", "#ff0000");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(item_r5.counter_secondary);
} }
const _c0$1 = function (a0, a1) { return { "chip--selected": a0, "different": a1 }; };
function ChipbarComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r13 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 7);
    i0.ɵɵlistener("click", function ChipbarComponent_div_3_Template_div_click_0_listener() { i0.ɵɵrestoreView(_r13); const item_r5 = ctx.$implicit; const ctx_r12 = i0.ɵɵnextContext(); return ctx_r12.chipSelectFunc(item_r5); });
    i0.ɵɵtemplate(1, ChipbarComponent_div_3_ion_icon_1_Template, 1, 1, "ion-icon", 8);
    i0.ɵɵtemplate(2, ChipbarComponent_div_3_label_2_Template, 2, 5, "label", 9);
    i0.ɵɵtext(3);
    i0.ɵɵtemplate(4, ChipbarComponent_div_3_label_4_Template, 2, 5, "label", 10);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r5 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵstyleProp("color", item_r5[ctx_r1.chipPropNames.selected] ? item_r5.sub_color : item_r5.main_color)("border-color", item_r5.main_color)("background-color", item_r5[ctx_r1.chipPropNames.selected] ? item_r5.main_color : "unset");
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(11, _c0$1, item_r5[ctx_r1.chipPropNames.selected], item_r5.different));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", item_r5[ctx_r1.chipPropNames.icon]);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", item_r5.counter);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", item_r5[ctx_r1.chipPropNames.lbl], " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", item_r5.counter_secondary);
} }
function ChipbarComponent_ion_button_5_Template(rf, ctx) { if (rf & 1) {
    const _r15 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ion-button", 5);
    i0.ɵɵlistener("click", function ChipbarComponent_ion_button_5_Template_ion_button_click_0_listener() { i0.ɵɵrestoreView(_r15); const ctx_r14 = i0.ɵɵnextContext(); return ctx_r14.scrollChipbar(); });
    i0.ɵɵelement(1, "ion-icon", 14);
    i0.ɵɵelementEnd();
} }
class ChipbarComponent {
    constructor(cd, view) {
        this.cd = cd;
        this.view = view;
        this.chips = [];
        this.chipPropNames = {
            lbl: "lbl",
            icon: "icon",
            selected: "selected",
        };
        this.chipSelect = new EventEmitter();
        this.listener = {
            view: null
        };
    }
    ngOnInit() {
        this.listenerView();
        this.getDOMelements();
    }
    ngOnDestroy() {
        if (this.listener.view) {
            this.listener.view.unsubscribe();
        }
    }
    // misc
    chipSelectFunc(chip) {
        const { selected } = this.chipPropNames;
        // WHOLE selection process can be done WAY better
        if (this.multiSelect) {
            chip[selected] = !chip[selected];
        }
        else {
            if (chip[selected]) {
                chip[selected] = false;
                this.chips[0][selected] = true;
            }
            else {
                this.chips.forEach((chip) => chip[selected] = false);
                chip[selected] = true;
            }
        }
        ViewService.updateView.next();
        this.chipSelect.emit(chip);
    }
    getDOMelements() {
        this.chipbar = document.getElementById("chipbar");
    }
    scrollChipbar(toLeft) {
        if (toLeft) {
            this.chipbar.scrollLeft -= 350;
            // this.chipbar2.scrollLeft -= 350;
        }
        else {
            this.chipbar.scrollLeft += 350;
            // this.chipbar2.scrollLeft += 350;
        }
        // View.updateView.next();
    }
    // listener
    listenerView() {
        this.listener.view = ViewService.updateView$.subscribe((obj) => {
            this.view.pipeChanged++;
            this.cd.markForCheck();
        });
    }
}
ChipbarComponent.ɵfac = function ChipbarComponent_Factory(t) { return new (t || ChipbarComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(ViewService)); };
ChipbarComponent.ɵcmp = i0.ɵɵdefineComponent({ type: ChipbarComponent, selectors: [["app-chipbar"]], inputs: { chips: "chips", singleRow: "singleRow", chipPropNames: "chipPropNames", multiSelect: "multiSelect", showArrows: "showArrows", update: "update" }, outputs: { chipSelect: "chipSelect" }, decls: 6, vars: 5, consts: [[1, "chips"], ["class", "scroller-btn", "color", "main_base", "fill", "clear", 3, "click", 4, "ngIf"], ["id", "chipbar", 1, "chips-scrollable"], ["class", "chip", 3, "ngClass", "color", "borderColor", "background-color", "click", 4, "ngFor", "ngForOf"], [1, "chips-scrollable-end"], ["color", "main_base", "fill", "clear", 1, "scroller-btn", 3, "click"], ["name", "chevron-back", 1, "btn-icon"], [1, "chip", 3, "ngClass", "click"], [3, "name", 4, "ngIf"], ["class", "counter", 3, "color", "background-color", 4, "ngIf"], ["class", "counter-secondary", 3, "color", "background-color", 4, "ngIf"], [3, "name"], [1, "counter"], [1, "counter-secondary"], ["name", "chevron-forward", 1, "btn-icon"]], template: function ChipbarComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵtemplate(1, ChipbarComponent_ion_button_1_Template, 2, 0, "ion-button", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵtemplate(3, ChipbarComponent_div_3_Template, 5, 14, "div", 3);
        i0.ɵɵelement(4, "div", 4);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(5, ChipbarComponent_ion_button_5_Template, 2, 0, "ion-button", 1);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵclassProp("multi-line", ctx.singleRow);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.showArrows);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngForOf", ctx.chips);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.showArrows);
    } }, directives: [i3.NgIf, i3.NgForOf, i1.IonButton, i1.IonIcon, i3.NgClass], styles: [".chip[_ngcontent-%COMP%]{border:1px solid var(--main-color,#0455bf);border-radius:99px;color:var(--main-color,#0455bf);cursor:pointer;font-size:var(--chip-font-size,12px);padding:var(--chip-padding-y,3px) var(--chip-padding-x,15px);white-space:nowrap;z-index:100}.chip[_ngcontent-%COMP%]:hover{opacity:.85}.chip.chip--selected[_ngcontent-%COMP%]{background-color:var(--main-color,#0455bf);border-color:var(--main-color,#0455bf);color:var(--selected-color,#fff)}.chip.different[_ngcontent-%COMP%]{border:1px solid var(--main-color,#ff7e24);color:var(--main-color,#ff7e24)}.chip.different.chip--selected[_ngcontent-%COMP%]{background-color:var(--main-color,#ff7e24);border-color:var(--main-color,#ff7e24);color:var(--selected-color,#fff)}.chip[_ngcontent-%COMP%]   .counter[_ngcontent-%COMP%]{margin-left:-10px}.chip[_ngcontent-%COMP%]   .counter[_ngcontent-%COMP%], .chip[_ngcontent-%COMP%]   .counter-secondary[_ngcontent-%COMP%]{background-color:#fff;border-radius:10px;font-weight:700;height:19px;margin-bottom:0;min-width:20px;opacity:.7;padding:2px;text-align:center}.chips[_ngcontent-%COMP%]{align-items:center;display:flex;overflow:hidden;padding:var(--chips-padding-y,5px) var(--chips-padding-x,7px)}.chips[_ngcontent-%COMP%]   .chips-scrollable[_ngcontent-%COMP%]{-moz-column-gap:5px;column-gap:5px;display:-ms-grid;display:grid;grid-auto-flow:column;justify-items:start;margin:0 5px -100px;max-width:var(--chipsbar-max-width,unset);overflow-x:auto;padding-bottom:100px;scroll-behavior:smooth;scrollbar-width:none}.chips[_ngcontent-%COMP%]   .chips-scrollable[_ngcontent-%COMP%]::-webkit-scrollbar{display:none}.chips[_ngcontent-%COMP%]   .chips-scrollable[_ngcontent-%COMP%]   .chips-scrollable-end[_ngcontent-%COMP%]{width:1px}.chips.multi-line[_ngcontent-%COMP%], .chips.multi-line[_ngcontent-%COMP%]   .chips-scrollable[_ngcontent-%COMP%]{display:block}.chips.multi-line[_ngcontent-%COMP%]   .chips-scrollable[_ngcontent-%COMP%]   .chip[_ngcontent-%COMP%]{display:inline-block;margin:4px 3px}.chips[_ngcontent-%COMP%]   .scroller-btn[_ngcontent-%COMP%]{--border-radius:50%;--padding-bottom:0;--padding-end:0;--padding-start:0;--padding-top:0;height:auto;margin:0}.chips[_ngcontent-%COMP%]   .scroller-btn[_ngcontent-%COMP%]   .btn-icon[_ngcontent-%COMP%]{font-size:14px;margin:5px}"], changeDetection: 0 });
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(ChipbarComponent, [{
        type: Component,
        args: [{
                selector: 'app-chipbar',
                templateUrl: './chipbar.component.html',
                styleUrls: ['./chipbar.component.scss'],
                changeDetection: ChangeDetectionStrategy.OnPush
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: ViewService }]; }, { chips: [{
            type: Input
        }], singleRow: [{
            type: Input
        }], chipPropNames: [{
            type: Input
        }], multiSelect: [{
            type: Input
        }], showArrows: [{
            type: Input
        }], update: [{
            type: Input
        }], chipSelect: [{
            type: Output
        }] }); })();

function AvatarItemComponent_img_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "img", 13);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("src", ctx_r0.avatar, i0.ɵɵsanitizeUrl);
} }
function AvatarItemComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 14);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.avatarText, " ");
} }
function AvatarItemComponent_div_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 15);
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("innerHTML", ctx_r2.firstRow, i0.ɵɵsanitizeHtml);
} }
function AvatarItemComponent_div_10_ion_icon_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ion-icon", 19);
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("src", ctx_r4.secondRowIcon);
} }
function AvatarItemComponent_div_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 16);
    i0.ɵɵtemplate(1, AvatarItemComponent_div_10_ion_icon_1_Template, 1, 1, "ion-icon", 17);
    i0.ɵɵelement(2, "label", 18);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r3.secondRowIcon);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("innerHTML", ctx_r3.secondRow, i0.ɵɵsanitizeHtml);
} }
const _c0 = function (a0, a1) { return { "not-visible-on-map": a0, "selected texts-light": a1 }; };
/**
 * Questo componente è stato creato inizialmente per la lista di elementi in mappa di balin.app
 * e sostituisce il componente app-item con layout: car+star e poi+star
 * E' composto da:
 *  - avatar con bordo di stato e label interno;
 *  - titolo
 *  - prima riga
 *  - seconda riga
 *  - icona di destra
 */
class AvatarItemComponent {
    constructor() {
        this.select = new EventEmitter(); // evento al click sulla parte principale dell'emento
        this.rightIconSelect = new EventEmitter(); // evento al click sull'icona di dx
    }
    ngOnInit() {
    }
}
AvatarItemComponent.ɵfac = function AvatarItemComponent_Factory(t) { return new (t || AvatarItemComponent)(); };
AvatarItemComponent.ɵcmp = i0.ɵɵdefineComponent({ type: AvatarItemComponent, selectors: [["avatar-item"]], inputs: { selected: "selected", rightIconName: "rightIconName", rightIconSelectedName: "rightIconSelectedName", rightIconSelected: "rightIconSelected", avatar: "avatar", avatarCss: "avatarCss", avatarText: "avatarText", title: "title", firstRow: "firstRow", secondRow: "secondRow", secondRowIcon: "secondRowIcon", viewDisabled: "viewDisabled" }, outputs: { select: "select", rightIconSelect: "rightIconSelect" }, decls: 14, vars: 11, consts: [[1, "compt", 3, "ngClass"], [1, "car-inner-wrap"], [1, "car-inner", 3, "click"], [1, "car-avt", "w-status", 3, "ngClass"], ["class", "avt-pic", 3, "src", 4, "ngIf"], ["class", "avt-lbl", 4, "ngIf"], [1, "car-fields"], [1, "cb-row", "cb-name"], ["class", "cb-row cb-status-lbl", 3, "innerHTML", 4, "ngIf"], ["class", "cb-row cb-status-lbl fz10", 4, "ngIf"], [1, "pane-action-btns", 3, "click"], ["fill", "clear", 1, "pane-action-btn"], [1, "icon-star", 3, "name"], [1, "avt-pic", 3, "src"], [1, "avt-lbl"], [1, "cb-row", "cb-status-lbl", 3, "innerHTML"], [1, "cb-row", "cb-status-lbl", "fz10"], ["class", "csl-icon", 3, "src", 4, "ngIf"], [3, "innerHTML"], [1, "csl-icon", 3, "src"]], template: function AvatarItemComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵlistener("click", function AvatarItemComponent_Template_div_click_2_listener() { return ctx.select.emit(); });
        i0.ɵɵelementStart(3, "div", 3);
        i0.ɵɵtemplate(4, AvatarItemComponent_img_4_Template, 1, 1, "img", 4);
        i0.ɵɵtemplate(5, AvatarItemComponent_div_5_Template, 2, 1, "div", 5);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(6, "div", 6);
        i0.ɵɵelementStart(7, "div", 7);
        i0.ɵɵtext(8);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(9, AvatarItemComponent_div_9_Template, 1, 1, "div", 8);
        i0.ɵɵtemplate(10, AvatarItemComponent_div_10_Template, 3, 2, "div", 9);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(11, "div", 10);
        i0.ɵɵlistener("click", function AvatarItemComponent_Template_div_click_11_listener() { return ctx.rightIconSelect.emit(); });
        i0.ɵɵelementStart(12, "ion-button", 11);
        i0.ɵɵelement(13, "ion-icon", 12);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(8, _c0, ctx.viewDisabled, ctx.selected));
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngClass", ctx.avatarCss);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.avatar);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.avatar);
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate1(" ", ctx.title, " ");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.firstRow);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.secondRow);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("name", ctx.rightIconSelected ? ctx.rightIconSelectedName : ctx.rightIconName);
    } }, directives: [i3.NgClass, i3.NgIf, i1.IonButton, i1.IonIcon], styles: [".compt[_ngcontent-%COMP%]   .car-inner-wrap[_ngcontent-%COMP%]   .car-inner[_ngcontent-%COMP%]   .car-fields[_ngcontent-%COMP%]   .cb-row[_ngcontent-%COMP%]{overflow-x:hidden;text-overflow:ellipsis;white-space:nowrap}.compt.not-visible-on-map[_ngcontent-%COMP%]   .car-inner[_ngcontent-%COMP%]{opacity:.5}.compt.selected[_ngcontent-%COMP%]{background-color:var(--selected-background-color,#0455bf)}.compt.selected[_ngcontent-%COMP%]   .car-inner-wrap[_ngcontent-%COMP%]{border-bottom-color:var(--selected-background-color,#0455bf)}.compt.selected[_ngcontent-%COMP%]   .car-inner-wrap[_ngcontent-%COMP%]   .cb-name[_ngcontent-%COMP%], .compt.selected[_ngcontent-%COMP%]   .car-inner-wrap[_ngcontent-%COMP%]   .cb-status-lbl[_ngcontent-%COMP%], .compt.selected[_ngcontent-%COMP%]   .car-inner-wrap[_ngcontent-%COMP%]   .fz0[_ngcontent-%COMP%]{color:var(--selected-text-color,#fff)!important}.compt[_ngcontent-%COMP%]   .car-inner-wrap[_ngcontent-%COMP%]{border-bottom:1px solid var(--border-divider-color,#d3cdcd);display:flex;margin-left:var(--margin-page,20px);padding-right:var(--padding-right,15px)}.compt[_ngcontent-%COMP%]   .car-inner-wrap[_ngcontent-%COMP%]   .car-inner[_ngcontent-%COMP%]{align-items:center;cursor:pointer;display:flex;flex:1;padding-bottom:8px;padding-right:10px;padding-top:8px}.compt[_ngcontent-%COMP%]   .car-inner-wrap[_ngcontent-%COMP%]   .car-inner[_ngcontent-%COMP%]   .car-avt[_ngcontent-%COMP%]{align-items:center;background:var(--avatar-background-color,#dfe5ea);border-radius:50%;display:flex;height:40px;justify-content:center;margin-right:15px;padding:0 6px;width:40px}.compt[_ngcontent-%COMP%]   .car-inner-wrap[_ngcontent-%COMP%]   .car-inner[_ngcontent-%COMP%]   .car-avt[_ngcontent-%COMP%]   .avt-lbl[_ngcontent-%COMP%]{color:var(--avatar-label-color,#374957);display:flex;font-size:15px;font-weight:500;justify-content:flex-end;overflow-x:hidden}.compt[_ngcontent-%COMP%]   .car-inner-wrap[_ngcontent-%COMP%]   .car-inner[_ngcontent-%COMP%]   .car-avt[_ngcontent-%COMP%]   .avt-pic[_ngcontent-%COMP%]{border-radius:50%;display:flex}.compt[_ngcontent-%COMP%]   .car-inner-wrap[_ngcontent-%COMP%]   .car-inner[_ngcontent-%COMP%]   .car-avt.avatar-only[_ngcontent-%COMP%]{background:initial;border:initial}.compt[_ngcontent-%COMP%]   .car-inner-wrap[_ngcontent-%COMP%]   .car-inner[_ngcontent-%COMP%]   .car-fields[_ngcontent-%COMP%]{display:-ms-grid;display:grid;flex:1}.compt[_ngcontent-%COMP%]   .car-inner-wrap[_ngcontent-%COMP%]   .car-inner[_ngcontent-%COMP%]   .car-fields[_ngcontent-%COMP%]   .cb-row.cb-name[_ngcontent-%COMP%]{color:var(--title-color,#374957);font-weight:500}.compt[_ngcontent-%COMP%]   .car-inner-wrap[_ngcontent-%COMP%]   .car-inner[_ngcontent-%COMP%]   .car-fields[_ngcontent-%COMP%]   .cb-row.cb-name[_ngcontent-%COMP%]:not(:last-child){margin-bottom:2px}.compt[_ngcontent-%COMP%]   .car-inner-wrap[_ngcontent-%COMP%]   .car-inner[_ngcontent-%COMP%]   .car-fields[_ngcontent-%COMP%]   .cb-row.cb-status-lbl[_ngcontent-%COMP%]{color:var(--rows-color,#5f7d95);font-size:13px}.compt[_ngcontent-%COMP%]   .car-inner-wrap[_ngcontent-%COMP%]   .car-inner[_ngcontent-%COMP%]   .car-fields[_ngcontent-%COMP%]   .cb-row.cb-status-lbl.fz10[_ngcontent-%COMP%]{color:var(--second-row-color,var(--rows-color,#5f7d95));font-size:10px}.compt[_ngcontent-%COMP%]   .car-inner-wrap[_ngcontent-%COMP%]   .car-inner[_ngcontent-%COMP%]   .car-fields[_ngcontent-%COMP%]   .cb-row.cb-status-lbl.fz10[_ngcontent-%COMP%]   .csl-icon[_ngcontent-%COMP%]{font-size:9px;margin-right:1px}.compt[_ngcontent-%COMP%]   .car-inner-wrap[_ngcontent-%COMP%]   .car-inner[_ngcontent-%COMP%]   .w-status[_ngcontent-%COMP%]{border:2px solid var(--avatar-border-color,var(--avatar-background-color,#dfe5ea));padding:0 4px}.compt[_ngcontent-%COMP%]   .car-inner-wrap[_ngcontent-%COMP%]   .pane-action-btns[_ngcontent-%COMP%]{align-items:center;cursor:pointer;display:flex}.compt[_ngcontent-%COMP%]   .car-inner-wrap[_ngcontent-%COMP%]   .pane-action-btns[_ngcontent-%COMP%]   .pane-action-btn[_ngcontent-%COMP%]{--border-radius:50%;--padding-bottom:0;--padding-end:0;--padding-start:0;--padding-top:0;height:auto;margin:0}.compt[_ngcontent-%COMP%]   .car-inner-wrap[_ngcontent-%COMP%]   .pane-action-btns[_ngcontent-%COMP%]   .pane-action-btn[_ngcontent-%COMP%]   .icon-star[_ngcontent-%COMP%]{color:var(--right-button-color,#0455bf);font-size:var(--right-button-size,15px);margin:5px}"], changeDetection: 0 });
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(AvatarItemComponent, [{
        type: Component,
        args: [{
                selector: 'avatar-item',
                templateUrl: './avatar-item.component.html',
                styleUrls: ['./avatar-item.component.scss'],
                changeDetection: ChangeDetectionStrategy.OnPush
            }]
    }], function () { return []; }, { selected: [{
            type: Input
        }], rightIconName: [{
            type: Input
        }], rightIconSelectedName: [{
            type: Input
        }], rightIconSelected: [{
            type: Input
        }], avatar: [{
            type: Input
        }], avatarCss: [{
            type: Input
        }], avatarText: [{
            type: Input
        }], title: [{
            type: Input
        }], firstRow: [{
            type: Input
        }], secondRow: [{
            type: Input
        }], secondRowIcon: [{
            type: Input
        }], viewDisabled: [{
            type: Input
        }], select: [{
            type: Output
        }], rightIconSelect: [{
            type: Output
        }] }); })();

class CommonLibModule {
}
CommonLibModule.ɵmod = i0.ɵɵdefineNgModule({ type: CommonLibModule });
CommonLibModule.ɵinj = i0.ɵɵdefineInjector({ factory: function CommonLibModule_Factory(t) { return new (t || CommonLibModule)(); }, imports: [[
            IonicStorageModule.forRoot(),
            IonicModule,
            CommonModule,
            FormsModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(CommonLibModule, { declarations: [CommonLibComponent,
        TopBarComponent,
        AlertPage,
        SmallAlertPage,
        ChipbarComponent,
        AvatarItemComponent,
        SearchPipe,
        DurationPipe,
        WeekDaysPipe,
        SortAlphabeticallyPipe,
        EmailListPipe,
        ParticipantListPipe,
        SortPipe,
        DecimalNumberPipe,
        PoiListPipe,
        DeltaTimePipe], imports: [i2.IonicStorageModule, IonicModule,
        CommonModule,
        FormsModule], exports: [CommonLibComponent,
        TopBarComponent,
        AlertPage,
        SmallAlertPage,
        ChipbarComponent,
        AvatarItemComponent,
        SearchPipe,
        DurationPipe,
        WeekDaysPipe,
        SortAlphabeticallyPipe,
        EmailListPipe,
        ParticipantListPipe,
        SortPipe,
        DecimalNumberPipe,
        PoiListPipe,
        DeltaTimePipe] }); })();
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(CommonLibModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    CommonLibComponent,
                    TopBarComponent,
                    AlertPage,
                    SmallAlertPage,
                    ChipbarComponent,
                    AvatarItemComponent,
                    SearchPipe,
                    DurationPipe,
                    WeekDaysPipe,
                    SortAlphabeticallyPipe,
                    EmailListPipe,
                    ParticipantListPipe,
                    SortPipe,
                    DecimalNumberPipe,
                    PoiListPipe,
                    DeltaTimePipe
                ],
                imports: [
                    IonicStorageModule.forRoot(),
                    IonicModule,
                    CommonModule,
                    FormsModule
                ],
                exports: [
                    CommonLibComponent,
                    TopBarComponent,
                    AlertPage,
                    SmallAlertPage,
                    ChipbarComponent,
                    AvatarItemComponent,
                    SearchPipe,
                    DurationPipe,
                    WeekDaysPipe,
                    SortAlphabeticallyPipe,
                    EmailListPipe,
                    ParticipantListPipe,
                    SortPipe,
                    DecimalNumberPipe,
                    PoiListPipe,
                    DeltaTimePipe
                ],
                schemas: [CUSTOM_ELEMENTS_SCHEMA]
            }]
    }], null, null); })();

class AuthService {
    constructor() { }
    // Inizializza firebase per quella specifica app e attiva il listener di cambio di stato
    initialization(firebase) {
        AuthService.firebase = firebase;
        if (AuthService.forcedEmail && AuthService.forcedToken) {
            console.error('forced credential');
            this.isForced = true;
            ViewService.updateView.next();
            AuthService.isLogged = true;
            AuthService.authStateChange.next(true);
        }
        else {
            AuthService.firebase.auth().onAuthStateChanged((user) => {
                if (user) {
                    AuthService.isLogged = true;
                    AuthService.authStateChange.next(true);
                }
                else {
                    AuthService.isLogged = false;
                    AuthService.authStateChange.next(false);
                }
            });
        }
    }
    //Dice o fa attendere fin quando non sa se siam loggati oppure no
    isReady() {
        return new Promise((resolve, reject) => {
            if ((AuthService.forcedEmail && AuthService.forcedToken) || (AuthService.firebase && AuthService.firebase.auth().currentUser))
                return resolve();
            let sub = AuthService.authStateChange.subscribe((loggedIn) => __awaiter(this, void 0, void 0, function* () {
                sub.unsubscribe();
                return resolve();
            }));
        });
    }
    // Recupera l'id del current user
    getIdToken() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!AuthService.firebase)
                return;
            if (AuthService.forcedToken)
                return AuthService.forcedToken;
            if (AuthService.firebase.auth().currentUser) {
                return yield AuthService.firebase.auth().currentUser.getIdToken(false);
            }
        });
    }
    // Recupera l'email dell'utente
    static getEmail() {
        if (!AuthService.firebase)
            return;
        if (AuthService.forcedEmail)
            return AuthService.forcedEmail;
        if (AuthService.firebase.auth().currentUser) {
            return AuthService.firebase.auth().currentUser.email;
        }
    }
    // Recupera UID dell'utente
    static getUID() {
        if (!AuthService.firebase)
            return;
        if (AuthService.forcedToken)
            return AuthService.forcedToken;
        if (AuthService.firebase.auth().currentUser) {
            return AuthService.firebase.auth().currentUser.uid;
        }
    }
    // Effettua il login da username e password
    loginWithEmailAndPassword(email, password) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!AuthService.firebase)
                return;
            yield AuthService.firebase.auth().setPersistence(AuthService.firebase.auth.Auth.Persistence.LOCAL);
            yield AuthService.firebase.auth().signInWithEmailAndPassword(email, password);
        });
    }
    // Registra un nuovo utente
    createUserWithEmailAndPassword(email, password) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!AuthService.firebase)
                return;
            yield AuthService.firebase.auth().createUserWithEmailAndPassword(email, password);
            yield AuthService.firebase.auth().setPersistence(AuthService.firebase.auth.Auth.Persistence.LOCAL);
        });
    }
    // Invia una mail alla mail inserita per il reset della password
    resetPassword(email) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!AuthService.firebase)
                return;
            yield AuthService.firebase.auth().sendPasswordResetEmail(email);
        });
    }
    // Riautentica l'utente per operazioni importanti come cambio password e cambio email utente
    reauthenticateWithCredential(password) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!AuthService.firebase)
                return;
            const user = AuthService.firebase.auth().currentUser;
            const credential = AuthService.firebase.auth.EmailAuthProvider.credential(user.email, password);
            yield user.reauthenticateWithCredential(credential);
        });
    }
    // Aggioorna l'email di un utente loggato
    updateEmail(email) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!AuthService.firebase)
                return;
            const user = AuthService.firebase.auth().currentUser;
            yield user.updateEmail(email);
        });
    }
    // Aggioorna la password di un utente loggato
    updatePassword(password) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!AuthService.firebase)
                return;
            const user = AuthService.firebase.auth().currentUser;
            yield user.updatePassword(password);
        });
    }
    // Effettua il logout
    logout() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!AuthService.firebase)
                return;
            yield AuthService.firebase.auth().signOut();
        });
    }
}
AuthService.authStateChange = new Subject();
AuthService.authStateChange$ = AuthService.authStateChange.asObservable();
AuthService.ɵfac = function AuthService_Factory(t) { return new (t || AuthService)(); };
AuthService.ɵprov = i0.ɵɵdefineInjectable({ token: AuthService, factory: AuthService.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(AuthService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

class ApiService {
    constructor(http, storage, auth, alertController) {
        this.http = http;
        this.storage = storage;
        this.auth = auth;
        this.alertController = alertController;
        this.isDevelopment = false;
    }
    /** Imposta e verifica l'API URL **/
    setModality(url) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                this.baseUrl = url;
                yield this.storage.ready();
                let baseUrl = yield this.storage.get("baseUrl");
                if (baseUrl && baseUrl !== this.baseUrl) {
                    this.apiChanged = true;
                    ViewService.updateView.next();
                }
                if (baseUrl) {
                    this.isDevelopment = true;
                    this.baseUrl = baseUrl;
                    console.error("da storage " + this.baseUrl);
                }
            }
            catch (err) {
                console.error(err);
            }
        });
    }
    /**
     * Setta l'header con le credenziali volute
     * @param {string} username
     * @param {string} password
     * @returns {HttpHeaders}
     */
    setHeaders(username, password) {
        return new HttpHeaders().set('Authorization', 'Basic ' + btoa(username + ':' + password));
    }
    /**
     * Setta l'header prendendo ogni volta il token di firebase (che nel tempo potrebbe scadere)
     * @returns {Observable<any>}
     */
    getFirebaseHeader(forcedEmail) {
        return new Promise((resolve, reject) => {
            this.auth.getIdToken().then((token) => {
                return resolve(this.setHeaders(forcedEmail || AuthService.getEmail(), token));
            }).catch((err) => {
                return reject(err);
            });
        });
    }
    upEvent(event) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.upEventListener)
                clearTimeout(this.upEventListener);
            this.upEventListener = setTimeout(() => {
                this.upEventCount = 0;
            }, 400);
            this.upEventCount++;
            if (this.upEventCount >= 5) {
                this.upEventCount = 0;
                console.error('upEvent');
                const alert = yield this.alertController.create({
                    cssClass: 'my-custom-class',
                    backdropDismiss: false,
                    message: '<small>Corrente:<br><b>' + this.baseUrl + '</b></small>',
                    inputs: [
                        {
                            name: 'manualUrl',
                            type: 'text',
                            placeholder: 'Url manuale'
                        }
                    ],
                    buttons: [
                        {
                            text: 'Usa URL manuale',
                            handler: (data) => {
                                if (data && data.manualUrl) {
                                    this.changeBaseUrl(data.manualUrl);
                                }
                            }
                        },
                        {
                            text: 'white-label-dev-635e0.ey.r.appspot.com',
                            handler: () => {
                                this.changeBaseUrl('https://white-label-dev-635e0.ey.r.appspot.com/webApp/');
                            }
                        },
                        {
                            text: 'api-dev.balin.app',
                            handler: () => {
                                this.changeBaseUrl('https://api-dev.balin.app/webApp/');
                            }
                        },
                        {
                            text: 'api.495318.net',
                            handler: () => {
                                this.changeBaseUrl('https://api.495318.net/webApp/');
                            }
                        },
                        {
                            text: 'Annulla',
                            role: 'cancel',
                            handler: () => {
                                console.log('Confirm Ok');
                            }
                        }
                    ]
                });
                yield alert.present();
            }
        });
    }
    changeBaseUrl(url) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.storage.set('baseUrl', url);
            this.baseUrl = url;
            window.location.reload();
            // setTimeout(() => {
            //   window.location.reload();
            // }, 5000);
        });
    }
    getLogin() {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                let options = {
                    headers: (yield this.getFirebaseHeader())
                };
                this.http.get(this.baseUrl + 'webApp/login?platform_type=' + ApiService.platformType, options).pipe(timeout(10000)).subscribe((res) => {
                    resolve(res);
                }, (err) => {
                    reject(err);
                });
            }
            catch (err) {
                reject(err);
            }
        }));
    }
    getConfigInfo() {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                let options = {
                    headers: (new HttpHeaders()),
                    timeout: 1
                };
                this.http.get(this.baseUrl + 'webApp/generalParameter?platform_type=' + ApiService.platformType, options).pipe(timeout(10000)).subscribe((res) => {
                    resolve(res);
                }, (err) => {
                    reject(err);
                });
            }
            catch (err) {
                reject(err);
            }
        }));
    }
    patchSpeedAlarm(idParticipant, idTarget, participant) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                let options = {
                    headers: (yield this.getFirebaseHeader())
                };
                let url = this.baseUrl + 'webApp/partecipant/' + idTarget + '?platform_type=' + ApiService.platformType;
                url += '&idPartecipant=' + idParticipant;
                let data = {
                    speed_alarm_enable: participant.speed_alarm_enable,
                    speed_alarm_value: participant.speed_alarm_value,
                    speed_alarm_hour_start: participant.speed_alarm_hour_start,
                    speed_alarm_minute_start: participant.speed_alarm_minute_start,
                    speed_alarm_hour_stop: participant.speed_alarm_hour_stop,
                    speed_alarm_minute_stop: participant.speed_alarm_minute_stop,
                    speed_alarm_day: participant.speed_alarm_day,
                    speed_alarm_email: participant.speed_alarm_email,
                    speed_alarm_partecipant: participant.speed_alarm_partecipant
                };
                this.http.patch(url, data, options).subscribe((res) => {
                    resolve(res);
                }, (err) => {
                    reject(err);
                });
            }
            catch (err) {
                reject(err);
            }
        }));
    }
    patchInput1Alarm(idParticipant, idTarget, participant) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                let options = {
                    headers: (yield this.getFirebaseHeader())
                };
                let url = this.baseUrl + 'webApp/partecipant/' + idTarget + '?platform_type=' + ApiService.platformType;
                url += '&idPartecipant=' + idParticipant;
                let data = {
                    din1_alarm_enable: participant.din1_alarm_enable,
                    din1_alarm_value: participant.din1_alarm_value,
                    din1_alarm_hour_start: participant.din1_alarm_hour_start,
                    din1_alarm_minute_start: participant.din1_alarm_minute_start,
                    din1_alarm_hour_stop: participant.din1_alarm_hour_stop,
                    din1_alarm_minute_stop: participant.din1_alarm_minute_stop,
                    din1_alarm_day: participant.din1_alarm_day,
                    din1_alarm_email: participant.din1_alarm_email,
                    din1_alarm_partecipant: participant.din1_alarm_partecipant
                };
                this.http.patch(url, data, options).subscribe((res) => {
                    resolve(res);
                }, (err) => {
                    reject(err);
                });
            }
            catch (err) {
                reject(err);
            }
        }));
    }
    patchOfflineAlarm(idParticipant, idTarget, participant) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                let options = {
                    headers: (yield this.getFirebaseHeader())
                };
                let url = this.baseUrl + 'webApp/partecipant/' + idTarget + '?platform_type=' + ApiService.platformType;
                url += '&idPartecipant=' + idParticipant;
                let data = {
                    offline_alarm_enable: participant.offline_alarm_enable,
                    offline_alarm_value: participant.offline_alarm_value,
                    offline_alarm_hour_start: participant.offline_alarm_hour_start,
                    offline_alarm_minute_start: participant.offline_alarm_minute_start,
                    offline_alarm_hour_stop: participant.offline_alarm_hour_stop,
                    offline_alarm_minute_stop: participant.offline_alarm_minute_stop,
                    offline_alarm_day: participant.offline_alarm_day,
                    offline_alarm_email: participant.offline_alarm_email,
                    offline_alarm_partecipant: participant.offline_alarm_partecipant
                };
                this.http.patch(url, data, options).subscribe((res) => {
                    resolve(res);
                }, (err) => {
                    reject(err);
                });
            }
            catch (err) {
                reject(err);
            }
        }));
    }
    patchMovementAlarm(idParticipant, idTarget, participant) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                let options = {
                    headers: (yield this.getFirebaseHeader())
                };
                let url = this.baseUrl + 'webApp/partecipant/' + idTarget + '?platform_type=' + ApiService.platformType;
                url += '&idPartecipant=' + idParticipant;
                let data = {
                    movement_alarm_enable: participant.movement_alarm_enable,
                    movement_alarm_hour_start: participant.movement_alarm_hour_start,
                    movement_alarm_minute_start: participant.movement_alarm_minute_start,
                    movement_alarm_hour_stop: participant.movement_alarm_hour_stop,
                    movement_alarm_minute_stop: participant.movement_alarm_minute_stop,
                    movement_alarm_day: participant.movement_alarm_day,
                    movement_alarm_email: participant.movement_alarm_email,
                    movement_alarm_partecipant: participant.movement_alarm_partecipant
                };
                this.http.patch(url, data, options).subscribe((res) => {
                    resolve(res);
                }, (err) => {
                    reject(err);
                });
            }
            catch (err) {
                reject(err);
            }
        }));
    }
    patchUnplugAlarm(idParticipant, idTarget, participant) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                let options = {
                    headers: (yield this.getFirebaseHeader())
                };
                let url = this.baseUrl + 'webApp/partecipant/' + idTarget + '?platform_type=' + ApiService.platformType;
                url += '&idPartecipant=' + idParticipant;
                let data = {
                    unplug_alarm_enable: participant.unplug_alarm_enable,
                    unplug_alarm_hour_start: participant.unplug_alarm_hour_start,
                    unplug_alarm_minute_start: participant.unplug_alarm_minute_start,
                    unplug_alarm_hour_stop: participant.unplug_alarm_hour_stop,
                    unplug_alarm_minute_stop: participant.unplug_alarm_minute_stop,
                    unplug_alarm_day: participant.unplug_alarm_day,
                    unplug_alarm_email: participant.unplug_alarm_email,
                    unplug_alarm_partecipant: participant.unplug_alarm_partecipant
                };
                this.http.patch(url, data, options).subscribe((res) => {
                    resolve(res);
                }, (err) => {
                    reject(err);
                });
            }
            catch (err) {
                reject(err);
            }
        }));
    }
    patchParkingAlarm(idParticipant, idTarget, participant) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                let options = {
                    headers: (yield this.getFirebaseHeader())
                };
                let url = this.baseUrl + 'webApp/partecipant/' + idTarget + '?platform_type=' + ApiService.platformType;
                url += '&idPartecipant=' + idParticipant;
                let data = {
                    parking_alarm_enable: participant.parking_alarm_enable,
                    parking_alarm_hour_start: participant.parking_alarm_hour_start,
                    parking_alarm_minute_start: participant.parking_alarm_minute_start,
                    parking_alarm_hour_stop: participant.parking_alarm_hour_stop,
                    parking_alarm_minute_stop: participant.parking_alarm_minute_stop,
                    parking_alarm_day: participant.parking_alarm_day,
                    parking_alarm_email: participant.parking_alarm_email,
                    parking_alarm_partecipant: participant.parking_alarm_partecipant
                };
                this.http.patch(url, data, options).subscribe((res) => {
                    resolve(res);
                }, (err) => {
                    reject(err);
                });
            }
            catch (err) {
                reject(err);
            }
        }));
    }
    getPositionsGps(idParticipant, idParticipant_search, start, stop, limit, skip, avlId) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                let options = {
                    headers: (yield this.getFirebaseHeader())
                };
                let url = this.baseUrl + 'webApp/positionGps?platform_type=' + ApiService.platformType;
                url += '&idPartecipant=' + idParticipant;
                url += '&idPartecipant_search=' + idParticipant_search;
                url += '&timestampStart=' + start;
                url += '&timestampStop=' + stop;
                url += '&limit=' + limit;
                url += '&skip=' + skip;
                if (avlId) {
                    url += '&avl_id=' + avlId;
                }
                this.http.get(url, options).subscribe((res) => {
                    resolve(res);
                }, (err) => {
                    reject(err);
                });
            }
            catch (err) {
                reject(err);
            }
        }));
    }
    getRoute(idParticipant, idParticipant_search, start, stop) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                let options = {
                    headers: (yield this.getFirebaseHeader())
                };
                let url = this.baseUrl + 'webApp/positionGps/report?platform_type=' + ApiService.platformType;
                url += '&idPartecipant=' + idParticipant;
                url += '&idPartecipant_search=' + idParticipant_search;
                url += '&timestampStart=' + start;
                url += '&timestampStop=' + stop;
                this.http.get(url, options).subscribe((res) => {
                    resolve(res);
                }, (err) => {
                    reject(err);
                });
            }
            catch (err) {
                reject(err);
            }
        }));
    }
    getAddress(idParticipant, lat, long) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                let res = yield this.storage.get(lat + '_' + long);
                if (res)
                    return resolve(res);
                let options = {
                    headers: (yield this.getFirebaseHeader())
                };
                let url = this.baseUrl + 'webApp/utility/locationiq/reverseGeocoding?platform_type=' + ApiService.platformType;
                url += '&idPartecipant=' + idParticipant;
                url += '&lat=' + lat;
                url += '&longi=' + long;
                this.http.get(url, options).subscribe((res) => {
                    // resolve(res);
                    if (res && res.display_name)
                        this.storage.set(lat + '_' + long, res.display_name).then(() => { }).catch(() => { });
                    resolve(res.display_name);
                }, (err) => {
                    reject(err);
                });
            }
            catch (err) {
                reject(err);
            }
        }));
    }
    getCoordinates(idParticipant, address) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                let options = {
                    headers: (yield this.getFirebaseHeader())
                };
                let url = this.baseUrl + 'webApp/utility/locationiq/geocoding?platform_type=' + ApiService.platformType;
                url += '&idPartecipant=' + idParticipant;
                url += '&address=' + address;
                this.http.get(url, options).subscribe((res) => {
                    resolve(res);
                }, (err) => {
                    reject(err);
                });
            }
            catch (err) {
                reject(err);
            }
        }));
    }
    getOrganization(idParticipant, idOrganization) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                let options = {
                    headers: (yield this.getFirebaseHeader())
                };
                let url = this.baseUrl + 'webApp/organization/' + idOrganization + '?platform_type=' + ApiService.platformType;
                url += '&idPartecipant=' + idParticipant;
                this.http.get(url, options).subscribe((res) => {
                    resolve(res);
                }, (err) => {
                    reject(err);
                });
            }
            catch (err) {
                reject(err);
            }
        }));
    }
    getParticipant(idParticipant, idPartecipantToRetrieve) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                let options = {
                    headers: (yield this.getFirebaseHeader())
                };
                let url = this.baseUrl + 'webApp/partecipant/' + idPartecipantToRetrieve + '?platform_type=' + ApiService.platformType;
                url += '&idPartecipant=' + idParticipant;
                this.http.get(url, options).subscribe((res) => {
                    resolve(res);
                }, (err) => {
                    reject(err);
                });
            }
            catch (err) {
                reject(err);
            }
        }));
    }
    postParticipant(idParticipant, participant) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                let options = {
                    headers: (yield this.getFirebaseHeader())
                };
                let url = this.baseUrl + 'webApp/partecipant/user?platform_type=' + ApiService.platformType;
                url += '&idPartecipant=' + idParticipant;
                let data = {
                    typeUser: participant.type,
                    email: participant.email,
                    list_partecipant: participant.list_partecipant,
                    functionality_alarm: participant.functionality_alarm,
                    functionality_veichle: participant.functionality_vehicle,
                    functionality_billing: participant.functionality_billing,
                    functionality_map: participant.functionality_map,
                    functionality_historical: participant.functionality_historical,
                    functionality_report: participant.functionality_report,
                    functionality_poi: participant.functionality_poi,
                    functionality_activation: participant.functionality_activation
                };
                this.http.post(url, data, options).subscribe((res) => {
                    resolve(res);
                }, (err) => {
                    reject(err);
                });
            }
            catch (err) {
                reject(err);
            }
        }));
    }
    patchParticipant(idParticipant, participant) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                let options = {
                    headers: (yield this.getFirebaseHeader())
                };
                let url = this.baseUrl + 'webApp/partecipant/' + participant._id + '?platform_type=' + ApiService.platformType;
                url += '&idPartecipant=' + idParticipant;
                let data = {
                    typeUser: participant.type,
                    email: participant.email,
                    list_partecipant: participant.list_partecipant,
                    functionality_alarm: participant.functionality_alarm,
                    functionality_veichle: participant.functionality_vehicle,
                    functionality_billing: participant.functionality_billing,
                    functionality_map: participant.functionality_map,
                    functionality_historical: participant.functionality_historical,
                    functionality_report: participant.functionality_report,
                    functionality_poi: participant.functionality_poi,
                    functionality_activation: participant.functionality_activation
                };
                this.http.patch(url, data, options).subscribe((res) => {
                    resolve(res);
                }, (err) => {
                    reject(err);
                });
            }
            catch (err) {
                reject(err);
            }
        }));
    }
    patchApiSettingsParticipant(idParticipant, api_enabled, generate_api_token) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                let options = {
                    headers: (yield this.getFirebaseHeader())
                };
                let url = this.baseUrl + 'webApp/partecipant/api_settings/' + idParticipant + '?platform_type=' + ApiService.platformType;
                url += '&idPartecipant=' + idParticipant;
                let data = {
                    api_enabled: api_enabled,
                    generate_api_token: generate_api_token
                };
                this.http.patch(url, data, options).subscribe((res) => {
                    resolve(res);
                }, (err) => {
                    reject(err);
                });
            }
            catch (err) {
                reject(err);
            }
        }));
    }
    patchChangeEmailMe(idParticipant, oldEmail, newEmail) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                let options = {
                    headers: (yield this.getFirebaseHeader(oldEmail))
                };
                let url = this.baseUrl + 'webApp/partecipant/' + idParticipant + '?platform_type=' + ApiService.platformType;
                url += '&idPartecipant=' + idParticipant;
                let data = {
                    email: newEmail
                };
                this.http.patch(url, data, options).subscribe((res) => {
                    resolve(res);
                }, (err) => {
                    reject(err);
                });
            }
            catch (err) {
                reject(err);
            }
        }));
    }
    patchParticipantRegister(idParticipant, idTargetPartecipant, name, label, odometer) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                let options = {
                    headers: (yield this.getFirebaseHeader())
                };
                let url = this.baseUrl + 'webApp/partecipant/' + idTargetPartecipant + '?platform_type=' + ApiService.platformType;
                url += '&idPartecipant=' + idParticipant;
                let data = {
                    label_string: name,
                    label_number: label,
                    real_odometer: odometer
                };
                this.http.patch(url, data, options).subscribe((res) => {
                    resolve(res);
                }, (err) => {
                    reject(err);
                });
            }
            catch (err) {
                reject(err);
            }
        }));
    }
    deleteParticipant(idParticipant, idPartecipantToDelete) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                let options = {
                    headers: (yield this.getFirebaseHeader())
                };
                let url = this.baseUrl + 'webApp/partecipant/' + idPartecipantToDelete + '?platform_type=' + ApiService.platformType;
                url += '&idPartecipant=' + idParticipant;
                this.http.delete(url, options).subscribe((res) => {
                    resolve(res);
                }, (err) => {
                    reject(err);
                });
            }
            catch (err) {
                reject(err);
            }
        }));
    }
    getPoi(idParticipant, idPoi) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                let options = {
                    headers: (yield this.getFirebaseHeader())
                };
                let url = this.baseUrl + 'webApp/poi/' + idPoi + '?platform_type=' + ApiService.platformType;
                url += '&idPartecipant=' + idParticipant;
                this.http.get(url, options).subscribe((res) => {
                    resolve(res);
                }, (err) => {
                    reject(err);
                });
            }
            catch (err) {
                reject(err);
            }
        }));
    }
    getPois(idParticipant, skip, limit) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                let options = {
                    headers: (yield this.getFirebaseHeader())
                };
                let url = this.baseUrl + 'webApp/poi?platform_type=' + ApiService.platformType;
                url += '&idPartecipant=' + idParticipant;
                url += '&limit=' + (limit || 500);
                url += '&skip=' + (skip || 0);
                this.http.get(url, options).subscribe((res) => {
                    resolve(res);
                }, (err) => {
                    reject(err);
                });
            }
            catch (err) {
                reject(err);
            }
        }));
    }
    getAlarmsPoi(idParticipant, skip, limit) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                let options = {
                    headers: (yield this.getFirebaseHeader())
                };
                let url = this.baseUrl + 'webApp/alarmPoi?platform_type=' + ApiService.platformType;
                url += '&idPartecipant=' + idParticipant;
                url += '&limit=' + (limit || 500);
                url += '&skip=' + (skip || 0);
                this.http.get(url, options).subscribe((res) => {
                    resolve(res);
                }, (err) => {
                    reject(err);
                });
            }
            catch (err) {
                reject(err);
            }
        }));
    }
    postAlarmsPoi(idParticipant, alarm) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                let options = {
                    headers: (yield this.getFirebaseHeader())
                };
                let url = this.baseUrl + 'webApp/alarmPoi?platform_type=' + ApiService.platformType;
                url += '&idPartecipant=' + idParticipant;
                let data = {
                    idPartecipant: alarm.idPartecipant,
                    idPoi: alarm.idPoi,
                    idOrganization: alarm.idOrganization,
                    onEntry: alarm.onEntry,
                    onExit: alarm.onExit,
                    emails: alarm.emails,
                    push: alarm.push,
                    alarmPoi_day: alarm.alarmPoi_day,
                    alarmPoi_hour_start: alarm.alarmPoi_hour_start,
                    alarmPoi_minute_start: alarm.alarmPoi_minute_start,
                    alarmPoi_hour_stop: alarm.alarmPoi_hour_stop,
                    alarmPoi_minute_stop: alarm.alarmPoi_minute_stop
                };
                console.error(data);
                this.http.post(url, data, options).subscribe((res) => {
                    resolve(res);
                }, (err) => {
                    reject(err);
                });
            }
            catch (err) {
                reject(err);
            }
        }));
    }
    patchAlarmsPoi(idParticipant, alarm) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                let options = {
                    headers: (yield this.getFirebaseHeader())
                };
                let url = this.baseUrl + 'webApp/alarmPoi/' + alarm._id + '?platform_type=' + ApiService.platformType;
                url += '&idPartecipant=' + idParticipant;
                let data = {
                    onEntry: alarm.onEntry,
                    onExit: alarm.onExit,
                    emails: alarm.emails,
                    push: alarm.push,
                    alarmPoi_day: alarm.alarmPoi_day,
                    alarmPoi_hour_start: alarm.alarmPoi_hour_start,
                    alarmPoi_minute_start: alarm.alarmPoi_minute_start,
                    alarmPoi_hour_stop: alarm.alarmPoi_hour_stop,
                    alarmPoi_minute_stop: alarm.alarmPoi_minute_stop
                };
                this.http.patch(url, data, options).subscribe((res) => {
                    resolve(res);
                }, (err) => {
                    reject(err);
                });
            }
            catch (err) {
                reject(err);
            }
        }));
    }
    deleteAlarmPoi(idParticipant, idAlarm) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                let options = {
                    headers: (yield this.getFirebaseHeader())
                };
                let url = this.baseUrl + 'webApp/alarmPoi/' + idAlarm + '?platform_type=' + ApiService.platformType;
                url += '&idPartecipant=' + idParticipant;
                this.http.delete(url, options).subscribe((res) => {
                    resolve(res);
                }, (err) => {
                    reject(err);
                });
            }
            catch (err) {
                reject(err);
            }
        }));
    }
    patchOrganization(idOrganization, idParticipant, language, timezone, name, send_welcome) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                let options = {
                    headers: (yield this.getFirebaseHeader())
                };
                let url = this.baseUrl + 'webApp/organization/' + idOrganization + '?idPartecipant=' + idParticipant + '&platform_type=' + ApiService.platformType;
                let data = {
                    translate_language: language,
                    timezone: timezone,
                    name: name,
                    send_welcome: send_welcome
                };
                this.http.patch(url, data, options).subscribe((res) => {
                    resolve(res);
                }, (err) => {
                    reject(err);
                });
            }
            catch (err) {
                reject(err);
            }
        }));
    }
    patchOrganizationPhone_contacts(organization__id, participant__id, body) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                let options = {
                    headers: (yield this.getFirebaseHeader())
                };
                this.http.patch(`${this.baseUrl}webapp/organization/phone_contacts/${organization__id}?idPartecipant=${participant__id}`, body, options).subscribe((res) => {
                    resolve(res);
                }, (err) => {
                    reject(err);
                });
            }
            catch (err) {
                reject(err);
            }
        }));
    }
    postCreatePoi(idParticipant, lat, lng, name, labelNumber, radius) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                let options = {
                    headers: (yield this.getFirebaseHeader())
                };
                let url = this.baseUrl + 'webApp/poi?platform_type=' + ApiService.platformType;
                url += '&idPartecipant=' + idParticipant;
                let data = {
                    name: name,
                    label_number: labelNumber,
                    position: {
                        type: 'Point',
                        coordinates: [lng, lat]
                    },
                    radius: radius
                };
                this.http.post(url, data, options).subscribe((res) => {
                    resolve(res);
                }, (err) => {
                    reject(err);
                });
            }
            catch (err) {
                reject(err);
            }
        }));
    }
    patchCreatePoi(idParticipant, idPoi, lat, lng, name, labelNumber, radius) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                let options = {
                    headers: (yield this.getFirebaseHeader())
                };
                let url = this.baseUrl + 'webApp/poi/' + idPoi + '?platform_type=' + ApiService.platformType;
                url += '&idPartecipant=' + idParticipant;
                let data = {
                    name: name,
                    label_number: labelNumber,
                    position: {
                        type: 'Point',
                        coordinates: [lng, lat]
                    },
                    radius: radius
                };
                this.http.patch(url, data, options).subscribe((res) => {
                    resolve(res);
                }, (err) => {
                    reject(err);
                });
            }
            catch (err) {
                reject(err);
            }
        }));
    }
    deletePoi(idParticipant, idPoi) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                let options = {
                    headers: (yield this.getFirebaseHeader())
                };
                let url = this.baseUrl + 'webApp/poi/' + idPoi + '?platform_type=' + ApiService.platformType;
                url += '&idPartecipant=' + idParticipant;
                this.http.delete(url, options).subscribe((res) => {
                    resolve(res);
                }, (err) => {
                    reject(err);
                });
            }
            catch (err) {
                reject(err);
            }
        }));
    }
    postTicket(idParticipant, name, email, subject, description, phone, filename, filename_base64Url) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                let options = {
                    headers: (yield this.getFirebaseHeader())
                };
                let url = this.baseUrl + 'webApp/zendesk/ticket?platform_type=' + ApiService.platformType;
                url += '&idPartecipant=' + idParticipant;
                let data = {
                    name: name,
                    email: email,
                    phone: phone,
                    subject: subject,
                    description: description
                };
                this.http.post(url, data, options).subscribe((res) => {
                    resolve(res);
                }, (err) => {
                    reject(err);
                });
            }
            catch (err) {
                reject(err);
            }
        }));
    }
    getTickets(idParticipant /*, skip: number, limit: number*/) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                let options = {
                    headers: (yield this.getFirebaseHeader())
                };
                let url = this.baseUrl + 'webApp/zendesk/tickets?platform_type=' + ApiService.platformType;
                url += '&idPartecipant=' + idParticipant;
                /*url += '&limit=' + (limit || 500);
                url += '&skip=' + (skip || 0);*/
                this.http.get(url, options).subscribe((res) => {
                    resolve(res);
                }, (err) => {
                    reject(err);
                });
            }
            catch (err) {
                reject(err);
            }
        }));
    }
    getTicketComments(idParticipant, idTicket) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                let options = {
                    headers: (yield this.getFirebaseHeader())
                };
                let url = this.baseUrl + 'webApp/zendesk/ticket/comment/' + idTicket + '?platform_type=' + ApiService.platformType;
                url += '&idPartecipant=' + idParticipant;
                this.http.get(url, options).subscribe((res) => {
                    resolve(res);
                }, (err) => {
                    reject(err);
                });
            }
            catch (err) {
                reject(err);
            }
        }));
    }
    patchTicket(idParticipant, idTicket, authorId, request) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                let options = {
                    headers: (yield this.getFirebaseHeader())
                };
                let url = this.baseUrl + 'webApp/zendesk/ticket/' + idTicket + '?platform_type=' + ApiService.platformType;
                url += '&idPartecipant=' + idParticipant;
                let data = {
                    request: request,
                    author_id: authorId
                };
                this.http.patch(url, data, options).subscribe((res) => {
                    resolve(res);
                }, (err) => {
                    reject(err);
                });
            }
            catch (err) {
                reject(err);
            }
        }));
    }
    getTicketsAuthors(idParticipant, ids) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                let options = {
                    headers: (yield this.getFirebaseHeader())
                };
                let url = this.baseUrl + 'webApp/zendesk/users/';
                for (let id of ids) {
                    url += id + ',';
                }
                url += '?platform_type=' + ApiService.platformType;
                url += '&idPartecipant=' + idParticipant;
                this.http.get(url, options).subscribe((res) => {
                    resolve(res);
                }, (err) => {
                    reject(err);
                });
            }
            catch (err) {
                reject(err);
            }
        }));
    }
    patchBillingUser(idParticipant, organization) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                let options = {
                    headers: (yield this.getFirebaseHeader())
                };
                let url = this.baseUrl + 'webApp/organization/billing/' + organization._id + '?platform_type=' + ApiService.platformType;
                url += '&idPartecipant=' + idParticipant;
                let data = {
                    billing_type: organization.billing_type,
                    billing_location: organization.billing_location,
                    billing_companyName: organization.billing_companyName,
                    billing_name: organization.billing_name,
                    billing_surname: organization.billing_surname,
                    billing_address: organization.billing_address,
                    billing_zip: organization.billing_zip,
                    billing_city: organization.billing_city,
                    billing_province: organization.billing_province,
                    billing_country: organization.billing_country,
                    billing_mail: organization.billing_mail,
                    billing_phone: organization.billing_phone,
                    billing_vat: organization.billing_vat,
                    billing_mailPEC: organization.billing_mailPEC,
                    billing_sdiCode_fatturaElettronica: organization.billing_sdiCode_fatturaElettronica,
                    billing_codiceFiscale: organization.billing_codiceFiscale
                };
                this.http.patch(url, data, options).subscribe((res) => {
                    resolve(res);
                }, (err) => {
                    reject(err);
                });
            }
            catch (err) {
                reject(err);
            }
        }));
    }
    getBillingPortalUrl(idParticipant, return_url) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                let options = {
                    headers: (yield this.getFirebaseHeader())
                };
                let url = this.baseUrl + 'webApp/organization/billing_stripe_portal_url';
                url += `?idPartecipant=${idParticipant}&return_url=${return_url}`;
                this.http.get(url, options).subscribe((res) => {
                    resolve(res);
                }, (err) => {
                    reject(err);
                });
            }
            catch (err) {
                reject(err);
            }
        }));
    }
    getCommandsTracker(idParticipant, idTargetParticipant) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                let options = {
                    headers: (yield this.getFirebaseHeader())
                };
                let url = this.baseUrl + 'webApp/commandTrackerGps/' + idTargetParticipant;
                url += '?idPartecipant=' + idParticipant;
                this.http.get(url, options).subscribe((res) => {
                    resolve(res);
                }, (err) => {
                    reject(err);
                });
            }
            catch (err) {
                reject(err);
            }
        }));
    }
    postCommandPosition(idParticipant, idTargetParticipant) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                let options = {
                    headers: (yield this.getFirebaseHeader())
                };
                let url = this.baseUrl + 'webApp/commandTrackerGps/get_position/' + idTargetParticipant;
                url += '?idPartecipant=' + idParticipant;
                this.http.post(url, {}, options).subscribe((res) => {
                    resolve(res);
                }, (err) => {
                    reject(err);
                });
            }
            catch (err) {
                reject(err);
            }
        }));
    }
    postResetTracker(idParticipant, idTargetParticipant) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                let options = {
                    headers: (yield this.getFirebaseHeader())
                };
                let url = this.baseUrl + 'webApp/commandTrackerGps/reset_tracker/' + idTargetParticipant;
                url += '?idPartecipant=' + idParticipant;
                this.http.post(url, {}, options).subscribe((res) => {
                    resolve(res);
                }, (err) => {
                    reject(err);
                });
            }
            catch (err) {
                reject(err);
            }
        }));
    }
    postStopEngine(idParticipant, idTargetParticipant, value, notifyOnSuccess, notifyOnError, emails, push, max_retry) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                let options = {
                    headers: (yield this.getFirebaseHeader())
                };
                let data = {
                    notifyOnSuccess: notifyOnSuccess,
                    notifyOnError: notifyOnError,
                    emails: emails,
                    push: push,
                    max_retry: max_retry
                };
                let url = this.baseUrl + 'webApp/commandTrackerGps/stop_engine/' + idTargetParticipant + '/' + value;
                url += '?idPartecipant=' + idParticipant;
                this.http.post(url, data, options).subscribe((res) => {
                    resolve(res);
                }, (err) => {
                    reject(err);
                });
            }
            catch (err) {
                reject(err);
            }
        }));
    }
    getNotificationsCount(idParticipant) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                let options = {
                    headers: (yield this.getFirebaseHeader())
                };
                let url = this.baseUrl + 'webApp/notification/countUnRead?platform_type=' + ApiService.platformType;
                url += '&idPartecipant=' + idParticipant;
                this.http.get(url, options).subscribe((res) => {
                    resolve(res);
                }, (err) => {
                    reject(err);
                });
            }
            catch (err) {
                reject(err);
            }
        }));
    }
    getNotifications(idParticipant, skip, limit, lang) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                let options = {
                    headers: (yield this.getFirebaseHeader())
                };
                let url = this.baseUrl + 'webApp/notification?platform_type=' + ApiService.platformType;
                url += '&idPartecipant=' + idParticipant;
                url += '&limit=' + (limit || 500);
                url += '&skip=' + (skip || 0);
                if (lang)
                    url += '&lang=' + lang;
                this.http.get(url, options).subscribe((res) => {
                    resolve(res);
                }, (err) => {
                    reject(err);
                });
            }
            catch (err) {
                reject(err);
            }
        }));
    }
    getNotification(idParticipant, idNotification, lang) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                let options = {
                    headers: (yield this.getFirebaseHeader())
                };
                let url = this.baseUrl + 'webApp/notification/' + idNotification + '?platform_type=' + ApiService.platformType;
                url += '&idPartecipant=' + idParticipant;
                if (lang)
                    url += '&lang=' + lang;
                this.http.get(url, options).subscribe((res) => {
                    resolve(res);
                }, (err) => {
                    reject(err);
                });
            }
            catch (err) {
                reject(err);
            }
        }));
    }
    patchNotification(idParticipant, idNotification, isRead) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                let options = {
                    headers: (yield this.getFirebaseHeader())
                };
                let url = this.baseUrl + 'webApp/notification/' + idNotification + '?platform_type=' + ApiService.platformType;
                url += '&idPartecipant=' + idParticipant;
                let data = {
                    isRead: isRead
                };
                this.http.patch(url, data, options).subscribe((res) => {
                    resolve(res);
                }, (err) => {
                    reject(err);
                });
            }
            catch (err) {
                reject(err);
            }
        }));
    }
    patchNotificationSetAll(idParticipant, isRead) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                let options = {
                    headers: (yield this.getFirebaseHeader())
                };
                let url = this.baseUrl + 'webApp/notification/setAllReady?platform_type=' + ApiService.platformType;
                url += '&idPartecipant=' + idParticipant;
                let data = {
                    setAllReady: isRead
                };
                this.http.patch(url, data, options).subscribe((res) => {
                    resolve(res);
                }, (err) => {
                    reject(err);
                });
            }
            catch (err) {
                reject(err);
            }
        }));
    }
    getClientSecretStripe(idOrganization, idParticipant) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                let options = {
                    headers: (yield this.getFirebaseHeader())
                };
                let url = this.baseUrl + 'webApp/stripe/setupIntents/client_secret/' + idOrganization + '?platform_type=' + ApiService.platformType;
                url += '&idPartecipant=' + idParticipant;
                this.http.get(url, options).subscribe((res) => {
                    resolve(res);
                }, (err) => {
                    reject(err);
                });
            }
            catch (err) {
                reject(err);
            }
        }));
    }
    postActivateTracker(idParticipant, imei, serial, name, label, odometer) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                let options = {
                    headers: (yield this.getFirebaseHeader())
                };
                let url = this.baseUrl + 'webApp/partecipant/trackerGPs';
                url += '?idPartecipant=' + idParticipant;
                const data = {
                    imei: imei,
                    serial_number: serial,
                    label_number: label,
                    label_string: name,
                    real_odometer: odometer
                };
                this.http.post(url, data, options).subscribe((res) => {
                    resolve(res);
                }, (err) => {
                    reject(err);
                });
            }
            catch (err) {
                reject(err);
            }
        }));
    }
    postTokenFCM(idParticipant, token, idDevice) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                let options = {
                    headers: (yield this.getFirebaseHeader())
                };
                let url = this.baseUrl + 'webApp/partecipant/tokenFCM';
                url += '?idPartecipant=' + idParticipant;
                const data = {
                    idPartecipant: idParticipant,
                    token: token,
                    idDevice: idDevice
                };
                this.http.post(url, data, options).subscribe((res) => {
                    resolve(res);
                }, (err) => {
                    reject(err);
                });
            }
            catch (err) {
                reject(err);
            }
        }));
    }
    deleteTokenFCM(idDevice) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                let options = {
                    headers: (yield this.getFirebaseHeader())
                };
                let url = this.baseUrl + 'webApp/partecipant/tokenFCM/' + idDevice;
                this.http.delete(url, options).subscribe((res) => {
                    resolve(res);
                }, (err) => {
                    reject(err);
                });
            }
            catch (err) {
                reject(err);
            }
        }));
    }
    // * webapp/utility
    patchCheck_codice_fiscale(participantId, body) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                let options = {
                    headers: (yield this.getFirebaseHeader())
                };
                this.http.patch(`${this.baseUrl}webapp/utility/check_codice_fiscale?idPartecipant=${participantId}`, body, options).subscribe((res) => {
                    resolve(res);
                }, (err) => {
                    reject(err);
                });
            }
            catch (err) {
                reject(err);
            }
        }));
    }
    patchCheck_partita_iva(participantId, body) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                let options = {
                    headers: (yield this.getFirebaseHeader())
                };
                this.http.patch(`${this.baseUrl}webapp/utility/check_partita_iva?idPartecipant=${participantId}`, body, options).subscribe((res) => {
                    resolve(res);
                }, (err) => {
                    reject(err);
                });
            }
            catch (err) {
                reject(err);
            }
        }));
    }
    patchCheck_zip(participantId, body) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                let options = {
                    headers: (yield this.getFirebaseHeader())
                };
                this.http.patch(`${this.baseUrl}webapp/utility/check_zip?idPartecipant=${participantId}`, body, options).subscribe((res) => {
                    resolve(res);
                }, (err) => {
                    reject(err);
                });
            }
            catch (err) {
                reject(err);
            }
        }));
    }
}
ApiService.ɵfac = function ApiService_Factory(t) { return new (t || ApiService)(i0.ɵɵinject(i1$1.HttpClient), i0.ɵɵinject(i2.Storage), i0.ɵɵinject(AuthService), i0.ɵɵinject(i1.AlertController)); };
ApiService.ɵprov = i0.ɵɵdefineInjectable({ token: ApiService, factory: ApiService.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(ApiService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1$1.HttpClient }, { type: i2.Storage }, { type: AuthService }, { type: i1.AlertController }]; }, null); })();

class Organization {
    constructor(data) {
        this.participants = [];
        if (data) {
            this.setData(data);
        }
    }
    setData(data) {
        var _a;
        this._id = data._id;
        this.name = data.name;
        this.timestamp_created = data.timestamp_created;
        this.minute_difference_from_UTC = data.minute_difference_from_UTC;
        this.platform_type = data.platform_type;
        this.service_sid = data.service_sid;
        this.translate_language = data.translate_language;
        this.timezone = data.timezone;
        this.phone_contacts = (_a = data.phone_contacts) !== null && _a !== void 0 ? _a : [];
        this.billing_setting = data.billing_setting;
        this.login_need_default_payment_method = data.login_need_default_payment_method;
        this.login_view_demo = data.login_view_demo;
        this.login_timestamp_trial_end = data.login_timestamp_trial_end;
        if (this.login_timestamp_trial_end)
            this.login_timestamp_trial_end_ms = this.login_timestamp_trial_end * 1000;
        this.login_isInTrial = data.login_isInTrial;
        this.login_delinquent = data.login_delinquent;
        this.billing_type = data.billing_type;
        this.billing_location = data.billing_location;
        this.billing_companyName = data.billing_companyName;
        this.billing_name = data.billing_name;
        this.billing_surname = data.billing_surname;
        this.billing_address = data.billing_address;
        this.billing_zip = data.billing_zip;
        this.billing_city = data.billing_city;
        this.billing_province = data.billing_province;
        this.billing_country = data.billing_country;
        this.billing_mail = data.billing_mail;
        this.billing_phone = data.billing_phone;
        this.billing_vat = data.billing_vat;
        this.billing_mailPEC = data.billing_mailPEC;
        this.billing_sdiCode_fatturaElettronica = data.billing_sdiCode_fatturaElettronica;
        this.billing_codiceFiscale = data.billing_codiceFiscale;
        // MESSI PER FORZARE TEST CONTROLLI INIZIALI BILLING
        // this.login_view_demo = false;
        // this.login_need_default_payment_method = true;
        // this.login_timestamp_trial_end_ms = Date.now();
        // this.login_delinquent = true;
    }
    addParticipant(participant) {
        if (participant) {
            this.participants.push(participant);
        }
    }
    updateParticipant(rawData) {
        if (rawData) {
            for (let participant of this.participants) {
                if (participant._id === rawData._id) {
                    participant.setData(rawData);
                    break;
                }
            }
        }
    }
    removeParticipant(id) {
        for (let i = 0; i < this.participants.length; i++) {
            if (this.participants[i]._id === id) {
                this.participants.splice(i, 1);
                break;
            }
        }
    }
    getParticipant(id) {
        return this.participants.find((elem) => {
            return elem._id === id;
        });
    }
}

class Poi {
    constructor(data) {
        if (data) {
            this.setData(data);
        }
    }
    setData(data) {
        this._id = data._id;
        this.name = data.name;
        this.idOrganization = data.idOrganization;
        this.images = data.images;
        this.position = data.position;
        this.radius = data.radius;
        this.timestampLastUpdate = data.timestampLastUpdate;
        this.timestampCreate = data.timestampCreate;
        this.address = data.address || data.adress; // cambiare poi con address
        this.label_number = data.label_number;
        if (this.position && this.position.coordinates && this.position.coordinates.length === 2) {
            this.latitude = this.position.coordinates[1];
            this.longitude = this.position.coordinates[0];
        }
    }
}

class PositionGps {
    constructor(data) {
        this.arrayPoi = [];
        if (data) {
            this._id = data._id;
            this.idOrganization = data.idOrganization;
            this.idPartecipant = data.idPartecipant;
            this.type = data.type;
            this.position = data.position;
            this.imei = data.imei;
            this.id_connection = data.id_connection;
            this.timestamp_server = data.timestamp_server;
            this.timestamp_position = data.timestamp_position;
            this.position_type = data.position_type;
            this.altitude = data.altitude;
            this.satellites = data.satellites;
            this.speed = data.speed;
            this.gsm_signal = data.gsm_signal;
            this.external_voltage = data.external_voltage;
            this.gsm_cell_id = data.gsm_cell_id;
            this.gsm_area_code = data.gsm_area_code;
            this.gsm_operator = data.gsm_operator;
            this.battery_voltage = data.battery_voltage;
            this.total_odometer = data.total_odometer;
            this.avl_id = data.avl_id;
            this.value = data.value;
            this.command_response = data.command_response;
            if (data.arrayPoi) {
                this.arrayPoi = [];
                for (let poi of data.arrayPoi) {
                    this.arrayPoi.push(new Poi(poi));
                }
                // this.arrayPoi.push(new Poi({name: 'test'}));
            }
        }
    }
}
// Sono 3 percorsi demo per i veicoli demo per storico e report
const DEMO_ROUTES = {
    "-1": [{ "_id": 0, "position_type": "moving", "delta_ms": 0, "speed": 81, "angle": 135, "total_odometer": 1200000, "latitude": 44.51515174751693, "longitude": 11.17900738102037 }, { "_id": 1, "position_type": "moving", "delta_ms": 2577, "speed": 88, "angle": 135, "total_odometer": 1200063, "latitude": 44.51492606151187, "longitude": 11.17973694187242 }, { "_id": 2, "position_type": "moving", "delta_ms": 5025, "speed": 100, "angle": 135, "total_odometer": 1200131, "latitude": 44.51466212253272, "longitude": 11.180520146904769 }, { "_id": 3, "position_type": "moving", "delta_ms": 9840, "speed": 80, "angle": 135, "total_odometer": 1200238, "latitude": 44.51419585591116, "longitude": 11.181699911822047 }, { "_id": 4, "position_type": "moving", "delta_ms": 12853, "speed": 86, "angle": 135, "total_odometer": 1200310, "latitude": 44.51390896206508, "longitude": 11.182520667780604 }, { "_id": 5, "position_type": "moving", "delta_ms": 15341, "speed": 81, "angle": 135, "total_odometer": 1200366, "latitude": 44.51369092179748, "longitude": 11.183164397944179 }, { "_id": 6, "position_type": "moving", "delta_ms": 17912, "speed": 84, "angle": 135, "total_odometer": 1200426, "latitude": 44.51342697722417, "longitude": 11.183834950197902 }, { "_id": 7, "position_type": "moving", "delta_ms": 20520, "speed": 98, "angle": 135, "total_odometer": 1200497, "latitude": 44.51313398156337, "longitude": 11.184637506653035 }, { "_id": 8, "position_type": "moving", "delta_ms": 22571, "speed": 93, "angle": 135, "total_odometer": 1200550, "latitude": 44.51293506502248, "longitude": 11.18524905030843 }, { "_id": 9, "position_type": "moving", "delta_ms": 24764, "speed": 87, "angle": 135, "total_odometer": 1200603, "latitude": 44.512724671788455, "longitude": 11.185860593963826 }, { "_id": 10, "position_type": "moving", "delta_ms": 26564, "speed": 86, "angle": 135, "total_odometer": 1200646, "latitude": 44.51254105525443, "longitude": 11.186343391586506 }, { "_id": 11, "position_type": "moving", "delta_ms": 29724, "speed": 82, "angle": 135, "total_odometer": 1200718, "latitude": 44.51224414277285, "longitude": 11.187160346300224 }, { "_id": 12, "position_type": "moving", "delta_ms": 32676, "speed": 89, "angle": 135, "total_odometer": 1200791, "latitude": 44.511957239318605, "longitude": 11.187997195512871 }, { "_id": 13, "position_type": "moving", "delta_ms": 36096, "speed": 80, "angle": 135, "total_odometer": 1200867, "latitude": 44.51164738200164, "longitude": 11.188855502397637 }, { "_id": 14, "position_type": "moving", "delta_ms": 39609, "speed": 83, "angle": 135, "total_odometer": 1200948, "latitude": 44.511306919593395, "longitude": 11.18976208904467 }, { "_id": 15, "position_type": "moving", "delta_ms": 42186, "speed": 88, "angle": 135, "total_odometer": 1201011, "latitude": 44.51105826601606, "longitude": 11.190480921060662 }, { "_id": 16, "position_type": "moving", "delta_ms": 44390, "speed": 98, "angle": 135, "total_odometer": 1201071, "latitude": 44.51081343684187, "longitude": 11.191162202150444 }, { "_id": 17, "position_type": "moving", "delta_ms": 46019, "speed": 95, "angle": 135, "total_odometer": 1201114, "latitude": 44.5106298142863, "longitude": 11.191650364191155 }, { "_id": 18, "position_type": "moving", "delta_ms": 48575, "speed": 100, "angle": 135, "total_odometer": 1201185, "latitude": 44.51033565430842, "longitude": 11.192448879132563 }, { "_id": 19, "position_type": "moving", "delta_ms": 51635, "speed": 80, "angle": 135, "total_odometer": 1201253, "latitude": 44.51007934556367, "longitude": 11.193232084164912 }, { "_id": 20, "position_type": "moving", "delta_ms": 53573, "speed": 91, "angle": 135, "total_odometer": 1201302, "latitude": 44.50987659307159, "longitude": 11.19378998364001 }, { "_id": 21, "position_type": "moving", "delta_ms": 56782, "speed": 83, "angle": 135, "total_odometer": 1201376, "latitude": 44.50956097612543, "longitude": 11.194613464920694 }, { "_id": 22, "position_type": "moving", "delta_ms": 59017, "speed": 95, "angle": 135, "total_odometer": 1201435, "latitude": 44.50933526846924, "longitude": 11.195289381592447 }, { "_id": 23, "position_type": "moving", "delta_ms": 61984, "speed": 91, "angle": 135, "total_odometer": 1201510, "latitude": 44.509005719405486, "longitude": 11.196115501969034 }, { "_id": 24, "position_type": "moving", "delta_ms": 64872, "speed": 86, "angle": 135, "total_odometer": 1201579, "latitude": 44.50873410241285, "longitude": 11.196909435837442 }, { "_id": 25, "position_type": "moving", "delta_ms": 66672, "speed": 80, "angle": 135, "total_odometer": 1201619, "latitude": 44.5085734269763, "longitude": 11.197365411369974 }, { "_id": 26, "position_type": "moving", "delta_ms": 70347, "speed": 95, "angle": 135, "total_odometer": 1201716, "latitude": 44.50817938772117, "longitude": 11.19845975264805 }, { "_id": 27, "position_type": "moving", "delta_ms": 73047, "speed": 88, "angle": 135, "total_odometer": 1201782, "latitude": 44.50791097955729, "longitude": 11.199202475968416 }, { "_id": 28, "position_type": "moving", "delta_ms": 75076, "speed": 94, "angle": 135, "total_odometer": 1201835, "latitude": 44.50770056818642, "longitude": 11.199814019623812 }, { "_id": 29, "position_type": "moving", "delta_ms": 76876, "speed": 92, "angle": 135, "total_odometer": 1201881, "latitude": 44.50751311014352, "longitude": 11.20033973259073 }, { "_id": 30, "position_type": "moving", "delta_ms": 80476, "speed": 88, "angle": 135, "total_odometer": 1201969, "latitude": 44.507141744127, "longitude": 11.201331429773305 }, { "_id": 31, "position_type": "moving", "delta_ms": 83053, "speed": 88, "angle": 135, "total_odometer": 1202032, "latitude": 44.50690072422185, "longitude": 11.202060990625355 }, { "_id": 32, "position_type": "moving", "delta_ms": 85798, "speed": 80, "angle": 135, "total_odometer": 1202093, "latitude": 44.50664884617266, "longitude": 11.202754354531605 }, { "_id": 33, "position_type": "moving", "delta_ms": 88240, "speed": 84, "angle": 135, "total_odometer": 1202150, "latitude": 44.50640017272291, "longitude": 11.20338735585912 }, { "_id": 34, "position_type": "moving", "delta_ms": 90484, "speed": 85, "angle": 135, "total_odometer": 1202203, "latitude": 44.50620888473199, "longitude": 11.203998899514515 }, { "_id": 35, "position_type": "moving", "delta_ms": 92734, "speed": 80, "angle": 135, "total_odometer": 1202253, "latitude": 44.50601596336594, "longitude": 11.204579603367918 }, { "_id": 36, "position_type": "moving", "delta_ms": 94840, "speed": 94, "angle": 135, "total_odometer": 1202308, "latitude": 44.50574815823774, "longitude": 11.205175053769224 }, { "_id": 37, "position_type": "moving", "delta_ms": 97417, "speed": 81, "angle": 135, "total_odometer": 1202366, "latitude": 44.505514784194254, "longitude": 11.205840241604918 }, { "_id": 38, "position_type": "moving", "delta_ms": 99842, "speed": 95, "angle": 135, "total_odometer": 1202430, "latitude": 44.50526993173441, "longitude": 11.206575166874998 }, { "_id": 39, "position_type": "moving", "delta_ms": 101723, "speed": 88, "angle": 135, "total_odometer": 1202476, "latitude": 44.50506716251262, "longitude": 11.207084786587828 }, { "_id": 40, "position_type": "moving", "delta_ms": 103459, "speed": 85, "angle": 135, "total_odometer": 1202517, "latitude": 44.5049026511163, "longitude": 11.207556855374449 }, { "_id": 41, "position_type": "moving", "delta_ms": 106224, "speed": 82, "angle": 135, "total_odometer": 1202580, "latitude": 44.50464249261173, "longitude": 11.20827032297241 }, { "_id": 42, "position_type": "moving", "delta_ms": 108132, "speed": 83, "angle": 135, "total_odometer": 1202624, "latitude": 44.50446650237676, "longitude": 11.20876921384918 }, { "_id": 43, "position_type": "moving", "delta_ms": 110478, "speed": 89, "angle": 135, "total_odometer": 1202682, "latitude": 44.504221397546694, "longitude": 11.209427656402381 }, { "_id": 44, "position_type": "moving", "delta_ms": 111952, "speed": 83, "angle": 135, "total_odometer": 1202716, "latitude": 44.50407983920305, "longitude": 11.209808530082496 }, { "_id": 45, "position_type": "moving", "delta_ms": 113370, "speed": 99, "angle": 135, "total_odometer": 1202755, "latitude": 44.50392297685319, "longitude": 11.210248412360938 }, { "_id": 46, "position_type": "moving", "delta_ms": 114696, "speed": 95, "angle": 135, "total_odometer": 1202790, "latitude": 44.50378141778491, "longitude": 11.210650743713172 }, { "_id": 47, "position_type": "moving", "delta_ms": 116208, "speed": 100, "angle": 135, "total_odometer": 1202832, "latitude": 44.50363372128931, "longitude": 11.21114538676725 }, { "_id": 48, "position_type": "moving", "delta_ms": 118403, "speed": 82, "angle": 135, "total_odometer": 1202882, "latitude": 44.50341181663101, "longitude": 11.211703286242347 }, { "_id": 49, "position_type": "moving", "delta_ms": 120183, "speed": 91, "angle": 135, "total_odometer": 1202927, "latitude": 44.503228170757794, "longitude": 11.212212905955177 }, { "_id": 50, "position_type": "moving", "delta_ms": 123700, "speed": 87, "angle": 135, "total_odometer": 1203012, "latitude": 44.50287622315279, "longitude": 11.213166220337092 }, { "_id": 51, "position_type": "moving", "delta_ms": 125944, "speed": 85, "angle": 135, "total_odometer": 1203065, "latitude": 44.502661967609406, "longitude": 11.213767035156428 }, { "_id": 52, "position_type": "moving", "delta_ms": 128614, "speed": 93, "angle": 135, "total_odometer": 1203134, "latitude": 44.50237329053115, "longitude": 11.214538988226055 }, { "_id": 53, "position_type": "moving", "delta_ms": 131427, "speed": 87, "angle": 135, "total_odometer": 1203202, "latitude": 44.50210929470378, "longitude": 11.215311464422344 }, { "_id": 54, "position_type": "moving", "delta_ms": 133587, "speed": 100, "angle": 135, "total_odometer": 1203262, "latitude": 44.50186442794017, "longitude": 11.215998109930156 }, { "_id": 55, "position_type": "moving", "delta_ms": 137144, "speed": 85, "angle": 135, "total_odometer": 1203346, "latitude": 44.501523908387476, "longitude": 11.216942247503399 }, { "_id": 56, "position_type": "moving", "delta_ms": 141329, "speed": 80, "angle": 135, "total_odometer": 1203439, "latitude": 44.50114129977574, "longitude": 11.217993673437237 }, { "_id": 57, "position_type": "moving", "delta_ms": 143616, "speed": 96, "angle": 135, "total_odometer": 1203500, "latitude": 44.500878559862656, "longitude": 11.218675425885731 }, { "_id": 58, "position_type": "moving", "delta_ms": 145941, "speed": 96, "angle": 135, "total_odometer": 1203562, "latitude": 44.50064516632472, "longitude": 11.219394257901723 }, { "_id": 59, "position_type": "moving", "delta_ms": 147520, "speed": 98, "angle": 135, "total_odometer": 1203605, "latitude": 44.50045385944932, "longitude": 11.219866326688344 }, { "_id": 60, "position_type": "moving", "delta_ms": 151564, "speed": 89, "angle": 135, "total_odometer": 1203705, "latitude": 44.50005971013909, "longitude": 11.2210027646492 }, { "_id": 61, "position_type": "moving", "delta_ms": 153893, "speed": 85, "angle": 135, "total_odometer": 1203760, "latitude": 44.49983779187702, "longitude": 11.221625037140655 }, { "_id": 62, "position_type": "moving", "delta_ms": 158342, "speed": 89, "angle": 135, "total_odometer": 1203870, "latitude": 44.499376455630646, "longitude": 11.222862951538403 }, { "_id": 63, "position_type": "moving", "delta_ms": 160019, "speed": 88, "angle": 135, "total_odometer": 1203911, "latitude": 44.49922723307464, "longitude": 11.223345749161084 }, { "_id": 64, "position_type": "moving", "delta_ms": 162785, "speed": 95, "angle": 135, "total_odometer": 1203984, "latitude": 44.498921134328704, "longitude": 11.22416114070161 }, { "_id": 65, "position_type": "moving", "delta_ms": 165809, "speed": 100, "angle": 135, "total_odometer": 1204068, "latitude": 44.498584423852115, "longitude": 11.225110642692883 }, { "_id": 66, "position_type": "moving", "delta_ms": 168120, "speed": 81, "angle": 135, "total_odometer": 1204120, "latitude": 44.498366326255784, "longitude": 11.22569536425813 }, { "_id": 67, "position_type": "moving", "delta_ms": 170578, "speed": 82, "angle": 135, "total_odometer": 1204176, "latitude": 44.49814440154848, "longitude": 11.226328365585644 }, { "_id": 68, "position_type": "moving", "delta_ms": 172549, "speed": 84, "angle": 135, "total_odometer": 1204222, "latitude": 44.497937781234086, "longitude": 11.226837985298474 }, { "_id": 69, "position_type": "moving", "delta_ms": 176235, "speed": 83, "angle": 135, "total_odometer": 1204307, "latitude": 44.49761265947746, "longitude": 11.227809574034259 }, { "_id": 70, "position_type": "moving", "delta_ms": 178195, "speed": 90, "angle": 135, "total_odometer": 1204356, "latitude": 44.497386905556745, "longitude": 11.228346015837237 }, { "_id": 71, "position_type": "moving", "delta_ms": 180782, "speed": 96, "angle": 135, "total_odometer": 1204425, "latitude": 44.497130539875045, "longitude": 11.229150678541705 }, { "_id": 72, "position_type": "moving", "delta_ms": 183208, "speed": 89, "angle": 135, "total_odometer": 1204485, "latitude": 44.49687417306623, "longitude": 11.229826595213458 }, { "_id": 73, "position_type": "moving", "delta_ms": 185481, "speed": 95, "angle": 135, "total_odometer": 1204545, "latitude": 44.496625457920814, "longitude": 11.230497147467181 }, { "_id": 74, "position_type": "moving", "delta_ms": 188555, "speed": 89, "angle": 135, "total_odometer": 1204621, "latitude": 44.49630645403078, "longitude": 11.231349086605418 }, { "_id": 75, "position_type": "moving", "delta_ms": 191555, "speed": 90, "angle": 135, "total_odometer": 1204696, "latitude": 44.4960232985633, "longitude": 11.232212757908213 }, { "_id": 76, "position_type": "moving", "delta_ms": 193559, "speed": 88, "angle": 135, "total_odometer": 1204745, "latitude": 44.49580519138739, "longitude": 11.232749199711192 }, { "_id": 77, "position_type": "moving", "delta_ms": 195401, "speed": 84, "angle": 135, "total_odometer": 1204788, "latitude": 44.49562917447518, "longitude": 11.233242726169932 }, { "_id": 78, "position_type": "moving", "delta_ms": 197381, "speed": 80, "angle": 135, "total_odometer": 1204832, "latitude": 44.49545315703166, "longitude": 11.233741617046702 }, { "_id": 79, "position_type": "moving", "delta_ms": 198989, "speed": 94, "angle": 135, "total_odometer": 1204874, "latitude": 44.495265659605245, "longitude": 11.234208321415293 }, { "_id": 80, "position_type": "moving", "delta_ms": 201375, "speed": 86, "angle": 135, "total_odometer": 1204931, "latitude": 44.495039896597966, "longitude": 11.234857415996897 }, { "_id": 81, "position_type": "moving", "delta_ms": 203619, "speed": 85, "angle": 135, "total_odometer": 1204984, "latitude": 44.494829438770104, "longitude": 11.235458230816233 }, { "_id": 82, "position_type": "moving", "delta_ms": 205251, "speed": 97, "angle": 135, "total_odometer": 1205028, "latitude": 44.4946495923881, "longitude": 11.235962486111033 }, { "_id": 83, "position_type": "moving", "delta_ms": 207051, "speed": 96, "angle": 135, "total_odometer": 1205076, "latitude": 44.49443913315163, "longitude": 11.236504292332041 }, { "_id": 84, "position_type": "moving", "delta_ms": 209589, "speed": 95, "angle": 135, "total_odometer": 1205143, "latitude": 44.49417322878706, "longitude": 11.237272510493005 }, { "_id": 85, "position_type": "moving", "delta_ms": 212125, "speed": 88, "angle": 135, "total_odometer": 1205205, "latitude": 44.49392832869365, "longitude": 11.237985978090967 }, { "_id": 86, "position_type": "moving", "delta_ms": 213385, "speed": 100, "angle": 135, "total_odometer": 1205240, "latitude": 44.493767612448444, "longitude": 11.238372216189111 }, { "_id": 87, "position_type": "moving", "delta_ms": 215978, "speed": 93, "angle": 135, "total_odometer": 1205307, "latitude": 44.493488271254016, "longitude": 11.239123234713281 }, { "_id": 88, "position_type": "moving", "delta_ms": 223594, "speed": 95, "angle": 135, "total_odometer": 1205508, "latitude": 44.492726772709375, "longitude": 11.241421887839044 }, { "_id": 89, "position_type": "moving", "delta_ms": 229256, "speed": 89, "angle": 135, "total_odometer": 1205648, "latitude": 44.492160425635795, "longitude": 11.2429990267398 }, { "_id": 90, "position_type": "moving", "delta_ms": 234398, "speed": 84, "angle": 135, "total_odometer": 1205768, "latitude": 44.49165530063278, "longitude": 11.244340131247247 }, { "_id": 91, "position_type": "moving", "delta_ms": 240878, "speed": 80, "angle": 135, "total_odometer": 1205912, "latitude": 44.49110425018535, "longitude": 11.245992372000421 }, { "_id": 92, "position_type": "moving", "delta_ms": 244816, "speed": 85, "angle": 135, "total_odometer": 1206005, "latitude": 44.490690958933, "longitude": 11.24701161142608 }, { "_id": 93, "position_type": "moving", "delta_ms": 250256, "speed": 88, "angle": 135, "total_odometer": 1206138, "latitude": 44.490178167567265, "longitude": 11.248535106146539 }, { "_id": 94, "position_type": "moving", "delta_ms": 255761, "speed": 85, "angle": 135, "total_odometer": 1206268, "latitude": 44.48963475687134, "longitude": 11.24999422785064 }, { "_id": 95, "position_type": "moving", "delta_ms": 258733, "speed": 86, "angle": 135, "total_odometer": 1206339, "latitude": 44.489297992772336, "longitude": 11.25076670404693 }, { "_id": 96, "position_type": "moving", "delta_ms": 262493, "speed": 90, "angle": 135, "total_odometer": 1206433, "latitude": 44.48887703491422, "longitude": 11.251796672308648 }, { "_id": 97, "position_type": "moving", "delta_ms": 265895, "speed": 91, "angle": 135, "total_odometer": 1206519, "latitude": 44.48845607401795, "longitude": 11.252719352209771 }, { "_id": 98, "position_type": "moving", "delta_ms": 268604, "speed": 93, "angle": 135, "total_odometer": 1206589, "latitude": 44.48810399529888, "longitude": 11.253459641897882 }, { "_id": 99, "position_type": "moving", "delta_ms": 272247, "speed": 83, "angle": 135, "total_odometer": 1206673, "latitude": 44.487660066928356, "longitude": 11.254328677618707 }, { "_id": 100, "position_type": "moving", "delta_ms": 276237, "speed": 83, "angle": 135, "total_odometer": 1206765, "latitude": 44.48717021101231, "longitude": 11.25526208635589 }, { "_id": 101, "position_type": "moving", "delta_ms": 279754, "speed": 87, "angle": 135, "total_odometer": 1206850, "latitude": 44.486665042790264, "longitude": 11.256077477896417 }, { "_id": 102, "position_type": "moving", "delta_ms": 285123, "speed": 59, "angle": 170, "total_odometer": 1206938, "latitude": 44.48600678672441, "longitude": 11.256699750387872 }, { "_id": 103, "position_type": "moving", "delta_ms": 289809, "speed": 53, "angle": 170, "total_odometer": 1207007, "latitude": 44.485417411618485, "longitude": 11.25700015779754 }, { "_id": 104, "position_type": "moving", "delta_ms": 294951, "speed": 56, "angle": 190, "total_odometer": 1207087, "latitude": 44.48469790666401, "longitude": 11.256860682928766 }, { "_id": 105, "position_type": "moving", "delta_ms": 299405, "speed": 59, "angle": 190, "total_odometer": 1207160, "latitude": 44.48403962840015, "longitude": 11.25675339456817 }, { "_id": 106, "position_type": "moving", "delta_ms": 303489, "speed": 52, "angle": 180, "total_odometer": 1207219, "latitude": 44.48357270559372, "longitude": 11.257107446158136 }, { "_id": 107, "position_type": "moving", "delta_ms": 308379, "speed": 53, "angle": 180, "total_odometer": 1207291, "latitude": 44.48341961533549, "longitude": 11.25799793955108 }, { "_id": 108, "position_type": "moving", "delta_ms": 314237, "speed": 51, "angle": 45, "total_odometer": 1207374, "latitude": 44.483832958110774, "longitude": 11.258877704107965 }, { "_id": 109, "position_type": "moving", "delta_ms": 321508, "speed": 50, "angle": 45, "total_odometer": 1207475, "latitude": 44.484399386046235, "longitude": 11.259875485861505 }, { "_id": 110, "position_type": "moving", "delta_ms": 327914, "speed": 59, "angle": 45, "total_odometer": 1207580, "latitude": 44.48497346280149, "longitude": 11.260937640631402 }, { "_id": 111, "position_type": "moving", "delta_ms": 334283, "speed": 52, "angle": 45, "total_odometer": 1207672, "latitude": 44.48532556041629, "longitude": 11.26198906656524 }, { "_id": 112, "position_type": "moving", "delta_ms": 342682, "speed": 60, "angle": 45, "total_odometer": 1207812, "latitude": 44.485914936450236, "longitude": 11.263555476629938 }, { "_id": 113, "position_type": "moving", "delta_ms": 348982, "speed": 92, "angle": 45, "total_odometer": 1207973, "latitude": 44.486657388692656, "longitude": 11.265304276907647 }, { "_id": 114, "position_type": "moving", "delta_ms": 354862, "speed": 90, "angle": 45, "total_odometer": 1208120, "latitude": 44.48746871745077, "longitude": 11.266774127447809 }, { "_id": 115, "position_type": "moving", "delta_ms": 360037, "speed": 80, "angle": 45, "total_odometer": 1208235, "latitude": 44.488188188229394, "longitude": 11.267827940139279 }, { "_id": 116, "position_type": "moving", "delta_ms": 364914, "speed": 93, "angle": 45, "total_odometer": 1208361, "latitude": 44.489106648668006, "longitude": 11.268761348876462 }, { "_id": 117, "position_type": "moving", "delta_ms": 370377, "speed": 85, "angle": 45, "total_odometer": 1208490, "latitude": 44.490109284801505, "longitude": 11.269576740416989 }, { "_id": 118, "position_type": "moving", "delta_ms": 378281, "speed": 92, "angle": 5, "total_odometer": 1208692, "latitude": 44.49179296764618, "longitude": 11.27052914882225 }, { "_id": 119, "position_type": "moving", "delta_ms": 385238, "speed": 89, "angle": 5, "total_odometer": 1208864, "latitude": 44.493323632402074, "longitude": 11.270904658084335 }, { "_id": 120, "position_type": "moving", "delta_ms": 391783, "speed": 99, "angle": 5, "total_odometer": 1209044, "latitude": 44.494935711222766, "longitude": 11.271181936884055 }, { "_id": 121, "position_type": "moving", "delta_ms": 400153, "speed": 80, "angle": 5, "total_odometer": 1209230, "latitude": 44.4966040439265, "longitude": 11.271407242441306 }, { "_id": 122, "position_type": "moving", "delta_ms": 407066, "speed": 88, "angle": 5, "total_odometer": 1209399, "latitude": 44.49811927722081, "longitude": 11.271664734506736 }, { "_id": 123, "position_type": "moving", "delta_ms": 413659, "speed": 89, "angle": 5, "total_odometer": 1209562, "latitude": 44.49958090435011, "longitude": 11.271836395883689 }, { "_id": 124, "position_type": "moving", "delta_ms": 421368, "speed": 99, "angle": 5, "total_odometer": 1209774, "latitude": 44.501478784141305, "longitude": 11.27217331356824 }, { "_id": 125, "position_type": "moving", "delta_ms": 427054, "speed": 88, "angle": 5, "total_odometer": 1209913, "latitude": 44.502726071745904, "longitude": 11.272344974945193 }, { "_id": 126, "position_type": "moving", "delta_ms": 440402, "speed": 89, "angle": 5, "total_odometer": 1210243, "latitude": 44.50561177683833, "longitude": 11.273304977573225 }, { "_id": 127, "position_type": "moving", "delta_ms": 447943, "speed": 95, "angle": 5, "total_odometer": 1210442, "latitude": 44.50729510685801, "longitude": 11.27418474213011 }, { "_id": 128, "position_type": "moving", "delta_ms": 466393, "speed": 48, "angle": 10, "total_odometer": 1210688, "latitude": 44.50914671373406, "longitude": 11.275879898227522 }, { "_id": 129, "position_type": "moving", "delta_ms": 477493, "speed": 48, "angle": 110, "total_odometer": 1210836, "latitude": 44.50934564320504, "longitude": 11.277725258029768 }, { "_id": 130, "position_type": "moving", "delta_ms": 481768, "speed": 48, "angle": 110, "total_odometer": 1210893, "latitude": 44.509360945443916, "longitude": 11.27845481888182 }, { "_id": 131, "position_type": "stop", "delta_ms": 481888, "speed": 0, "angle": 110, "total_odometer": 1210893, "latitude": 44.509360945443916, "longitude": 11.27845481888182 }, { "_id": 132, "position_type": "stop", "delta_ms": 493888, "speed": 0, "angle": 110, "total_odometer": 1210893, "latitude": 44.509360945443916, "longitude": 11.27845481888182 }, { "_id": 133, "position_type": "moving", "delta_ms": 500647, "speed": 49, "angle": 110, "total_odometer": 1210985, "latitude": 44.50868764313289, "longitude": 11.279141464389632 }, { "_id": 134, "position_type": "moving", "delta_ms": 515243, "speed": 55, "angle": 110, "total_odometer": 1211208, "latitude": 44.50772358310135, "longitude": 11.281609096683333 }, { "_id": 135, "position_type": "moving", "delta_ms": 522565, "speed": 59, "angle": 110, "total_odometer": 1211328, "latitude": 44.507172684495686, "longitude": 11.2829180146826 }, { "_id": 136, "position_type": "moving", "delta_ms": 528585, "speed": 58, "angle": 110, "total_odometer": 1211425, "latitude": 44.50688193035472, "longitude": 11.284076728977034 }, { "_id": 137, "position_type": "moving", "delta_ms": 545596, "speed": 51, "angle": 110, "total_odometer": 1211666, "latitude": 44.506081180241424, "longitude": 11.286901802455706 }, { "_id": 138, "position_type": "moving", "delta_ms": 563722, "speed": 57, "angle": 110, "total_odometer": 1211953, "latitude": 44.505101773747604, "longitude": 11.290249199306292 }, { "_id": 139, "position_type": "moving", "delta_ms": 576322, "speed": 54, "angle": 110, "total_odometer": 1212142, "latitude": 44.504459029293244, "longitude": 11.292459339534563 }, { "_id": 140, "position_type": "moving", "delta_ms": 590501, "speed": 49, "angle": 110, "total_odometer": 1212335, "latitude": 44.50377036665661, "longitude": 11.294690937434954 }, { "_id": 141, "position_type": "moving", "delta_ms": 600690, "speed": 59, "angle": 110, "total_odometer": 1212502, "latitude": 44.503173519124296, "longitude": 11.296622127925676 }, { "_id": 142, "position_type": "moving", "delta_ms": 611490, "speed": 52, "angle": 110, "total_odometer": 1212658, "latitude": 44.50260727350929, "longitude": 11.298424572383684 }, { "_id": 143, "position_type": "moving", "delta_ms": 622944, "speed": 44, "angle": 110, "total_odometer": 1212798, "latitude": 44.50214815140555, "longitude": 11.300076813136858 }, { "_id": 144, "position_type": "moving", "delta_ms": 631027, "speed": 53, "angle": 110, "total_odometer": 1212917, "latitude": 44.501795655189206, "longitude": 11.30149442200619 }, { "_id": 145, "position_type": "moving", "delta_ms": 641321, "speed": 57, "angle": 110, "total_odometer": 1213080, "latitude": 44.50142835268214, "longitude": 11.30348998551327 }, { "_id": 146, "position_type": "moving", "delta_ms": 646601, "speed": 45, "angle": 110, "total_odometer": 1213146, "latitude": 44.500831481172824, "longitude": 11.303597273873866 }, { "_id": 147, "position_type": "moving", "delta_ms": 655026, "speed": 47, "angle": 110, "total_odometer": 1213256, "latitude": 44.499897900661495, "longitude": 11.304069342660487 }, { "_id": 148, "position_type": "moving", "delta_ms": 660944, "speed": 59, "angle": 110, "total_odometer": 1213353, "latitude": 44.499653024610026, "longitude": 11.30524951462704 }, { "_id": 149, "position_type": "moving", "delta_ms": 667607, "speed": 47, "angle": 110, "total_odometer": 1213440, "latitude": 44.49997442421667, "longitude": 11.30625802521664 }, { "_id": 150, "position_type": "moving", "delta_ms": 676814, "speed": 52, "angle": 110, "total_odometer": 1213573, "latitude": 44.50116817867292, "longitude": 11.30647260193783 }, { "_id": 151, "position_type": "moving", "delta_ms": 687914, "speed": 48, "angle": 110, "total_odometer": 1213721, "latitude": 44.502315996446356, "longitude": 11.307416739511073 }, { "_id": 152, "position_type": "moving", "delta_ms": 694813, "speed": 60, "angle": 110, "total_odometer": 1213836, "latitude": 44.50323423439453, "longitude": 11.308081927346766 }, { "_id": 153, "position_type": "moving", "delta_ms": 705751, "speed": 52, "angle": 110, "total_odometer": 1213994, "latitude": 44.50456792249352, "longitude": 11.30879321165506 }, { "_id": 154, "position_type": "moving", "delta_ms": 714319, "speed": 50, "angle": 110, "total_odometer": 1214113, "latitude": 44.50556264119271, "longitude": 11.309372568802276 }, { "_id": 155, "position_type": "moving", "delta_ms": 733492, "speed": 46, "angle": 110, "total_odometer": 1214358, "latitude": 44.50758202450382, "longitude": 11.31060781054225 }, { "_id": 156, "position_type": "moving", "delta_ms": 738617, "speed": 59, "angle": 110, "total_odometer": 1214442, "latitude": 44.50825533958637, "longitude": 11.31110133700099 }, { "_id": 157, "position_type": "moving", "delta_ms": 753856, "speed": 60, "angle": 110, "total_odometer": 1214696, "latitude": 44.51038235204686, "longitude": 11.312281508967542 }, { "_id": 158, "position_type": "moving", "delta_ms": 776437, "speed": 44, "angle": 110, "total_odometer": 1214972, "latitude": 44.51266230078836, "longitude": 11.313676257655287 }, { "_id": 159, "position_type": "moving", "delta_ms": 790530, "speed": 47, "angle": 110, "total_odometer": 1215156, "latitude": 44.51425362155313, "longitude": 11.31431998781886 }, { "_id": 160, "position_type": "moving", "delta_ms": 798422, "speed": 52, "angle": 110, "total_odometer": 1215270, "latitude": 44.51433012626438, "longitude": 11.315757651850843 }, { "_id": 161, "position_type": "moving", "delta_ms": 806603, "speed": 55, "angle": 110, "total_odometer": 1215395, "latitude": 44.51361097801347, "longitude": 11.316980739161634 }, { "_id": 162, "position_type": "moving", "delta_ms": 812547, "speed": 43, "angle": 110, "total_odometer": 1215466, "latitude": 44.51338146074614, "longitude": 11.31781758837428 }, { "_id": 163, "position_type": "moving", "delta_ms": 817641, "speed": 53, "angle": 110, "total_odometer": 1215541, "latitude": 44.51374868793997, "longitude": 11.318611522242689 }, { "_id": 164, "position_type": "moving", "delta_ms": 826335, "speed": 53, "angle": 110, "total_odometer": 1215669, "latitude": 44.51472934213138, "longitude": 11.319460077044793 }, { "_id": 165, "position_type": "moving", "delta_ms": 834107, "speed": 44, "angle": 110, "total_odometer": 1215764, "latitude": 44.5152189665508, "longitude": 11.320447129962274 }, { "_id": 166, "position_type": "moving", "delta_ms": 839468, "speed": 47, "angle": 110, "total_odometer": 1215834, "latitude": 44.51488235020436, "longitude": 11.321198148486443 }, { "_id": 167, "position_type": "moving", "delta_ms": 848725, "speed": 56, "angle": 110, "total_odometer": 1215978, "latitude": 44.513994897788756, "longitude": 11.32252852415783 }, { "_id": 168, "position_type": "moving", "delta_ms": 858276, "speed": 49, "angle": 110, "total_odometer": 1216108, "latitude": 44.513489961933885, "longitude": 11.32400910353405 }, { "_id": 169, "position_type": "moving", "delta_ms": 865476, "speed": 58, "angle": 110, "total_odometer": 1216224, "latitude": 44.51322984175579, "longitude": 11.325425309893914 }, { "_id": 170, "position_type": "moving", "delta_ms": 876100, "speed": 41, "angle": 110, "total_odometer": 1216345, "latitude": 44.51329104660804, "longitude": 11.326948804614373 }, { "_id": 171, "position_type": "moving", "delta_ms": 882960, "speed": 53, "angle": 170, "total_odometer": 1216446, "latitude": 44.51243417282726, "longitude": 11.327377958056756 }, { "_id": 172, "position_type": "moving", "delta_ms": 899331, "speed": 42, "angle": 170, "total_odometer": 1216637, "latitude": 44.510888707906005, "longitude": 11.328450841662713 }, { "_id": 173, "position_type": "moving", "delta_ms": 905583, "speed": 57, "angle": 170, "total_odometer": 1216736, "latitude": 44.510110432267005, "longitude": 11.329071521759033 }, { "_id": 174, "position_type": "stop", "delta_ms": 917583, "speed": 0, "angle": 170, "total_odometer": 1216736, "latitude": 44.510110432267005, "longitude": 11.329071521759033 }, { "_id": 175, "position_type": "moving", "delta_ms": 923827, "speed": 49, "angle": 170, "total_odometer": 1216821, "latitude": 44.50934320200289, "longitude": 11.329073114154168 }, { "_id": 176, "position_type": "moving", "delta_ms": 938227, "speed": 58, "angle": 170, "total_odometer": 1217053, "latitude": 44.50742269470867, "longitude": 11.330227680304974 }, { "_id": 177, "position_type": "moving", "delta_ms": 951779, "speed": 51, "angle": 170, "total_odometer": 1217245, "latitude": 44.505846490588546, "longitude": 11.331236190894574 }, { "_id": 178, "position_type": "moving", "delta_ms": 967721, "speed": 42, "angle": 170, "total_odometer": 1217431, "latitude": 44.50428554741888, "longitude": 11.33209449777934 }, { "_id": 179, "position_type": "moving", "delta_ms": 978961, "speed": 49, "angle": 170, "total_odometer": 1217584, "latitude": 44.503045945126644, "longitude": 11.332952804664105 }, { "_id": 180, "position_type": "moving", "delta_ms": 988030, "speed": 52, "angle": 170, "total_odometer": 1217715, "latitude": 44.50194405429447, "longitude": 11.33355361948344 }, { "_id": 181, "position_type": "moving", "delta_ms": 998756, "speed": 49, "angle": 170, "total_odometer": 1217861, "latitude": 44.50072594734167, "longitude": 11.334254361800612 }, { "_id": 182, "position_type": "moving", "delta_ms": 1008206, "speed": 48, "angle": 170, "total_odometer": 1217987, "latitude": 44.49971584134638, "longitude": 11.334983922652663 }, { "_id": 183, "position_type": "moving", "delta_ms": 1019636, "speed": 40, "angle": 170, "total_odometer": 1218114, "latitude": 44.49864449768303, "longitude": 11.33556327979988 }, { "_id": 184, "position_type": "moving", "delta_ms": 1028194, "speed": 53, "angle": 260, "total_odometer": 1218240, "latitude": 44.49849144698131, "longitude": 11.333986140899123 }, { "_id": 185, "position_type": "moving", "delta_ms": 1038837, "speed": 46, "angle": 260, "total_odometer": 1218376, "latitude": 44.498399616367465, "longitude": 11.332269527129592 }, { "_id": 186, "position_type": "moving", "delta_ms": 1043573, "speed": 57, "angle": 260, "total_odometer": 1218451, "latitude": 44.49818534437266, "longitude": 11.331368304900588 }, { "_id": 187, "position_type": "moving", "delta_ms": 1050332, "speed": 49, "angle": 260, "total_odometer": 1218543, "latitude": 44.49818534437266, "longitude": 11.330209590606154 }, { "_id": 188, "position_type": "moving", "delta_ms": 1060382, "speed": 48, "angle": 260, "total_odometer": 1218677, "latitude": 44.49873632791124, "longitude": 11.328707553557814 }, { "_id": 189, "position_type": "moving", "delta_ms": 1066424, "speed": 56, "angle": 260, "total_odometer": 1218771, "latitude": 44.49910364737779, "longitude": 11.327634669951857 }, { "_id": 190, "position_type": "moving", "delta_ms": 1069108, "speed": 59, "angle": 260, "total_odometer": 1218815, "latitude": 44.49895059788128, "longitude": 11.327119685820998 }, { "_id": 191, "position_type": "moving", "delta_ms": 1075668, "speed": 45, "angle": 180, "total_odometer": 1218897, "latitude": 44.49821595470583, "longitude": 11.327248431853713 }, { "_id": 192, "position_type": "moving", "delta_ms": 1080934, "speed": 54, "angle": 180, "total_odometer": 1218976, "latitude": 44.49751191297703, "longitude": 11.327420093230666 }, { "_id": 193, "position_type": "moving", "delta_ms": 1084099, "speed": 58, "angle": 180, "total_odometer": 1219027, "latitude": 44.497052750748004, "longitude": 11.327463008574904 }, { "_id": 194, "position_type": "moving", "delta_ms": 1088797, "speed": 59, "angle": 270, "total_odometer": 1219104, "latitude": 44.497009977823026, "longitude": 11.326489157387773 }, { "_id": 195, "position_type": "moving", "delta_ms": 1097859, "speed": 58, "angle": 270, "total_odometer": 1219250, "latitude": 44.49697936685675, "longitude": 11.324643797585527 }, { "_id": 196, "position_type": "moving", "delta_ms": 1107127, "speed": 47, "angle": 270, "total_odometer": 1219371, "latitude": 44.497040588773245, "longitude": 11.323120302865068 }, { "_id": 197, "position_type": "moving", "delta_ms": 1115707, "speed": 60, "angle": 270, "total_odometer": 1219514, "latitude": 44.4971630324134, "longitude": 11.32131785840706 }, { "_id": 198, "position_type": "moving", "delta_ms": 1124507, "speed": 45, "angle": 270, "total_odometer": 1219624, "latitude": 44.49713242152748, "longitude": 11.319923109719316 }, { "_id": 199, "position_type": "moving", "delta_ms": 1132053, "speed": 52, "angle": 270, "total_odometer": 1219733, "latitude": 44.49710181062547, "longitude": 11.31854981870369 }, { "_id": 200, "position_type": "moving", "delta_ms": 1141625, "speed": 44, "angle": 270, "total_odometer": 1219850, "latitude": 44.497407918922356, "longitude": 11.317133612343827 }, { "_id": 201, "position_type": "moving", "delta_ms": 1152921, "speed": 58, "angle": 270, "total_odometer": 1220032, "latitude": 44.497545667131696, "longitude": 11.31483764142708 }, { "_id": 202, "position_type": "moving", "delta_ms": 1159693, "speed": 59, "angle": 270, "total_odometer": 1220143, "latitude": 44.49788268771124, "longitude": 11.313514825587573 }, { "_id": 203, "position_type": "moving", "delta_ms": 1163789, "speed": 58, "angle": 270, "total_odometer": 1220209, "latitude": 44.49841836900239, "longitude": 11.313879606013598 }, { "_id": 204, "position_type": "moving", "delta_ms": 1171693, "speed": 46, "angle": 270, "total_odometer": 1220310, "latitude": 44.499275448831824, "longitude": 11.3143302171281 }, { "_id": 205, "position_type": "moving", "delta_ms": 1175613, "speed": 45, "angle": 270, "total_odometer": 1220359, "latitude": 44.49938258292467, "longitude": 11.314931031947436 }, { "_id": 206, "position_type": "moving", "delta_ms": 1181897, "speed": 59, "angle": 270, "total_odometer": 1220462, "latitude": 44.499061180055584, "longitude": 11.316154119258227 }, { "_id": 207, "position_type": "stop", "delta_ms": 1193897, "speed": 0, "angle": 270, "total_odometer": 1220462, "latitude": 44.499061180055584, "longitude": 11.316154119258227 }],
    "-2": [{ "_id": 0, "position_type": "moving", "delta_ms": 0, "speed": 107, "angle": 170, "total_odometer": 1200000, "latitude": 45.795769643726395, "longitude": 12.827132016671774 }, { "_id": 1, "position_type": "moving", "delta_ms": 4194, "speed": 109, "angle": 170, "total_odometer": 1200127, "latitude": 45.79473734752469, "longitude": 12.827840119851706 }, { "_id": 2, "position_type": "moving", "delta_ms": 8042, "speed": 116, "angle": 47, "total_odometer": 1200251, "latitude": 45.794138906188046, "longitude": 12.829191953195211 }, { "_id": 3, "position_type": "moving", "delta_ms": 12762, "speed": 106, "angle": 47, "total_odometer": 1200390, "latitude": 45.79409402282876, "longitude": 12.83099439765322 }, { "_id": 4, "position_type": "moving", "delta_ms": 16255, "speed": 135, "angle": 47, "total_odometer": 1200521, "latitude": 45.79446804971846, "longitude": 12.832603723062155 }, { "_id": 5, "position_type": "moving", "delta_ms": 24880, "speed": 101, "angle": 47, "total_odometer": 1200763, "latitude": 45.79535074322536, "longitude": 12.835457593454 }, { "_id": 6, "position_type": "moving", "delta_ms": 43570, "speed": 73, "angle": 47, "total_odometer": 1201142, "latitude": 45.796592474828714, "longitude": 12.840017348779318 }, { "_id": 7, "position_type": "moving", "delta_ms": 56226, "speed": 95, "angle": 47, "total_odometer": 1201476, "latitude": 45.79737041306071, "longitude": 12.844180137170431 }, { "_id": 8, "position_type": "moving", "delta_ms": 69020, "speed": 74, "angle": 47, "total_odometer": 1201739, "latitude": 45.79802866000499, "longitude": 12.84744170333254 }, { "_id": 9, "position_type": "moving", "delta_ms": 81863, "speed": 74, "angle": 47, "total_odometer": 1202003, "latitude": 45.79862705957031, "longitude": 12.850746184838888 }, { "_id": 10, "position_type": "moving", "delta_ms": 91288, "speed": 110, "angle": 47, "total_odometer": 1202291, "latitude": 45.79925537219755, "longitude": 12.854351073754904 }, { "_id": 11, "position_type": "moving", "delta_ms": 105815, "speed": 85, "angle": 47, "total_odometer": 1202634, "latitude": 45.800003354182586, "longitude": 12.858642608178732 }, { "_id": 12, "position_type": "moving", "delta_ms": 116100, "speed": 105, "angle": 47, "total_odometer": 1202934, "latitude": 45.80072140744152, "longitude": 12.862376243127462 }, { "_id": 13, "position_type": "moving", "delta_ms": 131467, "speed": 93, "angle": 47, "total_odometer": 1203331, "latitude": 45.80167119678679, "longitude": 12.867311507714865 }, { "_id": 14, "position_type": "moving", "delta_ms": 146731, "speed": 75, "angle": 47, "total_odometer": 1203649, "latitude": 45.80232939292427, "longitude": 12.871302634729025 }, { "_id": 15, "position_type": "moving", "delta_ms": 166999, "speed": 73, "angle": 47, "total_odometer": 1204060, "latitude": 45.80331667255087, "longitude": 12.87640956069338 }, { "_id": 16, "position_type": "moving", "delta_ms": 177591, "speed": 104, "angle": 47, "total_odometer": 1204366, "latitude": 45.80403468310843, "longitude": 12.880229026330587 }, { "_id": 17, "position_type": "moving", "delta_ms": 192796, "speed": 76, "angle": 47, "total_odometer": 1204687, "latitude": 45.80454326832116, "longitude": 12.884305984033224 }, { "_id": 18, "position_type": "moving", "delta_ms": 210339, "speed": 71, "angle": 47, "total_odometer": 1205033, "latitude": 45.804992016123656, "longitude": 12.888726264489767 }, { "_id": 19, "position_type": "moving", "delta_ms": 216549, "speed": 91, "angle": 47, "total_odometer": 1205190, "latitude": 45.805111681593814, "longitude": 12.890743285668966 }, { "_id": 20, "position_type": "moving", "delta_ms": 228605, "speed": 106, "angle": 47, "total_odometer": 1205545, "latitude": 45.805089639433014, "longitude": 12.895328426278038 }, { "_id": 21, "position_type": "moving", "delta_ms": 243765, "speed": 71, "angle": 47, "total_odometer": 1205844, "latitude": 45.80499989031895, "longitude": 12.899190807259483 }, { "_id": 22, "position_type": "moving", "delta_ms": 253810, "speed": 105, "angle": 47, "total_odometer": 1206137, "latitude": 45.804910141060326, "longitude": 12.902967357552452 }, { "_id": 23, "position_type": "moving", "delta_ms": 272194, "speed": 103, "angle": 90, "total_odometer": 1206663, "latitude": 45.805029806706386, "longitude": 12.9097479819421 }, { "_id": 24, "position_type": "moving", "delta_ms": 288889, "speed": 80, "angle": 90, "total_odometer": 1207034, "latitude": 45.80532896969688, "longitude": 12.91451158515255 }, { "_id": 25, "position_type": "moving", "delta_ms": 301468, "speed": 89, "angle": 90, "total_odometer": 1207345, "latitude": 45.805598215014705, "longitude": 12.91850271216671 }, { "_id": 26, "position_type": "moving", "delta_ms": 314455, "speed": 79, "angle": 90, "total_odometer": 1207630, "latitude": 45.80589737495271, "longitude": 12.922150516426964 }, { "_id": 27, "position_type": "moving", "delta_ms": 328389, "speed": 85, "angle": 90, "total_odometer": 1207959, "latitude": 45.80628628047029, "longitude": 12.926356220162315 }, { "_id": 28, "position_type": "moving", "delta_ms": 342894, "speed": 102, "angle": 90, "total_odometer": 1208370, "latitude": 45.80662778199219, "longitude": 12.931633296884355 }, { "_id": 29, "position_type": "moving", "delta_ms": 352288, "speed": 105, "angle": 90, "total_odometer": 1208644, "latitude": 45.80683719024714, "longitude": 12.935152355111894 }, { "_id": 30, "position_type": "moving", "delta_ms": 362132, "speed": 98, "angle": 90, "total_odometer": 1208912, "latitude": 45.807166258771495, "longitude": 12.938585582650957 }, { "_id": 31, "position_type": "moving", "delta_ms": 377794, "speed": 77, "angle": 90, "total_odometer": 1209247, "latitude": 45.807593914915024, "longitude": 12.942869355224422 }, { "_id": 32, "position_type": "moving", "delta_ms": 391040, "speed": 78, "angle": 90, "total_odometer": 1209534, "latitude": 45.807863149285666, "longitude": 12.946560074828914 }, { "_id": 33, "position_type": "moving", "delta_ms": 400184, "speed": 87, "angle": 90, "total_odometer": 1209755, "latitude": 45.80807255289649, "longitude": 12.949392487548641 }, { "_id": 34, "position_type": "moving", "delta_ms": 409753, "speed": 79, "angle": 90, "total_odometer": 1209965, "latitude": 45.808252041079186, "longitude": 12.952096154235653 }, { "_id": 35, "position_type": "moving", "delta_ms": 424656, "speed": 93, "angle": 90, "total_odometer": 1210350, "latitude": 45.8086110157095, "longitude": 12.957031418823055 }, { "_id": 36, "position_type": "moving", "delta_ms": 437795, "speed": 100, "angle": 90, "total_odometer": 1210715, "latitude": 45.808969988026355, "longitude": 12.961709191345028 }, { "_id": 37, "position_type": "moving", "delta_ms": 452066, "speed": 84, "angle": 90, "total_odometer": 1211048, "latitude": 45.80944861418344, "longitude": 12.965957810424618 }, { "_id": 38, "position_type": "moving", "delta_ms": 469964, "speed": 106, "angle": 50, "total_odometer": 1211575, "latitude": 45.810675074938274, "longitude": 12.972523858093075 }, { "_id": 39, "position_type": "moving", "delta_ms": 485026, "speed": 87, "angle": 50, "total_odometer": 1211939, "latitude": 45.81148272946755, "longitude": 12.977072884582332 }, { "_id": 40, "position_type": "moving", "delta_ms": 499058, "speed": 98, "angle": 50, "total_odometer": 1212321, "latitude": 45.81235019721294, "longitude": 12.981836487792782 }, { "_id": 41, "position_type": "moving", "delta_ms": 509898, "speed": 89, "angle": 50, "total_odometer": 1212589, "latitude": 45.812978355076865, "longitude": 12.985183884643368 }, { "_id": 42, "position_type": "moving", "delta_ms": 521761, "speed": 88, "angle": 50, "total_odometer": 1212879, "latitude": 45.81357659407466, "longitude": 12.988831688903621 }, { "_id": 43, "position_type": "moving", "delta_ms": 538261, "speed": 84, "angle": 50, "total_odometer": 1213264, "latitude": 45.81456417922157, "longitude": 12.993598913795305 }, { "_id": 44, "position_type": "moving", "delta_ms": 550729, "speed": 82, "angle": 50, "total_odometer": 1213548, "latitude": 45.81504275730591, "longitude": 12.99720380271132 }, { "_id": 45, "position_type": "moving", "delta_ms": 560240, "speed": 81, "angle": 50, "total_odometer": 1213762, "latitude": 45.81546150975596, "longitude": 12.999907469398332 }, { "_id": 46, "position_type": "moving", "delta_ms": 574862, "speed": 81, "angle": 50, "total_odometer": 1214091, "latitude": 45.816172755192895, "longitude": 13.004027465681828 }, { "_id": 47, "position_type": "moving", "delta_ms": 588443, "speed": 88, "angle": 50, "total_odometer": 1214423, "latitude": 45.816741049794345, "longitude": 13.00823316941718 }, { "_id": 48, "position_type": "moving", "delta_ms": 597220, "speed": 105, "angle": 50, "total_odometer": 1214679, "latitude": 45.817099969712324, "longitude": 13.011494735579289 }, { "_id": 49, "position_type": "moving", "delta_ms": 623397, "speed": 70, "angle": 50, "total_odometer": 1215188, "latitude": 45.8176383452516, "longitude": 13.018017867903508 }, { "_id": 50, "position_type": "moving", "delta_ms": 637842, "speed": 80, "angle": 50, "total_odometer": 1215509, "latitude": 45.81798451936943, "longitude": 13.022130173970341 }, { "_id": 51, "position_type": "moving", "delta_ms": 656193, "speed": 82, "angle": 50, "total_odometer": 1215927, "latitude": 45.81840324969809, "longitude": 13.027494592000126 }, { "_id": 52, "position_type": "moving", "delta_ms": 672370, "speed": 81, "angle": 50, "total_odometer": 1216291, "latitude": 45.81891170372105, "longitude": 13.03212944917786 }, { "_id": 53, "position_type": "moving", "delta_ms": 690576, "speed": 87, "angle": 45, "total_odometer": 1216731, "latitude": 45.820287497210096, "longitude": 13.037450951863407 }, { "_id": 54, "position_type": "moving", "delta_ms": 704011, "speed": 97, "angle": 45, "total_odometer": 1217093, "latitude": 45.821394089043594, "longitude": 13.041842065798471 }, { "_id": 55, "position_type": "moving", "delta_ms": 717877, "speed": 108, "angle": 45, "total_odometer": 1217509, "latitude": 45.82285954167577, "longitude": 13.046777330385874 }, { "_id": 56, "position_type": "moving", "delta_ms": 728917, "speed": 105, "angle": 45, "total_odometer": 1217831, "latitude": 45.82366701950011, "longitude": 13.050768457400034 }, { "_id": 57, "position_type": "moving", "delta_ms": 752531, "speed": 84, "angle": 54, "total_odometer": 1218382, "latitude": 45.82495297852336, "longitude": 13.057634912478159 }, { "_id": 58, "position_type": "moving", "delta_ms": 777866, "speed": 80, "angle": 54, "total_odometer": 1218945, "latitude": 45.82595649251776, "longitude": 13.0647497525469 }, { "_id": 59, "position_type": "moving", "delta_ms": 796419, "speed": 104, "angle": 54, "total_odometer": 1219481, "latitude": 45.826883544116434, "longitude": 13.071530376936549 }, { "_id": 60, "position_type": "moving", "delta_ms": 813380, "speed": 104, "angle": 54, "total_odometer": 1219971, "latitude": 45.82783901745501, "longitude": 13.07769930950684 }, { "_id": 61, "position_type": "moving", "delta_ms": 830951, "speed": 84, "angle": 54, "total_odometer": 1220381, "latitude": 45.82855671189924, "longitude": 13.082892066159673 }, { "_id": 62, "position_type": "moving", "delta_ms": 847943, "speed": 75, "angle": 54, "total_odometer": 1220735, "latitude": 45.82924449372497, "longitude": 13.087355261960454 }, { "_id": 63, "position_type": "moving", "delta_ms": 862260, "speed": 87, "angle": 54, "total_odometer": 1221081, "latitude": 45.82982848609616, "longitude": 13.091747774431125 }, { "_id": 64, "position_type": "moving", "delta_ms": 879833, "speed": 76, "angle": 54, "total_odometer": 1221452, "latitude": 45.83054615488873, "longitude": 13.096425546953098 }, { "_id": 65, "position_type": "moving", "delta_ms": 906816, "speed": 109, "angle": 54, "total_odometer": 1222269, "latitude": 45.83201136660742, "longitude": 13.106746687242405 }, { "_id": 66, "position_type": "moving", "delta_ms": 931415, "speed": 78, "angle": 54, "total_odometer": 1222802, "latitude": 45.833327034056545, "longitude": 13.1133556502551 }, { "_id": 67, "position_type": "moving", "delta_ms": 958055, "speed": 90, "angle": 45, "total_odometer": 1223468, "latitude": 45.83595827564758, "longitude": 13.12108041221799 }, { "_id": 68, "position_type": "moving", "delta_ms": 977639, "speed": 75, "angle": 45, "total_odometer": 1223876, "latitude": 45.83751704119182, "longitude": 13.12584267122805 }, { "_id": 69, "position_type": "moving", "delta_ms": 991015, "speed": 102, "angle": 45, "total_odometer": 1224255, "latitude": 45.83898206938792, "longitude": 13.130262951684593 }, { "_id": 70, "position_type": "moving", "delta_ms": 1009927, "speed": 71, "angle": 45, "total_odometer": 1224628, "latitude": 45.84038726427168, "longitude": 13.134640316796897 }, { "_id": 71, "position_type": "moving", "delta_ms": 1021672, "speed": 99, "angle": 45, "total_odometer": 1224951, "latitude": 45.84155325010626, "longitude": 13.138459782434104 }, { "_id": 72, "position_type": "moving", "delta_ms": 1034222, "speed": 72, "angle": 45, "total_odometer": 1225202, "latitude": 45.84253983441932, "longitude": 13.141378025842307 }, { "_id": 73, "position_type": "moving", "delta_ms": 1040850, "speed": 107, "angle": 45, "total_odometer": 1225399, "latitude": 45.84334702675358, "longitude": 13.143652539086936 }, { "_id": 74, "position_type": "moving", "delta_ms": 1050340, "speed": 110, "angle": 45, "total_odometer": 1225689, "latitude": 45.84445316019057, "longitude": 13.14704285128176 }, { "_id": 75, "position_type": "moving", "delta_ms": 1059034, "speed": 106, "angle": 45, "total_odometer": 1225945, "latitude": 45.845409798400176, "longitude": 13.15004692537844 }, { "_id": 76, "position_type": "moving", "delta_ms": 1068574, "speed": 80, "angle": 45, "total_odometer": 1226157, "latitude": 45.84627673756804, "longitude": 13.152493100000022 }, { "_id": 77, "position_type": "moving", "delta_ms": 1075774, "speed": 104, "angle": 45, "total_odometer": 1226365, "latitude": 45.846994194248204, "longitude": 13.154982189965843 }, { "_id": 78, "position_type": "moving", "delta_ms": 1083239, "speed": 95, "angle": 45, "total_odometer": 1226562, "latitude": 45.847801321952566, "longitude": 13.157256703210471 }, { "_id": 79, "position_type": "moving", "delta_ms": 1095880, "speed": 86, "angle": 45, "total_odometer": 1226864, "latitude": 45.848937259622055, "longitude": 13.160804520091629 }, { "_id": 80, "position_type": "moving", "delta_ms": 1106581, "speed": 73, "angle": 45, "total_odometer": 1227081, "latitude": 45.8497742514818, "longitude": 13.163336525401688 }, { "_id": 81, "position_type": "moving", "delta_ms": 1116421, "speed": 75, "angle": 45, "total_odometer": 1227286, "latitude": 45.85055144693108, "longitude": 13.165739784679031 }, { "_id": 82, "position_type": "moving", "delta_ms": 1124976, "speed": 85, "angle": 45, "total_odometer": 1227488, "latitude": 45.85138841450051, "longitude": 13.168057213267899 }, { "_id": 83, "position_type": "moving", "delta_ms": 1133387, "speed": 107, "angle": 45, "total_odometer": 1227738, "latitude": 45.85234493344316, "longitude": 13.170975456676102 }, { "_id": 84, "position_type": "moving", "delta_ms": 1149796, "speed": 86, "angle": 45, "total_odometer": 1228130, "latitude": 45.853839461357865, "longitude": 13.175567398509598 }, { "_id": 85, "position_type": "moving", "delta_ms": 1165132, "speed": 100, "angle": 45, "total_odometer": 1228556, "latitude": 45.85539372778488, "longitude": 13.180588493785477 }, { "_id": 86, "position_type": "moving", "delta_ms": 1181223, "speed": 83, "angle": 45, "total_odometer": 1228927, "latitude": 45.856619176455304, "longitude": 13.185051689586258 }, { "_id": 87, "position_type": "moving", "delta_ms": 1192023, "speed": 87, "angle": 45, "total_odometer": 1229188, "latitude": 45.857574179103516, "longitude": 13.188136474325706 }, { "_id": 88, "position_type": "moving", "delta_ms": 1200648, "speed": 101, "angle": 45, "total_odometer": 1229430, "latitude": 45.8583512655559, "longitude": 13.191054717733909 }, { "_id": 89, "position_type": "moving", "delta_ms": 1208145, "speed": 109, "angle": 45, "total_odometer": 1229657, "latitude": 45.859218003018, "longitude": 13.193715469076682 }, { "_id": 90, "position_type": "moving", "delta_ms": 1218557, "speed": 93, "angle": 45, "total_odometer": 1229926, "latitude": 45.86020427404048, "longitude": 13.196891204550315 }, { "_id": 91, "position_type": "moving", "delta_ms": 1227941, "speed": 89, "angle": 45, "total_odometer": 1230158, "latitude": 45.860891664710394, "longitude": 13.199723617270042 }, { "_id": 92, "position_type": "moving", "delta_ms": 1238012, "speed": 89, "angle": 45, "total_odometer": 1230407, "latitude": 45.86190779187299, "longitude": 13.202598945334007 }, { "_id": 93, "position_type": "moving", "delta_ms": 1256595, "speed": 74, "angle": 45, "total_odometer": 1230789, "latitude": 45.86321268480696, "longitude": 13.207161972830258 }, { "_id": 94, "position_type": "moving", "delta_ms": 1267193, "speed": 107, "angle": 45, "total_odometer": 1231104, "latitude": 45.86434830771026, "longitude": 13.210895607778989 }, { "_id": 95, "position_type": "moving", "delta_ms": 1279750, "speed": 84, "angle": 45, "total_odometer": 1231397, "latitude": 45.86551379130551, "longitude": 13.214285919973813 }, { "_id": 96, "position_type": "moving", "delta_ms": 1289474, "speed": 87, "angle": 45, "total_odometer": 1231632, "latitude": 45.86641030052099, "longitude": 13.217032502005063 }, { "_id": 97, "position_type": "moving", "delta_ms": 1297542, "speed": 87, "angle": 45, "total_odometer": 1231827, "latitude": 45.86733667818776, "longitude": 13.219178269216977 }, { "_id": 98, "position_type": "moving", "delta_ms": 1315593, "speed": 70, "angle": 45, "total_odometer": 1232178, "latitude": 45.868651510304765, "longitude": 13.223298142263852 }, { "_id": 99, "position_type": "moving", "delta_ms": 1329334, "speed": 82, "angle": 45, "total_odometer": 1232491, "latitude": 45.86987666678468, "longitude": 13.226945946524106 }, { "_id": 100, "position_type": "moving", "delta_ms": 1343560, "speed": 83, "angle": 45, "total_odometer": 1232819, "latitude": 45.871343157318364, "longitude": 13.230616900498786 }, { "_id": 101, "position_type": "moving", "delta_ms": 1352616, "speed": 95, "angle": 45, "total_odometer": 1233058, "latitude": 45.87232921324275, "longitude": 13.233363482530036 }, { "_id": 102, "position_type": "moving", "delta_ms": 1363004, "speed": 70, "angle": 45, "total_odometer": 1233260, "latitude": 45.87322561253837, "longitude": 13.235637995774665 }, { "_id": 103, "position_type": "moving", "delta_ms": 1370751, "speed": 92, "angle": 45, "total_odometer": 1233458, "latitude": 45.87409211811416, "longitude": 13.237869593675056 }, { "_id": 104, "position_type": "moving", "delta_ms": 1387991, "speed": 90, "angle": 45, "total_odometer": 1233889, "latitude": 45.87594460195795, "longitude": 13.24276194291822 }, { "_id": 105, "position_type": "moving", "delta_ms": 1401053, "speed": 70, "angle": 45, "total_odometer": 1234143, "latitude": 45.8769903316969, "longitude": 13.245680186326423 }, { "_id": 106, "position_type": "moving", "delta_ms": 1411097, "speed": 100, "angle": 45, "total_odometer": 1234422, "latitude": 45.87812567313191, "longitude": 13.248898837144294 }, { "_id": 107, "position_type": "moving", "delta_ms": 1423235, "speed": 78, "angle": 45, "total_odometer": 1234685, "latitude": 45.879171361825904, "longitude": 13.251945826585212 }, { "_id": 108, "position_type": "moving", "delta_ms": 1431839, "speed": 100, "angle": 45, "total_odometer": 1234924, "latitude": 45.8803066586979, "longitude": 13.254563662583747 }, { "_id": 109, "position_type": "moving", "delta_ms": 1440749, "speed": 80, "angle": 45, "total_odometer": 1235122, "latitude": 45.88099380079851, "longitude": 13.256924006516853 }, { "_id": 110, "position_type": "moving", "delta_ms": 1446187, "speed": 47, "angle": 45, "total_odometer": 1235193, "latitude": 45.88121039817735, "longitude": 13.257798406655708 }, { "_id": 111, "position_type": "moving", "delta_ms": 1452187, "speed": 42, "angle": 45, "total_odometer": 1235263, "latitude": 45.88150168297618, "longitude": 13.258603069360175 }, { "_id": 112, "position_type": "stop", "delta_ms": 1452307, "speed": 0, "angle": 45, "total_odometer": 1235263, "latitude": 45.88150168297618, "longitude": 13.258603069360175 }, { "_id": 113, "position_type": "stop", "delta_ms": 1456907, "speed": 0, "angle": 45, "total_odometer": 1235263, "latitude": 45.88150168297618, "longitude": 13.258603069360175 }, { "_id": 114, "position_type": "stop", "delta_ms": 1461907, "speed": 0, "angle": 45, "total_odometer": 1235263, "latitude": 45.88150168297618, "longitude": 13.258603069360175 }, { "_id": 115, "position_type": "moving", "delta_ms": 1468321, "speed": 55, "angle": 45, "total_odometer": 1235361, "latitude": 45.88201702926386, "longitude": 13.259633037621894 }, { "_id": 116, "position_type": "moving", "delta_ms": 1476696, "speed": 49, "angle": 45, "total_odometer": 1235475, "latitude": 45.882621994893384, "longitude": 13.260834667260566 }, { "_id": 117, "position_type": "moving", "delta_ms": 1485696, "speed": 80, "angle": 40, "total_odometer": 1235675, "latitude": 45.8837273471775, "longitude": 13.262883874947944 }, { "_id": 118, "position_type": "moving", "delta_ms": 1492162, "speed": 108, "angle": 40, "total_odometer": 1235869, "latitude": 45.88474305691363, "longitude": 13.264922353799262 }, { "_id": 119, "position_type": "moving", "delta_ms": 1497107, "speed": 91, "angle": 40, "total_odometer": 1235994, "latitude": 45.885407739261645, "longitude": 13.26623127179853 }, { "_id": 120, "position_type": "moving", "delta_ms": 1501807, "speed": 108, "angle": 40, "total_odometer": 1236135, "latitude": 45.886229148230356, "longitude": 13.267632252245862 }, { "_id": 121, "position_type": "moving", "delta_ms": 1506175, "speed": 103, "angle": 40, "total_odometer": 1236260, "latitude": 45.88689381279726, "longitude": 13.26894117024513 }, { "_id": 122, "position_type": "moving", "delta_ms": 1511706, "speed": 82, "angle": 40, "total_odometer": 1236386, "latitude": 45.887602883106325, "longitude": 13.270216393946965 }, { "_id": 123, "position_type": "moving", "delta_ms": 1514628, "speed": 101, "angle": 40, "total_odometer": 1236468, "latitude": 45.888043493429215, "longitude": 13.271074700831731 }, { "_id": 124, "position_type": "moving", "delta_ms": 1518028, "speed": 90, "angle": 40, "total_odometer": 1236553, "latitude": 45.888543843286676, "longitude": 13.271911550044377 }, { "_id": 125, "position_type": "moving", "delta_ms": 1521868, "speed": 90, "angle": 40, "total_odometer": 1236649, "latitude": 45.889036720829154, "longitude": 13.272930789470037 }, { "_id": 126, "position_type": "moving", "delta_ms": 1529705, "speed": 96, "angle": 40, "total_odometer": 1236858, "latitude": 45.89018218319328, "longitude": 13.275069650964232 }, { "_id": 127, "position_type": "moving", "delta_ms": 1533133, "speed": 105, "angle": 40, "total_odometer": 1236958, "latitude": 45.89073478687101, "longitude": 13.27609961922595 }, { "_id": 128, "position_type": "moving", "delta_ms": 1536733, "speed": 97, "angle": 40, "total_odometer": 1237055, "latitude": 45.89125751501939, "longitude": 13.27710812981555 }, { "_id": 129, "position_type": "moving", "delta_ms": 1544039, "speed": 101, "angle": 40, "total_odometer": 1237260, "latitude": 45.89239155675178, "longitude": 13.279197838689013 }, { "_id": 130, "position_type": "moving", "delta_ms": 1548026, "speed": 93, "angle": 40, "total_odometer": 1237363, "latitude": 45.892981474850224, "longitude": 13.280227806950732 }, { "_id": 131, "position_type": "moving", "delta_ms": 1554124, "speed": 85, "angle": 40, "total_odometer": 1237507, "latitude": 45.89378184111752, "longitude": 13.281699630597812 }, { "_id": 132, "position_type": "moving", "delta_ms": 1559290, "speed": 108, "angle": 40, "total_odometer": 1237662, "latitude": 45.89461069084984, "longitude": 13.283319684842807 }, { "_id": 133, "position_type": "moving", "delta_ms": 1568941, "speed": 94, "angle": 90, "total_odometer": 1237914, "latitude": 45.8958141794396, "longitude": 13.286088466869739 }, { "_id": 134, "position_type": "moving", "delta_ms": 1576869, "speed": 89, "angle": 90, "total_odometer": 1238110, "latitude": 45.896172589346676, "longitude": 13.288577556835559 }, { "_id": 135, "position_type": "moving", "delta_ms": 1586078, "speed": 86, "angle": 90, "total_odometer": 1238330, "latitude": 45.89596351718199, "longitude": 13.291409969555286 }, { "_id": 136, "position_type": "moving", "delta_ms": 1598143, "speed": 91, "angle": 110, "total_odometer": 1238635, "latitude": 45.89527656024162, "longitude": 13.295229435192493 }, { "_id": 137, "position_type": "moving", "delta_ms": 1607662, "speed": 104, "angle": 110, "total_odometer": 1238910, "latitude": 45.894529858276535, "longitude": 13.298619747387317 }, { "_id": 138, "position_type": "moving", "delta_ms": 1615228, "speed": 108, "angle": 110, "total_odometer": 1239137, "latitude": 45.893902620866854, "longitude": 13.301409244762805 }, { "_id": 139, "position_type": "moving", "delta_ms": 1623020, "speed": 79, "angle": 110, "total_odometer": 1239308, "latitude": 45.89351432749159, "longitude": 13.30355501197472 }, { "_id": 140, "position_type": "moving", "delta_ms": 1628800, "speed": 71, "angle": 110, "total_odometer": 1239422, "latitude": 45.89291694776693, "longitude": 13.304756641613391 }, { "_id": 141, "position_type": "moving", "delta_ms": 1634541, "speed": 79, "angle": 110, "total_odometer": 1239548, "latitude": 45.89187151778683, "longitude": 13.305400371776965 }, { "_id": 142, "position_type": "moving", "delta_ms": 1642159, "speed": 86, "angle": 110, "total_odometer": 1239730, "latitude": 45.890844532279615, "longitude": 13.307232856750488 }, { "_id": 143, "position_type": "moving", "delta_ms": 1645644, "speed": 63, "angle": 110, "total_odometer": 1239791, "latitude": 45.89076632755309, "longitude": 13.3080182077755 }, { "_id": 144, "position_type": "moving", "delta_ms": 1649539, "speed": 73, "angle": 110, "total_odometer": 1239870, "latitude": 45.89037801225008, "longitude": 13.308876514660266 }, { "_id": 145, "position_type": "stop", "delta_ms": 1657539, "speed": 0, "angle": 110, "total_odometer": 1239870, "latitude": 45.89037801225008, "longitude": 13.308876514660266 }, { "_id": 146, "position_type": "stop", "delta_ms": 1677539, "speed": 0, "angle": 110, "total_odometer": 1239870, "latitude": 45.89037801225008, "longitude": 13.308876514660266 }],
    "-3": [{ "_id": 0, "position_type": "moving", "delta_ms": 0, "speed": 130, "angle": 75, "total_odometer": 1200000, "latitude": 45.50886895124027, "longitude": 9.031785714233406 }, { "_id": 1, "position_type": "moving", "delta_ms": 6029, "speed": 123, "angle": 75, "total_odometer": 1200206, "latitude": 45.509169700675756, "longitude": 9.034403550231941 }, { "_id": 2, "position_type": "moving", "delta_ms": 9837, "speed": 138, "angle": 75, "total_odometer": 1200352, "latitude": 45.509357668256904, "longitude": 9.036259638870247 }, { "_id": 3, "position_type": "moving", "delta_ms": 14564, "speed": 99, "angle": 75, "total_odometer": 1200482, "latitude": 45.509470448504274, "longitude": 9.03792260845948 }, { "_id": 4, "position_type": "moving", "delta_ms": 21294, "speed": 23, "angle": 75, "total_odometer": 1200525, "latitude": 45.50950804186985, "longitude": 9.038480507934578 }, { "_id": 5, "position_type": "stop", "delta_ms": 21414, "speed": 0, "angle": 75, "total_odometer": 1200525, "latitude": 45.50950804186985, "longitude": 9.038480507934578 }, { "_id": 6, "position_type": "stop", "delta_ms": 26414, "speed": 0, "angle": 75, "total_odometer": 1200525, "latitude": 45.50950804186985, "longitude": 9.038480507934578 }, { "_id": 7, "position_type": "stop", "delta_ms": 35414, "speed": 0, "angle": 75, "total_odometer": 1200525, "latitude": 45.50950804186985, "longitude": 9.038480507934578 }, { "_id": 8, "position_type": "stop", "delta_ms": 46414, "speed": 0, "angle": 75, "total_odometer": 1200525, "latitude": 45.50950804186985, "longitude": 9.038480507934578 }, { "_id": 9, "position_type": "moving", "delta_ms": 57527, "speed": 23, "angle": 75, "total_odometer": 1200596, "latitude": 45.50960202517396, "longitude": 9.039387094581611 }, { "_id": 10, "position_type": "moving", "delta_ms": 70127, "speed": 24, "angle": 75, "total_odometer": 1200680, "latitude": 45.50971480493173, "longitude": 9.040459978187569 }, { "_id": 11, "position_type": "moving", "delta_ms": 73237, "speed": 103, "angle": 75, "total_odometer": 1200769, "latitude": 45.50992908584889, "longitude": 9.041565048301704 }, { "_id": 12, "position_type": "moving", "delta_ms": 79193, "speed": 110, "angle": 75, "total_odometer": 1200951, "latitude": 45.51018095886642, "longitude": 9.043882476890571 }, { "_id": 13, "position_type": "moving", "delta_ms": 83787, "speed": 105, "angle": 75, "total_odometer": 1201085, "latitude": 45.51044158525367, "longitude": 9.045570358132945 }, { "_id": 14, "position_type": "moving", "delta_ms": 91241, "speed": 113, "angle": 75, "total_odometer": 1201319, "latitude": 45.510798715050896, "longitude": 9.048536881303416 }, { "_id": 15, "position_type": "moving", "delta_ms": 96627, "speed": 137, "angle": 75, "total_odometer": 1201524, "latitude": 45.51108441725715, "longitude": 9.051133259629832 }, { "_id": 16, "position_type": "moving", "delta_ms": 104161, "speed": 129, "angle": 75, "total_odometer": 1201794, "latitude": 45.51148289422804, "longitude": 9.054551680900245 }, { "_id": 17, "position_type": "moving", "delta_ms": 108941, "speed": 122, "angle": 75, "total_odometer": 1201956, "latitude": 45.51171596435622, "longitude": 9.056611617423682 }, { "_id": 18, "position_type": "moving", "delta_ms": 112677, "speed": 132, "angle": 75, "total_odometer": 1202093, "latitude": 45.51189640508289, "longitude": 9.058360417701392 }, { "_id": 19, "position_type": "moving", "delta_ms": 117486, "speed": 128, "angle": 75, "total_odometer": 1202264, "latitude": 45.512121955177705, "longitude": 9.060538371421485 }, { "_id": 20, "position_type": "moving", "delta_ms": 122036, "speed": 125, "angle": 75, "total_odometer": 1202422, "latitude": 45.512370059238016, "longitude": 9.062533934928565 }, { "_id": 21, "position_type": "moving", "delta_ms": 129072, "speed": 110, "angle": 75, "total_odometer": 1202637, "latitude": 45.512670789965966, "longitude": 9.065257500103353 }, { "_id": 22, "position_type": "moving", "delta_ms": 133384, "speed": 101, "angle": 75, "total_odometer": 1202758, "latitude": 45.51283619118135, "longitude": 9.066802452495931 }, { "_id": 23, "position_type": "moving", "delta_ms": 143136, "speed": 110, "angle": 75, "total_odometer": 1203056, "latitude": 45.51318155010515, "longitude": 9.070603435370899 }, { "_id": 24, "position_type": "moving", "delta_ms": 148762, "speed": 119, "angle": 75, "total_odometer": 1203242, "latitude": 45.5133695042883, "longitude": 9.072974508140064 }, { "_id": 25, "position_type": "moving", "delta_ms": 157109, "speed": 138, "angle": 75, "total_odometer": 1203562, "latitude": 45.513606366370944, "longitude": 9.077067617186282 }, { "_id": 26, "position_type": "moving", "delta_ms": 164520, "speed": 102, "angle": 75, "total_odometer": 1203772, "latitude": 45.51374921052914, "longitude": 9.079760555037234 }, { "_id": 27, "position_type": "moving", "delta_ms": 172574, "speed": 118, "angle": 75, "total_odometer": 1204036, "latitude": 45.5138995724092, "longitude": 9.083140138395999 }, { "_id": 28, "position_type": "moving", "delta_ms": 182088, "speed": 140, "angle": 75, "total_odometer": 1204406, "latitude": 45.514125114476045, "longitude": 9.087882283934329 }, { "_id": 29, "position_type": "moving", "delta_ms": 194975, "speed": 119, "angle": 75, "total_odometer": 1204832, "latitude": 45.514395763763076, "longitude": 9.09333253265259 }, { "_id": 30, "position_type": "moving", "delta_ms": 212605, "speed": 117, "angle": 75, "total_odometer": 1205405, "latitude": 45.5146664117485, "longitude": 9.100671056517337 }, { "_id": 31, "position_type": "moving", "delta_ms": 222434, "speed": 115, "angle": 75, "total_odometer": 1205719, "latitude": 45.514857876910746, "longitude": 9.104690783174272 }, { "_id": 32, "position_type": "moving", "delta_ms": 235245, "speed": 102, "angle": 75, "total_odometer": 1206082, "latitude": 45.51464736754301, "longitude": 9.109339714050293 }, { "_id": 33, "position_type": "moving", "delta_ms": 242772, "speed": 110, "angle": 75, "total_odometer": 1206312, "latitude": 45.51515859434481, "longitude": 9.112200968415971 }, { "_id": 34, "position_type": "moving", "delta_ms": 255895, "speed": 110, "angle": 75, "total_odometer": 1206713, "latitude": 45.51543204755242, "longitude": 9.117338783941156 }, { "_id": 35, "position_type": "moving", "delta_ms": 264938, "speed": 125, "angle": 75, "total_odometer": 1207027, "latitude": 45.515822975914666, "longitude": 9.121329910955316 }, { "_id": 36, "position_type": "moving", "delta_ms": 270106, "speed": 140, "angle": 75, "total_odometer": 1207228, "latitude": 45.51661985993503, "longitude": 9.123647339544183 }, { "_id": 37, "position_type": "moving", "delta_ms": 275536, "speed": 118, "angle": 75, "total_odometer": 1207406, "latitude": 45.517642260641246, "longitude": 9.125406868657953 }, { "_id": 38, "position_type": "moving", "delta_ms": 283220, "speed": 104, "angle": 75, "total_odometer": 1207628, "latitude": 45.51896533986232, "longitude": 9.127552635869867 }, { "_id": 39, "position_type": "moving", "delta_ms": 288888, "speed": 134, "angle": 75, "total_odometer": 1207839, "latitude": 45.52012127467404, "longitude": 9.129701104336121 }, { "_id": 40, "position_type": "moving", "delta_ms": 297954, "speed": 108, "angle": 75, "total_odometer": 1208111, "latitude": 45.52150443217953, "longitude": 9.132576432400086 }, { "_id": 41, "position_type": "moving", "delta_ms": 306475, "speed": 109, "angle": 75, "total_odometer": 1208369, "latitude": 45.5228424543651, "longitude": 9.135280099087097 }, { "_id": 42, "position_type": "moving", "delta_ms": 316452, "speed": 105, "angle": 75, "total_odometer": 1208660, "latitude": 45.52433077873654, "longitude": 9.138348546200135 }, { "_id": 43, "position_type": "moving", "delta_ms": 322959, "speed": 130, "angle": 75, "total_odometer": 1208895, "latitude": 45.52554846939032, "longitude": 9.140816178493836 }, { "_id": 44, "position_type": "moving", "delta_ms": 328418, "speed": 122, "angle": 75, "total_odometer": 1209080, "latitude": 45.526450445473834, "longitude": 9.142811742000916 }, { "_id": 45, "position_type": "moving", "delta_ms": 333742, "speed": 119, "angle": 75, "total_odometer": 1209256, "latitude": 45.52736977273896, "longitude": 9.144657101803162 }, { "_id": 46, "position_type": "moving", "delta_ms": 351600, "speed": 51, "angle": 45, "total_odometer": 1209509, "latitude": 45.52875275204167, "longitude": 9.147232022457459 }, { "_id": 47, "position_type": "moving", "delta_ms": 358738, "speed": 59, "angle": 45, "total_odometer": 1209626, "latitude": 45.529323972700396, "longitude": 9.148498025112488 }, { "_id": 48, "position_type": "stop", "delta_ms": 359098, "speed": 0, "angle": 45, "total_odometer": 1209626, "latitude": 45.529323972700396, "longitude": 9.148498025112488 }, { "_id": 49, "position_type": "stop", "delta_ms": 359458, "speed": 0, "angle": 45, "total_odometer": 1209626, "latitude": 45.529323972700396, "longitude": 9.148498025112488 }, { "_id": 50, "position_type": "stop", "delta_ms": 363058, "speed": 0, "angle": 45, "total_odometer": 1209626, "latitude": 45.529323972700396, "longitude": 9.148498025112488 }, { "_id": 51, "position_type": "moving", "delta_ms": 388046, "speed": 51, "angle": 45, "total_odometer": 1209980, "latitude": 45.53110449413027, "longitude": 9.152262779012913 }, { "_id": 52, "position_type": "moving", "delta_ms": 410926, "speed": 45, "angle": 45, "total_odometer": 1210266, "latitude": 45.53259259991433, "longitude": 9.155266853109593 }, { "_id": 53, "position_type": "moving", "delta_ms": 432526, "speed": 52, "angle": 45, "total_odometer": 1210578, "latitude": 45.534185881651005, "longitude": 9.15857133461594 }, { "_id": 54, "position_type": "moving", "delta_ms": 453832, "speed": 49, "angle": 45, "total_odometer": 1210868, "latitude": 45.535628814837864, "longitude": 9.161682697073216 }, { "_id": 55, "position_type": "moving", "delta_ms": 483622, "speed": 40, "angle": 45, "total_odometer": 1211199, "latitude": 45.53734224990991, "longitude": 9.165158839956517 }, { "_id": 56, "position_type": "moving", "delta_ms": 503647, "speed": 48, "angle": 45, "total_odometer": 1211466, "latitude": 45.53867989538625, "longitude": 9.168012710348362 }, { "_id": 57, "position_type": "moving", "delta_ms": 521110, "speed": 47, "angle": 45, "total_odometer": 1211694, "latitude": 45.539746983004086, "longitude": 9.170523257986302 }, { "_id": 58, "position_type": "moving", "delta_ms": 537783, "speed": 57, "angle": 45, "total_odometer": 1211958, "latitude": 45.54084410831307, "longitude": 9.173527332082982 }, { "_id": 59, "position_type": "moving", "delta_ms": 561483, "speed": 48, "angle": 45, "total_odometer": 1212274, "latitude": 45.5418692455448, "longitude": 9.177308418078084 }, { "_id": 60, "position_type": "moving", "delta_ms": 583083, "speed": 44, "angle": 45, "total_odometer": 1212538, "latitude": 45.542785988353614, "longitude": 9.180441238207479 }, { "_id": 61, "position_type": "moving", "delta_ms": 596750, "speed": 59, "angle": 45, "total_odometer": 1212762, "latitude": 45.543522377488124, "longitude": 9.183123447222371 }, { "_id": 62, "position_type": "moving", "delta_ms": 611785, "speed": 51, "angle": 45, "total_odometer": 1212975, "latitude": 45.54416282078706, "longitude": 9.185703354598424 }, { "_id": 63, "position_type": "moving", "delta_ms": 627805, "speed": 60, "angle": 45, "total_odometer": 1213242, "latitude": 45.54498935911411, "longitude": 9.188922005416295 }, { "_id": 64, "position_type": "moving", "delta_ms": 640025, "speed": 109, "angle": 45, "total_odometer": 1213612, "latitude": 45.546176547447594, "longitude": 9.193363743544957 }, { "_id": 65, "position_type": "moving", "delta_ms": 646271, "speed": 117, "angle": 45, "total_odometer": 1213815, "latitude": 45.546777645903376, "longitude": 9.195831375838658 }, { "_id": 66, "position_type": "moving", "delta_ms": 653837, "speed": 118, "angle": 45, "total_odometer": 1214063, "latitude": 45.54751398275201, "longitude": 9.198835449935338 }, { "_id": 67, "position_type": "moving", "delta_ms": 661244, "speed": 104, "angle": 45, "total_odometer": 1214277, "latitude": 45.54806998581765, "longitude": 9.201474743605992 }, { "_id": 68, "position_type": "moving", "delta_ms": 675852, "speed": 121, "angle": 45, "total_odometer": 1214768, "latitude": 45.548439740211414, "longitude": 9.207763463854102 }, { "_id": 69, "position_type": "moving", "delta_ms": 685652, "speed": 108, "angle": 45, "total_odometer": 1215062, "latitude": 45.54852990175939, "longitude": 9.21154001414707 }, { "_id": 70, "position_type": "moving", "delta_ms": 692337, "speed": 133, "angle": 45, "total_odometer": 1215309, "latitude": 45.54865011693169, "longitude": 9.214715749620703 }, { "_id": 71, "position_type": "moving", "delta_ms": 701856, "speed": 104, "angle": 45, "total_odometer": 1215584, "latitude": 45.54872013290555, "longitude": 9.218242095398006 }, { "_id": 72, "position_type": "moving", "delta_ms": 709160, "speed": 103, "angle": 45, "total_odometer": 1215793, "latitude": 45.54899061576629, "longitude": 9.22090284674078 }, { "_id": 73, "position_type": "moving", "delta_ms": 714726, "speed": 130, "angle": 45, "total_odometer": 1215994, "latitude": 45.54933623086085, "longitude": 9.223434852050838 }, { "_id": 74, "position_type": "moving", "delta_ms": 721067, "speed": 109, "angle": 45, "total_odometer": 1216186, "latitude": 45.54978702996438, "longitude": 9.225816653656063 }, { "_id": 75, "position_type": "moving", "delta_ms": 727731, "speed": 121, "angle": 45, "total_odometer": 1216410, "latitude": 45.55022262168572, "longitude": 9.228634423667224 }, { "_id": 76, "position_type": "moving", "delta_ms": 733655, "speed": 127, "angle": 45, "total_odometer": 1216619, "latitude": 45.55056822920479, "longitude": 9.231273717337878 }, { "_id": 77, "position_type": "moving", "delta_ms": 740758, "speed": 112, "angle": 45, "total_odometer": 1216840, "latitude": 45.55094388714124, "longitude": 9.234063214713366 }, { "_id": 78, "position_type": "moving", "delta_ms": 746038, "speed": 135, "angle": 45, "total_odometer": 1217038, "latitude": 45.55131954256687, "longitude": 9.236552304679186 }, { "_id": 79, "position_type": "moving", "delta_ms": 754678, "speed": 130, "angle": 45, "total_odometer": 1217350, "latitude": 45.55187056209145, "longitude": 9.240486390525197 }, { "_id": 80, "position_type": "moving", "delta_ms": 762007, "speed": 139, "angle": 45, "total_odometer": 1217633, "latitude": 45.55239647031308, "longitude": 9.244048364096974 }, { "_id": 81, "position_type": "moving", "delta_ms": 766261, "speed": 132, "angle": 45, "total_odometer": 1217789, "latitude": 45.55263688386107, "longitude": 9.246022469931935 }, { "_id": 82, "position_type": "moving", "delta_ms": 782513, "speed": 136, "angle": 45, "total_odometer": 1218403, "latitude": 45.553884012636296, "longitude": 9.253704316550587 }, { "_id": 83, "position_type": "moving", "delta_ms": 797451, "speed": 107, "angle": 45, "total_odometer": 1218847, "latitude": 45.554725433283146, "longitude": 9.259283311301564 }, { "_id": 84, "position_type": "moving", "delta_ms": 805783, "speed": 124, "angle": 45, "total_odometer": 1219134, "latitude": 45.55526633990351, "longitude": 9.26288820021758 }, { "_id": 85, "position_type": "moving", "delta_ms": 816129, "speed": 127, "angle": 45, "total_odometer": 1219499, "latitude": 45.55604764027478, "longitude": 9.267437226706837 }, { "_id": 86, "position_type": "moving", "delta_ms": 825819, "speed": 133, "angle": 45, "total_odometer": 1219857, "latitude": 45.556708732104426, "longitude": 9.271943337851857 }, { "_id": 87, "position_type": "moving", "delta_ms": 835763, "speed": 122, "angle": 45, "total_odometer": 1220194, "latitude": 45.55730971792787, "longitude": 9.276191956931447 }, { "_id": 88, "position_type": "moving", "delta_ms": 850331, "speed": 107, "angle": 45, "total_odometer": 1220627, "latitude": 45.55809098988902, "longitude": 9.281642205649709 }, { "_id": 89, "position_type": "moving", "delta_ms": 861076, "speed": 133, "angle": 45, "total_odometer": 1221024, "latitude": 45.55887225098748, "longitude": 9.28662038558135 }, { "_id": 90, "position_type": "moving", "delta_ms": 868840, "speed": 134, "angle": 45, "total_odometer": 1221313, "latitude": 45.55938306967862, "longitude": 9.290268189841603 }, { "_id": 91, "position_type": "moving", "delta_ms": 879557, "speed": 131, "angle": 45, "total_odometer": 1221703, "latitude": 45.560134265199956, "longitude": 9.295160539084767 }, { "_id": 92, "position_type": "moving", "delta_ms": 892470, "speed": 109, "angle": 45, "total_odometer": 1222094, "latitude": 45.560975008925425, "longitude": 9.300035806020963 }, { "_id": 93, "position_type": "moving", "delta_ms": 901835, "speed": 128, "angle": 45, "total_odometer": 1222427, "latitude": 45.56154590226201, "longitude": 9.304241509756315 }, { "_id": 94, "position_type": "moving", "delta_ms": 909301, "speed": 108, "angle": 45, "total_odometer": 1222651, "latitude": 45.561906463485734, "longitude": 9.307073922476041 }, { "_id": 95, "position_type": "moving", "delta_ms": 917202, "speed": 118, "angle": 45, "total_odometer": 1222910, "latitude": 45.562357161761426, "longitude": 9.31033548863815 }, { "_id": 96, "position_type": "moving", "delta_ms": 924507, "speed": 102, "angle": 45, "total_odometer": 1223117, "latitude": 45.5627177177788, "longitude": 9.312953324636686 }, { "_id": 97, "position_type": "moving", "delta_ms": 940601, "speed": 102, "angle": 45, "total_odometer": 1223573, "latitude": 45.56354209438642, "longitude": 9.318697223350906 }, { "_id": 98, "position_type": "moving", "delta_ms": 946946, "speed": 139, "angle": 45, "total_odometer": 1223818, "latitude": 45.56411296163811, "longitude": 9.321744212791824 }, { "_id": 99, "position_type": "moving", "delta_ms": 959519, "speed": 136, "angle": 45, "total_odometer": 1224293, "latitude": 45.56486409392077, "longitude": 9.327752360985183 }, { "_id": 100, "position_type": "moving", "delta_ms": 970154, "speed": 131, "angle": 45, "total_odometer": 1224680, "latitude": 45.56561521616035, "longitude": 9.33260179488411 }, { "_id": 101, "position_type": "moving", "delta_ms": 980567, "speed": 121, "angle": 45, "total_odometer": 1225030, "latitude": 45.56618606234558, "longitude": 9.337022075340652 }, { "_id": 102, "position_type": "moving", "delta_ms": 989419, "speed": 122, "angle": 45, "total_odometer": 1225330, "latitude": 45.56675822505447, "longitude": 9.34079245635993 }, { "_id": 103, "position_type": "moving", "delta_ms": 999461, "speed": 133, "angle": 45, "total_odometer": 1225701, "latitude": 45.567389147136524, "longitude": 9.345470228881902 }, { "_id": 104, "position_type": "moving", "delta_ms": 1005789, "speed": 128, "angle": 45, "total_odometer": 1225926, "latitude": 45.56780975792099, "longitude": 9.348302641601629 }, { "_id": 105, "position_type": "moving", "delta_ms": 1019577, "speed": 100, "angle": 45, "total_odometer": 1226309, "latitude": 45.56853079765266, "longitude": 9.353109160156317 }, { "_id": 106, "position_type": "moving", "delta_ms": 1031066, "speed": 120, "angle": 45, "total_odometer": 1226692, "latitude": 45.56925182812861, "longitude": 9.357915678711004 }, { "_id": 107, "position_type": "moving", "delta_ms": 1040106, "speed": 135, "angle": 45, "total_odometer": 1227031, "latitude": 45.56994280698282, "longitude": 9.362164297790594 }, { "_id": 108, "position_type": "moving", "delta_ms": 1049332, "speed": 135, "angle": 45, "total_odometer": 1227377, "latitude": 45.570513609190016, "longitude": 9.366541662902899 }, { "_id": 109, "position_type": "moving", "delta_ms": 1064966, "speed": 105, "angle": 45, "total_odometer": 1227833, "latitude": 45.57144548115175, "longitude": 9.372251870264611 }, { "_id": 110, "position_type": "moving", "delta_ms": 1074195, "speed": 110, "angle": 45, "total_odometer": 1228115, "latitude": 45.571926144220235, "longitude": 9.375813843836388 }, { "_id": 111, "position_type": "moving", "delta_ms": 1082287, "speed": 117, "angle": 45, "total_odometer": 1228378, "latitude": 45.57255700825488, "longitude": 9.379075409998498 }, { "_id": 112, "position_type": "moving", "delta_ms": 1091414, "speed": 127, "angle": 45, "total_odometer": 1228700, "latitude": 45.57303766181062, "longitude": 9.383152367701134 }, { "_id": 113, "position_type": "moving", "delta_ms": 1102268, "speed": 132, "angle": 45, "total_odometer": 1229098, "latitude": 45.57376413390653, "longitude": 9.388163184581998 }, { "_id": 114, "position_type": "moving", "delta_ms": 1115077, "speed": 120, "angle": 45, "total_odometer": 1229525, "latitude": 45.57469537641809, "longitude": 9.393484687267545 }, { "_id": 115, "position_type": "moving", "delta_ms": 1125876, "speed": 109, "angle": 45, "total_odometer": 1229852, "latitude": 45.57553648541376, "longitude": 9.397518729625943 }, { "_id": 116, "position_type": "moving", "delta_ms": 1139742, "speed": 108, "angle": 45, "total_odometer": 1230268, "latitude": 45.57638958224172, "longitude": 9.402720974951544 }, { "_id": 117, "position_type": "moving", "delta_ms": 1148571, "speed": 137, "angle": 45, "total_odometer": 1230604, "latitude": 45.57729074278103, "longitude": 9.406840847998419 }, { "_id": 118, "position_type": "moving", "delta_ms": 1162044, "speed": 101, "angle": 45, "total_odometer": 1230982, "latitude": 45.57810177490143, "longitude": 9.41156153586463 }, { "_id": 119, "position_type": "moving", "delta_ms": 1177776, "speed": 127, "angle": 45, "total_odometer": 1231537, "latitude": 45.57942866104968, "longitude": 9.418427990942755 }, { "_id": 120, "position_type": "moving", "delta_ms": 1188192, "speed": 122, "angle": 45, "total_odometer": 1231890, "latitude": 45.58026969914867, "longitude": 9.42280535605506 }, { "_id": 121, "position_type": "moving", "delta_ms": 1200466, "speed": 105, "angle": 45, "total_odometer": 1232248, "latitude": 45.58117079741771, "longitude": 9.427225636511603 }, { "_id": 122, "position_type": "moving", "delta_ms": 1211156, "speed": 132, "angle": 45, "total_odometer": 1232640, "latitude": 45.58222206045339, "longitude": 9.43203215506629 }, { "_id": 123, "position_type": "moving", "delta_ms": 1224915, "speed": 118, "angle": 45, "total_odometer": 1233091, "latitude": 45.58316019205369, "longitude": 9.437666543368772 }, { "_id": 124, "position_type": "moving", "delta_ms": 1238115, "speed": 114, "angle": 45, "total_odometer": 1233509, "latitude": 45.583530037366685, "longitude": 9.44300651550293 }, { "_id": 125, "position_type": "moving", "delta_ms": 1250069, "speed": 106, "angle": 45, "total_odometer": 1233861, "latitude": 45.585009576833386, "longitude": 9.44700383713235 }, { "_id": 126, "position_type": "moving", "delta_ms": 1259679, "speed": 118, "angle": 45, "total_odometer": 1234176, "latitude": 45.585760429667076, "longitude": 9.450909133458033 }, { "_id": 127, "position_type": "moving", "delta_ms": 1281625, "speed": 104, "angle": 45, "total_odometer": 1234810, "latitude": 45.58731059574696, "longitude": 9.458746100600232 }, { "_id": 128, "position_type": "moving", "delta_ms": 1293903, "speed": 112, "angle": 45, "total_odometer": 1235192, "latitude": 45.58803138511379, "longitude": 9.46355261915492 }, { "_id": 129, "position_type": "moving", "delta_ms": 1305435, "speed": 113, "angle": 45, "total_odometer": 1235554, "latitude": 45.58911110377385, "longitude": 9.467949027853253 }, { "_id": 130, "position_type": "moving", "delta_ms": 1317301, "speed": 108, "angle": 45, "total_odometer": 1235910, "latitude": 45.589801838278156, "longitude": 9.472412223654034 }, { "_id": 131, "position_type": "moving", "delta_ms": 1323970, "speed": 129, "angle": 45, "total_odometer": 1236149, "latitude": 45.5903724386312, "longitude": 9.475373382406476 }, { "_id": 132, "position_type": "moving", "delta_ms": 1336411, "speed": 136, "angle": 45, "total_odometer": 1236619, "latitude": 45.59151489967124, "longitude": 9.48119343288535 }, { "_id": 133, "position_type": "moving", "delta_ms": 1346934, "speed": 130, "angle": 45, "total_odometer": 1236999, "latitude": 45.59238578708826, "longitude": 9.485914120751561 }, { "_id": 134, "position_type": "moving", "delta_ms": 1353569, "speed": 102, "angle": 45, "total_odometer": 1237187, "latitude": 45.5928662709129, "longitude": 9.488231549340428 }, { "_id": 135, "position_type": "moving", "delta_ms": 1365987, "speed": 129, "angle": 45, "total_odometer": 1237632, "latitude": 45.59394324269887, "longitude": 9.493733784060234 }, { "_id": 136, "position_type": "moving", "delta_ms": 1378828, "speed": 134, "angle": 45, "total_odometer": 1238110, "latitude": 45.595084353397496, "longitude": 9.499656101565117 }, { "_id": 137, "position_type": "moving", "delta_ms": 1397078, "speed": 115, "angle": 45, "total_odometer": 1238693, "latitude": 45.59742656055812, "longitude": 9.506350895266289 }, { "_id": 138, "position_type": "moving", "delta_ms": 1411589, "speed": 129, "angle": 45, "total_odometer": 1239213, "latitude": 45.59946840498486, "longitude": 9.512359043459648 }, { "_id": 139, "position_type": "moving", "delta_ms": 1423309, "speed": 133, "angle": 45, "total_odometer": 1239646, "latitude": 45.601209919457816, "longitude": 9.517337223391289 }, { "_id": 140, "position_type": "moving", "delta_ms": 1443895, "speed": 103, "angle": 40, "total_odometer": 1240235, "latitude": 45.603431773237546, "longitude": 9.524203678469414 }, { "_id": 141, "position_type": "moving", "delta_ms": 1465423, "speed": 101, "angle": 40, "total_odometer": 1240839, "latitude": 45.605789973467054, "longitude": 9.531190446376359 }, { "_id": 142, "position_type": "moving", "delta_ms": 1480433, "speed": 112, "angle": 40, "total_odometer": 1241306, "latitude": 45.60768140282951, "longitude": 9.536554864406144 }, { "_id": 143, "position_type": "moving", "delta_ms": 1486945, "speed": 131, "angle": 40, "total_odometer": 1241543, "latitude": 45.60861208275482, "longitude": 9.539301446437394 }, { "_id": 144, "position_type": "moving", "delta_ms": 1504125, "speed": 101, "angle": 40, "total_odometer": 1242025, "latitude": 45.61044337558423, "longitude": 9.544923356532609 }, { "_id": 145, "position_type": "moving", "delta_ms": 1512225, "speed": 116, "angle": 40, "total_odometer": 1242286, "latitude": 45.61161417081383, "longitude": 9.547841599940812 }, { "_id": 146, "position_type": "moving", "delta_ms": 1527948, "speed": 117, "angle": 40, "total_odometer": 1242797, "latitude": 45.61343425147715, "longitude": 9.553876774677175 }, { "_id": 147, "position_type": "moving", "delta_ms": 1535797, "speed": 133, "angle": 40, "total_odometer": 1243087, "latitude": 45.61451492877077, "longitude": 9.557267086871999 }, { "_id": 148, "position_type": "moving", "delta_ms": 1544997, "speed": 108, "angle": 40, "total_odometer": 1243363, "latitude": 45.6155655672857, "longitude": 9.56048573768987 }, { "_id": 149, "position_type": "moving", "delta_ms": 1554846, "speed": 106, "angle": 40, "total_odometer": 1243653, "latitude": 45.616751443243665, "longitude": 9.563803554420822 }, { "_id": 150, "position_type": "moving", "delta_ms": 1564353, "speed": 117, "angle": 40, "total_odometer": 1243962, "latitude": 45.61792210678798, "longitude": 9.567408443336838 }, { "_id": 151, "position_type": "moving", "delta_ms": 1573394, "speed": 129, "angle": 40, "total_odometer": 1244286, "latitude": 45.619212810059594, "longitude": 9.571142078285568 }, { "_id": 152, "position_type": "moving", "delta_ms": 1582463, "speed": 129, "angle": 40, "total_odometer": 1244611, "latitude": 45.62059352950474, "longitude": 9.57483279789006 }, { "_id": 153, "position_type": "moving", "delta_ms": 1587271, "speed": 134, "angle": 40, "total_odometer": 1244790, "latitude": 45.621128977265826, "longitude": 9.577005384959868 }, { "_id": 154, "position_type": "moving", "delta_ms": 1597809, "speed": 110, "angle": 40, "total_odometer": 1245112, "latitude": 45.622509649524666, "longitude": 9.580653189220122 }, { "_id": 155, "position_type": "moving", "delta_ms": 1607320, "speed": 109, "angle": 40, "total_odometer": 1245400, "latitude": 45.62368019285002, "longitude": 9.58395767072647 }, { "_id": 156, "position_type": "moving", "delta_ms": 1617172, "speed": 114, "angle": 38, "total_odometer": 1245712, "latitude": 45.62539094297811, "longitude": 9.587133406200103 }, { "_id": 157, "position_type": "moving", "delta_ms": 1626469, "speed": 127, "angle": 38, "total_odometer": 1246040, "latitude": 45.62719167618699, "longitude": 9.590480803050689 }, { "_id": 158, "position_type": "moving", "delta_ms": 1633371, "speed": 109, "angle": 38, "total_odometer": 1246249, "latitude": 45.62836212175301, "longitude": 9.592583654918364 }, { "_id": 159, "position_type": "moving", "delta_ms": 1641873, "speed": 105, "angle": 38, "total_odometer": 1246497, "latitude": 45.62974441620733, "longitude": 9.595098064306583 }, { "_id": 160, "position_type": "moving", "delta_ms": 1649814, "speed": 131, "angle": 38, "total_odometer": 1246786, "latitude": 45.63139496232768, "longitude": 9.597973392370548 }, { "_id": 161, "position_type": "moving", "delta_ms": 1658341, "speed": 122, "angle": 38, "total_odometer": 1247075, "latitude": 45.63304545984177, "longitude": 9.600848720434513 }, { "_id": 162, "position_type": "moving", "delta_ms": 1668640, "speed": 115, "angle": 38, "total_odometer": 1247404, "latitude": 45.63496597757963, "longitude": 9.604067371252384 }, { "_id": 163, "position_type": "moving", "delta_ms": 1676346, "speed": 135, "angle": 38, "total_odometer": 1247693, "latitude": 45.63649634303213, "longitude": 9.607071445349064 }, { "_id": 164, "position_type": "moving", "delta_ms": 1682853, "speed": 130, "angle": 38, "total_odometer": 1247928, "latitude": 45.637829592371595, "longitude": 9.609419604912697 }, { "_id": 165, "position_type": "moving", "delta_ms": 1695616, "speed": 110, "angle": 38, "total_odometer": 1248318, "latitude": 45.63995998085793, "longitude": 9.613410731926857 }, { "_id": 166, "position_type": "moving", "delta_ms": 1707722, "speed": 124, "angle": 38, "total_odometer": 1248735, "latitude": 45.642210303258054, "longitude": 9.617702266350685 }, { "_id": 167, "position_type": "moving", "delta_ms": 1716293, "speed": 126, "angle": 38, "total_odometer": 1249035, "latitude": 45.64398049336243, "longitude": 9.620620509758888 }, { "_id": 168, "position_type": "moving", "delta_ms": 1726073, "speed": 60, "angle": 38, "total_odometer": 1249198, "latitude": 45.64523886478187, "longitude": 9.619547626152931 }, { "_id": 169, "position_type": "moving", "delta_ms": 1733273, "speed": 61, "angle": 38, "total_odometer": 1249320, "latitude": 45.64586890479644, "longitude": 9.62083508648008 }, { "_id": 170, "position_type": "moving", "delta_ms": 1747479, "speed": 93, "angle": 38, "total_odometer": 1249687, "latitude": 45.6473689715485, "longitude": 9.625040790215431 }, { "_id": 171, "position_type": "moving", "delta_ms": 1757264, "speed": 71, "angle": 38, "total_odometer": 1249880, "latitude": 45.64886899813059, "longitude": 9.623796245232521 }, { "_id": 172, "position_type": "stop", "delta_ms": 1760864, "speed": 0, "angle": 38, "total_odometer": 1249880, "latitude": 45.64886899813059, "longitude": 9.623796245232521 }, { "_id": 173, "position_type": "stop", "delta_ms": 1765864, "speed": 0, "angle": 38, "total_odometer": 1249880, "latitude": 45.64886899813059, "longitude": 9.623796245232521 }, { "_id": 174, "position_type": "stop", "delta_ms": 1775864, "speed": 0, "angle": 38, "total_odometer": 1249880, "latitude": 45.64886899813059, "longitude": 9.623796245232521 }]
};
// Sono 3 percorsi demo per la mappa principale
const DEMO_ROUTES_LIVE = {
    "-1": [{ "_id": 0, "position_type": "moving", "delta_ms": 0, "speed": 69, "angle": 135, "total_odometer": 1200000, "latitude": 45.49256328051418, "longitude": 9.145931223368855 }, { "_id": 1, "position_type": "moving", "delta_ms": 5072, "speed": 44, "angle": 135, "total_odometer": 1200062, "latitude": 45.492286689641865, "longitude": 9.146625555266112 }, { "_id": 2, "position_type": "moving", "delta_ms": 8140, "speed": 61, "angle": 135, "total_odometer": 1200114, "latitude": 45.49204225756367, "longitude": 9.14719418357727 }, { "_id": 3, "position_type": "moving", "delta_ms": 10840, "speed": 52, "angle": 135, "total_odometer": 1200153, "latitude": 45.4918617531942, "longitude": 9.147623337019652 }, { "_id": 4, "position_type": "moving", "delta_ms": 13933, "speed": 64, "angle": 135, "total_odometer": 1200208, "latitude": 45.491579713958785, "longitude": 9.148208058584899 }, { "_id": 5, "position_type": "moving", "delta_ms": 16487, "speed": 62, "angle": 135, "total_odometer": 1200252, "latitude": 45.491369123741954, "longitude": 9.14868549178955 }, { "_id": 6, "position_type": "moving", "delta_ms": 19173, "speed": 67, "angle": 135, "total_odometer": 1200302, "latitude": 45.491128182473005, "longitude": 9.149228245813154 }, { "_id": 7, "position_type": "moving", "delta_ms": 21729, "speed": 69, "angle": 135, "total_odometer": 1200351, "latitude": 45.49088374536683, "longitude": 9.149759323198102 }, { "_id": 8, "position_type": "moving", "delta_ms": 25329, "speed": 54, "angle": 135, "total_odometer": 1200405, "latitude": 45.49062426481643, "longitude": 9.150349409181379 }, { "_id": 9, "position_type": "moving", "delta_ms": 27257, "speed": 56, "angle": 135, "total_odometer": 1200435, "latitude": 45.49047008015506, "longitude": 9.150665909845136 }, { "_id": 10, "position_type": "moving", "delta_ms": 29828, "speed": 56, "angle": 135, "total_odometer": 1200475, "latitude": 45.49026324640985, "longitude": 9.15108969886949 }, { "_id": 11, "position_type": "moving", "delta_ms": 32708, "speed": 50, "angle": 135, "total_odometer": 1200515, "latitude": 45.490056411905094, "longitude": 9.151524216729902 }, { "_id": 12, "position_type": "moving", "delta_ms": 35636, "speed": 59, "angle": 135, "total_odometer": 1200563, "latitude": 45.48984205534415, "longitude": 9.15206602295091 }, { "_id": 13, "position_type": "moving", "delta_ms": 38375, "speed": 46, "angle": 135, "total_odometer": 1200598, "latitude": 45.48965402260146, "longitude": 9.152436167794965 }, { "_id": 14, "position_type": "moving", "delta_ms": 41209, "speed": 47, "angle": 135, "total_odometer": 1200635, "latitude": 45.4894876880692, "longitude": 9.152854164645019 }, { "_id": 15, "position_type": "moving", "delta_ms": 45619, "speed": 40, "angle": 135, "total_odometer": 1200684, "latitude": 45.48924324384338, "longitude": 9.153379877611938 }, { "_id": 16, "position_type": "moving", "delta_ms": 49677, "speed": 55, "angle": 135, "total_odometer": 1200746, "latitude": 45.4889372711377, "longitude": 9.154054298675932 }, { "_id": 17, "position_type": "moving", "delta_ms": 51879, "speed": 67, "angle": 135, "total_odometer": 1200787, "latitude": 45.48874171393094, "longitude": 9.154510274208464 }, { "_id": 18, "position_type": "moving", "delta_ms": 54914, "speed": 51, "angle": 135, "total_odometer": 1200830, "latitude": 45.4885273523666, "longitude": 9.154982342995085 }, { "_id": 19, "position_type": "moving", "delta_ms": 57503, "speed": 57, "angle": 135, "total_odometer": 1200871, "latitude": 45.488327662149395, "longitude": 9.155429730478426 }, { "_id": 20, "position_type": "moving", "delta_ms": 60720, "speed": 47, "angle": 135, "total_odometer": 1200913, "latitude": 45.48811705977318, "longitude": 9.155885706010958 }, { "_id": 21, "position_type": "moving", "delta_ms": 62205, "speed": 63, "angle": 180, "total_odometer": 1200939, "latitude": 45.48788389193818, "longitude": 9.15584279066672 }, { "_id": 22, "position_type": "moving", "delta_ms": 64005, "speed": 40, "angle": 180, "total_odometer": 1200959, "latitude": 45.487699613450246, "longitude": 9.155864248338839 }, { "_id": 23, "position_type": "moving", "delta_ms": 65919, "speed": 47, "angle": 225, "total_odometer": 1200984, "latitude": 45.48753037757316, "longitude": 9.155649671617647 }, { "_id": 24, "position_type": "moving", "delta_ms": 67719, "speed": 66, "angle": 225, "total_odometer": 1201017, "latitude": 45.487323533032864, "longitude": 9.15533853537192 }, { "_id": 25, "position_type": "moving", "delta_ms": 70250, "speed": 64, "angle": 225, "total_odometer": 1201062, "latitude": 45.487048992742636, "longitude": 9.154898653093477 }, { "_id": 26, "position_type": "moving", "delta_ms": 74039, "speed": 57, "angle": 225, "total_odometer": 1201122, "latitude": 45.48669171227908, "longitude": 9.15431929594626 }, { "_id": 27, "position_type": "moving", "delta_ms": 76566, "speed": 47, "angle": 225, "total_odometer": 1201155, "latitude": 45.48648862553175, "longitude": 9.154002795282503 }, { "_id": 28, "position_type": "moving", "delta_ms": 79579, "speed": 43, "angle": 225, "total_odometer": 1201191, "latitude": 45.48626673361897, "longitude": 9.153664836946627 }, { "_id": 29, "position_type": "stop", "delta_ms": 79699, "speed": 0, "angle": 225, "total_odometer": 1201191, "latitude": 45.48626673361897, "longitude": 9.153664836946627 }, { "_id": 30, "position_type": "stop", "delta_ms": 79819, "speed": 0, "angle": 225, "total_odometer": 1201191, "latitude": 45.48626673361897, "longitude": 9.153664836946627 }, { "_id": 31, "position_type": "moving", "delta_ms": 82201, "speed": 68, "angle": 225, "total_odometer": 1201236, "latitude": 45.485984666366406, "longitude": 9.153241047922274 }, { "_id": 32, "position_type": "moving", "delta_ms": 84783, "speed": 46, "angle": 225, "total_odometer": 1201269, "latitude": 45.485766533389295, "longitude": 9.152946004930635 }, { "_id": 33, "position_type": "moving", "delta_ms": 86904, "speed": 56, "angle": 225, "total_odometer": 1201302, "latitude": 45.48555592143751, "longitude": 9.152640233102938 }, { "_id": 34, "position_type": "moving", "delta_ms": 91990, "speed": 46, "angle": 225, "total_odometer": 1201367, "latitude": 45.48517291436165, "longitude": 9.152002930641174 }, { "_id": 35, "position_type": "stop", "delta_ms": 92110, "speed": 0, "angle": 225, "total_odometer": 1201367, "latitude": 45.48517291436165, "longitude": 9.152002930641174 }, { "_id": 36, "position_type": "stop", "delta_ms": 92230, "speed": 0, "angle": 225, "total_odometer": 1201367, "latitude": 45.48517291436165, "longitude": 9.152002930641174 }, { "_id": 37, "position_type": "moving", "delta_ms": 95230, "speed": 60, "angle": 225, "total_odometer": 1201417, "latitude": 45.48485638323233, "longitude": 9.151535162988802 }, { "_id": 38, "position_type": "moving", "delta_ms": 97982, "speed": 68, "angle": 225, "total_odometer": 1201469, "latitude": 45.484525415893046, "longitude": 9.151047000948092 }, { "_id": 39, "position_type": "moving", "delta_ms": 101244, "speed": 64, "angle": 225, "total_odometer": 1201527, "latitude": 45.484168119423714, "longitude": 9.150494465891024 }, { "_id": 40, "position_type": "moving", "delta_ms": 104582, "speed": 55, "angle": 225, "total_odometer": 1201578, "latitude": 45.483859192864166, "longitude": 9.150010924492062 }, { "_id": 41, "position_type": "moving", "delta_ms": 108433, "speed": 43, "angle": 225, "total_odometer": 1201624, "latitude": 45.483569591422444, "longitude": 9.149576406631649 }, { "_id": 42, "position_type": "moving", "delta_ms": 110580, "speed": 57, "angle": 225, "total_odometer": 1201658, "latitude": 45.48336649341936, "longitude": 9.149243812713802 }, { "_id": 43, "position_type": "moving", "delta_ms": 114638, "speed": 55, "angle": 225, "total_odometer": 1201720, "latitude": 45.482994145178736, "longitude": 9.148637633476437 }, { "_id": 44, "position_type": "stop", "delta_ms": 114758, "speed": 0, "angle": 225, "total_odometer": 1201720, "latitude": 45.482994145178736, "longitude": 9.148637633476437 }, { "_id": 45, "position_type": "stop", "delta_ms": 114878, "speed": 0, "angle": 225, "total_odometer": 1201720, "latitude": 45.482994145178736, "longitude": 9.148637633476437 }, { "_id": 46, "position_type": "moving", "delta_ms": 124078, "speed": 45, "angle": 145, "total_odometer": 1201835, "latitude": 45.4821435090422, "longitude": 9.149480822516306 }, { "_id": 47, "position_type": "moving", "delta_ms": 127834, "speed": 69, "angle": 145, "total_odometer": 1201907, "latitude": 45.481692167727566, "longitude": 9.15015673918806 }, { "_id": 48, "position_type": "moving", "delta_ms": 133041, "speed": 56, "angle": 145, "total_odometer": 1201988, "latitude": 45.48113550845989, "longitude": 9.150843384695872 }, { "_id": 49, "position_type": "stop", "delta_ms": 133161, "speed": 0, "angle": 145, "total_odometer": 1201988, "latitude": 45.48113550845989, "longitude": 9.150843384695872 }, { "_id": 50, "position_type": "moving", "delta_ms": 141242, "speed": 49, "angle": 145, "total_odometer": 1202098, "latitude": 45.48034564465507, "longitude": 9.151701691580637 }, { "_id": 51, "position_type": "moving", "delta_ms": 146642, "speed": 56, "angle": 182, "total_odometer": 1202182, "latitude": 45.47958586045153, "longitude": 9.151680233908518 }, { "_id": 52, "position_type": "moving", "delta_ms": 153442, "speed": 54, "angle": 182, "total_odometer": 1202284, "latitude": 45.47866808765222, "longitude": 9.15162658972822 }, { "_id": 53, "position_type": "moving", "delta_ms": 158777, "speed": 56, "angle": 182, "total_odometer": 1202367, "latitude": 45.4779233266065, "longitude": 9.151562216711863 }, { "_id": 54, "position_type": "moving", "delta_ms": 163249, "speed": 66, "angle": 182, "total_odometer": 1202449, "latitude": 45.477178555717, "longitude": 9.151530030203684 }, { "_id": 55, "position_type": "moving", "delta_ms": 172249, "speed": 46, "angle": 182, "total_odometer": 1202564, "latitude": 45.47614037381023, "longitude": 9.151465657187327 }, { "_id": 56, "position_type": "moving", "delta_ms": 177424, "speed": 64, "angle": 182, "total_odometer": 1202656, "latitude": 45.47531282380815, "longitude": 9.151422741843088 }, { "_id": 57, "position_type": "moving", "delta_ms": 184208, "speed": 52, "angle": 182, "total_odometer": 1202754, "latitude": 45.47443123052824, "longitude": 9.15137982649885 }, { "_id": 58, "position_type": "moving", "delta_ms": 189328, "speed": 45, "angle": 95, "total_odometer": 1202818, "latitude": 45.47387449952524, "longitude": 9.151605132056101 }, { "_id": 59, "position_type": "moving", "delta_ms": 193841, "speed": 67, "angle": 95, "total_odometer": 1202902, "latitude": 45.473573561558, "longitude": 9.152602913809641 }, { "_id": 60, "position_type": "moving", "delta_ms": 201184, "speed": 50, "angle": 95, "total_odometer": 1203004, "latitude": 45.473535944199085, "longitude": 9.153911831808909 }, { "_id": 61, "position_type": "moving", "delta_ms": 208101, "speed": 51, "angle": 95, "total_odometer": 1203102, "latitude": 45.47351442071237, "longitude": 9.155167105627878 }, { "_id": 62, "position_type": "stop", "delta_ms": 208221, "speed": 0, "angle": 95, "total_odometer": 1203102, "latitude": 45.47351442071237, "longitude": 9.155167105627878 }, { "_id": 63, "position_type": "moving", "delta_ms": 212421, "speed": 48, "angle": 95, "total_odometer": 1203158, "latitude": 45.4735068972347, "longitude": 9.15589666647993 }, { "_id": 64, "position_type": "moving", "delta_ms": 218833, "speed": 64, "angle": 95, "total_odometer": 1203272, "latitude": 45.473446709377214, "longitude": 9.15735578818403 }, { "_id": 65, "position_type": "moving", "delta_ms": 231391, "speed": 43, "angle": 95, "total_odometer": 1203422, "latitude": 45.47345726120125, "longitude": 9.159280433311183 }, { "_id": 66, "position_type": "stop", "delta_ms": 231511, "speed": 0, "angle": 95, "total_odometer": 1203422, "latitude": 45.47345726120125, "longitude": 9.159280433311183 }, { "_id": 67, "position_type": "moving", "delta_ms": 237271, "speed": 40, "angle": 1, "total_odometer": 1203486, "latitude": 45.47392173648489, "longitude": 9.159768315880047 }, { "_id": 68, "position_type": "moving", "delta_ms": 246099, "speed": 42, "angle": 1, "total_odometer": 1203589, "latitude": 45.47484710989028, "longitude": 9.159854146568524 }, { "_id": 69, "position_type": "moving", "delta_ms": 259939, "speed": 45, "angle": 1, "total_odometer": 1203762, "latitude": 45.47640317154983, "longitude": 9.159909741567208 }, { "_id": 70, "position_type": "moving", "delta_ms": 266164, "speed": 48, "angle": 1, "total_odometer": 1203845, "latitude": 45.477149515166374, "longitude": 9.15997122688089 }, { "_id": 71, "position_type": "moving", "delta_ms": 270735, "speed": 63, "angle": 1, "total_odometer": 1203925, "latitude": 45.477871717757886, "longitude": 9.160003413389068 }, { "_id": 72, "position_type": "moving", "delta_ms": 276930, "speed": 43, "angle": 1, "total_odometer": 1203999, "latitude": 45.4785386354769, "longitude": 9.160051693151336 }, { "_id": 73, "position_type": "moving", "delta_ms": 281398, "speed": 58, "angle": 1, "total_odometer": 1204071, "latitude": 45.47918935447413, "longitude": 9.160089244077545 }, { "_id": 74, "position_type": "moving", "delta_ms": 287483, "speed": 42, "angle": 1, "total_odometer": 1204142, "latitude": 45.47983254332331, "longitude": 9.160051693151336 }, { "_id": 75, "position_type": "moving", "delta_ms": 293763, "speed": 47, "angle": 270, "total_odometer": 1204224, "latitude": 45.48028117481264, "longitude": 9.159213456951564 }, { "_id": 76, "position_type": "moving", "delta_ms": 298970, "speed": 56, "angle": 270, "total_odometer": 1204305, "latitude": 45.48033383280436, "longitude": 9.158172759853786 }, { "_id": 77, "position_type": "moving", "delta_ms": 302930, "speed": 70, "angle": 270, "total_odometer": 1204382, "latitude": 45.48041658097766, "longitude": 9.157185706936305 }, { "_id": 78, "position_type": "moving", "delta_ms": 308161, "speed": 64, "angle": 270, "total_odometer": 1204475, "latitude": 45.48089049999267, "longitude": 9.156198654018825 }, { "_id": 79, "position_type": "moving", "delta_ms": 317536, "speed": 48, "angle": 315, "total_odometer": 1204600, "latitude": 45.48166531138324, "longitude": 9.155029210888332 }, { "_id": 80, "position_type": "moving", "delta_ms": 323836, "speed": 56, "angle": 315, "total_odometer": 1204698, "latitude": 45.4823197554218, "longitude": 9.154170904003566 }, { "_id": 81, "position_type": "moving", "delta_ms": 326960, "speed": 53, "angle": 315, "total_odometer": 1204744, "latitude": 45.48264321346124, "longitude": 9.153795394741481 }, { "_id": 82, "position_type": "stop", "delta_ms": 327080, "speed": 0, "angle": 315, "total_odometer": 1204744, "latitude": 45.48264321346124, "longitude": 9.153795394741481 }, { "_id": 83, "position_type": "stop", "delta_ms": 327200, "speed": 0, "angle": 315, "total_odometer": 1204744, "latitude": 45.48264321346124, "longitude": 9.153795394741481 }, { "_id": 84, "position_type": "moving", "delta_ms": 337010, "speed": 40, "angle": 45, "total_odometer": 1204853, "latitude": 45.48338038996084, "longitude": 9.154728803478664 }, { "_id": 85, "position_type": "moving", "delta_ms": 344053, "speed": 46, "angle": 45, "total_odometer": 1204943, "latitude": 45.483944549133476, "longitude": 9.15556565269131 }, { "_id": 86, "position_type": "moving", "delta_ms": 348580, "speed": 66, "angle": 45, "total_odometer": 1205026, "latitude": 45.48400472577846, "longitude": 9.156627807461208 }, { "_id": 87, "position_type": "moving", "delta_ms": 352231, "speed": 70, "angle": 45, "total_odometer": 1205097, "latitude": 45.484644098661484, "longitude": 9.156692180477565 }, { "_id": 88, "position_type": "moving", "delta_ms": 358516, "speed": 63, "angle": 45, "total_odometer": 1205207, "latitude": 45.48532859570511, "longitude": 9.157722148739284 }, { "_id": 89, "position_type": "moving", "delta_ms": 364973, "speed": 63, "angle": 45, "total_odometer": 1205320, "latitude": 45.486035649852404, "longitude": 9.158773574673122 }, { "_id": 90, "position_type": "stop", "delta_ms": 365093, "speed": 0, "angle": 45, "total_odometer": 1205320, "latitude": 45.486035649852404, "longitude": 9.158773574673122 }, { "_id": 91, "position_type": "stop", "delta_ms": 365213, "speed": 0, "angle": 45, "total_odometer": 1205320, "latitude": 45.486035649852404, "longitude": 9.158773574673122 }, { "_id": 92, "position_type": "stop", "delta_ms": 365333, "speed": 0, "angle": 45, "total_odometer": 1205320, "latitude": 45.486035649852404, "longitude": 9.158773574673122 }, { "_id": 93, "position_type": "moving", "delta_ms": 370944, "speed": 68, "angle": 45, "total_odometer": 1205426, "latitude": 45.486690043123424, "longitude": 9.159760627590602 }, { "_id": 94, "position_type": "moving", "delta_ms": 375726, "speed": 70, "angle": 45, "total_odometer": 1205519, "latitude": 45.48724664750892, "longitude": 9.160651120983546 }, { "_id": 95, "position_type": "moving", "delta_ms": 378259, "speed": 54, "angle": 45, "total_odometer": 1205557, "latitude": 45.48750990442407, "longitude": 9.160972986065334 }, { "_id": 96, "position_type": "moving", "delta_ms": 382323, "speed": 62, "angle": 90, "total_odometer": 1205627, "latitude": 45.48750238281499, "longitude": 9.161874208294337 }, { "_id": 97, "position_type": "moving", "delta_ms": 385548, "speed": 48, "angle": 2, "total_odometer": 1205670, "latitude": 45.487816807415115, "longitude": 9.161546230316162 }, { "_id": 98, "position_type": "moving", "delta_ms": 388775, "speed": 58, "angle": 315, "total_odometer": 1205722, "latitude": 45.4880890653066, "longitude": 9.160994443737453 }, { "_id": 99, "position_type": "moving", "delta_ms": 394313, "speed": 65, "angle": 315, "total_odometer": 1205822, "latitude": 45.488758477608776, "longitude": 9.160136136852687 }, { "_id": 100, "position_type": "moving", "delta_ms": 402966, "speed": 52, "angle": 315, "total_odometer": 1205947, "latitude": 45.48956042433725, "longitude": 9.159013662762371 }, { "_id": 101, "position_type": "stop", "delta_ms": 403086, "speed": 0, "angle": 315, "total_odometer": 1205947, "latitude": 45.48956042433725, "longitude": 9.159013662762371 }, { "_id": 102, "position_type": "stop", "delta_ms": 403206, "speed": 0, "angle": 315, "total_odometer": 1205947, "latitude": 45.48956042433725, "longitude": 9.159013662762371 }, { "_id": 103, "position_type": "moving", "delta_ms": 414177, "speed": 42, "angle": 45, "total_odometer": 1206075, "latitude": 45.490402807531034, "longitude": 9.160140190548626 }, { "_id": 104, "position_type": "moving", "delta_ms": 418616, "speed": 60, "angle": 45, "total_odometer": 1206149, "latitude": 45.49083151556895, "longitude": 9.160869751400677 }, { "_id": 105, "position_type": "moving", "delta_ms": 423926, "speed": 40, "angle": 45, "total_odometer": 1206208, "latitude": 45.491200051449376, "longitude": 9.161427650875774 }, { "_id": 106, "position_type": "stop", "delta_ms": 424046, "speed": 0, "angle": 45, "total_odometer": 1206208, "latitude": 45.491200051449376, "longitude": 9.161427650875774 }, { "_id": 107, "position_type": "stop", "delta_ms": 424166, "speed": 0, "angle": 45, "total_odometer": 1206208, "latitude": 45.491200051449376, "longitude": 9.161427650875774 }, { "_id": 108, "position_type": "moving", "delta_ms": 431306, "speed": 61, "angle": 320, "total_odometer": 1206329, "latitude": 45.49206497312619, "longitude": 9.160483513302532 }, { "_id": 109, "position_type": "moving", "delta_ms": 439282, "speed": 51, "angle": 320, "total_odometer": 1206442, "latitude": 45.4928095472349, "longitude": 9.159485731548992 }, { "_id": 110, "position_type": "moving", "delta_ms": 446032, "speed": 56, "angle": 320, "total_odometer": 1206547, "latitude": 45.493531549091024, "longitude": 9.158605966992107 }, { "_id": 111, "position_type": "moving", "delta_ms": 451321, "speed": 49, "angle": 320, "total_odometer": 1206619, "latitude": 45.49400535777879, "longitude": 9.157972965664593 }, { "_id": 112, "position_type": "stop", "delta_ms": 451441, "speed": 0, "angle": 320, "total_odometer": 1206619, "latitude": 45.49400535777879, "longitude": 9.157972965664593 }, { "_id": 113, "position_type": "stop", "delta_ms": 451561, "speed": 0, "angle": 320, "total_odometer": 1206619, "latitude": 45.49400535777879, "longitude": 9.157972965664593 }, { "_id": 114, "position_type": "moving", "delta_ms": 457193, "speed": 62, "angle": 320, "total_odometer": 1206716, "latitude": 45.49464461715125, "longitude": 9.157114658779827 }, { "_id": 115, "position_type": "moving", "delta_ms": 462930, "speed": 64, "angle": 320, "total_odometer": 1206818, "latitude": 45.49530643097402, "longitude": 9.156202707714764 }, { "_id": 116, "position_type": "moving", "delta_ms": 468213, "speed": 62, "angle": 320, "total_odometer": 1206909, "latitude": 45.49590055266696, "longitude": 9.155387316174236 }, { "_id": 117, "position_type": "moving", "delta_ms": 475566, "speed": 47, "angle": 320, "total_odometer": 1207005, "latitude": 45.496554831329554, "longitude": 9.154582653469769 }, { "_id": 118, "position_type": "moving", "delta_ms": 481140, "speed": 62, "angle": 320, "total_odometer": 1207101, "latitude": 45.497194061761455, "longitude": 9.153745804257122 }, { "_id": 119, "position_type": "moving", "delta_ms": 485940, "speed": 57, "angle": 320, "total_odometer": 1207177, "latitude": 45.49770420158381, "longitude": 9.15308565594275 }, { "_id": 120, "position_type": "stop", "delta_ms": 486060, "speed": 0, "angle": 320, "total_odometer": 1207177, "latitude": 45.49770420158381, "longitude": 9.15308565594275 }, { "_id": 121, "position_type": "stop", "delta_ms": 486180, "speed": 0, "angle": 320, "total_odometer": 1207177, "latitude": 45.49770420158381, "longitude": 9.15308565594275 }, { "_id": 122, "position_type": "moving", "delta_ms": 492287, "speed": 56, "angle": 225, "total_odometer": 1207272, "latitude": 45.497177781818635, "longitude": 9.152120060697388 }, { "_id": 123, "position_type": "moving", "delta_ms": 498587, "speed": 48, "angle": 225, "total_odometer": 1207356, "latitude": 45.496636316354504, "longitude": 9.151369042173219 }, { "_id": 124, "position_type": "moving", "delta_ms": 502580, "speed": 64, "angle": 225, "total_odometer": 1207427, "latitude": 45.496200132055314, "longitude": 9.150703854337525 }, { "_id": 125, "position_type": "moving", "delta_ms": 505837, "speed": 63, "angle": 225, "total_odometer": 1207484, "latitude": 45.49604972289288, "longitude": 9.149995751157594 }, { "_id": 126, "position_type": "moving", "delta_ms": 508878, "speed": 58, "angle": 225, "total_odometer": 1207533, "latitude": 45.49573386234412, "longitude": 9.149545140043092 }, { "_id": 127, "position_type": "moving", "delta_ms": 513126, "speed": 50, "angle": 225, "total_odometer": 1207592, "latitude": 45.495372876690375, "longitude": 9.148987240567994 }, { "_id": 128, "position_type": "moving", "delta_ms": 517308, "speed": 68, "angle": 225, "total_odometer": 1207671, "latitude": 45.4948915588858, "longitude": 9.148236222043824 }, { "_id": 129, "position_type": "moving", "delta_ms": 520850, "speed": 63, "angle": 225, "total_odometer": 1207733, "latitude": 45.4951171771189, "longitude": 9.147506661191773 }, { "_id": 130, "position_type": "moving", "delta_ms": 525965, "speed": 57, "angle": 225, "total_odometer": 1207814, "latitude": 45.494831393870975, "longitude": 9.146541065946412 }, { "_id": 131, "position_type": "moving", "delta_ms": 531923, "speed": 58, "angle": 225, "total_odometer": 1207910, "latitude": 45.49448544378831, "longitude": 9.145403809324097 }, { "_id": 132, "position_type": "moving", "delta_ms": 537589, "speed": 54, "angle": 225, "total_odometer": 1207995, "latitude": 45.494229740187365, "longitude": 9.144373841062379 }, { "_id": 133, "position_type": "stop", "delta_ms": 537709, "speed": 0, "angle": 225, "total_odometer": 1207995, "latitude": 45.494229740187365, "longitude": 9.144373841062379 }, { "_id": 134, "position_type": "moving", "delta_ms": 540647, "speed": 49, "angle": 165, "total_odometer": 1208035, "latitude": 45.493894817638314, "longitude": 9.144574188803775 }, { "_id": 135, "position_type": "moving", "delta_ms": 543504, "speed": 63, "angle": 165, "total_odometer": 1208085, "latitude": 45.49348869535286, "longitude": 9.144863867377383 }, { "_id": 136, "position_type": "moving", "delta_ms": 545134, "speed": 53, "angle": 165, "total_odometer": 1208109, "latitude": 45.49328563311186, "longitude": 9.144971155737979 }],
    "-2": [{ "_id": 0, "position_type": "moving", "delta_ms": 0, "speed": 109, "angle": 75, "total_odometer": 1200000, "latitude": 45.47757578406184, "longitude": 9.181158868533323 }, { "_id": 1, "position_type": "moving", "delta_ms": 7987, "speed": 64, "angle": 10, "total_odometer": 1200142, "latitude": 45.478802009118056, "longitude": 9.181695310336302 }, { "_id": 2, "position_type": "moving", "delta_ms": 15685, "speed": 65, "angle": 10, "total_odometer": 1200281, "latitude": 45.48002068488121, "longitude": 9.182092277270506 }, { "_id": 3, "position_type": "moving", "delta_ms": 20226, "speed": 65, "angle": 10, "total_odometer": 1200363, "latitude": 45.480727805646914, "longitude": 9.182414142352293 }, { "_id": 4, "position_type": "stop", "delta_ms": 20346, "speed": 0, "angle": 10, "total_odometer": 1200363, "latitude": 45.480727805646914, "longitude": 9.182414142352293 }, { "_id": 5, "position_type": "stop", "delta_ms": 20466, "speed": 0, "angle": 10, "total_odometer": 1200363, "latitude": 45.480727805646914, "longitude": 9.182414142352293 }, { "_id": 6, "position_type": "moving", "delta_ms": 26113, "speed": 51, "angle": 40, "total_odometer": 1200443, "latitude": 45.481036227882164, "longitude": 9.183347551089476 }, { "_id": 7, "position_type": "moving", "delta_ms": 31365, "speed": 61, "angle": 100, "total_odometer": 1200532, "latitude": 45.48085568824203, "longitude": 9.184463350039671 }, { "_id": 8, "position_type": "moving", "delta_ms": 37608, "speed": 64, "angle": 100, "total_odometer": 1200643, "latitude": 45.480599922761535, "longitude": 9.185847369891356 }, { "_id": 9, "position_type": "moving", "delta_ms": 42741, "speed": 54, "angle": 100, "total_odometer": 1200720, "latitude": 45.48044194938474, "longitude": 9.186812965136717 }, { "_id": 10, "position_type": "moving", "delta_ms": 50691, "speed": 48, "angle": 100, "total_odometer": 1200826, "latitude": 45.480201227196964, "longitude": 9.188132611972044 }, { "_id": 11, "position_type": "moving", "delta_ms": 55853, "speed": 53, "angle": 100, "total_odometer": 1200902, "latitude": 45.480058297911356, "longitude": 9.189087478381346 }, { "_id": 12, "position_type": "moving", "delta_ms": 58115, "speed": 70, "angle": 100, "total_odometer": 1200946, "latitude": 45.480043006999495, "longitude": 9.189660328142013 }, { "_id": 13, "position_type": "stop", "delta_ms": 58235, "speed": 0, "angle": 100, "total_odometer": 1200946, "latitude": 45.480043006999495, "longitude": 9.189660328142013 }, { "_id": 14, "position_type": "stop", "delta_ms": 58355, "speed": 0, "angle": 100, "total_odometer": 1200946, "latitude": 45.480043006999495, "longitude": 9.189660328142013 }, { "_id": 15, "position_type": "moving", "delta_ms": 63278, "speed": 68, "angle": 40, "total_odometer": 1201039, "latitude": 45.4806749023233, "longitude": 9.190443533174362 }, { "_id": 16, "position_type": "moving", "delta_ms": 69329, "speed": 47, "angle": 40, "total_odometer": 1201118, "latitude": 45.48117138653471, "longitude": 9.191173094026412 }, { "_id": 17, "position_type": "moving", "delta_ms": 75500, "speed": 49, "angle": 40, "total_odometer": 1201202, "latitude": 45.48175061258516, "longitude": 9.191870468370285 }, { "_id": 18, "position_type": "moving", "delta_ms": 81050, "speed": 48, "angle": 40, "total_odometer": 1201276, "latitude": 45.482262131937915, "longitude": 9.19249274086174 }, { "_id": 19, "position_type": "moving", "delta_ms": 85708, "speed": 51, "angle": 40, "total_odometer": 1201342, "latitude": 45.48270594643703, "longitude": 9.193061369172897 }, { "_id": 20, "position_type": "moving", "delta_ms": 90325, "speed": 46, "angle": 135, "total_odometer": 1201401, "latitude": 45.48264576840475, "longitude": 9.193823116533126 }, { "_id": 21, "position_type": "moving", "delta_ms": 95692, "speed": 55, "angle": 135, "total_odometer": 1201483, "latitude": 45.48197976856395, "longitude": 9.194279909133911 }, { "_id": 22, "position_type": "moving", "delta_ms": 99230, "speed": 59, "angle": 135, "total_odometer": 1201541, "latitude": 45.48183335867768, "longitude": 9.194994579437527 }, { "_id": 23, "position_type": "moving", "delta_ms": 102577, "speed": 57, "angle": 135, "total_odometer": 1201594, "latitude": 45.48157759763536, "longitude": 9.195573936584744 }, { "_id": 24, "position_type": "stop", "delta_ms": 102697, "speed": 0, "angle": 135, "total_odometer": 1201594, "latitude": 45.48157759763536, "longitude": 9.195573936584744 }, { "_id": 25, "position_type": "stop", "delta_ms": 102817, "speed": 0, "angle": 135, "total_odometer": 1201594, "latitude": 45.48157759763536, "longitude": 9.195573936584744 }, { "_id": 26, "position_type": "stop", "delta_ms": 102937, "speed": 0, "angle": 135, "total_odometer": 1201594, "latitude": 45.48157759763536, "longitude": 9.195573936584744 }, { "_id": 27, "position_type": "moving", "delta_ms": 110497, "speed": 40, "angle": 135, "total_odometer": 1201678, "latitude": 45.481170307155395, "longitude": 9.196485887649807 }, { "_id": 28, "position_type": "moving", "delta_ms": 115090, "speed": 58, "angle": 135, "total_odometer": 1201752, "latitude": 45.48101233537784, "longitude": 9.19740856755093 }, { "_id": 29, "position_type": "moving", "delta_ms": 121582, "speed": 56, "angle": 135, "total_odometer": 1201853, "latitude": 45.4805233723068, "longitude": 9.198502908829006 }, { "_id": 30, "position_type": "stop", "delta_ms": 121702, "speed": 0, "angle": 135, "total_odometer": 1201853, "latitude": 45.4805233723068, "longitude": 9.198502908829006 }, { "_id": 31, "position_type": "moving", "delta_ms": 128574, "speed": 55, "angle": 135, "total_odometer": 1201958, "latitude": 45.479989269334006, "longitude": 9.199618707779202 }, { "_id": 32, "position_type": "moving", "delta_ms": 137034, "speed": 40, "angle": 135, "total_odometer": 1202052, "latitude": 45.47950782006188, "longitude": 9.200616489532742 }, { "_id": 33, "position_type": "moving", "delta_ms": 143613, "speed": 58, "angle": 135, "total_odometer": 1202158, "latitude": 45.47899627570271, "longitude": 9.201764474991116 }, { "_id": 34, "position_type": "moving", "delta_ms": 147626, "speed": 61, "angle": 135, "total_odometer": 1202226, "latitude": 45.478642705563665, "longitude": 9.202483307007107 }, { "_id": 35, "position_type": "moving", "delta_ms": 152746, "speed": 45, "angle": 135, "total_odometer": 1202290, "latitude": 45.47834179305946, "longitude": 9.203191410187038 }, { "_id": 36, "position_type": "moving", "delta_ms": 157786, "speed": 50, "angle": 135, "total_odometer": 1202360, "latitude": 45.47798069593315, "longitude": 9.203931699875149 }, { "_id": 37, "position_type": "moving", "delta_ms": 161332, "speed": 67, "angle": 135, "total_odometer": 1202426, "latitude": 45.4776572111258, "longitude": 9.20465053189114 }, { "_id": 38, "position_type": "moving", "delta_ms": 165164, "speed": 62, "angle": 135, "total_odometer": 1202492, "latitude": 45.47733141247787, "longitude": 9.205359669223116 }, { "_id": 39, "position_type": "moving", "delta_ms": 169599, "speed": 56, "angle": 135, "total_odometer": 1202561, "latitude": 45.476970308876695, "longitude": 9.206078501239107 }, { "_id": 40, "position_type": "moving", "delta_ms": 173456, "speed": 42, "angle": 135, "total_odometer": 1202606, "latitude": 45.476737094904415, "longitude": 9.206561298861788 }, { "_id": 41, "position_type": "moving", "delta_ms": 176807, "speed": 58, "angle": 135, "total_odometer": 1202660, "latitude": 45.47647378764663, "longitude": 9.207151384845064 }, { "_id": 42, "position_type": "moving", "delta_ms": 181813, "speed": 64, "angle": 135, "total_odometer": 1202749, "latitude": 45.47599061209617, "longitude": 9.208064770814802 }, { "_id": 43, "position_type": "moving", "delta_ms": 186298, "speed": 61, "angle": 135, "total_odometer": 1202825, "latitude": 45.47561445351117, "longitude": 9.20888016235533 }, { "_id": 44, "position_type": "moving", "delta_ms": 191659, "speed": 47, "angle": 135, "total_odometer": 1202895, "latitude": 45.47524581566179, "longitude": 9.20962045204344 }, { "_id": 45, "position_type": "moving", "delta_ms": 195665, "speed": 62, "angle": 135, "total_odometer": 1202964, "latitude": 45.47492231515426, "longitude": 9.21038219940367 }, { "_id": 46, "position_type": "moving", "delta_ms": 199770, "speed": 57, "angle": 135, "total_odometer": 1203029, "latitude": 45.474598812789665, "longitude": 9.211079573747542 }, { "_id": 47, "position_type": "moving", "delta_ms": 204398, "speed": 63, "angle": 135, "total_odometer": 1203110, "latitude": 45.474196569876874, "longitude": 9.211958605855006 }, { "_id": 48, "position_type": "moving", "delta_ms": 209294, "speed": 50, "angle": 135, "total_odometer": 1203178, "latitude": 45.473858016485536, "longitude": 9.212688166707057 }, { "_id": 49, "position_type": "moving", "delta_ms": 211976, "speed": 51, "angle": 135, "total_odometer": 1203216, "latitude": 45.4736473600156, "longitude": 9.213074404805202 }, { "_id": 50, "position_type": "moving", "delta_ms": 217250, "speed": 43, "angle": 135, "total_odometer": 1203279, "latitude": 45.473399085307946, "longitude": 9.213803965657252 }, { "_id": 51, "position_type": "moving", "delta_ms": 221322, "speed": 61, "angle": 135, "total_odometer": 1203348, "latitude": 45.47304548004824, "longitude": 9.214544255345363 }, { "_id": 52, "position_type": "moving", "delta_ms": 227082, "speed": 55, "angle": 135, "total_odometer": 1203436, "latitude": 45.472609113052464, "longitude": 9.215499121754664 }, { "_id": 53, "position_type": "moving", "delta_ms": 232108, "speed": 53, "angle": 135, "total_odometer": 1203510, "latitude": 45.47221036094676, "longitude": 9.216260869114894 }, { "_id": 54, "position_type": "moving", "delta_ms": 236001, "speed": 49, "angle": 135, "total_odometer": 1203563, "latitude": 45.47196960359248, "longitude": 9.21685095509817 }, { "_id": 55, "position_type": "stop", "delta_ms": 236121, "speed": 0, "angle": 135, "total_odometer": 1203563, "latitude": 45.47196960359248, "longitude": 9.21685095509817 }, { "_id": 56, "position_type": "stop", "delta_ms": 236241, "speed": 0, "angle": 135, "total_odometer": 1203563, "latitude": 45.47196960359248, "longitude": 9.21685095509817 }, { "_id": 57, "position_type": "moving", "delta_ms": 237808, "speed": 62, "angle": 180, "total_odometer": 1203590, "latitude": 45.47177245418494, "longitude": 9.217069701182536 }, { "_id": 58, "position_type": "moving", "delta_ms": 240328, "speed": 60, "angle": 180, "total_odometer": 1203632, "latitude": 45.47138874368357, "longitude": 9.217069701182536 }, { "_id": 59, "position_type": "moving", "delta_ms": 243610, "speed": 68, "angle": 180, "total_odometer": 1203694, "latitude": 45.470824458788854, "longitude": 9.217091158854656 }, { "_id": 60, "position_type": "moving", "delta_ms": 247138, "speed": 50, "angle": 180, "total_odometer": 1203743, "latitude": 45.470380550701385, "longitude": 9.217069701182536 }, { "_id": 61, "position_type": "moving", "delta_ms": 250674, "speed": 57, "angle": 180, "total_odometer": 1203799, "latitude": 45.46986892348406, "longitude": 9.217069701182536 }, { "_id": 62, "position_type": "moving", "delta_ms": 255624, "speed": 40, "angle": 180, "total_odometer": 1203854, "latitude": 45.46937233968475, "longitude": 9.217091158854656 }, { "_id": 63, "position_type": "moving", "delta_ms": 261331, "speed": 41, "angle": 180, "total_odometer": 1203919, "latitude": 45.46878027717393, "longitude": 9.217112616526775 }, { "_id": 64, "position_type": "moving", "delta_ms": 264368, "speed": 64, "angle": 180, "total_odometer": 1203973, "latitude": 45.46829120795831, "longitude": 9.217101887690715 }, { "_id": 65, "position_type": "moving", "delta_ms": 269197, "speed": 41, "angle": 180, "total_odometer": 1204028, "latitude": 45.467794610258984, "longitude": 9.217134074198894 }, { "_id": 66, "position_type": "moving", "delta_ms": 272661, "speed": 53, "angle": 180, "total_odometer": 1204079, "latitude": 45.46733562970707, "longitude": 9.217134074198894 }, { "_id": 67, "position_type": "moving", "delta_ms": 276749, "speed": 59, "angle": 180, "total_odometer": 1204146, "latitude": 45.46672615795215, "longitude": 9.217166260707073 }, { "_id": 68, "position_type": "moving", "delta_ms": 279663, "speed": 63, "angle": 180, "total_odometer": 1204197, "latitude": 45.466267168700334, "longitude": 9.217176989543132 }, { "_id": 69, "position_type": "moving", "delta_ms": 285320, "speed": 49, "angle": 180, "total_odometer": 1204274, "latitude": 45.46557491554689, "longitude": 9.217187718379192 }, { "_id": 70, "position_type": "moving", "delta_ms": 291577, "speed": 42, "angle": 180, "total_odometer": 1204347, "latitude": 45.464912752402, "longitude": 9.217198447215251 }, { "_id": 71, "position_type": "moving", "delta_ms": 295543, "speed": 59, "angle": 180, "total_odometer": 1204412, "latitude": 45.4643258285667, "longitude": 9.217187718379192 }, { "_id": 72, "position_type": "moving", "delta_ms": 300386, "speed": 55, "angle": 180, "total_odometer": 1204486, "latitude": 45.46365797291743, "longitude": 9.217211874532548 }, { "_id": 73, "position_type": "moving", "delta_ms": 303881, "speed": 69, "angle": 180, "total_odometer": 1204553, "latitude": 45.463048461400234, "longitude": 9.217233332204668 }, { "_id": 74, "position_type": "moving", "delta_ms": 307208, "speed": 66, "angle": 180, "total_odometer": 1204614, "latitude": 45.46249914290584, "longitude": 9.217233332204668 }, { "_id": 75, "position_type": "moving", "delta_ms": 310268, "speed": 40, "angle": 270, "total_odometer": 1204648, "latitude": 45.46220442910823, "longitude": 9.21709580815428 }, { "_id": 76, "position_type": "moving", "delta_ms": 316177, "speed": 53, "angle": 270, "total_odometer": 1204735, "latitude": 45.46221947907998, "longitude": 9.215980009204085 }, { "_id": 77, "position_type": "moving", "delta_ms": 321577, "speed": 66, "angle": 270, "total_odometer": 1204834, "latitude": 45.462258344070214, "longitude": 9.214712055730669 }, { "_id": 78, "position_type": "moving", "delta_ms": 329527, "speed": 48, "angle": 270, "total_odometer": 1204940, "latitude": 45.462258344070214, "longitude": 9.213349493551103 }, { "_id": 79, "position_type": "moving", "delta_ms": 339045, "speed": 59, "angle": 270, "total_odometer": 1205096, "latitude": 45.46228091900474, "longitude": 9.211343201207963 }, { "_id": 80, "position_type": "moving", "delta_ms": 346371, "speed": 57, "angle": 270, "total_odometer": 1205212, "latitude": 45.462303493930236, "longitude": 9.209851892995683 }, { "_id": 81, "position_type": "moving", "delta_ms": 351883, "speed": 64, "angle": 270, "total_odometer": 1205310, "latitude": 45.46231101890338, "longitude": 9.208596619176713 }, { "_id": 82, "position_type": "moving", "delta_ms": 363043, "speed": 50, "angle": 270, "total_odometer": 1205465, "latitude": 45.46226586904939, "longitude": 9.206601055669633 }, { "_id": 83, "position_type": "moving", "delta_ms": 371251, "speed": 50, "angle": 270, "total_odometer": 1205579, "latitude": 45.46232606884668, "longitude": 9.205131205129472 }, { "_id": 84, "position_type": "moving", "delta_ms": 376147, "speed": 50, "angle": 270, "total_odometer": 1205647, "latitude": 45.46237121865245, "longitude": 9.204262169408647 }, { "_id": 85, "position_type": "moving", "delta_ms": 382369, "speed": 70, "angle": 270, "total_odometer": 1205768, "latitude": 45.46234864375408, "longitude": 9.20270648818001 }, { "_id": 86, "position_type": "moving", "delta_ms": 385594, "speed": 48, "angle": 270, "total_odometer": 1205811, "latitude": 45.46236369368735, "longitude": 9.202148588704912 }, { "_id": 87, "position_type": "moving", "delta_ms": 397834, "speed": 40, "angle": 270, "total_odometer": 1205947, "latitude": 45.46235616872122, "longitude": 9.200399788427202 }, { "_id": 88, "position_type": "moving", "delta_ms": 401225, "speed": 69, "angle": 270, "total_odometer": 1206012, "latitude": 45.46234111878597, "longitude": 9.199562939214555 }, { "_id": 89, "position_type": "moving", "delta_ms": 406193, "speed": 50, "angle": 270, "total_odometer": 1206081, "latitude": 45.46234111878597, "longitude": 9.198672445821611 }, { "_id": 90, "position_type": "moving", "delta_ms": 409793, "speed": 46, "angle": 270, "total_odometer": 1206127, "latitude": 45.4624690431076, "longitude": 9.198103817510454 }, { "_id": 91, "position_type": "stop", "delta_ms": 409913, "speed": 0, "angle": 270, "total_odometer": 1206127, "latitude": 45.4624690431076, "longitude": 9.198103817510454 }, { "_id": 92, "position_type": "stop", "delta_ms": 410033, "speed": 0, "angle": 270, "total_odometer": 1206127, "latitude": 45.4624690431076, "longitude": 9.198103817510454 }, { "_id": 93, "position_type": "moving", "delta_ms": 416084, "speed": 47, "angle": 20, "total_odometer": 1206206, "latitude": 45.463077044584814, "longitude": 9.198626830219236 }, { "_id": 94, "position_type": "moving", "delta_ms": 423124, "speed": 45, "angle": 20, "total_odometer": 1206294, "latitude": 45.46372417972571, "longitude": 9.19928128921887 }, { "_id": 95, "position_type": "moving", "delta_ms": 427987, "speed": 57, "angle": 20, "total_odometer": 1206371, "latitude": 45.46434120863956, "longitude": 9.199742629169432 }, { "_id": 96, "position_type": "moving", "delta_ms": 435891, "speed": 46, "angle": 20, "total_odometer": 1206472, "latitude": 45.46518396892749, "longitude": 9.200225426792112 }, { "_id": 97, "position_type": "moving", "delta_ms": 440162, "speed": 59, "angle": 20, "total_odometer": 1206542, "latitude": 45.46579345735643, "longitude": 9.200478443537227 }, { "_id": 98, "position_type": "moving", "delta_ms": 448474, "speed": 55, "angle": 10, "total_odometer": 1206669, "latitude": 45.46693717094387, "longitude": 9.200542816553584 }, { "_id": 99, "position_type": "moving", "delta_ms": 459544, "speed": 40, "angle": 340, "total_odometer": 1206792, "latitude": 45.46796799817581, "longitude": 9.199942001734248 }, { "_id": 100, "position_type": "moving", "delta_ms": 469102, "speed": 58, "angle": 340, "total_odometer": 1206946, "latitude": 45.46915417567479, "longitude": 9.198903255454857 }, { "_id": 101, "position_type": "moving", "delta_ms": 484339, "speed": 43, "angle": 340, "total_odometer": 1207128, "latitude": 45.470433251230055, "longitude": 9.197444133750755 }, { "_id": 102, "position_type": "moving", "delta_ms": 492902, "speed": 66, "angle": 340, "total_odometer": 1207285, "latitude": 45.47150163326859, "longitude": 9.196113758079369 }, { "_id": 103, "position_type": "moving", "delta_ms": 500395, "speed": 49, "angle": 340, "total_odometer": 1207387, "latitude": 45.47220886094236, "longitude": 9.195276908866722 }, { "_id": 104, "position_type": "stop", "delta_ms": 500515, "speed": 0, "angle": 340, "total_odometer": 1207387, "latitude": 45.47220886094236, "longitude": 9.195276908866722 }, { "_id": 105, "position_type": "stop", "delta_ms": 500635, "speed": 0, "angle": 340, "total_odometer": 1207387, "latitude": 45.47220886094236, "longitude": 9.195276908866722 }, { "_id": 106, "position_type": "moving", "delta_ms": 512901, "speed": 54, "angle": 290, "total_odometer": 1207571, "latitude": 45.47276687363559, "longitude": 9.1930517289203 }, { "_id": 107, "position_type": "moving", "delta_ms": 523574, "speed": 57, "angle": 290, "total_odometer": 1207740, "latitude": 45.47314305122808, "longitude": 9.190948877052625 }, { "_id": 108, "position_type": "moving", "delta_ms": 532488, "speed": 63, "angle": 270, "total_odometer": 1207896, "latitude": 45.473067815910454, "longitude": 9.188953313545545 }, { "_id": 109, "position_type": "moving", "delta_ms": 540152, "speed": 62, "angle": 250, "total_odometer": 1208028, "latitude": 45.472872203614585, "longitude": 9.187279615120252 }, { "_id": 110, "position_type": "moving", "delta_ms": 550109, "speed": 47, "angle": 250, "total_odometer": 1208158, "latitude": 45.47254116587485, "longitude": 9.185670289711316 }, { "_id": 111, "position_type": "moving", "delta_ms": 558579, "speed": 51, "angle": 250, "total_odometer": 1208278, "latitude": 45.47219507888605, "longitude": 9.184211168007215 }, { "_id": 112, "position_type": "moving", "delta_ms": 566405, "speed": 69, "angle": 250, "total_odometer": 1208428, "latitude": 45.471803847556984, "longitude": 9.182365808204969 }, { "_id": 113, "position_type": "moving", "delta_ms": 573667, "speed": 58, "angle": 310, "total_odometer": 1208545, "latitude": 45.47255621308702, "longitude": 9.18131438227113 }, { "_id": 114, "position_type": "moving", "delta_ms": 578519, "speed": 69, "angle": 310, "total_odometer": 1208638, "latitude": 45.473188192370465, "longitude": 9.180520448402723 }, { "_id": 115, "position_type": "moving", "delta_ms": 585788, "speed": 52, "angle": 20, "total_odometer": 1208743, "latitude": 45.47386530516708, "longitude": 9.181464585975965 }, { "_id": 116, "position_type": "moving", "delta_ms": 598259, "speed": 56, "angle": 345, "total_odometer": 1208937, "latitude": 45.47561071397213, "longitude": 9.18131438227113 }, { "_id": 117, "position_type": "moving", "delta_ms": 616709, "speed": 40, "angle": 345, "total_odometer": 1209142, "latitude": 45.477446344217284, "longitude": 9.181056890205701 }, { "_id": 118, "position_type": "stop", "delta_ms": 616829, "speed": 0, "angle": 345, "total_odometer": 1209142, "latitude": 45.477446344217284, "longitude": 9.181056890205701 }, { "_id": 119, "position_type": "stop", "delta_ms": 616949, "speed": 0, "angle": 345, "total_odometer": 1209142, "latitude": 45.477446344217284, "longitude": 9.181056890205701 }, { "_id": 120, "position_type": "stop", "delta_ms": 617069, "speed": 0, "angle": 345, "total_odometer": 1209142, "latitude": 45.477446344217284, "longitude": 9.181056890205701 }],
    "-3": [{ "_id": 0, "position_type": "moving", "delta_ms": 0, "speed": 49, "angle": 90, "total_odometer": 1200000, "latitude": 45.466868924145224, "longitude": 9.155303462145916 }, { "_id": 1, "position_type": "moving", "delta_ms": 8943, "speed": 64, "angle": 90, "total_odometer": 1200159, "latitude": 45.46673596538553, "longitude": 9.15733803936046 }, { "_id": 2, "position_type": "moving", "delta_ms": 17713, "speed": 55, "angle": 90, "total_odometer": 1200293, "latitude": 45.466630623938805, "longitude": 9.159054653129992 }, { "_id": 3, "position_type": "moving", "delta_ms": 25353, "speed": 49, "angle": 100, "total_odometer": 1200397, "latitude": 45.4664951846466, "longitude": 9.160385028801379 }, { "_id": 4, "position_type": "moving", "delta_ms": 35343, "speed": 40, "angle": 100, "total_odometer": 1200508, "latitude": 45.46637479389147, "longitude": 9.161801235161242 }, { "_id": 5, "position_type": "moving", "delta_ms": 41285, "speed": 63, "angle": 100, "total_odometer": 1200612, "latitude": 45.46629954953893, "longitude": 9.163131610832629 }, { "_id": 6, "position_type": "moving", "delta_ms": 45467, "speed": 68, "angle": 100, "total_odometer": 1200691, "latitude": 45.46623935398458, "longitude": 9.164140121422228 }, { "_id": 7, "position_type": "moving", "delta_ms": 51714, "speed": 68, "angle": 100, "total_odometer": 1200809, "latitude": 45.46608886481753, "longitude": 9.165642158470568 }, { "_id": 8, "position_type": "moving", "delta_ms": 61899, "speed": 41, "angle": 210, "total_odometer": 1200925, "latitude": 45.46505047861502, "longitude": 9.165449039421496 }, { "_id": 9, "position_type": "moving", "delta_ms": 71327, "speed": 42, "angle": 210, "total_odometer": 1201035, "latitude": 45.46408732069108, "longitude": 9.165127174339709 }, { "_id": 10, "position_type": "moving", "delta_ms": 81698, "speed": 42, "angle": 210, "total_odometer": 1201156, "latitude": 45.46301879811531, "longitude": 9.164783851585803 }, { "_id": 11, "position_type": "moving", "delta_ms": 90667, "speed": 59, "angle": 210, "total_odometer": 1201303, "latitude": 45.46173955431114, "longitude": 9.164290325127062 }, { "_id": 12, "position_type": "moving", "delta_ms": 94717, "speed": 40, "angle": 210, "total_odometer": 1201348, "latitude": 45.46133320020478, "longitude": 9.16435469814342 }, { "_id": 13, "position_type": "stop", "delta_ms": 94837, "speed": 0, "angle": 210, "total_odometer": 1201348, "latitude": 45.46133320020478, "longitude": 9.16435469814342 }, { "_id": 14, "position_type": "stop", "delta_ms": 94957, "speed": 0, "angle": 210, "total_odometer": 1201348, "latitude": 45.46133320020478, "longitude": 9.16435469814342 }, { "_id": 15, "position_type": "stop", "delta_ms": 95077, "speed": 0, "angle": 210, "total_odometer": 1201348, "latitude": 45.46133320020478, "longitude": 9.16435469814342 }, { "_id": 16, "position_type": "moving", "delta_ms": 108322, "speed": 53, "angle": 135, "total_odometer": 1201543, "latitude": 45.46033987783723, "longitude": 9.166414634666857 }, { "_id": 17, "position_type": "moving", "delta_ms": 119572, "speed": 40, "angle": 135, "total_odometer": 1201668, "latitude": 45.45948199443646, "longitude": 9.167466060600695 }, { "_id": 18, "position_type": "moving", "delta_ms": 126987, "speed": 50, "angle": 135, "total_odometer": 1201771, "latitude": 45.45883481060173, "longitude": 9.168410198173937 }, { "_id": 19, "position_type": "moving", "delta_ms": 135914, "speed": 50, "angle": 135, "total_odometer": 1201895, "latitude": 45.458082261918314, "longitude": 9.16959037014049 }, { "_id": 20, "position_type": "moving", "delta_ms": 143896, "speed": 46, "angle": 135, "total_odometer": 1201997, "latitude": 45.457480215740084, "longitude": 9.17057742305797 }, { "_id": 21, "position_type": "moving", "delta_ms": 148936, "speed": 70, "angle": 135, "total_odometer": 1202095, "latitude": 45.45689321452732, "longitude": 9.171521560631213 }, { "_id": 22, "position_type": "moving", "delta_ms": 153770, "speed": 70, "angle": 135, "total_odometer": 1202189, "latitude": 45.45638146489457, "longitude": 9.172487155876574 }, { "_id": 23, "position_type": "moving", "delta_ms": 161596, "speed": 46, "angle": 135, "total_odometer": 1202289, "latitude": 45.455749297171515, "longitude": 9.173409835777697 }, { "_id": 24, "position_type": "moving", "delta_ms": 169410, "speed": 41, "angle": 135, "total_odometer": 1202378, "latitude": 45.455222485322096, "longitude": 9.174268142662463 }, { "_id": 25, "position_type": "moving", "delta_ms": 176319, "speed": 62, "angle": 135, "total_odometer": 1202497, "latitude": 45.4544247322955, "longitude": 9.175298110924182 }, { "_id": 26, "position_type": "moving", "delta_ms": 184605, "speed": 53, "angle": 135, "total_odometer": 1202619, "latitude": 45.45363536603482, "longitude": 9.176389966280428 }, { "_id": 27, "position_type": "moving", "delta_ms": 190547, "speed": 63, "angle": 135, "total_odometer": 1202723, "latitude": 45.452958010219845, "longitude": 9.177312646181552 }, { "_id": 28, "position_type": "moving", "delta_ms": 198467, "speed": 65, "angle": 90, "total_odometer": 1202866, "latitude": 45.45303327237882, "longitude": 9.179141285505317 }, { "_id": 29, "position_type": "moving", "delta_ms": 210227, "speed": 45, "angle": 90, "total_odometer": 1203013, "latitude": 45.45285264302857, "longitude": 9.181008102979682 }, { "_id": 30, "position_type": "moving", "delta_ms": 219172, "speed": 66, "angle": 90, "total_odometer": 1203177, "latitude": 45.452611802994966, "longitude": 9.183089497175239 }, { "_id": 31, "position_type": "moving", "delta_ms": 232286, "speed": 42, "angle": 100, "total_odometer": 1203330, "latitude": 45.45246127745168, "longitude": 9.18504214533808 }, { "_id": 32, "position_type": "moving", "delta_ms": 243229, "speed": 50, "angle": 100, "total_odometer": 1203482, "latitude": 45.452265593644775, "longitude": 9.186973335828803 }, { "_id": 33, "position_type": "moving", "delta_ms": 251343, "speed": 63, "angle": 100, "total_odometer": 1203624, "latitude": 45.452082348984675, "longitude": 9.188785536936539 }, { "_id": 34, "position_type": "moving", "delta_ms": 260925, "speed": 68, "angle": 100, "total_odometer": 1203805, "latitude": 45.451974499548214, "longitude": 9.19110686716218 }, { "_id": 35, "position_type": "moving", "delta_ms": 268506, "speed": 66, "angle": 100, "total_odometer": 1203944, "latitude": 45.45193182202831, "longitude": 9.192897933778239 }, { "_id": 36, "position_type": "moving", "delta_ms": 277855, "speed": 67, "angle": 100, "total_odometer": 1204118, "latitude": 45.45200708555671, "longitude": 9.19512953167863 }, { "_id": 37, "position_type": "moving", "delta_ms": 287087, "speed": 62, "angle": 100, "total_odometer": 1204277, "latitude": 45.45199203285906, "longitude": 9.197168010529948 }, { "_id": 38, "position_type": "moving", "delta_ms": 298262, "speed": 48, "angle": 100, "total_odometer": 1204426, "latitude": 45.452037190939954, "longitude": 9.199077743348552 }, { "_id": 39, "position_type": "moving", "delta_ms": 314140, "speed": 56, "angle": 100, "total_odometer": 1204673, "latitude": 45.45209945271827, "longitude": 9.20224215658068 }, { "_id": 40, "position_type": "stop", "delta_ms": 314260, "speed": 0, "angle": 100, "total_odometer": 1204673, "latitude": 45.45209945271827, "longitude": 9.20224215658068 }, { "_id": 41, "position_type": "stop", "delta_ms": 314380, "speed": 0, "angle": 100, "total_odometer": 1204673, "latitude": 45.45209945271827, "longitude": 9.20224215658068 }, { "_id": 42, "position_type": "stop", "delta_ms": 314500, "speed": 0, "angle": 100, "total_odometer": 1204673, "latitude": 45.45209945271827, "longitude": 9.20224215658068 }, { "_id": 43, "position_type": "stop", "delta_ms": 314620, "speed": 0, "angle": 100, "total_odometer": 1204673, "latitude": 45.45209945271827, "longitude": 9.20224215658068 }, { "_id": 44, "position_type": "moving", "delta_ms": 328266, "speed": 43, "angle": 140, "total_odometer": 1204836, "latitude": 45.45110596768301, "longitude": 9.203787108973257 }, { "_id": 45, "position_type": "moving", "delta_ms": 336086, "speed": 58, "angle": 140, "total_odometer": 1204962, "latitude": 45.45038342211995, "longitude": 9.205031653956167 }, { "_id": 46, "position_type": "moving", "delta_ms": 345366, "speed": 45, "angle": 140, "total_odometer": 1205078, "latitude": 45.44972108055568, "longitude": 9.206190368250601 }, { "_id": 47, "position_type": "moving", "delta_ms": 351451, "speed": 42, "angle": 140, "total_odometer": 1205149, "latitude": 45.44928499782729, "longitude": 9.206868447553868 }, { "_id": 48, "position_type": "moving", "delta_ms": 357119, "speed": 47, "angle": 140, "total_odometer": 1205223, "latitude": 45.448855973664685, "longitude": 9.207598008405919 }, { "_id": 49, "position_type": "moving", "delta_ms": 362996, "speed": 49, "angle": 140, "total_odometer": 1205303, "latitude": 45.44836830301, "longitude": 9.208361760329623 }, { "_id": 50, "position_type": "moving", "delta_ms": 367646, "speed": 48, "angle": 140, "total_odometer": 1205365, "latitude": 45.44799196008478, "longitude": 9.20896257514896 }, { "_id": 51, "position_type": "moving", "delta_ms": 372116, "speed": 62, "angle": 140, "total_odometer": 1205442, "latitude": 45.44756292608715, "longitude": 9.209745780181308 }, { "_id": 52, "position_type": "moving", "delta_ms": 373739, "speed": 51, "angle": 180, "total_odometer": 1205465, "latitude": 45.44735217134924, "longitude": 9.20971359367313 }, { "_id": 53, "position_type": "moving", "delta_ms": 376718, "speed": 58, "angle": 250, "total_odometer": 1205513, "latitude": 45.44709625382316, "longitude": 9.20920933837833 }, { "_id": 54, "position_type": "moving", "delta_ms": 381570, "speed": 46, "angle": 250, "total_odometer": 1205575, "latitude": 45.44706614580258, "longitude": 9.208415404509921 }, { "_id": 55, "position_type": "moving", "delta_ms": 385750, "speed": 62, "angle": 250, "total_odometer": 1205647, "latitude": 45.44703603776591, "longitude": 9.207492724608798 }, { "_id": 56, "position_type": "moving", "delta_ms": 390004, "speed": 66, "angle": 250, "total_odometer": 1205725, "latitude": 45.44698334866312, "longitude": 9.206484214019198 }, { "_id": 57, "position_type": "moving", "delta_ms": 395708, "speed": 65, "angle": 250, "total_odometer": 1205828, "latitude": 45.446893024372386, "longitude": 9.205164567183871 }, { "_id": 58, "position_type": "moving", "delta_ms": 404135, "speed": 44, "angle": 250, "total_odometer": 1205931, "latitude": 45.44687044327712, "longitude": 9.203834191512485 }, { "_id": 59, "position_type": "moving", "delta_ms": 409335, "speed": 63, "angle": 250, "total_odometer": 1206022, "latitude": 45.44681775401963, "longitude": 9.202664748381991 }, { "_id": 60, "position_type": "moving", "delta_ms": 415970, "speed": 51, "angle": 250, "total_odometer": 1206116, "latitude": 45.446757537665114, "longitude": 9.20146311874332 }, { "_id": 61, "position_type": "moving", "delta_ms": 420827, "speed": 63, "angle": 250, "total_odometer": 1206201, "latitude": 45.44671990241089, "longitude": 9.200368777465243 }, { "_id": 62, "position_type": "moving", "delta_ms": 427277, "speed": 48, "angle": 250, "total_odometer": 1206287, "latitude": 45.44665215889, "longitude": 9.199263707351108 }, { "_id": 63, "position_type": "moving", "delta_ms": 433277, "speed": 45, "angle": 250, "total_odometer": 1206362, "latitude": 45.44662823858131, "longitude": 9.198301467977087 }, { "_id": 64, "position_type": "moving", "delta_ms": 441138, "speed": 49, "angle": 250, "total_odometer": 1206469, "latitude": 45.44656802202449, "longitude": 9.196928176961462 }, { "_id": 65, "position_type": "moving", "delta_ms": 446324, "speed": 59, "angle": 250, "total_odometer": 1206554, "latitude": 45.446507805403385, "longitude": 9.195833835683386 }, { "_id": 66, "position_type": "moving", "delta_ms": 452345, "speed": 55, "angle": 250, "total_odometer": 1206646, "latitude": 45.446447588717966, "longitude": 9.194653663716833 }, { "_id": 67, "position_type": "moving", "delta_ms": 457823, "speed": 46, "angle": 250, "total_odometer": 1206716, "latitude": 45.44642500744438, "longitude": 9.19375244148783 }, { "_id": 68, "position_type": "moving", "delta_ms": 463901, "speed": 61, "angle": 250, "total_odometer": 1206819, "latitude": 45.44635889285505, "longitude": 9.192429032776491 }, { "_id": 69, "position_type": "moving", "delta_ms": 471101, "speed": 62, "angle": 250, "total_odometer": 1206943, "latitude": 45.446298676010684, "longitude": 9.190841165039675 }, { "_id": 70, "position_type": "moving", "delta_ms": 478710, "speed": 44, "angle": 250, "total_odometer": 1207036, "latitude": 45.446245986219154, "longitude": 9.189650264237063 }, { "_id": 71, "position_type": "moving", "delta_ms": 484576, "speed": 54, "angle": 250, "total_odometer": 1207124, "latitude": 45.4461255522251, "longitude": 9.188523736450808 }, { "_id": 72, "position_type": "moving", "delta_ms": 493233, "speed": 42, "angle": 220, "total_odometer": 1207225, "latitude": 45.44579435741571, "longitude": 9.187311377976076 }, { "_id": 73, "position_type": "moving", "delta_ms": 499404, "speed": 49, "angle": 220, "total_odometer": 1207309, "latitude": 45.44547821510191, "longitude": 9.186324325058596 }, { "_id": 74, "position_type": "moving", "delta_ms": 505427, "speed": 52, "angle": 220, "total_odometer": 1207396, "latitude": 45.44516207101637, "longitude": 9.185305085632937 }, { "_id": 75, "position_type": "moving", "delta_ms": 510247, "speed": 59, "angle": 220, "total_odometer": 1207475, "latitude": 45.44487603436472, "longitude": 9.184371676895754 }, { "_id": 76, "position_type": "moving", "delta_ms": 513901, "speed": 66, "angle": 220, "total_odometer": 1207542, "latitude": 45.44463516026997, "longitude": 9.183577743027346 }, { "_id": 77, "position_type": "moving", "delta_ms": 523801, "speed": 40, "angle": 220, "total_odometer": 1207652, "latitude": 45.44424373767244, "longitude": 9.182279553864138 }, { "_id": 78, "position_type": "moving", "delta_ms": 529291, "speed": 40, "angle": 220, "total_odometer": 1207713, "latitude": 45.44402544312107, "longitude": 9.181560721848147 }, { "_id": 79, "position_type": "moving", "delta_ms": 535181, "speed": 55, "angle": 220, "total_odometer": 1207803, "latitude": 45.44372434580213, "longitude": 9.18048783824219 }, { "_id": 80, "position_type": "moving", "delta_ms": 546746, "speed": 47, "angle": 220, "total_odometer": 1207954, "latitude": 45.443654707048545, "longitude": 9.178556762842165 }, { "_id": 81, "position_type": "moving", "delta_ms": 559182, "speed": 44, "angle": 280, "total_odometer": 1208106, "latitude": 45.44372998162185, "longitude": 9.176604114679323 }, { "_id": 82, "position_type": "moving", "delta_ms": 567373, "speed": 69, "angle": 280, "total_odometer": 1208263, "latitude": 45.44382031097725, "longitude": 9.174587093500124 }, { "_id": 83, "position_type": "moving", "delta_ms": 575293, "speed": 70, "angle": 280, "total_odometer": 1208417, "latitude": 45.44392569504244, "longitude": 9.172612987665163 }, { "_id": 84, "position_type": "moving", "delta_ms": 586682, "speed": 55, "angle": 280, "total_odometer": 1208591, "latitude": 45.44403107891074, "longitude": 9.170381389764772 }, { "_id": 85, "position_type": "moving", "delta_ms": 596401, "speed": 60, "angle": 280, "total_odometer": 1208753, "latitude": 45.443985914419834, "longitude": 9.168299995569216 }, { "_id": 86, "position_type": "moving", "delta_ms": 605176, "speed": 64, "angle": 280, "total_odometer": 1208909, "latitude": 45.444076243365465, "longitude": 9.166304432062136 }, { "_id": 87, "position_type": "moving", "delta_ms": 617530, "speed": 44, "angle": 280, "total_odometer": 1209060, "latitude": 45.44458810465864, "longitude": 9.164501987604128 }, { "_id": 88, "position_type": "moving", "delta_ms": 628265, "speed": 56, "angle": 300, "total_odometer": 1209227, "latitude": 45.44509506923868, "longitude": 9.16248464287546 }, { "_id": 89, "position_type": "moving", "delta_ms": 642290, "speed": 48, "angle": 300, "total_odometer": 1209414, "latitude": 45.44596822582021, "longitude": 9.160424706352023 }, { "_id": 90, "position_type": "moving", "delta_ms": 652841, "speed": 58, "angle": 300, "total_odometer": 1209584, "latitude": 45.446916639208, "longitude": 9.158708092582492 }, { "_id": 91, "position_type": "moving", "delta_ms": 662284, "speed": 69, "angle": 330, "total_odometer": 1209765, "latitude": 45.44843455963774, "longitude": 9.157862309523782 }, { "_id": 92, "position_type": "moving", "delta_ms": 673704, "speed": 58, "angle": 330, "total_odometer": 1209949, "latitude": 45.44978937178641, "longitude": 9.156510476180276 }, { "_id": 93, "position_type": "moving", "delta_ms": 687075, "speed": 49, "angle": 330, "total_odometer": 1210131, "latitude": 45.451129098465124, "longitude": 9.15515864283677 }, { "_id": 94, "position_type": "moving", "delta_ms": 700769, "speed": 51, "angle": 330, "total_odometer": 1210325, "latitude": 45.45275479147161, "longitude": 9.154257420607767 }, { "_id": 95, "position_type": "moving", "delta_ms": 714554, "speed": 41, "angle": 330, "total_odometer": 1210482, "latitude": 45.454064343426005, "longitude": 9.153484944411478 }, { "_id": 96, "position_type": "moving", "delta_ms": 721937, "speed": 59, "angle": 330, "total_odometer": 1210603, "latitude": 45.4550577763483, "longitude": 9.152841214247903 }, { "_id": 97, "position_type": "stop", "delta_ms": 722057, "speed": 0, "angle": 330, "total_odometer": 1210603, "latitude": 45.4550577763483, "longitude": 9.152841214247903 }, { "_id": 98, "position_type": "stop", "delta_ms": 722177, "speed": 0, "angle": 330, "total_odometer": 1210603, "latitude": 45.4550577763483, "longitude": 9.152841214247903 }, { "_id": 99, "position_type": "stop", "delta_ms": 722297, "speed": 0, "angle": 330, "total_odometer": 1210603, "latitude": 45.4550577763483, "longitude": 9.152841214247903 }, { "_id": 100, "position_type": "stop", "delta_ms": 722417, "speed": 0, "angle": 330, "total_odometer": 1210603, "latitude": 45.4550577763483, "longitude": 9.152841214247903 }, { "_id": 101, "position_type": "stop", "delta_ms": 722537, "speed": 0, "angle": 330, "total_odometer": 1210603, "latitude": 45.4550577763483, "longitude": 9.152841214247903 }, { "_id": 102, "position_type": "moving", "delta_ms": 743961, "speed": 41, "angle": 330, "total_odometer": 1210847, "latitude": 45.45710946520459, "longitude": 9.151709092467021 }, { "_id": 103, "position_type": "moving", "delta_ms": 758643, "speed": 51, "angle": 330, "total_odometer": 1211055, "latitude": 45.45884034202206, "longitude": 9.150700581877421 }, { "_id": 104, "position_type": "moving", "delta_ms": 769659, "speed": 50, "angle": 330, "total_odometer": 1211208, "latitude": 45.46010460107563, "longitude": 9.149928105681132 }, { "_id": 105, "position_type": "stop", "delta_ms": 769779, "speed": 0, "angle": 330, "total_odometer": 1211208, "latitude": 45.46010460107563, "longitude": 9.149928105681132 }, { "_id": 106, "position_type": "stop", "delta_ms": 769899, "speed": 0, "angle": 330, "total_odometer": 1211208, "latitude": 45.46010460107563, "longitude": 9.149928105681132 }, { "_id": 107, "position_type": "moving", "delta_ms": 780821, "speed": 59, "angle": 45, "total_odometer": 1211387, "latitude": 45.46159672011164, "longitude": 9.150809690506993 }, { "_id": 108, "position_type": "moving", "delta_ms": 788952, "speed": 58, "angle": 45, "total_odometer": 1211518, "latitude": 45.462605070205036, "longitude": 9.151689455063877 }, { "_id": 109, "position_type": "moving", "delta_ms": 796315, "speed": 66, "angle": 45, "total_odometer": 1211653, "latitude": 45.46364350145109, "longitude": 9.152590677292881 }, { "_id": 110, "position_type": "moving", "delta_ms": 802125, "speed": 57, "angle": 45, "total_odometer": 1211745, "latitude": 45.464395975909206, "longitude": 9.15310566142374 }, { "_id": 111, "position_type": "moving", "delta_ms": 810577, "speed": 46, "angle": 45, "total_odometer": 1211853, "latitude": 45.46520863704287, "longitude": 9.15387813762003 }, { "_id": 112, "position_type": "moving", "delta_ms": 815891, "speed": 63, "angle": 45, "total_odometer": 1211946, "latitude": 45.46591594367923, "longitude": 9.154521867783604 }, { "_id": 113, "position_type": "moving", "delta_ms": 821918, "speed": 43, "angle": 45, "total_odometer": 1212018, "latitude": 45.466487802131006, "longitude": 9.154972478898106 }, { "_id": 114, "position_type": "stop", "delta_ms": 822038, "speed": 0, "angle": 45, "total_odometer": 1212018, "latitude": 45.466487802131006, "longitude": 9.154972478898106 }, { "_id": 115, "position_type": "stop", "delta_ms": 822158, "speed": 0, "angle": 45, "total_odometer": 1212018, "latitude": 45.466487802131006, "longitude": 9.154972478898106 }, { "_id": 116, "position_type": "stop", "delta_ms": 822278, "speed": 0, "angle": 45, "total_odometer": 1212018, "latitude": 45.466487802131006, "longitude": 9.154972478898106 }, { "_id": 117, "position_type": "stop", "delta_ms": 822398, "speed": 0, "angle": 45, "total_odometer": 1212018, "latitude": 45.466487802131006, "longitude": 9.154972478898106 }, { "_id": 118, "position_type": "stop", "delta_ms": 822518, "speed": 0, "angle": 45, "total_odometer": 1212018, "latitude": 45.466487802131006, "longitude": 9.154972478898106 }, { "_id": 119, "position_type": "stop", "delta_ms": 822638, "speed": 0, "angle": 45, "total_odometer": 1212018, "latitude": 45.466487802131006, "longitude": 9.154972478898106 }]
};

class VirtualPosition {
    constructor(data) {
        if (data) {
            this.setData(data);
        }
    }
    setData(data) {
        this.havePosition = data.havePosition;
        this.tripStatus = data.tripStatus;
        this.haveAnomaly = data.haveAnomaly;
        this.timestamp = data.timestamp;
        this.timestamp_expired = data.timestamp_expired;
        this.longitude = data.longitude;
        this.latitude = data.latitude;
        this.angle = data.angle;
        this.speed = data.speed;
        this.odometer_trip = data.odometer_trip;
        try {
            this.odometer_trip_km = parseInt("" + (this.odometer_trip / 1000));
        }
        catch (err) {
            this.odometer_trip_km = 0;
        }
        this.check_isOnline = data.check_isOnline;
    }
}

class Partecipant {
    constructor(data) {
        if (data) {
            this.setData(data);
        }
    }
    setData(data) {
        var _a;
        this.initials = (_a = data.email) === null || _a === void 0 ? void 0 : _a.charAt(0).toUpperCase();
        this._id = data._id;
        this.isDemo = data.isDemo; // Aggiunto in creazione veicoli demo (non arriva dal server)
        this.type = data.type;
        this.idOrganization = data.idOrganization;
        this.typeUser = data.typeUser;
        this.email = data.email;
        this.isOwner = data.isOwner;
        this.api_enabled = data.api_enabled;
        this.api_token = data.api_token;
        this.isActive = data.isActive;
        this.timestampActivation = data.timestampActivation;
        if (this.timestampActivation)
            this.timestampActivation_ms = this.timestampActivation * 1000;
        this.timestampDeactivation = data.timestampDeactivation;
        if (this.timestampDeactivation)
            this.timestampDeactivation_ms = this.timestampDeactivation * 1000;
        this.isPersonalized = data.isPersonalized;
        this.plan = data.plan;
        this.total_odometer = data.total_odometer;
        this.name = data.label_string;
        this.label_number = data.label_number;
        this.isOnline = data.isOnline;
        this.timestamp_isOnline = data.timestamp_isOnline;
        this.isGPSOnline = data.isGPSOnline;
        this.timestamp_isGPSOnline = data.timestamp_isGPSOnline;
        this.isPowerOn = data.isPowerOn;
        this.timestamp_isPowerOn = data.timestamp_isPowerOn;
        this.battery_voltage = data.battery_voltage;
        this.real_odometer = data.real_odometer;
        this.timestamp_position = data.timestamp_position;
        this.satellites = data.satellites;
        this.havePosition = data.havePosition;
        this.dout1 = data.dout1;
        this.timestamp_dout1 = data.timestamp_dout1;
        if (this.dout1 || this.dout1 === 0) {
            this.dout1_label = Partecipant.engineStates[this.dout1];
            if (!this.dout1_label)
                this.dout1_label = 'unknow';
        }
        else {
            this.dout1_label = "not_set";
        }
        this.list_partecipant = data.list_partecipant;
        if (!this.list_partecipant)
            this.list_partecipant = [];
        this.functionality_alarm = data.functionality_alarm;
        this.functionality_vehicle = data.functionality_veichle;
        this.functionality_billing = data.functionality_billing;
        this.functionality_map = data.functionality_map;
        this.functionality_historical = data.functionality_historical;
        this.functionality_report = data.functionality_report;
        this.functionality_poi = data.functionality_poi;
        this.functionality_activation = data.functionality_activation;
        this.din1 = data.din1;
        this.timestamp_din1 = data.timestamp_din1;
        this.typeTracker = data.type_trackerGps;
        this.imei = data.imei;
        if (data.lastPositionGps) {
            this.lastPositionGps = new PositionGps(data.lastPositionGps);
        }
        if (data.virtualPosition) {
            if (this.virtualPosition) {
                this.virtualPosition.setData(data.virtualPosition);
            }
            else {
                this.virtualPosition = new VirtualPosition(data.virtualPosition);
            }
        }
        this.latitude = data.latitude;
        this.longitude = data.longitude;
        this.speed_alarm_enable = data.speed_alarm_enable;
        this.speed_alarm_value = data.speed_alarm_value;
        this.speed_alarm_hour_start = data.speed_alarm_hour_start;
        this.speed_alarm_minute_start = data.speed_alarm_minute_start;
        this.speed_alarm_hour_stop = data.speed_alarm_hour_stop;
        this.speed_alarm_minute_stop = data.speed_alarm_minute_stop;
        this.speed_alarm_day = data.speed_alarm_day;
        this.speed_alarm_email = data.speed_alarm_email;
        this.speed_alarm_partecipant = data.speed_alarm_partecipant;
        if (!this.speed_alarm_day || this.speed_alarm_day.length < 7) {
            this.speed_alarm_day = [false, false, false, false, false, false, false];
            this.speed_alarm_day_default = true;
        }
        this.offline_alarm_enable = data.offline_alarm_enable;
        this.offline_alarm_value = data.offline_alarm_value;
        this.offline_alarm_hour_start = data.offline_alarm_hour_start;
        this.offline_alarm_minute_start = data.offline_alarm_minute_start;
        this.offline_alarm_hour_stop = data.offline_alarm_hour_stop;
        this.offline_alarm_minute_stop = data.offline_alarm_minute_stop;
        this.offline_alarm_day = data.offline_alarm_day;
        this.offline_alarm_email = data.offline_alarm_email;
        this.offline_alarm_partecipant = data.offline_alarm_partecipant;
        if (!this.offline_alarm_day || this.offline_alarm_day.length < 7) {
            this.offline_alarm_day = [false, false, false, false, false, false, false];
            this.offline_alarm_day_default = true;
        }
        this.movement_alarm_enable = data.movement_alarm_enable;
        this.movement_alarm_hour_start = data.movement_alarm_hour_start;
        this.movement_alarm_minute_start = data.movement_alarm_minute_start;
        this.movement_alarm_hour_stop = data.movement_alarm_hour_stop;
        this.movement_alarm_minute_stop = data.movement_alarm_minute_stop;
        this.movement_alarm_day = data.movement_alarm_day;
        this.movement_alarm_email = data.movement_alarm_email;
        this.movement_alarm_partecipant = data.movement_alarm_partecipant;
        if (!this.movement_alarm_day || this.movement_alarm_day.length < 7) {
            this.movement_alarm_day = [false, false, false, false, false, false, false];
            this.movement_alarm_day_default = true;
        }
        this.unplug_alarm_enable = data.unplug_alarm_enable;
        this.unplug_alarm_hour_start = data.unplug_alarm_hour_start;
        this.unplug_alarm_minute_start = data.unplug_alarm_minute_start;
        this.unplug_alarm_hour_stop = data.unplug_alarm_hour_stop;
        this.unplug_alarm_minute_stop = data.unplug_alarm_minute_stop;
        this.unplug_alarm_day = data.unplug_alarm_day;
        this.unplug_alarm_email = data.unplug_alarm_email;
        this.unplug_alarm_partecipant = data.unplug_alarm_partecipant;
        if (!this.unplug_alarm_day || this.unplug_alarm_day.length < 7) {
            this.unplug_alarm_day = [false, false, false, false, false, false, false];
            this.unplug_alarm_day_default = true;
        }
        this.parking_alarm_enable = data.parking_alarm_enable;
        this.parking_alarm_hour_start = data.parking_alarm_hour_start;
        this.parking_alarm_minute_start = data.parking_alarm_minute_start;
        this.parking_alarm_hour_stop = data.parking_alarm_hour_stop;
        this.parking_alarm_minute_stop = data.parking_alarm_minute_stop;
        this.parking_alarm_day = data.parking_alarm_day;
        this.parking_alarm_email = data.parking_alarm_email;
        this.parking_alarm_partecipant = data.parking_alarm_partecipant;
        if (!this.parking_alarm_day || this.parking_alarm_day.length < 7) {
            this.parking_alarm_day = [false, false, false, false, false, false, false];
            this.parking_alarm_day_default = true;
        }
        this.din1_alarm_enable = data.din1_alarm_enable;
        this.din1_alarm_value = data.din1_alarm_value;
        this.din1_alarm_hour_start = data.din1_alarm_hour_start;
        this.din1_alarm_minute_start = data.din1_alarm_minute_start;
        this.din1_alarm_hour_stop = data.din1_alarm_hour_stop;
        this.din1_alarm_minute_stop = data.din1_alarm_minute_stop;
        this.din1_alarm_day = data.din1_alarm_day;
        this.din1_alarm_email = data.din1_alarm_email;
        this.din1_alarm_partecipant = data.din1_alarm_partecipant;
        if (!this.din1_alarm_day || this.din1_alarm_day.length < 7) {
            this.din1_alarm_day = [false, false, false, false, false, false, false];
            this.din1_alarm_day_default = true;
        }
        // MESSA PER FORZARE CARD DISATTIVA IN ELENCO VEICOLI
        // this.isActive = false;
        // this.timestampDeactivation_ms = Date.now();
    }
    addAlarmPoi(alarm) {
        if (!this.alarmsPoi)
            this.alarmsPoi = [];
        const oldAlarms = this.alarmsPoi.find((elem) => {
            return elem._id === alarm._id;
        });
        if (!oldAlarms) {
            this.alarmsPoi.push(alarm);
        }
    }
    removeAlarmPoi(id) {
        for (let i = 0; i < this.alarmsPoi.length; i++) {
            if (this.alarmsPoi[i]._id === id) {
                this.alarmsPoi.splice(i, 1);
                return;
            }
        }
    }
    isTracker() {
        return this.type === 2;
    }
    isSelectableTracker() {
        return this.type === 2 && this.virtualPosition && this.virtualPosition.havePosition;
    }
    // Dice se il modello di localizzatore ha l'input 1;
    haveDin1() {
        return this.typeTracker === 1;
    }
    // Dice se il modello di localizzatore ha l'output1
    haveDout1() {
        return this.typeTracker === 1;
    }
    // Dice se l'alimentazione è funzionante
    isPowerOk() {
        return this.isDemo || (!this.isDemo && this.isPowerOn);
    }
    // Dice se il gsm funziona correttamente
    isGSMOk() {
        return this.isDemo || (this.virtualPosition && this.virtualPosition.check_isOnline !== 3);
    }
    // Dice se il gps funziona correttamente
    isGPSOk() {
        return this.isDemo || this.isGPSOnline;
    }
    // Verifica i permessi del partecipante
    functionalityIsEnabled(type) {
        if (this.isOwner)
            return true;
        switch (type) {
            case 'owner':
                // return false;
                return this.isOwner;
            case 'alarms':
                // return true;
                return this.functionality_alarm;
            case 'vehicles':
                return this.functionality_vehicle;
            case 'billing':
                // return true;
                return this.functionality_billing;
            case 'history':
                return this.functionality_historical;
            case 'report':
                return this.functionality_report;
            case 'poi':
                // return true;
                return this.functionality_poi;
            case 'activation':
                // return false;
                return this.functionality_activation;
            default:
                return false;
        }
    }
    setLastCommands(res) {
        this.timestamp_last_command_position = 0;
        this.timestamp_last_command_reset = 0;
        this.timestamp_last_command_dout1 = 0;
        if (!res)
            return;
        if (res.list_commandTrackerGps_finished) {
            for (let raw of res.list_commandTrackerGps_finished) {
                if (raw.type === 4 && this.timestamp_last_command_position <= raw.timestamp_lastSend) { //comando posizione
                    this.timestamp_last_command_position = raw.timestamp_lastSend;
                    this.response_last_command_position = Partecipant.commandStates[raw.status_commandTrackerGps];
                    if (!this.response_last_command_position)
                        this.response_last_command_position = "unknow";
                }
                else if (raw.type === 5 && this.timestamp_last_command_reset <= raw.timestamp_lastSend) { //comando reset
                    this.timestamp_last_command_reset = raw.timestamp_lastSend;
                    this.response_last_command_reset = Partecipant.commandStates[raw.status_commandTrackerGps];
                    if (!this.response_last_command_reset)
                        this.response_last_command_reset = "unknow";
                }
                else if (raw.type === 3 && this.timestamp_last_command_dout1 <= raw.timestamp_lastSend) { //comando reset
                    this.timestamp_last_command_dout1 = raw.timestamp_lastSend;
                    this.response_last_command_dout1 = Partecipant.commandStates[raw.status_commandTrackerGps];
                    if (!this.response_last_command_dout1)
                        this.response_last_command_dout1 = "unknow";
                    if (raw.status_output || raw.status_output === 0) {
                        this.response_last_command_dout1_label = Partecipant.engineStates[raw.status_output];
                        if (!this.response_last_command_dout1_label)
                            this.dout1_label = 'unknow';
                    }
                    else {
                        this.response_last_command_dout1_label = "not_set";
                    }
                }
            }
        }
        if (res.list_commandTrackerGps) {
            for (let raw of res.list_commandTrackerGps) {
                if (raw.type === 4 && this.timestamp_last_command_position <= raw.timestamp_lastSend) { //comando posizione
                    this.timestamp_last_command_position = raw.timestamp_lastSend;
                    this.response_last_command_position = Partecipant.commandStates[raw.status_commandTrackerGps];
                    if (!this.response_last_command_position)
                        this.response_last_command_position = "unknow";
                }
                else if (raw.type === 5 && this.timestamp_last_command_reset <= raw.timestamp_lastSend) { //comando reset
                    this.timestamp_last_command_reset = raw.timestamp_lastSend;
                    this.response_last_command_reset = Partecipant.commandStates[raw.status_commandTrackerGps];
                    if (!this.response_last_command_reset)
                        this.response_last_command_reset = "unknow";
                }
                else if (raw.type === 3 && this.timestamp_last_command_dout1 <= raw.timestamp_lastSend) { //comando reset
                    this.timestamp_last_command_dout1 = raw.timestamp_lastSend;
                    this.response_last_command_dout1 = Partecipant.commandStates[raw.status_commandTrackerGps];
                    if (!this.response_last_command_dout1)
                        this.response_last_command_dout1 = "unknow";
                    if (raw.status_output || raw.status_output === 0) {
                        this.response_last_command_dout1_label = Partecipant.engineStates[raw.status_output];
                        if (!this.response_last_command_dout1_label)
                            this.dout1_label = 'unknow';
                    }
                    else {
                        this.response_last_command_dout1_label = "not_set";
                    }
                }
            }
        }
    }
    // Crea una posizione nuova di un veicolo demo
    resetDemoPosition(pos) {
        if (!this.report || !this.report.total_distance || !this.report.time_trip) {
            this.report = {
                total_distance: 6000,
                time_trip: 60 * 1000 * 15 // 15 min
            };
        }
        else {
            this.report.total_distance += Math.random() * (90 - 1) + 1;
            this.report.time_trip += Math.random() * (10000 - 1) + 1;
        }
        if (!this.virtualPosition)
            this.virtualPosition = new VirtualPosition();
        this.virtualPosition.setData({
            havePosition: true,
            tripStatus: pos.position_type === 'moving',
            haveAnomaly: false,
            timestamp: Date.now() - (5 * 60 * 1000),
            timestamp_expired: Date.now() + 1000000000,
            longitude: pos.longitude,
            latitude: pos.latitude,
            angle: pos.angle,
            odometer_trip: 10000,
            speed: pos.speed
        });
        this.virtualPosition.address = undefined;
        this.total_odometer = pos.total_odometer;
    }
    // Dice se abbiamo la posizione oppure no
    hasPosition() {
        return (this.virtualPosition && this.virtualPosition.havePosition);
    }
    // Dive se il particpinat è in movimento o fermo;
    isMoving() {
        return (this.hasPosition() && this.virtualPosition.tripStatus === true);
    }
}
Partecipant.engineStates = {
    0: 'on',
    1: 'off'
};
Partecipant.commandStates = {
    1: "sent",
    2: "in_sent",
    // 3: "sent", // scommentare per far scattare il timeout di comando non andato a buon fine
    // 4: "sent" // scommentare per far scattare il timeout di comando non andato a buon fine
    3: "error",
    4: "success"
};
class HoursMinutes {
    constructor(time) {
        let times = time.split(':');
        this.hours = parseInt(times[0]);
        this.minutes = parseInt(times[1]);
    }
    // Controlla se le date di start e stop si accavallano
    static isValidIntervalTime(start, stop) {
        if (start.hours > stop.hours) {
            return false;
        }
        else if (start.hours === stop.hours) {
            if (start.minutes >= stop.minutes)
                return false;
        }
        return true;
    }
    // Traduce valori interi in stringa HH:mm
    static getStringValue(hours, minutes) {
        let res = '';
        if (!hours || hours < 10)
            res += '0';
        res += (hours || 0) + ':';
        if (!minutes || minutes < 10)
            res += '0';
        res += (minutes || 0);
        return res;
    }
}

class AlarmPoi {
    constructor(data) {
        if (data) {
            this.setData(data);
        }
    }
    setData(data) {
        this._id = data._id;
        this.idPartecipant = data.idPartecipant;
        this.idPoi = data.idPoi;
        this.idOrganization = data.idOrganization;
        this.onEntry = data.onEntry;
        this.onExit = data.onExit;
        this.emails = data.emails;
        this.push = data.push;
        this.timestampLastCheck = data.timestampLastCheck;
        this.isEntry = data.isEntry;
        this.alarmPoi_hour_start = data.alarmPoi_hour_start;
        this.alarmPoi_minute_start = data.alarmPoi_minute_start;
        this.alarmPoi_hour_stop = data.alarmPoi_hour_stop;
        this.alarmPoi_minute_stop = data.alarmPoi_minute_stop;
        this.alarmPoi_day = data.alarmPoi_day;
        if (!this.alarmPoi_day || this.alarmPoi_day.length < 7) {
            this.alarmPoi_day = [false, false, false, false, false, false, false];
            this.alarmPoi_day_default = true;
        }
    }
}

// NON PIU USATA IN BALINAPP MA SOLO IN ADMINAPP
class Platform {
    constructor(data) {
        this.timezones = [
            "Europe/Amsterdam",
            "Europe/Andorra",
            "Europe/Astrakhan",
            "Europe/Athens",
            "Europe/Belfast",
            "Europe/Belgrade",
            "Europe/Berlin",
            "Europe/Bratislava",
            "Europe/Brussels",
            "Europe/Bucharest",
            "Europe/Budapest",
            "Europe/Busingen",
            "Europe/Chisinau",
            "Europe/Copenhagen",
            "Europe/Dublin",
            "Europe/Gibraltar",
            "Europe/Guernsey",
            "Europe/Helsinki",
            "Europe/Isle_of_Man",
            "Europe/Istanbul",
            "Europe/Jersey",
            "Europe/Kaliningrad",
            "Europe/Kiev",
            "Europe/Kirov",
            "Europe/Lisbon",
            "Europe/Ljubljana",
            "Europe/London",
            "Europe/Luxembourg",
            "Europe/Madrid",
            "Europe/Malta",
            "Europe/Mariehamn",
            "Europe/Minsk",
            "Europe/Monaco",
            "Europe/Moscow",
            "Europe/Nicosia",
            "Europe/Oslo",
            "Europe/Paris",
            "Europe/Podgorica",
            "Europe/Prague",
            "Europe/Riga",
            "Europe/Rome",
            "Europe/Samara",
            "Europe/San_Marino",
            "Europe/Sarajevo",
            "Europe/Saratov",
            "Europe/Simferopol",
            "Europe/Skopje",
            "Europe/Sofia",
            "Europe/Stockholm",
            "Europe/Tallinn",
            "Europe/Tirane",
            "Europe/Tiraspol",
            "Europe/Ulyanovsk",
            "Europe/Uzhgorod",
            "Europe/Vaduz",
            "Europe/Vatican",
            "Europe/Vienna",
            "Europe/Vilnius",
            "Europe/Volgograd",
            "Europe/Warsaw",
            "Europe/Zagreb",
            "Europe/Zaporozhye",
            "Europe/Zurich",
        ];
        this.italy_province = [];
        this.nations = [];
        this.languages = [
            { code: "it", language: "Italian" },
            { code: "fr", language: "French" },
            { code: "es", language: "Spanish" }
        ];
        if (data) {
            this.setData(data);
        }
    }
    setData(data) {
        if (data.timezone && data.timezone.length > 0) {
            this.timezones = data.timezone;
        }
        if (data.translate_language && data.translate_language.length > 0) {
            this.languages = data.translate_language;
        }
        if (data.italy_province && data.italy_province.length > 0) {
            this.italy_province = data.italy_province;
        }
        if (data.nation && data.nation.length > 0) {
            this.nations = data.nation;
        }
        this.type = data.type;
        this.type_partecipant = [];
        for (let p of data.type_partecipant) {
            this.type_partecipant.push(new TypeParticipant(p));
        }
    }
    getProvinceIta(provinceCode) {
        return this.italy_province.find((elem) => {
            return elem.sigla === provinceCode;
        });
    }
    getNation(nationCode) {
        return this.nations.find((elem) => {
            return elem.code === nationCode;
        });
    }
    getLanguage(languageCode) {
        return this.languages.find((elem) => {
            return elem.code === languageCode;
        });
    }
    getTypeTracker(type) {
        if (this.type_partecipant) {
            return this.type_partecipant.find((elem) => {
                return elem.type_trackerGps === type;
            });
        }
        return null;
    }
}
class TypeParticipant {
    constructor(data) {
        // manual_url: string = 'https://teltonika-gps.com/downloads/en/fmb920/FMB920_Quick_Manual_v1.3.pdf'; // Forzato a quello di teltonika ma devo farlo aggiungere da dani
        this.manual_url = "https://balin.app/support";
        if (data) {
            this.setData(data);
        }
    }
    setData(data) {
        this.type = data.type;
        this.type_trackerGps = data.type_trackerGps;
        if (data.url_specifications) {
            this.manual_url = data.url_specifications;
        }
    }
}

class GeneralConfig {
    constructor(data, platform_type) {
        this.timezones = [
            "Europe/Amsterdam",
            "Europe/Andorra",
            "Europe/Astrakhan",
            "Europe/Athens",
            "Europe/Belfast",
            "Europe/Belgrade",
            "Europe/Berlin",
            "Europe/Bratislava",
            "Europe/Brussels",
            "Europe/Bucharest",
            "Europe/Budapest",
            "Europe/Busingen",
            "Europe/Chisinau",
            "Europe/Copenhagen",
            "Europe/Dublin",
            "Europe/Gibraltar",
            "Europe/Guernsey",
            "Europe/Helsinki",
            "Europe/Isle_of_Man",
            "Europe/Istanbul",
            "Europe/Jersey",
            "Europe/Kaliningrad",
            "Europe/Kiev",
            "Europe/Kirov",
            "Europe/Lisbon",
            "Europe/Ljubljana",
            "Europe/London",
            "Europe/Luxembourg",
            "Europe/Madrid",
            "Europe/Malta",
            "Europe/Mariehamn",
            "Europe/Minsk",
            "Europe/Monaco",
            "Europe/Moscow",
            "Europe/Nicosia",
            "Europe/Oslo",
            "Europe/Paris",
            "Europe/Podgorica",
            "Europe/Prague",
            "Europe/Riga",
            "Europe/Rome",
            "Europe/Samara",
            "Europe/San_Marino",
            "Europe/Sarajevo",
            "Europe/Saratov",
            "Europe/Simferopol",
            "Europe/Skopje",
            "Europe/Sofia",
            "Europe/Stockholm",
            "Europe/Tallinn",
            "Europe/Tirane",
            "Europe/Tiraspol",
            "Europe/Ulyanovsk",
            "Europe/Uzhgorod",
            "Europe/Vaduz",
            "Europe/Vatican",
            "Europe/Vienna",
            "Europe/Vilnius",
            "Europe/Volgograd",
            "Europe/Warsaw",
            "Europe/Zagreb",
            "Europe/Zaporozhye",
            "Europe/Zurich",
        ];
        this.italy_province = [];
        this.nations = [];
        // Il server me li passa in platform ma io li metto direttamente qua visto che non ho più tipi di platform
        this.languages = [
            // {code: "de", language: "Deutsch"},
            { code: "en", language: "English" },
            // {code: "es", language: "Español"},
            // {code: "fr", language: "Français"},
            { code: "it", language: "Italiano" },
        ];
        this.time_hint_native_app = 2000;
        if (data) {
            this.setData(data, platform_type);
        }
    }
    setData(data, platform_type) {
        if (!platform_type)
            platform_type = 1; // default 1 = balinApp
        if (data.timezone && data.timezone.length > 0) {
            this.timezones = data.timezone;
        }
        if (data.italy_province && data.italy_province.length > 0) {
            this.italy_province = data.italy_province;
        }
        if (data.nation && data.nation.length > 0) {
            this.nations = data.nation;
        }
        if (data.array_platform && data.array_platform.length > 0) {
            const raw_platform = data.array_platform.find((elem) => elem.type === platform_type); // type = 1 = balinApp
            if (raw_platform) {
                if (raw_platform.translate_language && raw_platform.translate_language.length > 0) {
                    this.languages = raw_platform.translate_language;
                }
                this.type = raw_platform.type;
                this.type_partecipant = [];
                for (let p of raw_platform.type_partecipant) {
                    this.type_partecipant.push(new TypeParticipant(p));
                }
                this.url_activation = raw_platform.url_activation;
                this.url_buy = raw_platform.url_buy;
                this.url_youtube = raw_platform.url_youtube;
                this.url_support = raw_platform.url_support;
                this.sito = raw_platform.sito;
                this.time_hint_native_app = raw_platform.time_hint_native_app || 2000;
                this.stripe_public_key = raw_platform.stripe_public_key;
                this.ios_review_version = raw_platform.ios_review_version;
                this.ios_min_version = raw_platform.ios_min_version;
                this.android_min_version = raw_platform.android_min_version;
            }
            else {
                console.error(`Piattaforma con type ${platform_type} non trovata in general_config`);
            }
        }
        this.type_trackerGps = data.type_trackerGps;
        this.list_dial_code_phone = data.list_dial_code_phone;
    }
    // * accessor
    get type_trackerGps() {
        return this._type_trackerGps;
    }
    set type_trackerGps(value) {
        const ret = {};
        value === null || value === void 0 ? void 0 : value.forEach(el => {
            ret[`_${el.type_trackerGps}`] = el;
        });
        this._type_trackerGps = ret;
    }
    // * method
    getProvinceIta(provinceCode) {
        return this.italy_province.find((elem) => {
            return elem.sigla === provinceCode;
        });
    }
    getNation(nationCode) {
        return this.nations.find((elem) => {
            return elem.code === nationCode;
        });
    }
    getLanguage(languageCode) {
        return this.languages.find((elem) => {
            return elem.code === languageCode;
        });
    }
    getTypeTracker(type) {
        if (this.type_partecipant) {
            return this.type_partecipant.find((elem) => {
                return elem.type_trackerGps === type;
            });
        }
        return null;
    }
}

class DataService {
    constructor() {
        this.showTabs = true;
        this.showDemoBadge = true;
        this.organizations = [];
        this.selOrganization = new Organization();
        this.pois = [];
        this.intervalsDemo = [];
    }
    initialize(api, firebase) {
        return __awaiter(this, void 0, void 0, function* () {
            DataService.api = api;
            DataService.firebase = firebase;
            let dataLogin = yield DataService.api.getLogin();
            console.error(dataLogin);
            if (dataLogin.list_organization) {
                this.organizations = [];
                for (let org of dataLogin.list_organization) {
                    this.organizations.push(new Organization(org));
                }
                if (dataLogin.list_partecipant && this.organizations.length > 0) {
                    this.selOrganization = this.organizations[0];
                    this.triggerNotificationsDatabase(this.selOrganization._id);
                    for (let part of dataLogin.list_partecipant) {
                        const org = this.organizations.find(el => el._id === part.idOrganization);
                        let participant = new Partecipant(part);
                        if (participant.email === AuthService.getEmail()) {
                            org.me = participant;
                        }
                        if (participant.isOwner) {
                            org.owner = participant;
                        }
                        org.addParticipant(participant);
                    }
                }
            }
            this.initializeDemo();
            if (this.selOrganization.me.functionalityIsEnabled('poi')) {
                yield this.retrievePoi(api, 0).then(() => __awaiter(this, void 0, void 0, function* () {
                    yield this.retrieveAlarmsPoi(api, 0);
                    DataService.initialized = true;
                    DataService.onInit.next(true);
                })).catch((err) => {
                    console.error(err);
                });
            }
            else {
                DataService.initialized = true;
                DataService.onInit.next(true);
            }
            this.retrieveNotificationCount();
        });
    }
    clearData() {
        return __awaiter(this, void 0, void 0, function* () {
            this.pois = [];
            this.selOrganization = undefined;
            this.organizations = [];
            this.resetDemo();
            if (this.notificationReference)
                this.notificationReference.off();
        });
    }
    // Inizializza 3 veicoli demo
    initializeDemo() {
        if (this.selOrganization.login_view_demo) {
            const intervalDelta = 3000;
            let positionCounter1 = 0;
            let positionCounter2 = 0;
            let positionCounter3 = 0;
            this.selOrganization.participants = [];
            let firstPos = DEMO_ROUTES_LIVE['-1'][0];
            this.selOrganization.participants.push(new Partecipant({
                _id: '-1',
                isDemo: true,
                type: 2,
                idOrganization: this.selOrganization._id,
                type_trackerGps: 1,
                imei: '00000001',
                isActive: true,
                timestampActivation: 1605017515,
                label_number: 1,
                label_string: 'Veicolo demo 1',
                total_odometer: 1000
            }));
            this.selOrganization.participants[0].resetDemoPosition(firstPos);
            this.intervalsDemo.push(setInterval(() => {
                setTimeout(() => {
                    let pos = DEMO_ROUTES_LIVE['-1'][positionCounter1];
                    if (!this.selOrganization.participants[0] || !this.selOrganization.participants[0].isDemo)
                        return;
                    this.selOrganization.participants[0].resetDemoPosition(pos);
                    DataService.updateData.next({ target: 'participant', type: 'update', participant: this.selOrganization.participants[0] });
                    ViewService.updateView.next();
                }, Math.floor(Math.random() * (1000 - 1 + 1) + 1));
                positionCounter1++;
                if (positionCounter1 >= DEMO_ROUTES_LIVE['-1'].length)
                    positionCounter1 = 0;
            }, intervalDelta));
            firstPos = DEMO_ROUTES_LIVE['-2'][0];
            this.selOrganization.participants.push(new Partecipant({
                _id: '-2',
                isDemo: true,
                type: 2,
                idOrganization: this.selOrganization._id,
                type_trackerGps: 1,
                imei: '00000002',
                isActive: true,
                timestampActivation: 1605017515,
                label_number: 2,
                label_string: 'Veicolo demo 2',
                total_odometer: 1000
            }));
            this.selOrganization.participants[1].resetDemoPosition(firstPos);
            this.intervalsDemo.push(setInterval(() => {
                setTimeout(() => {
                    let pos = DEMO_ROUTES_LIVE['-2'][positionCounter2];
                    if (!this.selOrganization.participants[1] || !this.selOrganization.participants[1].isDemo)
                        return;
                    this.selOrganization.participants[1].resetDemoPosition(pos);
                    DataService.updateData.next({ target: 'participant', type: 'update', participant: this.selOrganization.participants[1] });
                    ViewService.updateView.next();
                }, Math.floor(Math.random() * (1000 - 1 + 1) + 1));
                positionCounter2++;
                if (positionCounter2 >= DEMO_ROUTES_LIVE['-2'].length)
                    positionCounter2 = 0;
            }, intervalDelta));
            firstPos = DEMO_ROUTES_LIVE['-3'][0];
            this.selOrganization.participants.push(new Partecipant({
                _id: '-3',
                isDemo: true,
                type: 2,
                idOrganization: this.selOrganization._id,
                type_trackerGps: 1,
                imei: '00000003',
                isActive: true,
                timestampActivation: 1605017515,
                label_number: 3,
                label_string: 'Veicolo demo 3',
                total_odometer: 1000
            }));
            this.selOrganization.participants[2].resetDemoPosition(firstPos);
            this.intervalsDemo.push(setInterval(() => {
                setTimeout(() => {
                    let pos = DEMO_ROUTES_LIVE['-3'][positionCounter3];
                    if (!this.selOrganization.participants[2] || !this.selOrganization.participants[2].isDemo)
                        return;
                    this.selOrganization.participants[2].resetDemoPosition(pos);
                    DataService.updateData.next({ target: 'participant', type: 'update', participant: this.selOrganization.participants[2] });
                    ViewService.updateView.next();
                }, Math.floor(Math.random() * (1000 - 1 + 1) + 1));
                positionCounter3++;
                if (positionCounter3 >= DEMO_ROUTES_LIVE['-3'].length)
                    positionCounter3 = 0;
            }, intervalDelta));
            this.isDemo = true;
        }
    }
    // Resetta tutte le impostazioni demo
    resetDemo() {
        console.error('resetDemo');
        for (let interval of this.intervalsDemo) {
            clearInterval(interval);
        }
        this.isDemo = false;
        this.intervalsDemo = [];
        if (this.selOrganization && this.selOrganization.participants) {
            for (let i = 0; i < this.selOrganization.participants.length; i++) {
                if (this.selOrganization.participants[i].isDemo) {
                    DataService.updateData.next({ target: 'participant', type: 'delete', participant: this.selOrganization.participants[i] });
                    this.selOrganization.participants.splice(i, 1);
                    i--;
                }
            }
        }
        return false;
    }
    getMeId() {
        if (this.selOrganization && this.selOrganization.me)
            return this.selOrganization.me._id;
    }
    // recupera i poi
    retrievePoi(api, skip) {
        return new Promise((resolve, reject) => {
            if (skip === 0)
                this.pois = [];
            api.getPois(this.selOrganization.me._id, skip, DataService.limit).then((res) => __awaiter(this, void 0, void 0, function* () {
                if (res.data) {
                    for (let raw of res.data) {
                        this.pois.push(new Poi(raw));
                    }
                }
                if (!res.has_more) {
                    ViewService.updateView.next();
                    return resolve();
                }
                else {
                    return resolve(this.retrievePoi(api, skip + res.data.length));
                }
            })).catch((err) => {
                return reject(err);
            });
        });
    }
    // recupera gli allarmi e gli associa ai poi
    retrieveAlarmsPoi(api, skip) {
        return new Promise((resolve, reject) => {
            api.getAlarmsPoi(this.selOrganization.me._id, skip, DataService.limit).then((res) => __awaiter(this, void 0, void 0, function* () {
                if (res.data) {
                    for (let raw of res.data) {
                        const alarm = new AlarmPoi(raw);
                        alarm.poi = this.pois.find((elem) => {
                            return elem._id === alarm.idPoi;
                        });
                        const participant = this.selOrganization.participants.find((elem) => {
                            return elem._id === alarm.idPartecipant;
                        });
                        if (participant) {
                            participant.addAlarmPoi(alarm);
                        }
                    }
                }
                if (!res.has_more) {
                    ViewService.updateView.next();
                    return resolve();
                }
                else {
                    return resolve(this.retrievePoi(api, skip + res.data.length));
                }
            })).catch((err) => {
                return reject(err);
            });
        });
    }
    retrieveNotificationCount() {
        DataService.api.getNotificationsCount(this.selOrganization.me._id).then((res) => {
            if (res) {
                this.notificationsCount = res.data;
                ViewService.updateView.next();
            }
        }).catch((err) => {
            console.error(err);
        });
    }
    static isInitialized() {
        return new Promise((resolve) => {
            if (DataService.initialized)
                return resolve();
            let listener = DataService.onInit$.subscribe(() => {
                listener.unsubscribe();
                return resolve();
            });
        });
    }
    triggerNotificationsDatabase(organizationId) {
        if (this.notificationReference)
            this.notificationReference.off();
        this.notificationReference = DataService.firebase.database().ref('/organization/' + organizationId);
        let first = true;
        this.notificationReference.on('value', (snapshot) => {
            if (!first) {
                this.parseNotification(snapshot.val());
            }
            else {
                first = false;
            }
        });
    }
    /**
     * Parsifica l'oggetto di notifica ricevuto sul database delle notifiche
     * @param notification
     */
    parseNotification(notification) {
        if (!notification)
            return;
        switch (notification.element) {
            case 'organization':
                this.manageOrganizationNotification(notification);
                break;
            case 'partecipant':
                this.manageParticipantNotification(notification);
                break;
            case 'poi':
                this.managePoiNotification(notification);
                break;
            case 'list_commandTrackerGps_finished':
                DataService.updateData.next({ target: 'commandTrackerGps', type: notification.type, id: notification._id });
                break;
            case 'notification':
                this.retrieveNotificationCount();
                DataService.updateData.next({ target: 'notification', type: notification.type, id: notification._id });
                break;
        }
    }
    // Gestisce update di una organizzazione
    manageOrganizationNotification(notification) {
        return __awaiter(this, void 0, void 0, function* () {
            switch (notification.type) {
                case 'update':
                    console.log('UPDATE/CREATE organization');
                    if (this.selOrganization._id === notification._id) {
                        yield DataService.api.getOrganization(this.selOrganization.me._id, notification._id).then((res) => {
                            this.selOrganization.setData(res);
                            if (!this.selOrganization.login_view_demo)
                                this.isDemo = this.resetDemo();
                            DataService.updateData.next({ target: 'organization', type: notification.type });
                            ViewService.updateView.next();
                        }).catch((err) => {
                            console.error(err);
                        });
                    }
                    break;
            }
        });
    }
    // Gestisce update, cancellazione e inserimento di un partecipante
    manageParticipantNotification(notification) {
        return __awaiter(this, void 0, void 0, function* () {
            let participant;
            switch (notification.type) {
                case 'insert':
                case 'create':
                    participant = this.selOrganization.participants.find((elem) => {
                        return elem._id === notification._id;
                    });
                    yield DataService.api.getParticipant(this.selOrganization.me._id, notification._id).then((res) => {
                        if (participant) {
                            participant.setData(res);
                            DataService.updateData.next({ target: 'participant', type: 'update', participant: participant });
                        }
                        else {
                            participant = new Partecipant(res);
                            this.selOrganization.addParticipant(participant);
                            DataService.updateData.next({ target: 'participant', type: 'create', participant: participant });
                        }
                        ViewService.updateView.next();
                    }).catch((err) => {
                        console.error(err);
                    });
                    break;
                case 'update':
                    participant = this.selOrganization.participants.find((elem) => {
                        return elem._id === notification._id;
                    });
                    yield DataService.api.getParticipant(this.selOrganization.me._id, notification._id).then((res) => {
                        if (participant) {
                            participant.setData(res);
                            DataService.updateData.next({ target: 'participant', type: 'update', participant: participant });
                            ViewService.updateView.next();
                        }
                    }).catch((err) => {
                        console.error(err);
                    });
                    break;
                case 'delete':
                    this.selOrganization.removeParticipant(notification._id);
                    DataService.updateData.next({ target: 'participant', type: notification.type, id: notification._id });
                    ViewService.updateView.next();
                    break;
            }
        });
    }
    // Gestisce update, cancellazione e inserimento di un poi
    managePoiNotification(notification) {
        switch (notification.type) {
            case 'create':
            case 'update':
                console.log('UPDATE/CREATE poi');
                let poi = this.pois.find((elem) => {
                    return elem._id === notification._id;
                });
                DataService.api.getPoi(this.selOrganization.me._id, notification._id).then((res) => {
                    if (poi) {
                        poi.setData(res);
                    }
                    else {
                        poi = new Poi(res);
                        this.pois.push(poi);
                    }
                    DataService.updateData.next({ target: 'poi', poi: poi });
                    ViewService.updateView.next();
                }).catch((err) => {
                    console.error(err);
                });
                break;
            case 'delete':
                for (let i = 0; i < this.pois.length; i++) {
                    if (this.pois[i]._id === notification._id) {
                        this.pois.splice(i, 1);
                        break;
                    }
                }
                DataService.updateData.next({ target: 'poi', type: notification.type, id: notification._id });
                ViewService.updateView.next();
                break;
        }
    }
    // Ritorna un report per un veicolo demo
    getDemoReport(participant, start, stop) {
        if (!participant.isDemo)
            return [];
        let res = {
            data: [],
            report: {
                time_total: 60 * 60 * 1000,
                time_trip: 30 * 60 * 1000,
                total_distance: 10000,
                time_stop: 30 * 60 * 1000
            }
        };
        let totalPositions = DEMO_ROUTES['-1'];
        if (DEMO_ROUTES[participant._id]) {
            totalPositions = DEMO_ROUTES[participant._id];
        }
        for (let pos of totalPositions) {
            let raw = {
                _id: pos._id.toString(),
                idOrganization: participant.idOrganization,
                type: 2,
                position: {
                    type: 'Point',
                    coordinates: [pos.longitude, pos.latitude]
                },
                imei: participant.imei,
                timestamp_server: pos.delta_ms + start,
                timestamp_position: pos.delta_ms + start,
                position_type: 5,
                altitude: 0,
                angle: pos.angle || 0,
                satellites: 3,
                speed: pos.speed,
                total_odometer: pos.total_odometer,
                avl_id: 250,
                value: pos.position_type === 'moving' ? 1 : 0
            };
            if ((res.data.length === 0 || res.data[res.data.length - 1].value !== raw.value)
                && (pos.delta_ms + start) <= stop) {
                res.data.push(raw);
            }
        }
        if (res.data.length > 0) {
            res.data.push({
                _id: 'end',
                idOrganization: participant.idOrganization,
                type: 2,
                position: {
                    type: 'Point',
                    coordinates: [res.data[res.data.length - 1].longitude, res.data[res.data.length - 1].latitude]
                },
                imei: participant.imei,
                timestamp_server: stop,
                timestamp_position: stop,
                position_type: 5,
                altitude: 0,
                angle: res.data[res.data.length - 1].angle || 0,
                satellites: 3,
                speed: res.data[res.data.length - 1].speed,
                total_odometer: res.data[res.data.length - 1].total_odometer,
                avl_id: 250,
                value: res.data[res.data.length - 1].value === 1 ? 0 : 1
            });
        }
        return res;
    }
    // Ritorna un report per un veicolo demo
    getDemoHistory(participant, start, stop) {
        if (!participant.isDemo)
            return [];
        let totalPositions = DEMO_ROUTES['-1'];
        if (DEMO_ROUTES[participant._id]) {
            totalPositions = DEMO_ROUTES[participant._id];
        }
        let res = { data: [], has_more: false };
        for (let pos of totalPositions) {
            let raw = {
                _id: pos._id.toString(),
                idOrganization: participant.idOrganization,
                type: 2,
                position: {
                    type: 'Point',
                    coordinates: [pos.longitude, pos.latitude]
                },
                imei: participant.imei,
                timestamp_server: pos.delta_ms + start,
                timestamp_position: pos.delta_ms + start,
                position_type: 4,
                altitude: 0,
                angle: pos.angle || 0,
                satellites: 3,
                speed: pos.speed,
                total_odometer: pos.total_odometer
            };
            res.data.push(raw);
        }
        return res;
    }
    // Salva un allarme su un veicolo demo
    saveDemoAlarm(type, target, values) {
        switch (type) {
            case 'speed':
                target.speed_alarm_enable = values.speed_alarm_enable;
                target.speed_alarm_value = values.speed_alarm_value;
                target.speed_alarm_hour_start = values.speed_alarm_hour_start;
                target.speed_alarm_minute_start = values.speed_alarm_minute_start;
                target.speed_alarm_hour_stop = values.speed_alarm_hour_stop;
                target.speed_alarm_minute_stop = values.speed_alarm_minute_stop;
                target.speed_alarm_day = values.speed_alarm_day;
                target.speed_alarm_email = values.speed_alarm_email;
                target.speed_alarm_partecipant = values.speed_alarm_partecipant;
                break;
            case 'offline':
                target.offline_alarm_enable = values.offline_alarm_enable;
                target.offline_alarm_value = values.offline_alarm_value;
                target.offline_alarm_hour_start = values.offline_alarm_hour_start;
                target.offline_alarm_minute_start = values.offline_alarm_minute_start;
                target.offline_alarm_hour_stop = values.offline_alarm_hour_stop;
                target.offline_alarm_minute_stop = values.offline_alarm_minute_stop;
                target.offline_alarm_day = values.offline_alarm_day;
                target.offline_alarm_email = values.offline_alarm_email;
                target.offline_alarm_partecipant = values.offline_alarm_partecipant;
                break;
            case 'movement':
                target.movement_alarm_enable = values.movement_alarm_enable;
                target.movement_alarm_hour_start = values.movement_alarm_hour_start;
                target.movement_alarm_minute_start = values.movement_alarm_minute_start;
                target.movement_alarm_hour_stop = values.movement_alarm_hour_stop;
                target.movement_alarm_minute_stop = values.movement_alarm_minute_stop;
                target.movement_alarm_day = values.movement_alarm_day;
                target.movement_alarm_email = values.movement_alarm_email;
                target.movement_alarm_partecipant = values.movement_alarm_partecipant;
                break;
            case 'unplug':
                target.unplug_alarm_enable = values.unplug_alarm_enable;
                target.unplug_alarm_hour_start = values.unplug_alarm_hour_start;
                target.unplug_alarm_minute_start = values.unplug_alarm_minute_start;
                target.unplug_alarm_hour_stop = values.unplug_alarm_hour_stop;
                target.unplug_alarm_minute_stop = values.unplug_alarm_minute_stop;
                target.unplug_alarm_day = values.unplug_alarm_day;
                target.unplug_alarm_email = values.unplug_alarm_email;
                target.unplug_alarm_partecipant = values.unplug_alarm_partecipant;
                break;
            case 'parking':
                target.parking_alarm_enable = values.parking_alarm_enable;
                target.parking_alarm_hour_start = values.parking_alarm_hour_start;
                target.parking_alarm_minute_start = values.parking_alarm_minute_start;
                target.parking_alarm_hour_stop = values.parking_alarm_hour_stop;
                target.parking_alarm_minute_stop = values.parking_alarm_minute_stop;
                target.parking_alarm_day = values.parking_alarm_day;
                target.parking_alarm_email = values.parking_alarm_email;
                target.parking_alarm_partecipant = values.parking_alarm_partecipant;
                break;
            case 'input1':
                target.din1_alarm_enable = values.din1_alarm_enable;
                target.din1_alarm_value = values.din1_alarm_value;
                target.din1_alarm_hour_start = values.din1_alarm_hour_start;
                target.din1_alarm_minute_start = values.din1_alarm_minute_start;
                target.din1_alarm_hour_stop = values.din1_alarm_hour_stop;
                target.din1_alarm_minute_stop = values.din1_alarm_minute_stop;
                target.din1_alarm_day = values.din1_alarm_day;
                target.din1_alarm_email = values.din1_alarm_email;
                target.din1_alarm_partecipant = values.din1_alarm_partecipant;
                break;
        }
    }
    // Salva i dati di un veicolo demo in maniera fittizia
    saveDemoFields(target, name, label_number, odometer) {
        target.name = name;
        target.label_number = label_number;
        target.real_odometer = odometer;
        DataService.updateData.next({ target: 'participant', type: 'update', participant: target });
    }
    getPoi(id) {
        return this.pois.find((elem) => {
            return elem._id === id;
        });
    }
    static clearActivationParams() {
        DataService.activationImei = undefined;
        DataService.activationSerial = undefined;
        DataService.activationModel = undefined;
    }
    // Ritorna l'url di apertura dell'app (esempio ritorno portale esternbo stripe)
    getAppUrl() {
        switch (DataService.nativeApp) {
            case 'ios':
            case 'android':
                return 'https://balin.app/open-app.html';
            default:
                return window.location.origin;
        }
    }
}
DataService.initialized = false;
DataService.onInit = new Subject();
DataService.onInit$ = DataService.onInit.asObservable();
DataService.limit = 5000;
DataService.platform = new Platform();
DataService.updateData = new Subject();
DataService.updateData$ = DataService.updateData.asObservable();
DataService.generalConfig = new GeneralConfig();
DataService.ɵfac = function DataService_Factory(t) { return new (t || DataService)(); };
DataService.ɵprov = i0.ɵɵdefineInjectable({ token: DataService, factory: DataService.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(DataService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

class GoogleMapsService {
    constructor() {
        this.listeners = {};
        this.circles = {};
        this.markers = {};
        this.controls = {};
        this.polylines = {};
        this.popups = {};
        this.mainMapChangeEnabled = true;
        this.onMapClosed = new Subject();
        this.onMapClosed$ = this.onMapClosed.asObservable();
        // this.tdweb.onUserLocationUpdate$.subscribe((user: User) => {
        //   if(user && user.location && user.location.content && user.location.content.live_period){
        //     this.insertMarker(user);
        //   }
        // });
        // this.tdweb.onUpdateUser$.subscribe((user: User) => {
        //   if(this.markers[user.id]){
        //     let markerUrl: string = user.markerLive;
        //     if(((user.location.date + user.location.content.live_period) * 1000) < (new Date()).getTime()){
        //       markerUrl = user.markerNoLive;
        //     }
        //     this.markers[user.id].setIcon({
        //       url: markerUrl || 'assets/imgs/marker-red.png',
        //       size: new google.maps.Size(46, 55),
        //       scaledSize: new google.maps.Size(46, 55),
        //       origin: new google.maps.Point(0, 0),
        //       anchor: new google.maps.Point(18, 55)
        //     });
        //   }
        // });
    }
    initialization(google, overlappingMarkerSpiderfier) {
        GoogleMapsService.google = google;
        GoogleMapsService.overlappingMarkerSpiderfier = overlappingMarkerSpiderfier;
        GoogleMapsService.googleReady.next();
    }
    isReady() {
        return new Promise((resolve) => {
            if (GoogleMapsService.google)
                return resolve();
            let sub = GoogleMapsService.googleReady$.subscribe(() => __awaiter(this, void 0, void 0, function* () {
                sub.unsubscribe();
                return resolve();
            }));
        });
    }
    getMap() {
        if (!this.map) {
            this.divMap = document.createElement("div");
            this.divMap.style.width = "100%";
            this.divMap.style.height = "100%";
            this.map = new GoogleMapsService.google.maps.Map(this.divMap, {
                center: { lat: 41.8897, lng: 12.4935 },
                zoom: 7,
                fullscreenControl: false,
                zoomControlOptions: {
                    position: GoogleMapsService.google.maps.ControlPosition.LEFT_BOTTOM
                },
                streetViewControl: false,
                streetViewControlOptions: {
                    position: GoogleMapsService.google.maps.ControlPosition.LEFT_BOTTOM
                },
                mapTypeControl: false,
            });
        }
        if (!this.oms) {
            this.oms = new GoogleMapsService.overlappingMarkerSpiderfier(this.map, {
                markersWontMove: true,
                markersWontHide: true,
                basicFormatEvents: true
            });
        }
        return this.map;
    }
    getDivMap() {
        return this.divMap;
    }
    setCurrentMap(currentMap) {
        this.currentMap = currentMap;
    }
    addPolyline(polyline, map) {
        let polylineId = polyline.get("id");
        if (!polylineId)
            return console.error("No polylineId _id, polyline not added in map");
        if (!this.polylines.hasOwnProperty(map)) {
            this.polylines[map] = {};
        }
        if (this.polylines[map][polylineId])
            this.polylines[map][polylineId].setMap(null);
        this.polylines[map][polylineId] = polyline;
        polyline.setMap(this.map);
    }
    removePolyline(polyline, map) {
        let polylineId = polyline.get("id");
        if (!polylineId)
            return console.error("No polyline _id, polyline not removed in map");
        if (!this.polylines.hasOwnProperty(map)) {
            this.polylines[map] = {};
        }
        if (this.polylines[map].hasOwnProperty(polylineId)) {
            delete this.polylines[map][polylineId];
        }
        polyline.setMap(null);
    }
    addPopup(popup, map) {
        let popupId = popup.id;
        if (!popupId)
            return console.error("No popup id, popup not added in map");
        if (!this.popups.hasOwnProperty(map)) {
            this.popups[map] = {};
        }
        if (this.popups[map][popupId])
            this.popups[map][popupId].setMap(null);
        this.popups[map][popupId] = popup;
        popup.setMap(this.map);
    }
    removePopup(popup, map) {
        let popupId = popup.id;
        if (!popupId)
            return console.error("No popup id, popup not remove in map");
        if (!this.popups.hasOwnProperty(map)) {
            this.popups[map] = {};
        }
        if (this.popups[map].hasOwnProperty(popupId)) {
            delete this.popups[map][popupId];
        }
        popup.setMap(null);
    }
    addCircle(circle, map) {
        let circleId = circle.get("id");
        if (!circleId)
            return console.error("No circle _id, circle not added in map");
        if (!this.circles.hasOwnProperty(map)) {
            this.circles[map] = {};
        }
        if (this.circles[map][circleId])
            this.circles[map][circleId].setMap(null);
        this.circles[map][circleId] = circle;
        if (this.getMainMapUpdateState() || map !== "main") {
            circle.setMap(this.map);
        }
    }
    removeCircle(circle, map) {
        let circleId = circle.get("id");
        if (!circleId)
            return console.error("No circle _id, circle not removed in map");
        if (!this.circles.hasOwnProperty(map)) {
            this.circles[map] = {};
        }
        if (this.circles[map].hasOwnProperty(circleId)) {
            delete this.circles[map][circleId];
        }
        circle.setMap(null);
    }
    addMarker(marker, map, spiderClick) {
        let markerId = marker.id;
        if (!markerId)
            return console.error("No marker _id, marker not added in map", markerId);
        if (!this.markers.hasOwnProperty(map)) {
            this.markers[map] = {};
        }
        if (this.markers[map][markerId])
            this.markers[map][markerId].setMap(null);
        this.markers[map][markerId] = marker;
        if (this.getMainMapUpdateState() || map !== "main") {
            if (spiderClick) {
                this.oms.addMarker(marker);
            }
            else {
                marker.setMap(this.map);
            }
        }
    }
    getMainMapUpdateState() {
        return this.mainMapChangeEnabled;
    }
    emitCloseMap() {
        this.onMapClosed.next();
    }
    addListener(listenerRef, map) {
        if (!this.listeners.hasOwnProperty(map)) {
            this.listeners[map] = [];
        }
        this.listeners[map].push(listenerRef);
    }
    removeListeners(map) {
        if (!map) {
            for (let key in this.listeners) {
                if (Array.isArray(this.listeners[key])) {
                    for (let listener of this.listeners[key]) {
                        GoogleMapsService.google.maps.event.removeListener(listener);
                    }
                    this.listeners[key] = [];
                }
            }
        }
        else {
            if (this.listeners[map] && Array.isArray(this.listeners[map])) {
                for (let listener of this.listeners[map]) {
                    GoogleMapsService.google.maps.event.removeListener(listener);
                }
                this.listeners[map] = [];
            }
        }
    }
    removeCircles(map) {
        if (!map) {
            for (let key in this.circles) {
                if (this.circles[key]) {
                    for (let circleId in this.circles[key]) {
                        this.circles[key][circleId].setMap(null);
                    }
                }
            }
        }
        else {
            if (this.circles[map]) {
                for (let circleId in this.circles[map]) {
                    this.circles[map][circleId].setMap(null);
                }
            }
        }
    }
    removeMarkers(map) {
        if (!map) {
            for (let key in this.markers) {
                if (this.markers[key]) {
                    for (let markerId in this.markers[key]) {
                        this.markers[key][markerId].setMap(null);
                    }
                }
            }
        }
        else {
            if (this.markers[map]) {
                for (let markerId in this.markers[map]) {
                    this.markers[map][markerId].setMap(null);
                }
            }
        }
    }
    removePolylines(map) {
        if (!map) {
            for (let key in this.polylines) {
                if (this.polylines[key]) {
                    for (let polylineId in this.polylines[key]) {
                        this.polylines[key][polylineId].setMap(null);
                    }
                }
            }
        }
        else {
            if (this.polylines[map]) {
                for (let polylineId in this.polylines[map]) {
                    this.polylines[map][polylineId].setMap(null);
                }
            }
        }
    }
    removePopups(map) {
        if (!map) {
            for (let key in this.popups) {
                if (this.popups[key]) {
                    for (let popupId in this.popups[key]) {
                        this.popups[key][popupId].setMap(null);
                    }
                }
            }
        }
        else {
            if (this.popups[map]) {
                for (let popupId in this.popups[map]) {
                    this.popups[map][popupId].setMap(null);
                }
            }
        }
    }
    clearMap() {
        this.disableInfoTraffic();
        this.removeListeners();
        this.removeCircles();
        this.removeMarkers();
        this.removePolylines();
        this.removePopups();
        this.removeUIControls();
        if (this.map) {
            this.map.setMapTypeId(GoogleMapsService.google.maps.MapTypeId.ROADMAP);
            let streetView = this.map.getStreetView();
            if (streetView)
                streetView.setVisible(false);
        }
        // if(this.directionsRenderer) this.directionsRenderer.setMap(null);
        this.listeners = {};
        this.circles = {};
        this.markers = {};
        this.polylines = {};
        this.popups = {};
        // this.disableMainMapUpdate();
    }
    enableMainMapUpdate() {
        this.mainMapChangeEnabled = true;
    }
    enableInfoTraffic() {
        if (!this.trafficLayer) {
            this.trafficLayer = new GoogleMapsService.google.maps.TrafficLayer();
        }
        this.trafficLayer.setMap(this.map);
    }
    disableInfoTraffic() {
        if (this.trafficLayer)
            this.trafficLayer.setMap(null);
    }
    removeUIControls() {
        if (this.map) {
            for (let control of this.map.controls) {
                if (control !== undefined) {
                    try {
                        control.clear();
                    }
                    catch (err) {
                        console.error(err);
                    }
                }
            }
            this.map.setOptions({
                zoomControl: false,
                mapTypeControl: false,
                scaleControl: false,
                streetViewControl: false,
                rotateControl: false,
                fullscreenControl: false
            });
        }
    }
    disableMainMapUpdate() {
        this.mainMapChangeEnabled = false;
    }
    initMap() {
        if (this.divMap) {
            this.divMap = document.createElement("div");
            this.divMap.style.width = "100%";
            this.divMap.style.height = "100%";
        }
        if (!this.map) {
            this.map = new GoogleMapsService.google.maps.Map(this.divMap, {
                center: { lat: 41.8897, lng: 12.4935 },
                zoom: 7,
                fullscreenControl: false,
                zoomControlOptions: {
                    position: GoogleMapsService.google.maps.ControlPosition.LEFT_BOTTOM
                },
                streetViewControl: true,
                streetViewControlOptions: {
                    position: GoogleMapsService.google.maps.ControlPosition.LEFT_BOTTOM
                },
                mapTypeControl: false,
            });
            // if(this.dataService.users.length <= 0){
            //   this.tdweb.onFinishLoadUsersLocations$.subscribe(() => {
            //     this.setLiveLocations();
            //   });
            // }else{
            //   this.setLiveLocations();
            // }
        }
    }
    setLiveLocations() {
        // for(let user of this.dataService.users){
        //   if(user.location && user.location.content){
        //     this.insertMarker(user);
        //   }
        // }
        this.fitCenter();
    }
    // private async insertMarker(user: User){
    //   if(this.map){
    //     let markerUrl: string = user.markerLive;
    //     if(((user.location.date + user.location.content.live_period) * 1000) < (new Date()).getTime()){
    //       markerUrl = user.markerNoLive;
    //     }
    //     if(this.markers.hasOwnProperty(user.location.sender_user_id)){
    //       this.markers[user.id].setIcon({
    //         url: markerUrl || 'assets/imgs/marker_green.png',
    //         size: new GoogleMapsService.google.maps.Size(46, 55),
    //         scaledSize: new GoogleMapsService.google.maps.Size(46, 55),
    //         origin: new GoogleMapsService.google.maps.Point(0, 0),
    //         anchor: new GoogleMapsService.google.maps.Point(18, 55)
    //       });
    //       this.markers[user.location.sender_user_id].setPosition({lat: user.location.content.latitude, lng: user.location.content.longitude});
    //     }else{
    //       const marker = new GoogleMapsService.google.maps.Marker({
    //         icon: {
    //           url: markerUrl || 'assets/imgs/marker-green.png',
    //           size: new GoogleMapsService.google.maps.Size(46, 55),
    //           scaledSize: new GoogleMapsService.google.maps.Size(46, 55),
    //           origin: new GoogleMapsService.google.maps.Point(0, 0),
    //           anchor: new GoogleMapsService.google.maps.Point(18, 55)
    //         },
    //         id: user.location.sender_user_id,
    //         position: {lat: user.location.content.latitude, lng: user.location.content.longitude}
    //       });
    //       marker.setMap(this.map);
    //       this.markers[user.location.sender_user_id] = marker;
    //     }
    //   }
    // }
    updateUserMarker() {
    }
    insertUser() {
        const marker = new GoogleMapsService.google.maps.Marker({
            id: "indicatorMarker",
            position: { lat: 41.8897, lng: 12.4935 }
        });
        marker.setMap(this.map);
    }
    /*addMarker(marker: any, map: string){
      let markerId: string = marker.get("id");
      if(!markerId) return console.error("No marker _id, marker not added in map");
      if(!this.markers.hasOwnProperty(map)){
        this.markers[map] = {};
      }
      if(this.markers[map][markerId]) this.markers[map][markerId].setMap(null);
      marker.setMap(this.map);
      this.markers[map][markerId] = marker;
    }*/
    removeMarker(marker, map) {
        let markerId = marker.get("id");
        if (!markerId)
            return console.error("No marker _id, marker not removed in map");
        if (!this.markers.hasOwnProperty(map)) {
            this.markers[map] = {};
        }
        if (this.markers[map].hasOwnProperty(markerId)) {
            delete this.markers[map][markerId];
        }
        marker.setMap(null);
    }
    fitCenter() {
        let bounds = new GoogleMapsService.google.maps.LatLngBounds();
        let haveMarkers = 0;
        for (let key in this.markers) {
            bounds.extend(this.markers[key].getPosition());
            haveMarkers++;
        }
        if (haveMarkers > 0) {
            this.map.fitBounds(bounds);
            this.map.panToBounds(bounds);
            if (this.map.getZoom() > 18) {
                this.map.setZoom(18);
            }
        }
    }
}
GoogleMapsService.googleReady = new Subject();
GoogleMapsService.googleReady$ = GoogleMapsService.googleReady.asObservable();
GoogleMapsService.ɵfac = function GoogleMapsService_Factory(t) { return new (t || GoogleMapsService)(); };
GoogleMapsService.ɵprov = i0.ɵɵdefineInjectable({ token: GoogleMapsService, factory: GoogleMapsService.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(GoogleMapsService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

class HistoryMapService {
    constructor(googleMaps) {
        this.googleMaps = googleMaps;
        this.MAP_NAME = "history";
        this.stopMarkers = [];
        this.specialMarkers = [];
        this.coordinates = [];
        this.onSelectMarker = new Subject();
        this.onSelectMarker$ = this.onSelectMarker.asObservable();
    }
    initMap(mapType, urlMarkerBlue, urlMarkerYellow, urlMarkerGreen, isMobile, roadMapLabel, roadMapImage, satelliteMapLabel, satelliteMapImage) {
        HistoryMapService.urlMarkerBlue = urlMarkerBlue;
        HistoryMapService.urlMarkerYellow = urlMarkerYellow;
        HistoryMapService.urlMarkerGreen = urlMarkerGreen;
        HistoryMapService.isMobile = isMobile;
        HistoryMapService.roadMapLabel = roadMapLabel;
        HistoryMapService.roadMapImage = roadMapImage;
        HistoryMapService.satelliteMapLabel = satelliteMapLabel;
        HistoryMapService.satelliteMapImage = satelliteMapImage;
        this.mapType = mapType;
        this.polyline = null;
        this.infoWindow = new GoogleMapsService.google.maps.InfoWindow();
        this.infoWindow.setContent(document.getElementById("history-infowindow"));
        switch (this.mapType) {
            case "Google":
                this.initMapGoogle();
                break;
        }
    }
    clearMap() {
        this.cleanStopMarkers();
        this.cleanPolyline();
        this.stopMarkers = [];
        this.specialMarkers = [];
        this.polyline = undefined;
        this.selectedMarker = undefined;
    }
    /**
     * Desegna la polilinea tra i vari marker
     * @param {any[]} positions
     */
    drawPolyline(positions) {
        return __awaiter(this, void 0, void 0, function* () {
            switch (this.mapType) {
                case "Google":
                    this.drawPolylineGoogle(positions);
                    break;
            }
        });
    }
    cleanPolyline() {
        switch (this.mapType) {
            case "Google":
                this.cleanPolylineGoogle();
                break;
        }
    }
    /**
     * Disegna le frecce sulla polyline
     */
    drawArrows() {
        return __awaiter(this, void 0, void 0, function* () {
            switch (this.mapType) {
                case "Google":
                    this.drawArrowsGoogle();
                    break;
            }
        });
    }
    /**
     * Rimuove le frecce sulla polyline
     */
    cleanArrows() {
        return __awaiter(this, void 0, void 0, function* () {
            switch (this.mapType) {
                case "Google":
                    this.cleanArrowsGoogle();
                    break;
            }
        });
    }
    drawStopMarkers(positions) {
        this.showStops = true;
        switch (this.mapType) {
            case "Google":
                this.drawStopMarkersGoogle(positions);
                break;
        }
    }
    cleanStopMarkers() {
        this.showStops = false;
        switch (this.mapType) {
            case "Google":
                this.cleanStopMarkersGoogle();
                break;
        }
    }
    selectPath(start, stop) {
        switch (this.mapType) {
            case "Google":
                this.selectPathGoogle(start, stop);
                break;
        }
    }
    cleanPath() {
        switch (this.mapType) {
            case "Google":
                this.cleanPathGoogle();
                break;
        }
    }
    selectStopMarker(id, position, label) {
        switch (this.mapType) {
            case "Google":
                this.selectStopMarkerGoogle(id, position, label);
                break;
        }
    }
    changeZoom(delta) {
        switch (this.mapType) {
            case "Google":
                this.changeZoomGoogle(delta);
                break;
        }
    }
    resizeMap() {
        switch (this.mapType) {
            case "Google":
                this.resizeMapGoogle();
                break;
        }
    }
    setMapType(type) {
        switch (this.mapType) {
            case "Google":
                this.setMapTypeGoogle(type);
                break;
        }
    }
    getMapType() {
        switch (this.mapType) {
            case "Google":
                return this.getMapTypeGoogle();
                break;
        }
    }
    // Chiude l'infowindow
    closeInfoWindow() {
        switch (this.mapType) {
            case "Google":
                return this.closeInfoWindowGoogle();
        }
    }
    /*** GOOGLE MAPS ***/
    initMapGoogle(isRefresh) {
        return __awaiter(this, void 0, void 0, function* () {
            // console.log('history-map service initMapGoogle()');
            this.googleMaps.clearMap();
            this.mapHistory = this.googleMaps.getMap();
            let mapContainer = document.getElementById("history-map");
            if (mapContainer) {
                mapContainer.appendChild(this.googleMaps.getDivMap());
                this.googleMaps.setCurrentMap(this.MAP_NAME);
            }
            this.mapHistory.setOptions({
                center: { lat: 44.69, lng: 7.84 },
                zoom: 9,
                fullscreenControl: false,
                zoomControl: !HistoryMapService.isMobile,
                streetViewControl: false,
                mapTypeControl: false,
                mapTypeId: HistoryMapService.currentMapType || GoogleMapsService.google.maps.MapTypeId.ROADMAP,
            });
            let boundsChangeListener = GoogleMapsService.google.maps.event.addListener(this.mapHistory, 'bounds_changed', () => {
                this.lastZoom = this.mapHistory.getZoom();
                this.lastCenter = this.mapHistory.getCenter();
            });
            this.googleMaps.addListener(boundsChangeListener, this.MAP_NAME);
            let clickListener = GoogleMapsService.google.maps.event.addListener(this.mapHistory, 'click', () => {
                if (this.selectedPathPolyline)
                    this.cleanPath();
                this.selectedPathPolyline = undefined;
                this.closeInfoWindowGoogle();
                this.onSelectMarker.next({ id: '' });
            });
            this.googleMaps.addListener(clickListener, this.MAP_NAME);
            this.stopMarkers = [];
            if (HistoryMapService.roadMapLabel &&
                HistoryMapService.roadMapImage &&
                HistoryMapService.satelliteMapLabel &&
                HistoryMapService.satelliteMapImage) {
                this.setMapTypeControls();
            }
        });
    }
    drawPolylineGoogle(positions) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!positions || positions.length <= 0)
                return;
            let icon = {
                url: HistoryMapService.urlMarkerBlue,
                size: new GoogleMapsService.google.maps.Size(46, 55),
                scaledSize: new GoogleMapsService.google.maps.Size(46, 55),
                origin: new GoogleMapsService.google.maps.Point(0, 0),
                anchor: new GoogleMapsService.google.maps.Point(23, 55),
                labelOrigin: new GoogleMapsService.google.maps.Point(23, 24)
            };
            let label = {
                color: 'white',
                fontWeight: 'bold',
                fontSize: '12px',
                text: 'START'
            };
            let coordinates = [];
            this.positionInPolyline = [];
            let count = 0;
            let lastIndex = -1;
            for (let i = 0; i < positions.length; i++) {
                if (positions[i].satellites > 0 && positions[i].position && positions[i].position.coordinates) {
                    const coord = {
                        lat: positions[i].position.coordinates[1],
                        lng: positions[i].position.coordinates[0]
                    };
                    if (count === 0) {
                        let marker = new GoogleMapsService.google.maps.Marker({
                            zIndex: 10,
                            icon: icon,
                            position: coord,
                            label: label,
                            id: 'START-' + positions[i]._id
                        });
                        marker.addListener("spider_click", (a) => {
                            this.onSelectMarker.next({ id: marker.id, type: 'start' });
                            this.infoWindow.open(this.mapHistory, marker);
                        });
                        this.specialMarkers.push(marker);
                        this.googleMaps.addMarker(marker, this.MAP_NAME, true);
                    }
                    count++;
                    lastIndex = i;
                    coordinates.push(coord);
                    this.positionInPolyline.push(positions[i]);
                }
            }
            if (lastIndex >= 0) {
                label.text = 'END';
                let marker = new GoogleMapsService.google.maps.Marker({
                    zIndex: 11,
                    icon: icon,
                    position: {
                        lat: positions[lastIndex].position.coordinates[1],
                        lng: positions[lastIndex].position.coordinates[0]
                    },
                    label: label,
                    id: 'END-' + positions[lastIndex]._id
                });
                marker.addListener("spider_click", () => {
                    this.onSelectMarker.next({ id: marker.id, type: 'end' });
                    this.infoWindow.open(this.mapHistory, marker);
                });
                this.specialMarkers.push(marker);
                this.googleMaps.addMarker(marker, this.MAP_NAME, true);
            }
            this.polyline = new GoogleMapsService.google.maps.Polyline({
                id: "main-polyline",
                path: coordinates,
                geodesic: true,
                strokeColor: "#1bb21d",
                strokeOpacity: 0.8,
                strokeWeight: 6,
                zIndex: 2
            });
            this.googleMaps.addPolyline(this.polyline, this.MAP_NAME);
            GoogleMapsService.google.maps.event.addListener(this.polyline, 'click', (h) => {
                var latlng = h.latLng;
                var needle = {
                    minDistance: 9999999999,
                    index: -1,
                    latlng: null
                };
                this.polyline.getPath().forEach((routePoint, index) => {
                    var dist = GoogleMapsService.google.maps.geometry.spherical.computeDistanceBetween(latlng, routePoint);
                    if (dist < needle.minDistance) {
                        needle.minDistance = dist;
                        needle.index = index;
                        needle.latlng = routePoint;
                    }
                });
                if (this.selectedMarker) {
                    this.googleMaps.removeMarker(this.selectedMarker, this.MAP_NAME);
                }
                icon.url = HistoryMapService.urlMarkerGreen;
                this.selectedMarker = new GoogleMapsService.google.maps.Marker({
                    zIndex: 11,
                    icon: icon,
                    position: {
                        lat: needle.latlng.lat(),
                        lng: needle.latlng.lng()
                    },
                    id: 'SEL-' + this.positionInPolyline[needle.index]._id
                });
                this.selectedMarker.addListener("spider_click", () => {
                    this.onSelectMarker.next({ id: this.selectedMarker.id.replace('SEL-', '') });
                    this.infoWindow.open(this.mapHistory, this.selectedMarker);
                });
                this.infoWindow.open(this.mapHistory, this.selectedMarker);
                this.googleMaps.addMarker(this.selectedMarker, this.MAP_NAME, true);
                this.onSelectMarker.next({ id: this.positionInPolyline[needle.index]._id });
            });
            let bounds = new GoogleMapsService.google.maps.LatLngBounds();
            for (let i = 0; i < coordinates.length; i++) {
                bounds.extend(coordinates[i]);
            }
            this.coordinates = coordinates;
            this.mapHistory.fitBounds(bounds);
        });
    }
    cleanPolylineGoogle() {
        if (this.polyline) {
            this.googleMaps.removePolyline(this.polyline, this.MAP_NAME);
        }
        if (this.selectedPathPolyline) {
            this.googleMaps.removePolyline(this.selectedPathPolyline, this.MAP_NAME);
        }
        if (this.specialMarkers && this.specialMarkers.length > 0) {
            for (let marker of this.specialMarkers) {
                this.googleMaps.removeMarker(marker, this.MAP_NAME);
            }
        }
        if (this.selectedMarker) {
            this.googleMaps.removeMarker(this.selectedMarker, this.MAP_NAME);
        }
    }
    drawArrowsGoogle() {
        if (this.polyline) {
            this.polyline.set('icons', [{
                    icon: {
                        path: "M 0,0 1,1 M -1,1 0,0",
                        strokeColor: "black",
                        strokeWeight: 4,
                        strokeOpacity: 1
                    },
                    offset: '0',
                    repeat: '100px'
                }]);
        }
    }
    cleanArrowsGoogle() {
        if (this.polyline) {
            this.polyline.set('icons', []);
        }
    }
    drawStopMarkersGoogle(positions) {
        this.cleanStopMarkersGoogle();
        let count = 0;
        for (let i = 0; i < positions.length; i++) {
            this.drawStopSingleMarkerGoogle(positions[i], count + 1);
            if (positions[i].position && positions[i].position.coordinates && positions[i].value === 0) {
                count++;
            }
        }
    }
    drawStopSingleMarkerGoogle(position, label_number) {
        let icon = {
            url: HistoryMapService.urlMarkerYellow,
            size: new GoogleMapsService.google.maps.Size(46, 55),
            scaledSize: new GoogleMapsService.google.maps.Size(46, 55),
            origin: new GoogleMapsService.google.maps.Point(0, 0),
            anchor: new GoogleMapsService.google.maps.Point(23, 55),
            labelOrigin: new GoogleMapsService.google.maps.Point(23, 24)
        };
        let label = {
            color: 'white',
            fontSize: '12px'
        };
        if (position.position && position.position.coordinates && position.value === 0) {
            const coord = {
                lat: position.position.coordinates[1],
                lng: position.position.coordinates[0]
            };
            label.text = '' + label_number;
            let marker = new GoogleMapsService.google.maps.Marker({
                zIndex: label_number,
                position: coord,
                label: label,
                icon: icon,
                id: position._id
            });
            marker.addListener("spider_click", () => {
                this.onSelectMarker.next({ id: marker.id });
                this.infoWindow.open(this.mapHistory, marker);
            });
            this.stopMarkers.push(marker);
            this.googleMaps.addMarker(marker, this.MAP_NAME, true);
            return marker;
        }
    }
    cleanStopMarkersGoogle() {
        if (this.stopMarkers) {
            for (let marker of this.stopMarkers) {
                this.googleMaps.removeMarker(marker, this.MAP_NAME);
            }
        }
        this.stopMarkers = [];
    }
    selectPathGoogle(start, stop) {
        this.closeInfoWindow();
        let coordinates = [];
        let bounds = new GoogleMapsService.google.maps.LatLngBounds();
        for (let position of this.positionInPolyline) {
            if (position.timestamp_position >= start) {
                if (position.timestamp_position <= stop) {
                    const c = {
                        lat: position.position.coordinates[1],
                        lng: position.position.coordinates[0]
                    };
                    coordinates.push(c);
                    bounds.extend(c);
                }
                else {
                    break;
                }
            }
        }
        this.selectedPathPolyline = new GoogleMapsService.google.maps.Polyline({
            id: "secondary-polyline",
            path: coordinates,
            geodesic: true,
            strokeColor: "red",
            strokeOpacity: 0.7,
            strokeWeight: 12,
            zIndex: 1
        });
        this.googleMaps.addPolyline(this.selectedPathPolyline, this.MAP_NAME);
        this.mapHistory.fitBounds(bounds);
    }
    cleanPathGoogle() {
        if (this.selectedPathPolyline) {
            this.googleMaps.removePolyline(this.selectedPathPolyline, this.MAP_NAME);
            this.selectedPathPolyline = undefined;
        }
    }
    selectStopMarkerGoogle(id, position, label) {
        if (this.selectedPathPolyline)
            this.cleanPath();
        let marker;
        if (this.stopMarkers) {
            marker = this.stopMarkers.find(el => el.get('id') === id);
        }
        if (!marker && this.specialMarkers) {
            marker = this.specialMarkers.find(el => el.get('id') === id);
        }
        if (marker) {
            this.mapHistory.setCenter(marker.getPosition());
        }
        else {
            marker = this.drawStopSingleMarkerGoogle(position, label);
        }
        if (marker)
            GoogleMapsService.google.maps.event.trigger(marker, 'spider_click');
    }
    changeZoomGoogle(delta) {
        let zoom = this.mapHistory.getZoom();
        this.mapHistory.setZoom(zoom + delta);
    }
    resizeMapGoogle() {
        var _a;
        if (((_a = this.coordinates) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            let bounds = new GoogleMapsService.google.maps.LatLngBounds();
            for (let i = 0; i < this.coordinates.length; i++) {
                bounds.extend(this.coordinates[i]);
            }
            if (!bounds.isEmpty()) {
                this.mapHistory.fitBounds(bounds);
            }
        }
    }
    setMapTypeGoogle(type) {
        this.mapHistory.setMapTypeId(type);
    }
    getMapTypeGoogle() {
        return this.mapHistory.getMapTypeId();
    }
    closeInfoWindowGoogle() {
        if (this.infoWindow)
            this.infoWindow.close();
        if (this.selectedMarker)
            this.googleMaps.removeMarker(this.selectedMarker, this.MAP_NAME);
        this.selectedMarker = undefined;
        if (!this.showStops) {
            this.cleanStopMarkersGoogle();
        }
    }
    // Setta il menù con le icone per cambio tipo mappa e infotraffico
    setMapTypeControls() {
        return __awaiter(this, void 0, void 0, function* () {
            // console.log('history-map service setMapTypeControls()');
            const size = HistoryMapService.isMobile ? '50px' : '75px';
            if (!this.buttonMapType_1) {
                this.buttonMapType_1 = document.createElement('div');
                let controlUIMap = document.createElement('div');
                controlUIMap.style.height = size;
                controlUIMap.style.width = size;
                controlUIMap.style.background = "linear-gradient(0deg,rgba(0,0,0,0.3),rgba(0,0,0,0.3)),url(" + HistoryMapService.satelliteMapImage + ")";
                controlUIMap.style.backgroundSize = size + " " + size;
                controlUIMap.style.border = '2px solid #fff';
                controlUIMap.style.borderRadius = '5px';
                controlUIMap.style.cursor = 'pointer';
                controlUIMap.style.marginRight = HistoryMapService.isMobile ? '8px' : '10px';
                this.buttonMapType_1.style.marginBottom = "5px";
                this.buttonMapType_1.appendChild(controlUIMap);
                let controlTexMap = document.createElement('div');
                controlTexMap.style.color = "#fff";
                controlTexMap.style.fontFamily = 'Roboto,Arial,sans-serif';
                controlTexMap.style.fontSize = HistoryMapService.isMobile ? '8px' : '10px';
                controlTexMap.style.lineHeight = '38px';
                controlTexMap.style.paddingLeft = '5px';
                controlTexMap.style.paddingRight = '5px';
                controlTexMap.style.marginTop = HistoryMapService.isMobile ? '20px' : '40px';
                controlTexMap.style.textOverflow = 'ellipsis';
                controlTexMap.style.overflow = 'hidden';
                controlTexMap.style.whiteSpace = 'nowrap';
                controlTexMap.innerHTML = HistoryMapService.satelliteMapLabel;
                this.buttonMapType_1.addEventListener('click', () => {
                    let mapTypeId = this.mapHistory.getMapTypeId();
                    if (mapTypeId == GoogleMapsService.google.maps.MapTypeId.HYBRID) {
                        controlUIMap.style.background = "linear-gradient(0deg,rgba(0,0,0,0.3),rgba(0,0,0,0.3)),url(" + HistoryMapService.satelliteMapImage + ")";
                        controlUIMap.style.backgroundSize = size + " " + size;
                        controlTexMap.innerHTML = HistoryMapService.satelliteMapLabel;
                        HistoryMapService.currentMapType = GoogleMapsService.google.maps.MapTypeId.ROADMAP;
                    }
                    else {
                        controlUIMap.style.background = "linear-gradient(0deg,rgba(0,0,0,0.3),rgba(0,0,0,0.3)),url(" + HistoryMapService.roadMapImage + ")";
                        controlUIMap.style.backgroundSize = size + " " + size;
                        controlTexMap.innerHTML = HistoryMapService.roadMapLabel;
                        HistoryMapService.currentMapType = GoogleMapsService.google.maps.MapTypeId.HYBRID;
                    }
                    this.mapHistory.setMapTypeId(HistoryMapService.currentMapType);
                });
                controlUIMap.appendChild(controlTexMap);
            }
            this.mapHistory.controls[GoogleMapsService.google.maps.ControlPosition.RIGHT_BOTTOM].push(this.buttonMapType_1);
        });
    }
}
HistoryMapService.ɵfac = function HistoryMapService_Factory(t) { return new (t || HistoryMapService)(i0.ɵɵinject(GoogleMapsService)); };
HistoryMapService.ɵprov = i0.ɵɵdefineInjectable({ token: HistoryMapService, factory: HistoryMapService.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(HistoryMapService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: GoogleMapsService }]; }, null); })();

class AlarmsPoiMapService {
    constructor(googleMaps) {
        this.googleMaps = googleMaps;
        this.MAP_NAME = "alarms-poi";
        this.poiMarkers = [];
        this.circles = [];
        this.onSelectMarker = new Subject();
        this.onSelectMarker$ = this.onSelectMarker.asObservable();
    }
    initMap(mapType, urlMarkerPoi) {
        AlarmsPoiMapService.urlMarkerPoi = urlMarkerPoi;
        this.mapType = mapType;
        switch (this.mapType) {
            case "Google":
                this.initMapGoogle();
                break;
        }
    }
    drawPoiMarkers(poi) {
        switch (this.mapType) {
            case "Google":
                this.drawPoiMarkersGoogle(poi);
                break;
        }
    }
    clearMap() {
        this.poiMarkers = [];
    }
    cleanPoiMarkers() {
        switch (this.mapType) {
            case "Google":
                this.cleanPoiMarkesGoogle();
                break;
        }
    }
    removePoiMarker(id) {
        switch (this.mapType) {
            case "Google":
                this.removePoiMarkerGoogle(id);
                break;
        }
    }
    selectPoiMarker(id) {
        switch (this.mapType) {
            case "Google":
                this.selectPoiMarkerGoogle(id);
                break;
        }
    }
    initMapGoogle() {
        return __awaiter(this, void 0, void 0, function* () {
            this.googleMaps.clearMap();
            this.map = this.googleMaps.getMap();
            let mapContainer = document.getElementById("alarms-poi-map");
            if (mapContainer) {
                mapContainer.appendChild(this.googleMaps.getDivMap());
                this.googleMaps.setCurrentMap(this.MAP_NAME);
            }
            this.map.setOptions({
                center: { lat: 44.69, lng: 7.84 },
                zoom: 9,
                fullscreenControl: false,
                zoomControl: true,
                streetViewControl: false,
                mapTypeControl: true
            });
            this.poiMarkers = [];
            this.circles = [];
        });
    }
    drawPoiMarkersGoogle(pois) {
        let icon = {
            url: AlarmsPoiMapService.urlMarkerPoi,
            size: new GoogleMapsService.google.maps.Size(36, 45),
            scaledSize: new GoogleMapsService.google.maps.Size(36, 45),
            origin: new GoogleMapsService.google.maps.Point(0, 0),
            anchor: new GoogleMapsService.google.maps.Point(18, 45),
            labelOrigin: new GoogleMapsService.google.maps.Point(18, 22)
        };
        let label = {
            color: 'white',
            fontSize: '12px'
        };
        let count = 0;
        let bounds = new GoogleMapsService.google.maps.LatLngBounds();
        for (let i = 0; i < pois.length; i++) {
            if (pois[i].position && pois[i].position.coordinates) {
                const coord = {
                    lat: pois[i].position.coordinates[1],
                    lng: pois[i].position.coordinates[0]
                };
                label = '';
                if (pois[i].label_number) {
                    label += pois[i].label_number;
                }
                let marker = new GoogleMapsService.google.maps.Marker({
                    zIndex: count,
                    position: coord,
                    label: label,
                    icon: icon,
                    id: pois[i]._id
                });
                let circle = new GoogleMapsService.google.maps.Circle({
                    center: coord,
                    radius: pois[i].radius,
                    strokeColor: "#ff8214",
                    fillColor: "#fff314",
                    fillOpacity: 0.2,
                    id: pois[i]._id
                });
                bounds.union(circle.getBounds());
                marker.addListener("click", () => {
                    this.onSelectMarker.next({ id: marker.id });
                });
                this.poiMarkers.push(marker);
                this.circles.push(circle);
                this.googleMaps.addCircle(circle, this.MAP_NAME);
                this.googleMaps.addMarker(marker, this.MAP_NAME, true);
                count++;
            }
        }
        if (!bounds.isEmpty()) {
            this.map.fitBounds(bounds);
        }
    }
    cleanPoiMarkesGoogle() {
        if (this.poiMarkers) {
            for (let marker of this.poiMarkers) {
                this.googleMaps.removeMarker(marker, this.MAP_NAME);
            }
        }
        if (this.circles) {
            for (let circle of this.circles) {
                this.googleMaps.removeMarker(circle, this.MAP_NAME);
            }
        }
    }
    removePoiMarkerGoogle(id) {
        let marker = this.poiMarkers.find(el => el.get('id') === id);
        let circle = this.circles.find(el => el.get('id') === id);
        if (marker) {
            this.googleMaps.removeMarker(marker, this.MAP_NAME);
        }
        if (circle) {
            this.googleMaps.removeCircle(circle, this.MAP_NAME);
        }
    }
    selectPoiMarkerGoogle(id) {
        let marker;
        if (this.poiMarkers) {
            marker = this.poiMarkers.find(el => el.get('id') === id);
        }
        if (marker) {
            this.map.setCenter(marker.getPosition());
            GoogleMapsService.google.maps.event.trigger(marker, 'click');
        }
    }
}
AlarmsPoiMapService.ɵfac = function AlarmsPoiMapService_Factory(t) { return new (t || AlarmsPoiMapService)(i0.ɵɵinject(GoogleMapsService)); };
AlarmsPoiMapService.ɵprov = i0.ɵɵdefineInjectable({ token: AlarmsPoiMapService, factory: AlarmsPoiMapService.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(AlarmsPoiMapService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: GoogleMapsService }]; }, null); })();

class PoiMapService {
    constructor(googleMaps) {
        this.googleMaps = googleMaps;
        this.MAP_NAME = "poi";
    }
    initMap(mapType, urlMarkerPoi, popupLabel, lat, lng, radius) {
        PoiMapService.urlMarkerPoi = urlMarkerPoi;
        PoiMapService.popupLabel = popupLabel;
        this.mapType = mapType;
        switch (this.mapType) {
            case "Google":
                this.initMapGoogle(lat, lng, radius);
                break;
        }
    }
    drawPoiMarker(lat, lng, radius) {
        switch (this.mapType) {
            case "Google":
                this.drawPoiMarkerGoogle(lat, lng, radius);
                break;
        }
    }
    cleanPoiMarkers() {
        switch (this.mapType) {
            case "Google":
                this.cleanPoiMarkeGoogle();
                break;
        }
    }
    // Muove il marker, il cerchio e anche il label nella posizione voluta (solitamente a ricerca indirizzo
    movePoiMarker(lat, lng) {
        switch (this.mapType) {
            case "Google":
                this.movePoiMarkerGoogle(lat, lng);
                break;
        }
    }
    // Cambia il raggio del marker
    changeCircleRadius(radius) {
        switch (this.mapType) {
            case "Google":
                this.changeCircleRadiusGoogle(radius);
                break;
        }
    }
    initMapGoogle(lat, lng, radius) {
        return __awaiter(this, void 0, void 0, function* () {
            this.googleMaps.clearMap();
            this.map = this.googleMaps.getMap();
            let mapContainer = document.getElementById("poi-map");
            if (mapContainer) {
                mapContainer.appendChild(this.googleMaps.getDivMap());
                this.googleMaps.setCurrentMap(this.MAP_NAME);
            }
            this.map.setOptions({
                center: { lat: lat || 44.69, lng: lng || 7.84 },
                zoom: 9,
                fullscreenControl: false,
                zoomControl: true,
                streetViewControl: false,
                mapTypeControl: false,
                mapTypeControlOptions: {
                    style: GoogleMapsService.google.maps.MapTypeControlStyle.HORIZONTAL_BAR,
                    position: GoogleMapsService.google.maps.ControlPosition.RIGHT_BOTTOM
                },
            });
            this.poiMarker = undefined;
            this.circle = undefined;
            this.drawPoiMarker(lat || 44.7030, lng || 7.8395, radius);
        });
    }
    drawPoiMarkerGoogle(lat, lng, radius) {
        let icon = {
            url: PoiMapService.urlMarkerPoi,
            size: new GoogleMapsService.google.maps.Size(36, 45),
            scaledSize: new GoogleMapsService.google.maps.Size(36, 45),
            origin: new GoogleMapsService.google.maps.Point(0, 0),
            anchor: new GoogleMapsService.google.maps.Point(18, 45),
            labelOrigin: new GoogleMapsService.google.maps.Point(18, 22)
        };
        const coord = {
            lat: lat,
            lng: lng
        };
        let marker = new GoogleMapsService.google.maps.Marker({
            zIndex: 1,
            position: coord,
            icon: icon,
            id: 'poi',
            draggable: true,
            raiseOnDrag: true
        });
        let circle = new GoogleMapsService.google.maps.Circle({
            center: coord,
            radius: radius,
            strokeColor: "#2e97f2",
            strokeWeight: 2,
            fillColor: "#2e97f2",
            fillOpacity: 0.15,
            id: 'poi'
        });
        marker.addListener('dragend', () => {
            if (this.circle)
                this.circle.setCenter(marker.getPosition());
            if (this.popup)
                this.popup.position = marker.getPosition();
        });
        this.poiMarker = marker;
        this.circle = circle;
        this.googleMaps.addCircle(circle, this.MAP_NAME);
        this.googleMaps.addMarker(marker, this.MAP_NAME, true);
        this.popup = this.createPopupGoogle(marker.getPosition());
        this.googleMaps.addPopup(this.popup, this.MAP_NAME);
        this.fitCenterGoogle();
    }
    cleanPoiMarkeGoogle() {
        if (this.poiMarker) {
            this.googleMaps.removeMarker(this.poiMarker, this.MAP_NAME);
        }
        if (this.circle) {
            this.googleMaps.removeMarker(this.circle, this.MAP_NAME);
        }
        if (this.popup) {
            this.googleMaps.removePopup(this.popup, this.MAP_NAME);
        }
    }
    // Crea il label sopra al marker, devo mettere anche la classe all'interno del metodo altrimenti non si riesce a fare
    createPopupGoogle(position) {
        class Popup extends GoogleMapsService.google.maps.OverlayView {
            constructor(position, content, id) {
                super();
                this.position = position;
                this.id = id;
                content.classList.add("map-poi-popup-bubble");
                // This zero-height div is positioned at the bottom of the bubble.
                const bubbleAnchor = document.createElement("div");
                bubbleAnchor.classList.add("map-poi-popup-bubble-anchor");
                bubbleAnchor.appendChild(content);
                // This zero-height div is positioned at the bottom of the tip.
                this.containerDiv = document.createElement("div");
                this.containerDiv.classList.add("map-poi-popup-container");
                this.containerDiv.appendChild(bubbleAnchor);
                // Optionally stop clicks, etc., from bubbling up to the map.
                Popup.preventMapHitsAndGesturesFrom(this.containerDiv);
            }
            /** Called when the popup is added to the map. */
            onAdd() {
                this.getPanes().floatPane.appendChild(this.containerDiv);
            }
            /** Called when the popup is removed from the map. */
            onRemove() {
                if (this.containerDiv.parentElement) {
                    this.containerDiv.parentElement.removeChild(this.containerDiv);
                }
            }
            /** Called each frame when the popup needs to draw itself. */
            draw() {
                const divPosition = this.getProjection().fromLatLngToDivPixel(this.position);
                //Hide the popup when it is far out of view.
                const display = Math.abs(divPosition.x) < 4000 && Math.abs(divPosition.y) < 4000
                    ? "block"
                    : "none";
                // const display = 'block';
                if (display === "block") {
                    this.containerDiv.style.left = divPosition.x + "px";
                    this.containerDiv.style.top = divPosition.y + "px";
                }
                if (this.containerDiv.style.display !== display) {
                    this.containerDiv.style.display = display;
                }
            }
        }
        let element = document.createElement('div');
        element.innerText = PoiMapService.popupLabel;
        return new Popup(position, element, 'label');
    }
    movePoiMarkerGoogle(lat, lng) {
        const position = new GoogleMapsService.google.maps.LatLng(lat, lng);
        if (this.poiMarker)
            this.poiMarker.setPosition(position);
        if (this.circle)
            this.circle.setCenter(position);
        if (this.popup)
            this.popup.position = position;
        this.fitCenterGoogle();
    }
    changeCircleRadiusGoogle(radius) {
        if (this.circle) {
            this.circle.setRadius(radius);
            this.fitCenterGoogle();
        }
    }
    fitCenterGoogle() {
        let bounds = this.circle.getBounds();
        if (!bounds.isEmpty()) {
            this.map.fitBounds(bounds);
            setTimeout(() => {
                if (this.map.getZoom() > 16) {
                    this.map.setZoom(16);
                }
            }, 200);
        }
    }
}
PoiMapService.ɵfac = function PoiMapService_Factory(t) { return new (t || PoiMapService)(i0.ɵɵinject(GoogleMapsService)); };
PoiMapService.ɵprov = i0.ɵɵdefineInjectable({ token: PoiMapService, factory: PoiMapService.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(PoiMapService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: GoogleMapsService }]; }, null); })();

class Utility {
    /** Crea le tappe di un report e il suo sommario **/
    static parseRoute(route, report, lang) {
        let summary = {
            totalDuration: 0,
            driveDuration: 0,
            stopDuration: 0,
            totalDistance: 0
        };
        if (report) {
            summary.totalDuration = report.time_total || 0;
            summary.driveDuration = report.time_trip || 0;
            summary.stopDuration = report.time_stop || 0;
            summary.totalDistance = ((report.total_distance || 0) / 1000);
        }
        // let totalDistance = 0;
        let stopsCounter = 0;
        for (let i = 0; i < route.length; i++) {
            if (i !== (route.length - 1)) {
                let distance = ((route[i + 1].total_odometer - route[i].total_odometer) / 1000);
                route[i].distance = distance;
                // totalDistance += distance;
                route[i].durationMs = route[i + 1].timestamp_position - route[i].timestamp_position;
                // summary.totalDuration += route[i].durationMs;
                route[i].endPathTimestamp = route[i + 1].timestamp_position;
                if (route[i].durationMs <= (60000 * 60)) {
                    route[i].labelUnitDuration = lang['minuti'];
                    const min = Math.floor(route[i].durationMs / 60000);
                    route[i].duration = min < 10 ? ('0' + min) : ('' + min);
                    const sec = Math.floor((route[i].durationMs - (min * 60000)) / 1000);
                    route[i].duration += sec < 10 ? (':0' + sec) : (':' + sec);
                }
                else if (route[i].durationMs <= (60000 * 60 * 24)) {
                    route[i].labelUnitDuration = lang['ore'];
                    const ore = Math.floor(route[i].durationMs / (60000 * 60));
                    route[i].duration = ore < 10 ? ('0' + ore) : ('' + ore);
                    const min = Math.floor((route[i].durationMs - (ore * 60000 * 60)) / 60000);
                    route[i].duration += min < 10 ? (':0' + min) : (':' + min);
                }
                else {
                    route[i].labelUnitDuration = lang['giorni'];
                    const gg = Math.floor(route[i].durationMs / (60000 * 60 * 24));
                    route[i].duration = '' + gg;
                }
                if (route[i].value === 1) {
                    route[i].pathType = 'trip';
                    route[i].labelActivity = lang['distanza_percorsa'];
                    // summary.driveDuration += route[i].durationMs;
                }
                else {
                    route[i].pathType = 'stop';
                    route[i].labelActivity = lang['fermata_per'];
                    stopsCounter++;
                }
            }
            if (i === 0) {
                route[i].divider = {
                    circleType: 'special',
                    addedLbl: lang['inizio']
                };
            }
            else if (i === (route.length - 1)) {
                route[i].divider = {
                    circleType: 'special',
                    addedLbl: lang['fino']
                };
            }
            else {
                route[i].divider = {
                    circleType: 'normal'
                };
            }
            route[i].divider.num = stopsCounter;
        }
        // summary.totalDistance = totalDistance.toFixed(1);
        if (summary.driveDuration > 0) {
            summary.avgSpeed = (summary.totalDistance / (summary.driveDuration / (60000 * 60))).toFixed(2);
        }
        else {
            summary.avgSpeed = 0;
        }
        // summary.stopDuration = summary.totalDuration - summary.driveDuration;
        // if(summary.stopDuration < 0) summary.stopDuration = 0;
        return summary;
    }
    static validateEmail(email) {
        // let re = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
        let re = /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/;
        return re.test(String(email).toLowerCase());
    }
    // Valida solo telefoni scritti in formato +39...
    static validatePhone(phone) {
        let re = new RegExp('^\\d+$');
        if (!phone || phone.length < 6 || phone[0] !== '+')
            return false;
        const aus = phone.substr(1, phone.length);
        return re.test(aus);
    }
    // Pulisce un numero di telefono e gli aggiunge il +39 se necessario
    static sanitizePhone(phone) {
        phone = phone.replace(/[^\d+]+/, '');
        if (phone.length < 0)
            return null;
        if (phone[0] === '+')
            return phone;
        for (let dial of Utility.italia_phone_prefix) {
            if (phone.indexOf(dial) === 0) {
                return `+39${phone}`;
            }
        }
        return null;
    }
    // Ritorna data in formato YYYY-MM-DDTHH:mm
    static toDateString(date) {
        return (date.getFullYear().toString() + '-'
            + ("0" + (date.getMonth() + 1)).slice(-2) + '-'
            + ("0" + (date.getDate())).slice(-2))
            + 'T' + date.toTimeString().slice(0, 5);
    }
    // Ritorna data in formato YYYY-MM-DD
    static toIsoDateString(date) {
        return (date.getFullYear().toString() + '-'
            + ("0" + (date.getMonth() + 1)).slice(-2) + '-'
            + ("0" + (date.getDate())).slice(-2));
    }
    // Ritorna time in formato HH:mm
    static toIsoTimeString(date) {
        return date.toTimeString().slice(0, 5);
    }
    // Seleziona la corretta icona per il marker con l'headeang corretto
    static selectMarkerIcons(movingMarkers, stopMarkers, inMoving, angle) {
        // 1. Scelta icone verdi o rosse a seconda dello stato del veicolo;
        let obj = stopMarkers;
        if (inMoving)
            obj = movingMarkers;
        // 2. Cerco l'immagine con angolazione più prossima;
        for (let k in obj) {
            if (obj[k].min < obj[k].max) { // Sono tutti i casi diversi dal primo
                if (obj[k].max > angle && obj[k].min <= angle)
                    return obj[k].url;
            }
            else { // Quando si trova nel primo intervallo a cavallo dello 0
                if ((obj[k].max > angle && 0 <= angle) || (obj[k].min <= angle && 360 > angle))
                    return obj[k].url;
            }
        }
    }
    // Prende un numero di versione scritto in formato '0.0.1' e lo trasforma in un numero confrontabile moltiplicando ogni spazio per 10 a seconda della posizione 1.1.1 = (1x100) + (1*10) + 1
    static parseVersionNumber(version) {
        if (!version)
            return 0;
        let parts = version.split('.');
        let moltiplicatore = 1;
        let total = 0;
        for (let i = parts.length - 1; i >= 0; i--) {
            const num = parseInt(parts[i]);
            total += num * moltiplicatore;
            moltiplicatore = moltiplicatore * 10;
        }
        return total;
    }
    // Passando un language code (es it, it-IT) ritorna sempre un codice a due lettere (es. it)
    static parseLanguageCode(code) {
        return code.substr(0, 2);
    }
}
Utility.italia_phone_prefix = [
    '351', '352', '330', '331', '333', '334', '335', '336', '337', '338', '339', '360', '361', '362',
    '363', '366', '368', '381', '340', '341', '342', '343', '344', '345', '346', '347', '348', '349',
    '383', '320', '322', '323', '324', '327', '328', '329', '355', '380', '388', '389', '390', '391',
    '392', '393', '397', '377', '379', '371', '370', '353', '373', '375', '350', '382', '378', '376'
];
Utility.wait = (delay, ...args) => new Promise(resolve => setTimeout(resolve, delay, ...args));

class MainMapService {
    constructor(googleMaps) {
        this.googleMaps = googleMaps;
        this.MAP_NAME = "main";
        this.participantMarkers = [];
        this.popupMarkers = [];
        this.poiMarkers = [];
        this.onSelectMarker = new Subject();
        this.onSelectMarker$ = this.onSelectMarker.asObservable();
        this.infoTrafficEnabled = true;
    }
    initMap(mapType, iconsRed, iconsGreen, iconPoi, iconDisabled, infotrafficLabel, infotrafficImage, roadMapLabel, roadMapImage, satelliteMapLabel, satelliteMapImage, lightInit, isMobile) {
        MainMapService.iconsRed = iconsRed;
        MainMapService.iconsGreen = iconsGreen;
        MainMapService.iconPoi = iconPoi;
        MainMapService.iconDisabled = iconDisabled;
        MainMapService.infotrafficLabel = infotrafficLabel;
        MainMapService.infotrafficImage = infotrafficImage;
        MainMapService.roadMapLabel = roadMapLabel;
        MainMapService.roadMapImage = roadMapImage;
        MainMapService.satelliteMapLabel = satelliteMapLabel;
        MainMapService.satelliteMapImage = satelliteMapImage;
        MainMapService.isMobile = isMobile;
        this.mapType = mapType;
        switch (this.mapType) {
            case "Google":
                this.initMapGoogle(lightInit);
                break;
        }
    }
    drawSelectMarker(lat, lng) {
        switch (this.mapType) {
            case "Google":
                this.drawSelectMarkerGoogle(lat, lng);
                break;
        }
    }
    clearMap() {
        this.selectedMarker = undefined;
        this.poiMarkers = [];
        this.participantMarkers = [];
        this.popupMarkers = [];
        // this.cleanStopMarkers();
        // this.cleanPolyline();
        // this.stopMarkers = [];
        // this.specialMarkers = [];
        // this.polyline = undefined;
        // this.selectedMarker = undefined;
    }
    drawParticipantMarkers(participants) {
        switch (this.mapType) {
            case "Google":
                this.drawParticipantMarkersGoogle(participants);
                break;
        }
    }
    toggleVisibilityParticipant(participant, showPopup) {
        switch (this.mapType) {
            case "Google":
                this.toggleVisibilityParticipantGoogle(participant, showPopup);
                break;
        }
    }
    drawPoiMarkers(pois) {
        switch (this.mapType) {
            case "Google":
                this.drawPoiMarkersGoogle(pois);
                break;
        }
    }
    toggleVisibilityPoi(poi) {
        switch (this.mapType) {
            case "Google":
                this.toggleVisibilityPoiGoogle(poi);
                break;
        }
    }
    changeZoom(delta) {
        switch (this.mapType) {
            case "Google":
                this.changeZoomGoogle(delta);
                break;
        }
    }
    resizeMap() {
        switch (this.mapType) {
            case "Google":
                this.resizeMapGoogle();
                break;
        }
    }
    setCenter(lat, lng) {
        switch (this.mapType) {
            case "Google":
                this.setCenterGoogle(lat, lng);
                break;
        }
    }
    setMapType(type) {
        switch (this.mapType) {
            case "Google":
                this.setMapTypeGoogle(type);
                break;
        }
    }
    getMapType() {
        switch (this.mapType) {
            case "Google":
                return this.getMapTypeGoogle();
        }
    }
    selectParticipant(id) {
        switch (this.mapType) {
            case "Google":
                return this.selectParticipantGoogle(id);
                break;
        }
    }
    selectPoi(id) {
        switch (this.mapType) {
            case "Google":
                return this.selectPoiGoogle(id);
                break;
        }
    }
    drawCirclePoi(poi) {
        switch (this.mapType) {
            case "Google":
                return this.drawCirclePoiGoogle(poi);
                break;
        }
    }
    removeCirclePoi() {
        switch (this.mapType) {
            case "Google":
                return this.removeCirclePoiGoogle();
                break;
        }
    }
    // Visualizza o elimina il label numerico all'interno dei marker
    toggleVisibilityLabel(visible) {
        MainMapService.labelVisible = visible;
        switch (this.mapType) {
            case "Google":
                return this.toggleVisibilityLabelGoogle(visible);
        }
    }
    // Visualizza o elimina popup per il label number sopra i marker delle posizioni
    toggleVisibilityPopup(visible) {
        MainMapService.popupVisible = visible;
        switch (this.mapType) {
            case "Google":
                return this.toggleVisibilityPopupGoogle(visible);
        }
    }
    // Aggiorna il marker dopo una notifica di cambio posizione oppure cambio label o cose simili
    updateParticipantMarker(participant) {
        switch (this.mapType) {
            case "Google":
                return this.updateParticipantMarkerGoogle(participant);
        }
    }
    // Aggiorna il marker dopo una notifica di cambio di un poi
    updatePoiMarker(poi) {
        switch (this.mapType) {
            case "Google":
                return this.updatePoiMarkerGoogle(poi);
        }
    }
    removeParticipantMarker(id) {
        switch (this.mapType) {
            case "Google":
                return this.removeParticipantMarkerGoogle(id);
        }
    }
    removePoiMarker(id) {
        switch (this.mapType) {
            case "Google":
                return this.removePoiMarkerGoogle(id);
        }
    }
    // Chiude l'infowindow
    closeInfoWindow() {
        switch (this.mapType) {
            case "Google":
                return this.closeInfoWindowGoogle();
        }
    }
    static clearService() {
        MainMapService.initCount = -1;
        MainMapService.currentZoom = undefined;
        MainMapService.currentCenter = undefined;
        MainMapService.currentInfotraffic = undefined;
        MainMapService.currentMapType = undefined;
    }
    requestResize(consumed) {
        this.needResize = !consumed;
    }
    isToResize() {
        return this.needResize;
    }
    // Dice se la mappa è già visibile
    isCurrentMap() {
        return this.googleMaps.currentMap === this.MAP_NAME;
    }
    /*// Visualizza o meno i poi sulla mappa
    toggleVisibilityPoiMarker(visible: boolean){
      switch (this.mapType) {
        case "Google":
          return this.toggleVisibilityPoiMarkerGoogle(visible);
      }
    }*/
    /*** GOOGLE MAPS ***/
    initMapGoogle(lightInit) {
        return __awaiter(this, void 0, void 0, function* () {
            this.clearMap();
            yield this.googleMaps.isReady(); // Attende che google sia caricato
            this.googleMaps.clearMap();
            this.map = this.googleMaps.getMap();
            let mapContainer = document.getElementById("main-map");
            if (mapContainer) {
                mapContainer.appendChild(this.googleMaps.getDivMap());
                this.googleMaps.setCurrentMap(this.MAP_NAME);
            }
            const listenerRef = this.map.addListener('rightclick', (event) => {
                this.drawSelectMarkerGoogle(event.latLng.lat(), event.latLng.lng());
            });
            this.googleMaps.addListener(listenerRef, this.MAP_NAME);
            const listenerClick = this.map.addListener('click', (event) => {
                this.closeInfoWindow();
            });
            this.googleMaps.addListener(listenerClick, this.MAP_NAME);
            const listenerZoomChange = this.map.addListener("zoom_changed", () => {
                MainMapService.currentZoom = this.map.getZoom();
            });
            this.googleMaps.addListener(listenerZoomChange, this.MAP_NAME);
            const listenerCenterChange = this.map.addListener("center_changed", () => {
                MainMapService.currentCenter = this.map.getCenter();
            });
            this.googleMaps.addListener(listenerCenterChange, this.MAP_NAME);
            if (!lightInit) {
                this.infoWindow = new GoogleMapsService.google.maps.InfoWindow();
                this.infoWindow.setContent(document.getElementById("main-map-infowindow"));
                this.infoWindow.setZIndex(4000);
            }
            MainMapService.initCount++;
            this.map.setOptions({
                center: MainMapService.currentCenter || { lat: 41.8933203, lng: 12.4829321 },
                zoom: MainMapService.currentZoom || 6,
                fullscreenControl: false,
                zoomControl: !MainMapService.isMobile,
                streetViewControl: false,
                mapTypeControl: false,
                clickableIcons: false,
                mapTypeId: MainMapService.currentMapType || GoogleMapsService.google.maps.MapTypeId.ROADMAP
            });
            if (MainMapService.currentInfotraffic) {
                this.googleMaps.enableInfoTraffic();
            }
            else {
                this.googleMaps.disableInfoTraffic();
            }
            this.setMapTypeControls();
        });
    }
    // Visualizza il marker di selezione sulla mappa (tasto dx o ricerca indirizzo)
    drawSelectMarkerGoogle(lat, lng) {
        console.log(lat, lng);
        this.selectedMarker = new GoogleMapsService.google.maps.Marker({
            zIndex: 10000,
            position: { lat: lat, lng: lng },
            id: 'selected-marker'
        });
        this.onSelectMarker.next({ type: 'selected-marker', id: this.selectedMarker.id, position: { lat: lat, lng: lng } });
        this.infoWindow.open(this.map, this.selectedMarker);
        this.selectedMarker.addListener("spider_click", () => {
            this.onSelectMarker.next({ type: 'selected-marker', id: this.selectedMarker.id, position: { lat: lat, lng: lng } });
            this.infoWindow.open(this.map, this.selectedMarker);
        });
        this.googleMaps.addMarker(this.selectedMarker, this.MAP_NAME, false);
    }
    // Inserisce i marker dei partecipanti localizzati
    drawParticipantMarkersGoogle(participants) {
        this.participantMarkers = [];
        this.popupMarkers = [];
        for (let i = 0; i < participants.length; i++) {
            this.drawSingleParticipantMarkerGoogle(participants[i], i);
        }
        // this.resizeMap();
    }
    // Metodo ausiliario per la creazione di un marker di un participant
    drawSingleParticipantMarkerGoogle(participant, index) {
        let icon = {
            url: MainMapService.iconDisabled,
            size: new GoogleMapsService.google.maps.Size(46, 55),
            scaledSize: new GoogleMapsService.google.maps.Size(46, 55),
            origin: new GoogleMapsService.google.maps.Point(0, 0),
            anchor: new GoogleMapsService.google.maps.Point(23, 55),
            labelOrigin: new GoogleMapsService.google.maps.Point(23, 24)
        };
        if (participant.virtualPosition && participant.virtualPosition.latitude && participant.virtualPosition.longitude) {
            const coord = {
                lat: participant.virtualPosition.latitude,
                lng: participant.virtualPosition.longitude
            };
            let label = {
                color: 'white',
                fontSize: '12px'
            };
            // Scelgo l'icona in base all'heading
            const urlIcon = Utility.selectMarkerIcons(MainMapService.iconsGreen, MainMapService.iconsRed, participant.virtualPosition.tripStatus, participant.virtualPosition.angle);
            if (urlIcon)
                icon.url = urlIcon;
            if (participant.label_number) {
                label.text = participant.label_number + '';
            }
            else {
                label = undefined;
            }
            let marker = new GoogleMapsService.google.maps.Marker({
                zIndex: index,
                position: coord,
                label: label,
                icon: icon,
                id: participant._id
            });
            marker.customLabel = label;
            let popup = this.createPopupGoogle(marker.getPosition(), participant.name || participant.imei, participant._id);
            this.googleMaps.addPopup(popup, this.MAP_NAME);
            marker.addListener("spider_click", () => {
                this.onSelectMarker.next({ type: 'participant', id: marker.id });
                if (!MainMapService.isMobile)
                    this.infoWindow.open(this.map, marker);
            });
            this.participantMarkers.push(marker);
            this.popupMarkers.push(popup);
            this.googleMaps.addMarker(marker, this.MAP_NAME, true);
        }
    }
    // Rimuove o visualizza un marker dalla mappa
    toggleVisibilityParticipantGoogle(participant, showPopup) {
        let p = this.popupMarkers.find((elem) => {
            return elem.id === participant._id;
        });
        if (this.infoWindow)
            this.infoWindow.close();
        for (let marker of this.participantMarkers) {
            if (marker.id === participant._id) {
                if (participant.hideOnMap) {
                    if (marker.getVisible()) {
                        marker.setVisible(false);
                        if (p)
                            p.setMap(null);
                    }
                }
                else {
                    if (!marker.getVisible()) {
                        marker.setVisible(true);
                        if (showPopup) {
                            if (p) {
                                p.setMap(this.map);
                            }
                        }
                    }
                }
                break;
            }
        }
    }
    // Inserisce i marker dei POI
    drawPoiMarkersGoogle(pois) {
        this.poiMarkers = [];
        for (let i = 0; i < pois.length; i++) {
            this.drawSinglePoiMarkerGoogle(pois[i], i);
        }
    }
    // Metodo ausiliario per la creazione di un marker poi
    drawSinglePoiMarkerGoogle(poi, index) {
        let icon = {
            url: MainMapService.iconPoi,
            size: new GoogleMapsService.google.maps.Size(36, 45),
            scaledSize: new GoogleMapsService.google.maps.Size(36, 45),
            origin: new GoogleMapsService.google.maps.Point(0, 0),
            anchor: new GoogleMapsService.google.maps.Point(18, 45),
            labelOrigin: new GoogleMapsService.google.maps.Point(18, 22)
        };
        if (poi.position && poi.position.coordinates && poi.position.coordinates.length === 2) {
            const coord = {
                lat: poi.position.coordinates[1],
                lng: poi.position.coordinates[0]
            };
            let label = {
                color: 'white',
                fontSize: '12px'
            };
            if (poi.label_number) {
                label.text = poi.label_number + '';
            }
            else {
                label = undefined;
            }
            let marker = new GoogleMapsService.google.maps.Marker({
                zIndex: index,
                position: coord,
                label: label,
                icon: icon,
                id: poi._id
            });
            marker.customLabel = label;
            marker.addListener("spider_click", () => {
                this.onSelectMarker.next({ type: 'poi', id: marker.id });
                if (!MainMapService.isMobile)
                    this.infoWindow.open(this.map, marker);
            });
            this.poiMarkers.push(marker);
            this.googleMaps.addMarker(marker, this.MAP_NAME, true);
        }
    }
    // Rimuove o visualizza un marker di un poi dalla mappa
    toggleVisibilityPoiGoogle(poi) {
        if (this.infoWindow)
            this.infoWindow.close();
        for (let marker of this.poiMarkers) {
            if (marker.id === poi._id) {
                if (poi.hideOnMap) {
                    if (marker.getMap()) {
                        this.googleMaps.removeMarker(marker, this.MAP_NAME);
                    }
                }
                else {
                    if (!marker.getMap()) {
                        this.googleMaps.addMarker(marker, this.MAP_NAME, true);
                    }
                }
                return;
            }
        }
    }
    // Crea il label sopra al marker, devo mettere anche la classe all'interno del metodo altrimenti non si riesce a fare
    createPopupGoogle(position, label, id) {
        class Popup extends GoogleMapsService.google.maps.OverlayView {
            constructor(position, content, id) {
                super();
                this.position = position;
                this.id = id;
                content.classList.add("map-poi-popup-bubble");
                // This zero-height div is positioned at the bottom of the bubble.
                const bubbleAnchor = document.createElement("div");
                bubbleAnchor.classList.add("map-poi-popup-bubble-anchor");
                bubbleAnchor.appendChild(content);
                // This zero-height div is positioned at the bottom of the tip.
                this.containerDiv = document.createElement("div");
                this.containerDiv.classList.add("map-poi-popup-container");
                this.containerDiv.appendChild(bubbleAnchor);
                // Optionally stop clicks, etc., from bubbling up to the map.
                Popup.preventMapHitsAndGesturesFrom(this.containerDiv);
            }
            /** Called when the popup is added to the map. */
            onAdd() {
                this.getPanes().floatPane.appendChild(this.containerDiv);
            }
            /** Called when the popup is removed from the map. */
            onRemove() {
                if (this.containerDiv.parentElement) {
                    this.containerDiv.parentElement.removeChild(this.containerDiv);
                }
            }
            /** Called each frame when the popup needs to draw itself. */
            draw() {
                const divPosition = this.getProjection().fromLatLngToDivPixel(this.position);
                //Hide the popup when it is far out of view.
                const display = Math.abs(divPosition.x) < 4000 && Math.abs(divPosition.y) < 4000
                    ? "block"
                    : "none";
                // const display = 'block';
                if (display === "block") {
                    this.containerDiv.style.left = divPosition.x + "px";
                    this.containerDiv.style.top = divPosition.y + "px";
                }
                if (this.containerDiv.style.display !== display) {
                    this.containerDiv.style.display = display;
                }
            }
        }
        let element = document.createElement('div');
        element.innerText = label;
        return new Popup(position, element, id);
    }
    changeZoomGoogle(delta) {
        let zoom = this.map.getZoom();
        this.map.setZoom(zoom + delta);
    }
    resizeMapGoogle() {
        let bounds = new GoogleMapsService.google.maps.LatLngBounds();
        for (let i = 0; i < this.participantMarkers.length; i++) {
            if (this.participantMarkers[i].getVisible()) {
                bounds.extend(this.participantMarkers[i].getPosition());
            }
        }
        for (let i = 0; i < this.poiMarkers.length; i++) {
            if (this.poiMarkers[i].getMap()) {
                bounds.extend(this.poiMarkers[i].getPosition());
            }
        }
        if (!bounds.isEmpty()) {
            this.map.fitBounds(bounds, 50);
            setTimeout(() => {
                if (this.map.getZoom() > 16) {
                    this.map.setZoom(16);
                }
            }, 200);
        }
    }
    setCenterGoogle(lat, lng) {
        this.map.setCenter({ lat: lat, lng: lng });
    }
    setMapTypeGoogle(type) {
        this.map.setMapTypeId(type);
    }
    getMapTypeGoogle() {
        return this.map.getMapTypeId();
    }
    selectParticipantGoogle(id) {
        for (let marker of this.participantMarkers) {
            if (marker.id === id) {
                let position = marker.getPosition();
                this.setCenter(position.lat(), position.lng());
                this.onSelectMarker.next({ type: 'participant', id: marker.id });
                this.infoWindow.open(this.map, marker);
                return;
            }
        }
    }
    selectPoiGoogle(id) {
        for (let marker of this.poiMarkers) {
            if (marker.id === id) {
                let position = marker.getPosition();
                this.setCenter(position.lat(), position.lng());
                this.onSelectMarker.next({ type: 'poi', id: marker.id });
                this.infoWindow.open(this.map, marker);
                return;
            }
        }
    }
    drawCirclePoiGoogle(poi) {
        this.removeCirclePoi();
        for (let marker of this.poiMarkers) {
            if (marker.id === poi._id) {
                this.circle = new GoogleMapsService.google.maps.Circle({
                    center: marker.getPosition(),
                    radius: poi.radius,
                    strokeColor: "#2e97f2",
                    strokeWeight: 2,
                    fillColor: "#2e97f2",
                    fillOpacity: 0.15,
                    id: 'circle'
                });
                this.googleMaps.addCircle(this.circle, this.MAP_NAME);
                return;
            }
        }
    }
    removeCirclePoiGoogle() {
        if (this.circle)
            this.googleMaps.removeCircle(this.circle, this.MAP_NAME);
        this.circle = undefined;
    }
    /*private toggleVisibilityPoiMarkerGoogle(visible: boolean){
      for(let marker of this.poiMarkers){
        if(visible){
          marker.setMap(this.map);
        }else{
          marker.setMap(null);
        }
      }
    }*/
    toggleVisibilityLabelGoogle(visible) {
        for (let marker of this.participantMarkers) {
            marker.setLabel(visible ? marker.customLabel : undefined);
        }
        for (let marker of this.poiMarkers) {
            marker.setLabel(visible ? marker.customLabel : undefined);
        }
    }
    toggleVisibilityPopupGoogle(visible) {
        for (let popup of this.popupMarkers) {
            if (visible) {
                let relMarker = this.participantMarkers.find((elem) => {
                    return elem.id === popup.id;
                });
                if (relMarker) {
                    if (relMarker.getVisible())
                        popup.setMap(this.map);
                }
            }
            else {
                popup.setMap(null);
            }
        }
    }
    updateParticipantMarkerGoogle(participant) {
        let marker = this.participantMarkers.find((elem) => {
            return elem.id === participant._id;
        });
        if (marker) { // modifico il marker esistente
            // Aggiorno posizione
            marker.setPosition({ lat: participant.virtualPosition.latitude, lng: participant.virtualPosition.longitude });
            // Aggiorno la posizione del popup
            for (let popup of this.popupMarkers) {
                if (popup.id === participant._id) {
                    popup.position = marker.getPosition();
                    break;
                }
            }
            // Aggiorno marker
            let icon = {
                url: MainMapService.iconDisabled,
                size: new GoogleMapsService.google.maps.Size(46, 55),
                scaledSize: new GoogleMapsService.google.maps.Size(46, 55),
                origin: new GoogleMapsService.google.maps.Point(0, 0),
                anchor: new GoogleMapsService.google.maps.Point(23, 55),
                labelOrigin: new GoogleMapsService.google.maps.Point(23, 24)
            };
            const urlIcon = Utility.selectMarkerIcons(MainMapService.iconsGreen, MainMapService.iconsRed, participant.virtualPosition.tripStatus, participant.virtualPosition.angle);
            if (urlIcon)
                icon.url = urlIcon;
            marker.setIcon(icon);
            if (participant.label_number || participant.label_number === 0) {
                marker.customLabel = {
                    color: 'white',
                    fontSize: '12px',
                    text: participant.label_number + ''
                };
            }
            else {
                marker.customLabel = undefined;
            }
            if (MainMapService.labelVisible)
                marker.setLabel(marker.customLabel);
        }
        else { // devo aggiungere il marker perchè è nuovo
            this.drawSingleParticipantMarkerGoogle(participant, this.participantMarkers.length);
        }
    }
    removeParticipantMarkerGoogle(id) {
        for (let i = 0; i < this.participantMarkers.length; i++) {
            if (this.participantMarkers[i].id === id) {
                this.googleMaps.removeMarker(this.participantMarkers[i], this.MAP_NAME);
                for (let j = 0; j < this.popupMarkers.length; j++) {
                    if (this.popupMarkers[i].id === id) {
                        this.googleMaps.removePopup(this.popupMarkers[i], this.MAP_NAME);
                        this.popupMarkers.splice(j, 1);
                        break;
                    }
                }
                this.participantMarkers.splice(i, 1);
                return;
            }
        }
    }
    updatePoiMarkerGoogle(poi) {
        let marker = this.poiMarkers.find((elem) => {
            return elem.id === poi._id;
        });
        if (marker) { // Aggiorno il marker del poi
            // Aggiorno posizione
            marker.setPosition({ lat: poi.latitude, lng: poi.longitude });
            if (poi.label_number || poi.label_number === 0) {
                marker.customLabel = {
                    color: 'white',
                    fontSize: '12px',
                    text: poi.label_number + ''
                };
            }
            else {
                marker.customLabel = undefined;
            }
            if (MainMapService.labelVisible)
                marker.setLabel(marker.customLabel);
        }
        else { // Aggiungo un nuovo marker del poi
            this.drawSinglePoiMarkerGoogle(poi, this.poiMarkers.length);
        }
    }
    removePoiMarkerGoogle(id) {
        for (let i = 0; i < this.poiMarkers.length; i++) {
            if (this.poiMarkers[i].id === id) {
                this.googleMaps.removeMarker(this.poiMarkers[i], this.MAP_NAME);
                this.poiMarkers.splice(i, 1);
                return;
            }
        }
    }
    // Setta il menù con le icone per cambio tipo mappa e infotraffico
    setMapTypeControls() {
        return __awaiter(this, void 0, void 0, function* () {
            // console.log('main-map service setMapTypeControls()');
            const size = MainMapService.isMobile ? '54px' : '75px';
            if (!this.buttonMapType_1) {
                this.buttonMapType_1 = document.createElement('div');
                let controlUIMap = document.createElement('div');
                controlUIMap.style.height = size;
                controlUIMap.style.width = size;
                controlUIMap.style.background = "linear-gradient(0deg,rgba(0,0,0,0.3),rgba(0,0,0,0.3)),url(" + MainMapService.satelliteMapImage + ")";
                controlUIMap.style.backgroundSize = size + " " + size;
                controlUIMap.style.border = '2px solid #fff';
                controlUIMap.style.borderRadius = '5px';
                controlUIMap.style.cursor = 'pointer';
                controlUIMap.style.marginRight = MainMapService.isMobile ? '8px' : '10px';
                this.buttonMapType_1.style.marginBottom = "5px";
                this.buttonMapType_1.appendChild(controlUIMap);
                let controlTexMap = document.createElement('div');
                controlTexMap.style.color = "#fff";
                controlTexMap.style.fontFamily = 'Roboto,Arial,sans-serif';
                controlTexMap.style.fontSize = MainMapService.isMobile ? '8px' : '10px';
                controlTexMap.style.lineHeight = '38px';
                controlTexMap.style.paddingLeft = '5px';
                controlTexMap.style.paddingRight = '5px';
                controlTexMap.style.marginTop = MainMapService.isMobile ? '20px' : '40px';
                controlTexMap.style.textOverflow = 'ellipsis';
                controlTexMap.style.overflow = 'hidden';
                controlTexMap.style.whiteSpace = 'nowrap';
                controlTexMap.innerHTML = MainMapService.satelliteMapLabel;
                this.buttonMapType_1.addEventListener('click', () => {
                    let mapTypeId = this.map.getMapTypeId();
                    if (mapTypeId == GoogleMapsService.google.maps.MapTypeId.HYBRID) {
                        controlUIMap.style.background = "linear-gradient(0deg,rgba(0,0,0,0.3),rgba(0,0,0,0.3)),url(" + MainMapService.satelliteMapImage + ")";
                        controlUIMap.style.backgroundSize = size + " " + size;
                        controlTexMap.innerHTML = MainMapService.satelliteMapLabel;
                        MainMapService.currentMapType = GoogleMapsService.google.maps.MapTypeId.ROADMAP;
                    }
                    else {
                        controlUIMap.style.background = "linear-gradient(0deg,rgba(0,0,0,0.3),rgba(0,0,0,0.3)),url(" + MainMapService.roadMapImage + ")";
                        controlUIMap.style.backgroundSize = size + " " + size;
                        controlTexMap.innerHTML = MainMapService.roadMapLabel;
                        MainMapService.currentMapType = GoogleMapsService.google.maps.MapTypeId.HYBRID;
                    }
                    this.map.setMapTypeId(MainMapService.currentMapType);
                });
                controlUIMap.appendChild(controlTexMap);
            }
            if (!this.buttonMapType_2) {
                this.buttonMapType_2 = document.createElement('div');
                let controlUITraffic = document.createElement('div');
                controlUITraffic.style.height = size;
                controlUITraffic.style.width = size;
                controlUITraffic.style.background = "linear-gradient(0deg,rgba(0,0,0,0.3),rgba(0,0,0,0.3)),url(" + MainMapService.infotrafficImage + ")";
                controlUITraffic.style.backgroundSize = size + " " + size;
                controlUITraffic.style.border = '2px solid #fff';
                controlUITraffic.style.borderRadius = '5px';
                controlUITraffic.style.cursor = 'pointer';
                controlUITraffic.style.marginRight = MainMapService.isMobile ? '8px' : '10px';
                controlUITraffic.style.marginBottom = "5px";
                this.buttonMapType_2.appendChild(controlUITraffic);
                let controlTextTraffic = document.createElement('div');
                controlTextTraffic.style.color = "#fff";
                controlTextTraffic.style.fontFamily = 'Roboto,Arial,sans-serif';
                controlTextTraffic.style.fontSize = MainMapService.isMobile ? '8px' : '10px';
                controlTextTraffic.style.lineHeight = '38px';
                controlTextTraffic.style.paddingLeft = '5px';
                controlTextTraffic.style.paddingRight = '5px';
                controlTextTraffic.style.textOverflow = 'ellipsis';
                controlTextTraffic.style.overflow = 'hidden';
                controlTextTraffic.style.whiteSpace = 'nowrap';
                controlTextTraffic.style.marginTop = MainMapService.isMobile ? '20px' : '40px';
                controlTextTraffic.innerHTML = MainMapService.infotrafficLabel;
                this.buttonMapType_2.addEventListener('click', () => {
                    if (MainMapService.currentInfotraffic) {
                        MainMapService.currentInfotraffic = false;
                        this.googleMaps.disableInfoTraffic();
                        controlUITraffic.style.borderColor = "#fff";
                    }
                    else {
                        MainMapService.currentInfotraffic = true;
                        this.googleMaps.enableInfoTraffic();
                        controlUITraffic.style.borderColor = "#32aadf";
                    }
                });
                controlUITraffic.appendChild(controlTextTraffic);
            }
            this.map.controls[GoogleMapsService.google.maps.ControlPosition.RIGHT_BOTTOM].push(this.buttonMapType_1);
            this.map.controls[GoogleMapsService.google.maps.ControlPosition.RIGHT_BOTTOM].push(this.buttonMapType_2);
        });
    }
    closeInfoWindowGoogle() {
        if (this.infoWindow)
            this.infoWindow.close();
        if (this.circle)
            this.googleMaps.removeCircle(this.circle, this.MAP_NAME);
        if (this.selectedMarker)
            this.googleMaps.removeMarker(this.selectedMarker, this.MAP_NAME);
    }
}
MainMapService.initCount = -1;
MainMapService.labelVisible = true;
MainMapService.popupVisible = true;
MainMapService.ɵfac = function MainMapService_Factory(t) { return new (t || MainMapService)(i0.ɵɵinject(GoogleMapsService)); };
MainMapService.ɵprov = i0.ɵɵdefineInjectable({ token: MainMapService, factory: MainMapService.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(MainMapService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: GoogleMapsService }]; }, null); })();

class UpdatesService {
    constructor() { }
    initialize(firebase) {
        UpdatesService.firebase = firebase;
    }
    triggerNotificationsDatabase() {
        // if(this.notificationReference) this.notificationReference.off();
        // let id: string = this.id;
        // if(this.systemSubUser && this.systemSubUser.isSencondaryUser){
        //   id = this.systemSubUser.idUserPrincipal;
        // }
        // this.notificationReference = firebaseDatabase.ref('notifications/users/' + id);
        // let first: boolean = true;
        // this.notificationReference.on('value', (snapshot) => {
        //   if(!first){
        //     this.parseNotification(snapshot.val());
        //   }else{
        //     first = false;
        //   }
        // });
        // if(this.notificationReferenceTrackerGps) this.notificationReferenceTrackerGps.off();
        // this.notificationReferenceTrackerGps = firebaseDatabaseTrackerGps.ref("trackerData/" + id);
        // let first1: boolean = true;
        // this.notificationReferenceTrackerGps.on('value', (snapshot) => {
        //   if(!first1){
        //     this.parseNotification(snapshot.val());
        //   }else{
        //     first1 = false;
        //   }
        // });
    }
}
UpdatesService.ɵfac = function UpdatesService_Factory(t) { return new (t || UpdatesService)(); };
UpdatesService.ɵprov = i0.ɵɵdefineInjectable({ token: UpdatesService, factory: UpdatesService.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(UpdatesService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

class VehicleMapService {
    constructor(googleMaps) {
        this.googleMaps = googleMaps;
        this.MAP_NAME = "vehicle";
    }
    initMap(mapType, markersRed, markersGreen, urlMarkerDisabled, urlMarkerStart, vehicle) {
        VehicleMapService.markersRed = markersRed;
        VehicleMapService.markersGreen = markersGreen;
        VehicleMapService.urlMarkerDisabled = urlMarkerDisabled;
        VehicleMapService.urlMarkerStart = urlMarkerStart;
        this.mapType = mapType;
        this.polyline = null;
        switch (this.mapType) {
            case "Google":
                this.initMapGoogle(vehicle);
                break;
        }
    }
    clearMap() {
        // this.cleanPolyline();
        this.polyline = undefined;
    }
    // Disegna la polilinea del percorso
    drawPolyline(positions) {
        return __awaiter(this, void 0, void 0, function* () {
            switch (this.mapType) {
                case "Google":
                    this.drawPolylineGoogle(positions);
                    break;
            }
        });
    }
    // Disegna le frecce sulla polyline
    drawArrows() {
        return __awaiter(this, void 0, void 0, function* () {
            switch (this.mapType) {
                case "Google":
                    this.drawArrowsGoogle();
                    break;
            }
        });
    }
    // cleanPolyline(){
    //   switch (this.mapType) {
    //     case "Google":
    //       this.cleanPolylineGoogle();
    //       break;
    //   }
    // }
    //
    //
    // /**
    //  * Rimuove le frecce sulla polyline
    //  */
    // async cleanArrows() {
    //   switch (this.mapType) {
    //     case "Google":
    //       this.cleanArrowsGoogle();
    //       break;
    //   }
    // }
    //
    // drawStopMarkers(positions: PositionGps[]){
    //   switch (this.mapType) {
    //     case "Google":
    //       this.drawStopMarkersGoogle(positions);
    //       break;
    //   }
    // }
    //
    // cleanStopMarkers(){
    //   switch (this.mapType) {
    //     case "Google":
    //       this.cleanStopMarkersGoogle();
    //       break;
    //   }
    // }
    //
    // selectPath(start: number, stop: number){
    //   switch (this.mapType) {
    //     case "Google":
    //       this.selectPathGoogle(start, stop);
    //       break;
    //   }
    // }
    //
    // cleanPath(){
    //   switch (this.mapType) {
    //     case "Google":
    //       this.cleanPathGoogle();
    //       break;
    //   }
    // }
    //
    // selectStopMarker(id: string){
    //   switch (this.mapType) {
    //     case "Google":
    //       this.selectStopMarkerGoogle(id);
    //       break;
    //   }
    // }
    //
    // changeZoom(delta: number){
    //   switch (this.mapType) {
    //     case "Google":
    //       this.changeZoomGoogle(delta);
    //       break;
    //   }
    // }
    //
    // resizeMap(){
    //   switch (this.mapType) {
    //     case "Google":
    //       this.resizeMapGoogle();
    //       break;
    //   }
    // }
    //
    // setMapType(type: string){
    //   switch (this.mapType) {
    //     case "Google":
    //       this.setMapTypeGoogle(type);
    //       break;
    //   }
    // }
    //
    // getMapType(){
    //   switch (this.mapType) {
    //     case "Google":
    //       return this.getMapTypeGoogle();
    //       break;
    //   }
    // }
    /*** GOOGLE MAPS ***/
    initMapGoogle(vehicle) {
        return __awaiter(this, void 0, void 0, function* () {
            this.googleMaps.clearMap();
            this.map = this.googleMaps.getMap();
            let mapContainer = document.getElementById("vehicle-map");
            if (mapContainer) {
                mapContainer.appendChild(this.googleMaps.getDivMap());
                this.googleMaps.setCurrentMap(this.MAP_NAME);
            }
            let center = { lat: 44.69, lng: 7.84 };
            if (vehicle.virtualPosition) {
                center.lat = vehicle.virtualPosition.latitude;
                center.lng = vehicle.virtualPosition.longitude;
            }
            this.map.setOptions({
                center: center,
                zoom: 16,
                fullscreenControl: false,
                zoomControl: true,
                streetViewControl: true,
                mapTypeControl: false
            });
            let icon = {
                url: VehicleMapService.urlMarkerDisabled,
                size: new GoogleMapsService.google.maps.Size(46, 55),
                scaledSize: new GoogleMapsService.google.maps.Size(46, 55),
                origin: new GoogleMapsService.google.maps.Point(0, 0),
                anchor: new GoogleMapsService.google.maps.Point(23, 55),
                labelOrigin: new GoogleMapsService.google.maps.Point(23, 24)
            };
            if (vehicle.virtualPosition && vehicle.virtualPosition.latitude && vehicle.virtualPosition.longitude) {
                const coord = {
                    lat: vehicle.virtualPosition.latitude,
                    lng: vehicle.virtualPosition.longitude
                };
                let label = {
                    color: 'white',
                    fontSize: '12px'
                };
                // Scelgo l'icona in base all'angle
                const urlIcon = Utility.selectMarkerIcons(VehicleMapService.markersGreen, VehicleMapService.markersRed, vehicle.virtualPosition.tripStatus, vehicle.virtualPosition.angle);
                if (urlIcon)
                    icon.url = urlIcon;
                if (vehicle.label_number) {
                    label.text = vehicle.label_number + '';
                }
                else {
                    label.text = '';
                }
                let marker = new GoogleMapsService.google.maps.Marker({
                    zIndex: 2,
                    position: coord,
                    label: label,
                    icon: icon,
                    id: vehicle._id
                });
                this.googleMaps.addMarker(marker, this.MAP_NAME, true);
            }
        });
    }
    drawPolylineGoogle(positions) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!positions || positions.length <= 0)
                return;
            let icon = {
                url: VehicleMapService.urlMarkerStart,
                size: new GoogleMapsService.google.maps.Size(46, 55),
                scaledSize: new GoogleMapsService.google.maps.Size(46, 55),
                origin: new GoogleMapsService.google.maps.Point(0, 0),
                anchor: new GoogleMapsService.google.maps.Point(23, 55),
                labelOrigin: new GoogleMapsService.google.maps.Point(23, 24)
            };
            let label = {
                color: 'white',
                fontWeight: 'bold',
                fontSize: '12px',
                text: 'START'
            };
            let coordinates = [];
            this.positionInPolyline = [];
            let count = 0;
            for (let i = 0; i < positions.length; i++) {
                if (positions[i].satellites > 0 && positions[i].position && positions[i].position.coordinates) {
                    const coord = {
                        lat: positions[i].position.coordinates[1],
                        lng: positions[i].position.coordinates[0]
                    };
                    if (count === 0) {
                        let marker = new GoogleMapsService.google.maps.Marker({
                            zIndex: 1,
                            icon: icon,
                            position: coord,
                            label: label,
                            id: positions[i]._id
                        });
                        this.googleMaps.addMarker(marker, this.MAP_NAME, true);
                    }
                    count++;
                    coordinates.push(coord);
                    this.positionInPolyline.push(positions[i]);
                }
            }
            this.polyline = new GoogleMapsService.google.maps.Polyline({
                id: "main-polyline",
                path: coordinates,
                geodesic: true,
                strokeColor: "#1bb21d",
                strokeOpacity: 0.8,
                strokeWeight: 6,
                zIndex: 2
            });
            this.googleMaps.addPolyline(this.polyline, this.MAP_NAME);
            this.drawArrows();
        });
    }
    drawArrowsGoogle() {
        if (this.polyline) {
            this.polyline.set('icons', [{
                    icon: {
                        path: "M 0,0 1,1 M -1,1 0,0",
                        strokeColor: "black",
                        strokeWeight: 4,
                        strokeOpacity: 1
                    },
                    offset: '0',
                    repeat: '50px'
                }]);
        }
    }
}
VehicleMapService.ɵfac = function VehicleMapService_Factory(t) { return new (t || VehicleMapService)(i0.ɵɵinject(GoogleMapsService)); };
VehicleMapService.ɵprov = i0.ɵɵdefineInjectable({ token: VehicleMapService, factory: VehicleMapService.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(VehicleMapService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: GoogleMapsService }]; }, null); })();

class NavigationService {
    constructor() { }
    static initialize(route, router, location) {
        NavigationService.route = route;
        NavigationService.router = router;
        NavigationService.location = location;
    }
    static navigate(url, isRoot, isRelativeUrl, data) {
        return __awaiter(this, void 0, void 0, function* () {
            yield NavigationService.router.navigate([url], { replaceUrl: isRoot, relativeTo: this.route, queryParams: data });
        });
    }
    static goBack() {
        NavigationService.location.back();
    }
    static foForward() {
        NavigationService.location.forward();
    }
    static getQueryParams() {
        return new Promise((resolve) => {
            this.route.queryParams.subscribe(params => {
                return resolve(params);
            });
        });
    }
    static clearQueryParams() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.router.navigate([], { queryParams: {} });
        });
    }
}
NavigationService.ɵfac = function NavigationService_Factory(t) { return new (t || NavigationService)(); };
NavigationService.ɵprov = i0.ɵɵdefineInjectable({ token: NavigationService, factory: NavigationService.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(NavigationService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

class StatisticsService {
    constructor() { }
    // Inizializza firebase per quella specifica app e attiva il listener di cambio di stato
    static initialization(firebase, tagPlatform) {
        console.log("StatisticsService initialization");
        try {
            StatisticsService.analytics = firebase.analytics();
            StatisticsService.tagPlatform = tagPlatform;
        }
        catch (err) {
            console.error(err);
        }
    }
    // Invia un evento all'analytics di google
    static sendLogEventGoogle(name, params) {
        console.log("sendLogEventGoogle", StatisticsService.analytics);
        try {
            if (StatisticsService.analytics) {
                if (!params)
                    params = {};
                params.platform = StatisticsService.tagPlatform;
                StatisticsService.analytics.logEvent(name, params);
            }
        }
        catch (err) {
            console.error(err);
        }
    }
}
StatisticsService.ɵfac = function StatisticsService_Factory(t) { return new (t || StatisticsService)(); };
StatisticsService.ɵprov = i0.ɵɵdefineInjectable({ token: StatisticsService, factory: StatisticsService.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(StatisticsService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

class Document {
    constructor(data) {
        if (data) {
            this._id = data._id;
            this.idUser = data.idUser;
        }
    }
}

class TrackerGps {
    constructor(data) {
        if (data) {
            this.setData(data);
        }
    }
    setData(data) {
        if (data) {
            this._id = data._id;
            this.type_trackerGps = data.type_trackerGps;
            this.status = data.status;
            this.imei = data.imei;
            this.serial_number = data.serial_number;
            this.timestamp_created = data.timestamp_created;
            this.note = data.note;
            this.status_trackerGps = data.status_trackerGps;
            this.timestamp_status_trackerGps = data.timestamp_status_trackerGps;
        }
    }
}

class User {
    constructor(data) {
        if (data) {
            this._id = data._id;
            this.email = data.email;
            this.dialNumber = data.email;
            this.phoneNumber = data.phoneNumber;
            this.uidFirebase = data.uidFirebase;
            this.timestampCreate = data.timestampCreate;
        }
    }
}

class Notification {
    constructor(data) {
        if (data) {
            this.setData(data);
        }
    }
    setData(data) {
        this._id = data._id;
        this.idOrganization = data.idOrganization;
        this.isRead = data.isRead;
        this.timestamp = data.timestamp;
        if (this.timestamp)
            this.timestamp_ms = this.timestamp * 1000;
        this.type = data.type;
        this.title = data.title;
        this.description = data.description;
        if (data.partecipant)
            this.participant = new Partecipant(data.partecipant);
        if (data.poi)
            this.poi = new Poi(data.poi);
        if (data.alarmPoi)
            this.alarmPoi = new AlarmPoi(data.alarmPoi);
        this.isInPoi = data.isInPoi;
    }
}

/*
 * Public API Surface of common-lib
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AlarmPoi, AlarmsPoiMapService, AlertPage, ApiService, AuthService, AvatarItemComponent, ChipbarComponent, CommonLibComponent, CommonLibModule, CommonLibService, DEMO_ROUTES, DEMO_ROUTES_LIVE, DataService, DecimalNumberPipe, DeltaTimePipe, Document, DurationPipe, EmailListPipe, GoogleMapsService, HistoryMapService, HoursMinutes, MainMapService, NavigationService, Notification, Organization, Partecipant, ParticipantListPipe, Poi, PoiListPipe, PoiMapService, PositionGps, SearchPipe, SmallAlertPage, SortAlphabeticallyPipe, SortPipe, StatisticsService, TopBarComponent, TrackerGps, UpdatesService, User, Utility, VehicleMapService, ViewService, VirtualPosition, WeekDaysPipe };
//# sourceMappingURL=common-lib.js.map
